{
 " ao(à) paciente {nome}{cpf}": " (मरीज़: {nome}{cpf})",
 " junto ao plano de saúde {c}": " (स्वास्थ्य बीमा {c})",
 " às {h}": " {h} बजे",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" या \"पेज 1 / 10\", जिस कोने में चाहें।",
 "\"{nome}\" está no {provedor}.": "\"{nome}\" {provedor} में है।",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" JPG या PNG नहीं है। इसे JPG में बदलकर फिर कोशिश करें।",
 "\"{nome}\" não é um PDF.": "\"{nome}\" PDF नहीं है।",
 "\"{nova}\" às {hora} coincide com: {outras}.": "\"{nova}\" {hora} बजे इनसे टकराता है: {outras}।",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "\"{n}\" अब समूह का है। 1 मिनट के भीतर बाकी सदस्य सब कुछ देख सकेंगे।",
 "\"{titulo}\" foi criada com os mesmos dados.": "\"{titulo}\" उसी डेटा के साथ बनाया गया।",
 "\"{titulo}\" já foi adicionado em {data}.": "\"{titulo}\" {data} को पहले ही जोड़ा जा चुका है।",
 "% ao mês": "% प्रति माह",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(एडमिन के कंप्यूटर पर: 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(कॉपी)",
 "(sem título)": "(बिना शीर्षक)",
 "+ Adicionar alerta": "+ अलर्ट जोड़ें",
 "+ Adicionar outra OAB": "+ एक और OAB जोड़ें",
 "+ Adicionar pausa": "+ ब्रेक जोड़ें",
 "+ Adicionar subtarefa": "+ उप-कार्य जोड़ें",
 "+ Matéria em {nome}": "+ {nome} में विषय",
 "+ Perfil": "+ प्रोफ़ाइल",
 "+ Subtarefa": "+ उप-कार्य",
 "+5 min": "+5 मिनट",
 "+{n} acompanhante(s)": "+{n} साथी",
 "+{n} páginas acima da meta": "लक्ष्य से +{n} पेज ज़्यादा",
 ", carteirinha nº {n},": ", कार्ड नं. {n},",
 ", pago em {d}{f}": ", {d} को भुगतान किया गया{f}",
 "1 cápsula": "1 कैप्सूल",
 "1 dose": "1 खुराक",
 "1 dose (30 g)": "1 खुराक (30 g)",
 "1 pessoa": "1 व्यक्ति",
 "1 publicação nova": "1 नया प्रकाशन",
 "1 página": "1 पेज",
 "1 tarja no documento": "दस्तावेज़ में 1 काली पट्टी",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. My Planner इंस्टॉल करें और अपना खाता बनाएँ।  2. यह लिंक फिर से खोलें (या सेटिंग्स › समूह और आमंत्रण में कोड डालें)।",
 "1. Quais dados tratamos": "1. हम कौन-सा डेटा प्रोसेस करते हैं",
 "1. Sobre o app": "1. ऐप के बारे में",
 "1ª dose": "पहली खुराक",
 "2 por folha": "प्रति शीट 2",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 कप आटा\n3 अंडे\n1 चम्मच बेकिंग पाउडर",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "हर शीट पर 2, 4, 6 या 9 पेज (प्रिंट के लिए)।",
 "2. Para que usamos": "2. हम इसका उपयोग किसलिए करते हैं",
 "2. Sua conta": "2. आपका खाता",
 "2ª dose": "दूसरी खुराक",
 "3 a 5 g": "3 से 5 g",
 "3. Bases legais (LGPD)": "3. कानूनी आधार (LGPD)",
 "3. Uso correto": "3. सही उपयोग",
 "3ª dose": "तीसरी खुराक",
 "4 por folha": "प्रति शीट 4",
 "4. Com quem compartilhamos": "4. हम किसके साथ साझा करते हैं",
 "4. Planos e testes": "4. प्लान और ट्रायल",
 "5. Limites": "5. सीमाएँ",
 "5. Segurança": "5. सुरक्षा",
 "6 por folha": "प्रति शीट 6",
 "6. Por quanto tempo": "6. कितने समय तक",
 "7. Seus direitos (art. 18 da LGPD)": "7. आपके अधिकार (LGPD का art. 18)",
 "8. Crianças e adolescentes": "8. बच्चे और किशोर",
 "9 por folha": "प्रति शीट 9",
 "9. Mudanças": "9. बदलाव",
 "@letra-dom": "र",
 "@letra-qua": "बु",
 "@letra-qui": "गु",
 "@letra-sab": "श",
 "@letra-seg": "सो",
 "@letra-sex": "शु",
 "@letra-ter": "मं",
 "A IA está classificando...": "AI वर्गीकरण कर रहा है...",
 "A IA está lendo a caixa...": "AI बॉक्स पढ़ रहा है...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "AI पेज पढ़ता है और PDF में खोज व कॉपी हो सकती है।",
 "A IA lê o PDF e sugere um nome claro.": "AI PDF पढ़कर एक साफ़ नाम सुझाता है।",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "AI ने अपेक्षित प्रारूप में उत्तर नहीं दिया। फिर से कोशिश करें।",
 "A IA não encontrou dados para esta ficha no arquivo.": "AI को फ़ाइल में इस कार्ड का कोई डेटा नहीं मिला।",
 "A IA não encontrou tarefas nesta caixa.": "AI को इस बॉक्स में कोई कार्य नहीं मिला।",
 "A IA resume o PDF e responde perguntas.": "AI PDF का सारांश देता है और सवालों के जवाब देता है।",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "SEFAZ दर्ज करता है कि इनवॉइस आपकी जानकारी में आ गया है (यह खरीद की पुष्टि या अस्वीकार नहीं करता) और अगली खोज में, 1 घंटे के भीतर, पूरा XML उपलब्ध कराता है।",
 "A VENCER (7 DIAS)": "जल्द देय (7 दिन)",
 "A aba inteira": "पूरा टैब",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "{aba} टैब सीमा के करीब है। इसके पुराने आइटम आर्काइव करें या मिटाएँ।",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "{aba} टैब की सदस्यता नहीं है। लिंक सुरक्षित रहता है और सदस्यता लेने पर वापस आ जाता है।",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "\"{nome}\" की खोज बहुत व्यापक है। पूरा नाम लिखें।",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "इस ऐप में GIF खोज अभी चालू नहीं है। तब तक, एनिमेटेड स्टिकर (🎉) इस्तेमाल करें।",
 "A cada": "हर",
 "A cada N páginas": "हर N पेज पर",
 "A cada quantos dias": "कितने दिनों में",
 "A cada {n} dia(s)": "हर {n} दिन में",
 "A cada {n} mês(es)": "हर {n} महीने में",
 "A cada {n} mês(es) · dia {d}": "हर {n} महीने में · दिन {d}",
 "A cada {n} semana(s)": "हर {n} हफ़्ते में",
 "A cada {n} semana(s) · {dia}": "हर {n} हफ़्ते में · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "बॉक्स {aba} में, \"प्राप्त नोट्स\" के अंदर है।",
 "A caixa foi para {destino}.": "बॉक्स {destino} में भेज दिया गया।",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "कुंजी केवल इसी डिवाइस पर, सिस्टम की सुरक्षित तिजोरी में रखी जाती है। दूसरे डिवाइस पर इसे फिर से जोड़ें।",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "कुंजी केवल इसी ब्राउज़र में रखी जाती है। इसे निजी कंप्यूटर पर ही इस्तेमाल करें।",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "कनेक्शन एन्क्रिप्टेड है। वॉल्ट एंड-टू-एंड एन्क्रिप्शन (AES-256) का उपयोग करता है: सपोर्ट टीम भी इसे नहीं पढ़ सकती। ऐप को पासवर्ड, पैटर्न या बायोमेट्रिक से लॉक किया जा सकता है।",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "WhatsApp द्वारा पुष्टि अभी सर्वर पर चालू नहीं की गई है।",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "खाता और क्लाउड में सेव सारा डेटा: कार्य, नोट्स, टैब, रिकॉर्ड, संदेश, ऐप को भेजी गई फ़ाइलें और सेटिंग्स। इस डिवाइस का डेटा भी हट जाता है। इसे वापस नहीं किया जा सकता।",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "यह रंग बार, शीर्षकों और इस टैब से जुड़े कार्यों में दिखता है।",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "My Planner का रंग ऐप का मुख्य रंग है। हर कार्य का अपने विवरण में अलग रंग हो सकता है।",
 "A data de fim é anterior à de início.": "समाप्ति तिथि आरंभ तिथि से पहले है।",
 "A data inicial precisa ser antes da final.": "शुरुआती तारीख अंतिम तारीख से पहले होनी चाहिए।",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "टीम त्रुटि देखेगी और अगले अपडेट में ठीक करेगी।",
 "A equipe vê e altera conforme o papel de cada um": "टीम हर व्यक्ति की भूमिका के अनुसार देखती और बदलती है",
 "A fazer": "करना है",
 "A foto passa de 8 MB.": "फ़ोटो 8 MB से बड़ी है।",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "फ़ोटो बहुत बड़ी है। फ़ोटो क्रॉप करने के लिए ऐप का नया वर्शन इंस्टॉल करें।",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "\"nuvem\" फ़ंक्शन अभी सर्वर पर प्रकाशित नहीं हुआ है। 32-LIGAR-DRIVE-ONEDRIVE.bat चलाएँ।",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "\"nuvem\" फ़ंक्शन अभी सर्वर पर प्रकाशित नहीं हुआ है। 9-LIGAR-DRIVE-ONEDRIVE.bat चलाएँ (COMO RODAR, संस्करण 0.15.1 देखें)।",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "रिकॉर्डिंग अभी तैयार हो रही है। कुछ मिनट बाद फिर कोशिश करें।",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "समय इसी समय क्षेत्र में दर्ज होता है। दूसरे समय क्षेत्र में ऐप बदले हुए समय पर दिखाता और सूचित करता है।",
 "A imagem original não está neste dispositivo.": "मूल इमेज इस डिवाइस में नहीं है।",
 "A pagar": "देय",
 "A pagar: {v}": "देय: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "कैलेंडर की अनुमति हटा दी गई है। फ़ोन की सेटिंग में जाकर इसे फिर से दें।",
 "A pessoa sai do grupo e deixa de receber os envios.": "व्यक्ति समूह छोड़ देता है और भेजी गई चीज़ें मिलना बंद हो जाता है।",
 "A receber": "मिलना बाकी",
 "A receber: {v}": "मिलना बाकी: {v}",
 "A reunião ainda está sendo gravada.": "मीटिंग अभी रिकॉर्ड हो रही है।",
 "A senha atual não confere.": "मौजूदा पासवर्ड सही नहीं है।",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "वॉल्ट पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।",
 "A senha precisa ter 8 caracteres ou mais.": "पासवर्ड में 8 या अधिक अक्षर होने चाहिए।",
 "A senha precisa ter pelo menos 8 caracteres.": "पासवर्ड में कम से कम 8 अक्षर होने चाहिए।",
 "A senha é a mesma no celular e no My Planner Web.": "फ़ोन और My Planner Web पर पासवर्ड एक ही है।",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "ऐप खोलने पर और हर बदलाव के बाद सिंक होता है। कैलेंडर से जुड़े टास्क पर 📆 दिखता है।",
 "A sua equipe num lugar só": "आपकी पूरी टीम एक ही जगह",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "घर का काम अपने-आप My Planner में नहीं जाता। \"My Planner में भेजें\" पूरा फ़ॉर्म खोलता है, जहाँ आप दिन, समय, आवृत्ति, ब्रेक और अलर्ट चुन सकते हैं।",
 "A validade não pode ser antes da emissão.": "वैधता तिथि जारी होने की तिथि से पहले नहीं हो सकती।",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "iPhone संस्करण जल्द ही App Store पर आएगा। तब तक My Planner Web का उपयोग करें।",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "iPhone वर्ज़न जल्द ही App Store पर आ रहा है। तब तक My Planner Web इस्तेमाल करें: Safari में शेयर करें > होम स्क्रीन में जोड़ें पर टैप करें, ताकि यह मोबाइल पर एक आइकन बन जाए।",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, लेटर, A5 या लीगल, बिना कुछ काटे।",
 "ADICIONAR AMIGO": "दोस्त जोड़ें",
 "AGUARDANDO RESPOSTA": "जवाब का इंतज़ार",
 "AMIGOS": "दोस्त",
 "ANOTAÇÕES": "नोट्स",
 "ANOTAÇÕES RECEBIDAS · {aba}": "प्राप्त नोट्स · {aba}",
 "ATIVIDADE": "गतिविधि",
 "ATIVIDADE FÍSICA": "शारीरिक गतिविधि",
 "ATRASADAS": "देरी से",
 "Aba": "टैब",
 "Aba bloqueada": "टैब लॉक है",
 "Aba {nome}": "{nome} टैब",
 "Abas": "टैब",
 "Abas liberadas pelo suporte": "सहायता टीम द्वारा खोले गए टैब",
 "Abas para comprar": "खरीदने के लिए टैब",
 "Abas que você já tem": "आपके पास मौजूद टैब",
 "Abastecimento": "ईंधन भरवाना",
 "Abastecimentos": "ईंधन भरवाना",
 "Abdominal": "क्रंच",
 "Abertura do prazo da declaração do IR": "आयकर रिटर्न की अवधि शुरू",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "कंपनी खोलें और वॉल्ट पासवर्ड डालने के लिए \"इनवॉइस खोजें\" पर टैप करें।",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "My Planner Anne खोलें और अपने पहचान नंबर और पासवर्ड से लॉगिन करें।",
 "Abra o My Planner no celular.": "मोबाइल पर My Planner खोलें।",
 "Abra o cofre": "वॉल्ट खोलें",
 "Abra um PDF para começar.": "शुरू करने के लिए एक PDF खोलें।",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "समय मापने के लिए कोई विषय खोलें और \"अभी पढ़ें\" पर टैप करें। हर विषय के लिए साप्ताहिक लक्ष्य तय करें।",
 "Abraço": "झप्पी",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "फ़ोन का शेयर मेन्यू खोलता है: WhatsApp, ईमेल, Google Drive, OneDrive, Files में सेव करें और अन्य।",
 "Abre o PDF para ler aqui mesmo.": "PDF को यहीं पढ़ने के लिए खोलता है।",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "PDF स्कैनर खोलता है (किनारे और परछाइयाँ ठीक)।",
 "Abrir": "खोलें",
 "Abrir Ajustes": "सेटिंग्स खोलें",
 "Abrir PDF": "PDF खोलें",
 "Abrir PDF do celular, Drive ou OneDrive": "मोबाइल, Drive या OneDrive से PDF खोलें",
 "Abrir a aba": "टैब खोलें",
 "Abrir a cópia guardada": "सहेजी गई कॉपी खोलें",
 "Abrir a pasta no Drive": "Drive में फ़ोल्डर खोलें",
 "Abrir com outro app": "दूसरे ऐप से खोलें",
 "Abrir configurações": "सेटिंग्स खोलें",
 "Abrir em outro app": "दूसरे ऐप में खोलें",
 "Abrir no DJEN": "DJEN में खोलें",
 "Abrir no modo seguro": "सुरक्षित मोड में खोलें",
 "Abrir normalmente": "सामान्य रूप से खोलें",
 "Abrir nota fiscal": "बिल खोलें",
 "Abrir o PDF": "PDF खोलें",
 "Abrir o PDF no {nome}": "PDF को {nome} में खोलें",
 "Abrir o XML": "XML खोलें",
 "Abrir o app": "ऐप खोलें",
 "Abrir o app My Planner": "My Planner ऐप खोलें",
 "Abrir o cartão": "कार्ड खोलें",
 "Abrir o cofre": "वॉल्ट खोलें",
 "Abrir o cofre para ver": "देखने के लिए वॉल्ट खोलें",
 "Abrir o diário oficial": "आधिकारिक राजपत्र खोलें",
 "Abrir ou baixar": "खोलें या डाउनलोड करें",
 "Abrir página": "पेज खोलें",
 "Abrir site": "वेबसाइट खोलें",
 "Abrir {nome}": "{nome} खोलें",
 "Acabamento": "फ़िनिशिंग",
 "Acabou": "खत्म हो गया",
 "Academia": "जिम",
 "Aceitar": "स्वीकारें",
 "Aceitar, editar ou recusar": "स्वीकारें, संपादित करें या अस्वीकारें",
 "Aceite os termos para continuar.": "आगे बढ़ने के लिए शर्तें स्वीकार करें।",
 "Aceito": "स्वीकृत",
 "Aceito com alterações": "बदलावों के साथ स्वीकृत",
 "Acerto de contas": "हिसाब बराबर",
 "Acerto de contas: {v}": "हिसाब बराबर: {v}",
 "Acessibilidade": "सुगम्यता",
 "Acesso ilimitado": "असीमित एक्सेस",
 "Acesso ilimitado a todas as funções, sem prazo": "सभी सुविधाओं तक असीमित पहुँच, बिना समय सीमा",
 "Achatar": "फ़्लैट करें",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "खर्च सहित सब कुछ देखता है और डायरी में दर्ज करता है।",
 "Acompanhamento": "साइड डिश",
 "Acompanhantes": "साथी",
 "Acrescentar no fim da página": "पेज के अंत में जोड़ें",
 "Adaptador de tomada": "प्लग एडैप्टर",
 "Adestramento": "ट्रेनिंग",
 "Adicionar": "जोड़ें",
 "Adicionar amigo": "दोस्त जोड़ें",
 "Adicionar amigos do app": "ऐप के दोस्त जोड़ें",
 "Adicionar ao Planner?": "Planner में जोड़ें?",
 "Adicionar arquivo": "फ़ाइल जोड़ें",
 "Adicionar cômodo": "कमरा जोड़ें",
 "Adicionar fotos e vídeos": "फ़ोटो और वीडियो जोड़ें",
 "Adicionar imagem": "इमेज जोड़ें",
 "Adicionar item (ex.: 2 ovos mexidos)": "आइटम जोड़ें (जैसे: 2 भुर्जी अंडे)",
 "Adicionar na página": "पेज में जोड़ें",
 "Adicionar passo": "चरण जोड़ें",
 "Adicionar país": "देश जोड़ें",
 "Adicionar página": "पेज जोड़ें",
 "Adicionar texto": "टेक्स्ट जोड़ें",
 "Adicionar {nome}": "{nome} जोड़ें",
 "Adicionar à equipe": "टीम में जोड़ें",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "किसी दोस्त को उसके कोड से जोड़ें या अपना कोड जिसे चाहें उसे भेजें।",
 "Admin": "एडमिन",
 "Administração": "प्रबंधन",
 "Adubar a cada quantos dias": "कितने दिनों में खाद दें",
 "Adubar: {p}": "खाद दें: {p}",
 "Adubei hoje": "आज खाद दी",
 "Advogado": "वकील",
 "Advogados": "वकील",
 "Afundo": "लंज",
 "Agachamento": "स्क्वैट",
 "Agenda do Google": "Google कैलेंडर",
 "Agenda limpa": "एजेंडा साफ़ हो गया",
 "Agenda não liberada": "कैलेंडर की अनुमति नहीं है",
 "Agenda sincronizada ✓": "कैलेंडर सिंक हो गया ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "एजेंडा, नोट्स, वित्त, पढ़ाई, संदेश और बहुत कुछ एक ही ऐप में।",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "अपॉइंटमेंट, मरीज़ों का रिकॉर्ड और भुगतान, मेडिकल रिकॉर्ड के बिना।",
 "Agendado": "शेड्यूल हुआ",
 "Agendado no My Planner": "My Planner में शेड्यूल किया गया",
 "Agendamento no pet shop": "पेट शॉप अपॉइंटमेंट",
 "Agendar": "शेड्यूल करें",
 "Agendar no My Planner": "My Planner में शेड्यूल करें",
 "Agendar no My Planner (dias e horários)": "My Planner में शेड्यूल करें (दिन और समय)",
 "Agora não": "अभी नहीं",
 "Agora o verso do documento.": "अब दस्तावेज़ का पिछला हिस्सा।",
 "Agora, {hora}": "अभी, {hora}",
 "Agora: {ml}": "अभी: {ml}",
 "Aguardando o celular · {s}s": "मोबाइल की प्रतीक्षा · {s} से.",
 "Aguarde": "कृपया प्रतीक्षा करें",
 "Aguarde um pouco": "कृपया थोड़ा रुकें",
 "Aguarde...": "कृपया प्रतीक्षा करें...",
 "Ainda a pagar no mês": "इस महीने अभी देना बाकी",
 "Ainda a receber no mês": "इस महीने अभी मिलना बाकी",
 "Ainda não confirmado": "अभी पुष्टि नहीं हुई",
 "Ainda não disponível: falta configurar no servidor.": "अभी उपलब्ध नहीं: सर्वर पर सेटअप बाकी है।",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "इस महीने आपने अभी तक कुछ नहीं बचाया। पैसा आते ही {v} (आमदनी का 10%) अलग रख दें, कैसा रहेगा?",
 "Ainda não há feriados deste país para este ano.": "इस देश के इस साल के अवकाश अभी उपलब्ध नहीं हैं।",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "इस टैब में अभी साझा करने के लिए कुछ नहीं है। पहले बनाएँ (जैसे: यात्रा) और फिर यहाँ लौटें।",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "समूह में अभी कोई और व्यक्ति नहीं है (या आप सदस्यों की सूची नहीं देख सकते)।",
 "Ainda não marcado como feito. Toque para abrir.": "अभी तक हो गया के रूप में चिह्नित नहीं। खोलने के लिए टैप करें।",
 "Ainda não sincronizado": "अभी सिंक नहीं हुआ",
 "Ainda sem chave neste dispositivo.": "इस डिवाइस पर अभी कोई कुंजी नहीं है।",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking या सीधे: बुकिंग, चेक-आउट पर सफ़ाई, आय, खर्च और महीने का मुनाफ़ा",
 "Ajuda na organização": "आयोजन में मदद",
 "Ajudante": "सहायक",
 "Ajustar": "बदलें",
 "Ajustar a data final": "समाप्ति तिथि बदलें",
 "Ajustar a folha": "पेज एडजस्ट करें",
 "Ajustar tamanho da página": "पेज का आकार बदलें",
 "Ajuste visual": "दिखावट सुधारें",
 "Ajustes": "सेटिंग्स",
 "Alarme dos remédios": "दवा का अलार्म",
 "Alarme que insiste até marcar como tomado": "दवा ली गई चिह्नित करने तक बजता रहने वाला अलार्म",
 "Alemão": "जर्मन",
 "Alergia": "एलर्जी",
 "Alergias": "एलर्जी",
 "Alergias e alertas": "एलर्जी और चेतावनियाँ",
 "Alertas": "अलर्ट",
 "Alertas das tarefas": "कार्यों के अलर्ट",
 "Alertas dos compromissos": "अपॉइंटमेंट अलर्ट",
 "Algo deu errado, mas o app continua aberto": "कुछ गड़बड़ हुई, पर ऐप खुला है",
 "Alguns arquivos foram guardados em outro dispositivo.": "कुछ फ़ाइलें किसी दूसरे डिवाइस पर सहेजी गई हैं।",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "कुछ घड़ियाँ (जैसे Huawei की) Health Connect को डेटा नहीं भेज सकतीं। ऐसे में, हाथ से दर्ज करें।",
 "Alguém": "कोई",
 "Alguém indicou o app para você?": "क्या किसी ने आपको यह ऐप सुझाया है?",
 "Alimentação": "भोजन",
 "Alimentação & Despensa": "भोजन और पैंट्री",
 "Alimentação {semana}": "भोजन {semana}",
 "Alimento": "खाद्य पदार्थ",
 "Alinhamento e balanceamento": "अलाइनमेंट और बैलेंसिंग",
 "Almoço": "दोपहर का भोजन",
 "Alongamento": "स्ट्रेचिंग",
 "Alta": "ऊँची",
 "Alterado por último por {nome}": "अंतिम बदलाव: {nome}",
 "Alterar metadados": "मेटाडेटा बदलें",
 "Alterar o valor pago": "भुगतान की गई राशि बदलें",
 "Alterações": "बदलाव",
 "Alto-falante": "स्पीकर",
 "Aluga como": "किराये पर कैसे",
 "Alugar a casa ou um cômodo": "घर या कमरा किराये पर दें",
 "Aluguel": "किराया",
 "Aluguel & Hospedagem": "किराया और होमस्टे",
 "Aluguel de carro": "किराये की कार",
 "Aluno": "छात्र",
 "Alunos": "छात्र",
 "Alvará ou licença": "परमिट या लाइसेंस",
 "Alvenaria": "चिनाई",
 "Alvo": "लक्ष्य राशि",
 "Alíquota do ISS (%)": "ISS दर (%)",
 "Alíquota do ISS deste serviço (%)": "इस सेवा की ISS दर (%)",
 "Amanhã": "कल",
 "Ambiente": "परिवेश",
 "Ameno": "सुहावना",
 "Amigos": "दोस्त",
 "Amor": "प्यार",
 "Amortização": "मूलधन भुगतान",
 "Ampliar a foto": "फ़ोटो बड़ा करें",
 "Amém": "आमीन",
 "Analisar com IA": "AI से विश्लेषण",
 "Anamnese e histórico (no cofre)": "केस हिस्ट्री और इतिहास (वॉल्ट में)",
 "Anexar arquivos": "फ़ाइलें अटैच करें",
 "Anexar comprovante": "रसीद जोड़ें",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "दस्तावेज़ जोड़ना, स्टेटमेंट इम्पोर्ट करना और रिपोर्ट, PDF व बैकअप सहेजना।",
 "Anexos": "अटैचमेंट",
 "Anexos guardados aqui no dispositivo: {n}": "इस डिवाइस में सहेजे गए अटैचमेंट: {n}",
 "Animais e natureza": "जानवर और प्रकृति",
 "Animação": "एनिमेशन",
 "Anime": "एनीमे",
 "Aniversário": "जन्मदिन",
 "Aniversário de Campo Grande": "Campo Grande स्थापना दिवस",
 "Aniversário de São Paulo": "São Paulo स्थापना दिवस",
 "Ano": "वर्ष",
 "Ano anterior": "पिछला वर्ष",
 "Ano de lançamento": "रिलीज़ वर्ष",
 "Ano de {ano}": "वर्ष {ano}",
 "Ano passado": "पिछला वर्ष",
 "Anotar pela foto da página": "पेज की फ़ोटो से नोट बनाएँ",
 "Anotação": "नोट",
 "Anotação de {data}": "{data} का नोट",
 "Anotação do professor": "शिक्षक का नोट",
 "Anotação à mão": "हाथ से लिखा नोट",
 "Anotações": "नोट्स",
 "Anotações Rápidas": "क्विक नोट्स",
 "Anotações arquivadas": "संग्रहीत नोट्स",
 "Anotações arquivadas ({n})": "संग्रहीत नोट्स ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "हर बुकिंग की तारीखें, स्रोत और राशि लिखें। चेक-आउट की सफ़ाई अपने-आप सफ़ाई सूची में जुड़ जाती है।",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "निर्माण कार्य का रोज़ का हाल फ़ोटो के साथ लिखें। प्रगति देखने के लिए फ़ोटो को पहले या बाद में चिह्नित करें।",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "जो उधार दिया या लिया, उसे फ़ोटो और समय-सीमा के साथ लिखें। लौटाने के दिन ऐप याद दिलाएगा।",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "जिन जगहों पर जाना चाहते हैं, उन्हें लिख लें। Google Maps या Waze में खोजें, सभी से होकर जाने वाला रास्ता बनाएँ और उन्हें दिन के यात्रा कार्यक्रम में जोड़ें।",
 "Anteriores ({n})": "पिछली ({n})",
 "Antes": "पहले",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "शुरू करने से पहले देख लें कि ऐप क्या इस्तेमाल करता है और क्यों। आप बाद में सेटिंग्स > गोपनीयता और शर्तें में सब कुछ बदल सकते हैं।",
 "Antes de uma data": "किसी तारीख से पहले",
 "Antes do início": "शुरू होने से पहले",
 "Antes e depois": "पहले और बाद में",
 "Antes: {lista}": "पहले: {lista}",
 "Antipulgas": "पिस्सू-रोधी",
 "Anual": "सालाना",
 "Ao ar livre": "खुले में",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "रद्द करने पर टैब श्वेत-श्याम हो जाता है और कार्यों से लिंक हट जाते हैं, लेकिन कुछ भी मिटाया नहीं जाता।",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "खाता बनाकर या ऐप का उपयोग जारी रखकर, आप इन शर्तों और नीचे दी गई गोपनीयता नीति से सहमत होते हैं।",
 "Ao fechar, a página é salva.": "बंद करने पर पेज सहेज लिया जाता है।",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "सहेजते ही वॉल्ट पासवर्ड बन जाएगा। यह फ़ील्ड डिवाइस पर एन्क्रिप्ट होती है।",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "पढ़ाई और दस्तावेज़ में \"फ़ाइल\" या \"फ़ोटो\" पर टैप करने पर फ़ोन का चयनकर्ता Google Drive, OneDrive और Dropbox दिखाता है (अगर ये ऐप इंस्टॉल हों)। फ़ाइल सीधे वहीं से चुनें।",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "अटैच की गई फ़ाइल पर टैप करने से वह आपके चुने हुए फ़ोन ऐप में खुलती है (Android पर \"सिर्फ़ एक बार\" या \"हमेशा\")। वहाँ किया गया बदलाव फ़ाइल में ही सेव होता है।",
 "Apaga a conta e todos os vencimentos dela.": "यह बिल और इसकी सभी देय तिथियाँ हटाता है।",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "इस फ़ाइल के विषय और पेज मिट जाएँगे। प्लानर के कार्य बने रहेंगे।",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "इस विषय के पेज मिट जाएँगे। पढ़ाई का समय इतिहास में बना रहेगा।",
 "Apaga o cartão e as compras dele.": "यह कार्ड और इसकी खरीदारी हटाता है।",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "खाता और क्लाउड व इस डिवाइस का सारा डेटा हमेशा के लिए मिट जाएगा। इसे वापस नहीं लाया जा सकता।",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "एजेंडा के सभी कार्य हटाता है, पिछले और आने वाले दोनों।",
 "Apaga todas as {n} parcelas.": "सभी {n} किस्तें हटा देता है।",
 "Apaga todos os meses desta conta.": "इस बिल के सभी महीने मिट जाएँगे।",
 "Apagar": "मिटाएँ",
 "Apagar \"{nome}\"?": "\"{nome}\" मिटाएँ?",
 "Apagar a caixa?": "बॉक्स मिटाएँ?",
 "Apagar a chave": "कुंजी मिटाएँ",
 "Apagar a chave deste dispositivo?": "इस डिवाइस से कुंजी मिटाएँ?",
 "Apagar a conta?": "खाता मिटाएँ?",
 "Apagar a lista de erros?": "त्रुटियों की सूची मिटाएँ?",
 "Apagar a pasta (os documentos continuam)": "फ़ोल्डर हटाएं (दस्तावेज़ बने रहेंगे)",
 "Apagar as da agenda": "कैलेंडर वाले हटाएं",
 "Apagar caixa": "बॉक्स मिटाएँ",
 "Apagar de verdade (as páginas com tarja viram imagem)": "सच में मिटाएँ (काली पट्टी वाले पेज इमेज बन जाते हैं)",
 "Apagar de vez": "हमेशा के लिए हटाएँ",
 "Apagar desenho": "ड्रॉइंग मिटाएँ",
 "Apagar envio": "भेजा गया हटाएँ",
 "Apagar lista": "सूची मिटाएँ",
 "Apagar minha conta": "मेरा खाता हटाएँ",
 "Apagar minha conta e todos os dados": "मेरा खाता और सारा डेटा मिटाएँ",
 "Apagar o escritório": "ऑफ़िस मिटाएँ",
 "Apagar o escritório?": "ऑफ़िस मिटाएँ?",
 "Apagar o grupo": "समूह हटाएँ",
 "Apagar o grupo?": "समूह हटाएँ?",
 "Apagar o lançamento?": "यह प्रविष्टि मिटाएँ?",
 "Apagar para todos": "सभी के लिए हटाएँ",
 "Apagar tudo": "सब मिटाएँ",
 "Apagar tudo antes de": "इससे पहले का सब हटाएँ",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "आज के, इस महीने के, किसी अवधि के या नाम से कार्य एक बार में हटाएँ। हटाने से पहले ऐप दिखाता है कि क्या हटेगा और आपका पासवर्ड माँगता है।",
 "Aparece na barra quando estiver liberada": "उपलब्ध होने पर बार में दिखेगा",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "ये Planner में दिखते हैं, वैकल्पिक अवकाशों (कार्निवल, ऐश वेडनेसडे और कॉर्पस क्रिस्टी) के साथ।",
 "Aplicar": "लागू करें",
 "Aponte a câmera do celular para este QR Code.": "मोबाइल का कैमरा इस QR कोड की ओर करें।",
 "Aponte para o QR Code na tela do computador": "कंप्यूटर स्क्रीन पर दिख रहे QR कोड की ओर करें",
 "Apostila": "अध्ययन सामग्री",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "अध्ययन सामग्री, अभ्यास सूचियाँ, स्लाइड, वीडियो, लिंक और संदेश। ⋮ › समूह को भेजें से हर छात्र को अपने ऐप में मिल जाता है।",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "पतों पर \"रास्ता\" बटन के लिए ऐप (कार्य, अपॉइंटमेंट, यात्रा कार्यक्रम, निर्माण कार्य, स्कूल...)।",
 "Apple Saúde": "Apple Health",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: यह पहले से सब कुछ iPhone के Health ऐप में सेव करती है। कुछ करने की ज़रूरत नहीं।",
 "Apresentação": "प्रस्तुति",
 "Aprovação": "मंज़ूरी",
 "Aqui": "यहाँ",
 "Ar-condicionado": "एयर-कंडीशनर",
 "Arco-íris": "इंद्रधनुष",
 "Arenoso": "रेतीली",
 "Armazenamento": "स्टोरेज",
 "Armário": "अलमारी",
 "Arquivadas ({n})": "संग्रहीत ({n})",
 "Arquivados ({n})": "संग्रहित ({n})",
 "Arquivar": "संग्रहीत करें",
 "Arquivar a caixa de anotações?": "नोट्स का बॉक्स संग्रहित करें?",
 "Arquivar conversa": "चैट संग्रहीत करें",
 "Arquivo": "फ़ाइल",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "फ़ाइल (Drive, OneDrive, Dropbox या डिवाइस से)",
 "Arquivo OFX ou CSV do banco": "बैंक की OFX या CSV फ़ाइल",
 "Arquivo adicionado": "फ़ाइल जोड़ दी गई",
 "Arquivo menor (para WhatsApp e e-mail)": "छोटी फ़ाइल (WhatsApp और ईमेल के लिए)",
 "Arquivo menor para WhatsApp e e-mail.": "WhatsApp और ईमेल के लिए छोटी फ़ाइल।",
 "Arquivo não encontrado.": "फ़ाइल नहीं मिली।",
 "Arquivo ou PDF": "फ़ाइल या PDF",
 "Arquivo ou documento": "फ़ाइल या दस्तावेज़",
 "Arquivos": "फ़ाइलें",
 "Arquivos (frente, verso, PDF)": "फ़ाइलें (आगे, पीछे, PDF)",
 "Arquivos (importar e exportar)": "फ़ाइलें (इम्पोर्ट और एक्सपोर्ट)",
 "Arquivos de {nome}": "{nome} की फ़ाइलें",
 "Arquivos na nuvem e cópias de segurança": "क्लाउड में फ़ाइलें और बैकअप",
 "Arrasou!": "कमाल कर दिया!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "बिंदुओं को पेज के 4 कोनों तक खींचें। ऐप पेज को काटकर सीधा कर देता है।",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "जो छिपाना है उस पर उंगली खींचें। पट्टी हटाने के लिए उस पर टैप करें।",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "हटाने के लिए दाएँ स्वाइप करें, या दूसरे टैब में भेजने के लिए बाएँ।",
 "Arraste para a direita para excluir.": "हटाने के लिए दाईं ओर स्वाइप करें।",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "क्रम बदलने के लिए खींचें, घुमाएँ, डुप्लिकेट करें, हटाएँ और खाली पेज जोड़ें।",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "बोर्ड का बाकी हिस्सा देखने के लिए खींचें। यह नीचे और दाईं ओर बढ़ता है।",
 "Arraste um documento para a direita para excluir.": "हटाने के लिए किसी दस्तावेज़ को दाईं ओर स्वाइप करें।",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "संग्रहीत करने के लिए बॉक्स को बाईं ओर और हटाने के लिए दाईं ओर स्वाइप करें।",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "संग्रहीत करने के लिए बॉक्स को बाईं ओर, हटाने के लिए दाईं ओर खींचें। क्रम बदलने के लिए ⋮⋮ दबाकर रखें।",
 "Arroz": "चावल",
 "Artes": "कला",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Claude Pro, ChatGPT Plus और Gemini Advanced की सदस्यताएँ दूसरे ऐप इस्तेमाल नहीं कर सकते। यहाँ AI चालू करने के लिए अपने खाते में API कुंजी बनाएँ (Gemini का मुफ़्त उपयोग है; Claude और ChatGPT उपयोग के हिसाब से शुल्क लेते हैं, हर विश्लेषण के कुछ पैसे)।",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "सर्वर पर कॉल अभी चालू नहीं की गई हैं (17-LIGAR-MENSAGENS.bat)।",
 "As compras dele também saem das Finanças.": "इसकी खरीदारियाँ भी वित्त से हट जाएँगी।",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "किस्तों वाली खरीदारी सभी किस्तों के साथ दर्ज होती है: अगली किस्तें आगे के कार्ड बिलों में दिखती हैं।",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "इस दस्तावेज़ की फ़ोटो उस डिवाइस में हैं जिस पर इसे स्कैन किया गया था। वहां आप इसे एडिट, शेयर कर सकते हैं और टेक्स्ट पढ़ सकते हैं।",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "इमेज केवल आपके चुने हुए AI को, आपकी अपनी की के साथ भेजी जाती हैं।",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "चेक-आउट की सफ़ाई यहाँ अपने-आप दिखती है, चेकलिस्ट और पहले-बाद की फ़ोटो के साथ।",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "यहाँ जारी किए गए इनवॉइस, खोज में मिले इनवॉइस और आयात किए गए XML इस सूची में दिखते हैं।",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "किस्तें यहाँ दिखती हैं। हर किस्त में रसीद (फ़ोटो, PDF या PIX का स्क्रीनशॉट) जोड़ें।",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "अगले 12 महीनों की किस्तें My Planner में पहले से हैं।",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "बाकी किस्तें अनुबंध की मौजूदा राशि, ब्याज और अवधि से फिर से बनाई जाती हैं। चुकाई गई किस्तें नहीं बदलतीं।",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "इस दस्तावेज़ के पेज उस डिवाइस में हैं जिस पर इसे स्कैन किया गया था। इसे वहीं खोलें या Drive या OneDrive में सेव की गई कॉपी इस्तेमाल करें।",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "पेज हल्की इमेज बन जाते हैं: स्कैन किए गए PDF के लिए बढ़िया। टेक्स्ट खोजने लायक नहीं रहता (ज़रूरत हो तो बाद में OCR इस्तेमाल करें)।",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "पेज सिर्फ़ आपके चुने AI को, आपकी अपनी कुंजी से भेजे जाते हैं।",
 "As receitas do cardápio já têm tudo na despensa.": "मेनू की रेसिपी का सारा सामान पैंट्री में मौजूद है।",
 "As senhas novas não conferem.": "नए पासवर्ड मेल नहीं खाते।",
 "As senhas não conferem.": "पासवर्ड मेल नहीं खाते।",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "टास्क My Planner में बने रहेंगे। क्या आप Google कैलेंडर से आए टास्क भी हटाना चाहते हैं?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "कमरे के कार्य मेरा घर में बिना कमरे के बने रहेंगे।",
 "As tarefas vinculadas continuam no My Planner.": "जुड़े हुए कार्य My Planner में बने रहेंगे।",
 "Aspirar e passar pano": "वैक्यूम और पोछा",
 "Assinada": "सदस्यता ली गई",
 "Assinar": "हस्ताक्षर करें",
 "Assinar (simulação de teste)": "सदस्यता लें (परीक्षण सिमुलेशन)",
 "Assinar o documento": "दस्तावेज़ पर हस्ताक्षर करें",
 "Assinatura": "हस्ताक्षर",
 "Assinatura do profissional": "पेशेवर के हस्ताक्षर",
 "Assinatura e segurança": "हस्ताक्षर और सुरक्षा",
 "Assinaturas (simulação de teste)": "सदस्यताएँ (परीक्षण सिमुलेशन)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "इस टैब में नोट्स भेजने के लिए सेटिंग्स में इसकी सदस्यता लें।",
 "Assine a aba em Ajustes para vincular.": "लिंक करने के लिए सेटिंग्स में टैब की सदस्यता लें।",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "इस टैब में नोट्स भेजने के लिए सेटिंग्स › खरीदारी में इसकी सदस्यता लें।",
 "Assine a aba em Ajustes › Compras para vincular.": "लिंक करने के लिए सेटिंग्स › खरीदारी में टैब की सदस्यता लें।",
 "Assine a aba para abrir o vínculo.": "लिंक खोलने के लिए टैब की सदस्यता लें।",
 "Assisti mais uma aula": "एक और क्लास देखी",
 "Assistido": "देख लिया",
 "Assistindo": "देख रहे हैं",
 "Assistência técnica (nome)": "सर्विस सेंटर (नाम)",
 "Assistência: {nome}": "सर्विस सेंटर: {nome}",
 "Assunto": "विषय",
 "Assunto (ex.: Reunião semanal)": "विषय (जैसे: साप्ताहिक मीटिंग)",
 "Atender": "उठाएँ",
 "Atendimento": "अपॉइंटमेंट",
 "Atendimentos": "अपॉइंटमेंट",
 "Ativar avisos": "सूचनाएँ चालू करें",
 "Ativar monitor": "मॉनिटर चालू करें",
 "Ativas": "सक्रिय",
 "Atividade": "काम",
 "Atividade do roteiro": "यात्रा कार्यक्रम की गतिविधि",
 "Atividade hoje": "आज की गतिविधि",
 "Atividade: {blocos}": "गतिविधि: {blocos}",
 "Atividades": "गतिविधियाँ",
 "Atividades de hoje": "आज की गतिविधियाँ",
 "Atividades e materiais": "गतिविधियाँ और सामग्री",
 "Atividades físicas e saúde": "व्यायाम और स्वास्थ्य",
 "Atrasada": "बकाया",
 "Atrasada há {n} dia(s)": "{n} दिन से देरी",
 "Atrasadas": "बकाया",
 "Atrasados": "देर से",
 "Atuais": "मौजूदा",
 "Atualidades": "समसामयिकी",
 "Atualizar": "अपडेट करें",
 "Atualizar agora": "अभी अपडेट करें",
 "Atualizar alarmes no My Planner": "My Planner में अलार्म अपडेट करें",
 "Atualizar rega e adubo na agenda": "एजेंडा में पानी और खाद अपडेट करें",
 "Atualização automática disponível no app instalado (APK).": "स्वचालित अपडेट इंस्टॉल किए गए ऐप (APK) में उपलब्ध है।",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "अपडेट डाउनलोड हो गया। ऐप दोबारा खोलने या सूचना पर टैप करने पर लागू होगा।",
 "Atualização pronta": "अपडेट तैयार है",
 "Atualizações": "अपडेट",
 "Até": "तक",
 "Audiência": "सुनवाई",
 "Aula dada": "क्लास हो गई",
 "Aula {a} de {n} ({p}%)": "पाठ {a} / {n} ({p}%)",
 "Aulas assistidas": "देखी गई क्लास",
 "Autoajuda": "स्वयं सहायता",
 "Autor": "लेखक",
 "Avaliação": "मूल्यांकन",
 "Avaliações e notas": "मूल्यांकन और अंक",
 "Avançado": "उन्नत",
 "Aveia": "ओट्स",
 "Avisar a hora de sair": "निकलने के समय की याद दिलाएँ",
 "Avisar antes de vencer": "समाप्ति से पहले सूचित करें",
 "Avisar no celular quando alguém incluir algo": "जब कोई कुछ जोड़े तो फ़ोन पर सूचना दें",
 "Aviso": "सूचना",
 "Aviso com as tarefas do dia": "दिन के कार्यों की सूचना",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "सर्वर ने टेस्ट सूचना भेजी है। यह कुछ सेकंड में आएगी; फ़ोन की सूचना बार में देखने के लिए ऐप से बाहर निकलें।",
 "Aviso enviado": "सूचना भेजी गई",
 "Aviso {dias} dia(s) antes e no dia": "{dias} दिन पहले और उसी दिन सूचना",
 "Avisos no celular": "फ़ोन पर सूचनाएँ",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "फ़ोन पर सूचनाएँ Expo, Google और Apple की सेवाओं से होकर जाती हैं।",
 "Ação": "एक्शन",
 "Ações": "शेयर",
 "BOLETO E DOCUMENTOS": "बोलेटो और दस्तावेज़",
 "Backup importado.": "बैकअप इम्पोर्ट हो गया।",
 "Bairro": "मोहल्ला",
 "Baixa": "कम",
 "Baixando atualização...": "अपडेट डाउनलोड हो रहा है...",
 "Baixar": "डाउनलोड करें",
 "Baixar a versão {v}": "संस्करण {v} डाउनलोड करें",
 "Baixar agora": "अभी डाउनलोड करें",
 "Baixar o My Planner para Android": "Android के लिए My Planner डाउनलोड करें",
 "Baixar o My Planner para Android (versão {v})": "Android के लिए My Planner डाउनलोड करें (वर्ज़न {v})",
 "Baixar o My Planner para iPhone": "iPhone के लिए My Planner डाउनलोड करें",
 "Baixar o PDF da nota (DANFSe)": "इनवॉइस का PDF डाउनलोड करें (DANFSe)",
 "Baixar o PDF?": "PDF डाउनलोड करें?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "पूरा XML डाउनलोड करें (SEFAZ को सूचना जाती है)",
 "Baixe a versão mais recente para Android: {apk}": "नवीनतम Android संस्करण डाउनलोड करें: {apk}",
 "Baixe aqui a versão mais recente: {link}": "नवीनतम वर्ज़न यहाँ डाउनलोड करें: {link}",
 "Balança": "झूलना",
 "Balanço e relatórios": "बैलेंस शीट और रिपोर्ट",
 "Banana": "केला",
 "Banco": "बैंक",
 "Banco, financeira ou pessoa": "बैंक, वित्त कंपनी या व्यक्ति",
 "Bandeiras": "झंडे",
 "Banheiro": "बाथरूम",
 "Banho": "नहलाना",
 "Banho e tosa": "नहलाना और ग्रूमिंग",
 "Barra": "बार",
 "Bateria": "बैटरी",
 "Batimentos (média)": "धड़कन (औसत)",
 "Batizado": "नामकरण संस्कार",
 "Bebida": "पेय",
 "Bebê": "शिशु",
 "Beijo": "किस",
 "Bem": "संपत्ति",
 "Bem clara": "बहुत हल्का",
 "Bem-Estar": "सेहत",
 "Bem-Estar · Cronograma alimentar": "वेलनेस · भोजन योजना",
 "Bens": "संपत्तियाँ",
 "Bichos e diversão": "जानवर और मनोरंजन",
 "Bicicleta": "साइकिल",
 "Bicicleta ergométrica": "एक्सरसाइज़ बाइक",
 "Biografia": "जीवनी",
 "Biologia": "जीव विज्ञान",
 "Biometria (digital ou rosto)": "बायोमेट्रिक (फ़िंगरप्रिंट या चेहरा)",
 "Biometria ({tipos})": "बायोमेट्रिक ({tipos})",
 "Biometria não confirmada.": "बायोमेट्रिक पुष्टि नहीं हुई।",
 "Bloqueado": "ब्लॉक किया गया",
 "Bloquear": "ब्लॉक करें",
 "Bloquear agora": "अभी लॉक करें",
 "Bloqueio": "ब्लॉक",
 "Blusas de frio": "गर्म कपड़े",
 "Boa noite": "शुभ रात्रि",
 "Boa sorte!": "ऑल द बेस्ट!",
 "Boas-vindas ao My Planner": "My Planner में आपका स्वागत है",
 "Boas-vindas pelo WhatsApp": "WhatsApp पर स्वागत संदेश",
 "Boleto": "बोलेटो (बिल)",
 "Boleto anexado": "बोलेटो जोड़ा गया",
 "Boleto do banco {b}": "बैंक {b} का बोलेटो",
 "Boleto e documentos (foto, PDF ou arquivo)": "बोलेटो और दस्तावेज़ (फ़ोटो, PDF या फ़ाइल)",
 "Boleto ou conta (foto, PDF ou arquivo)": "बोलेटो या बिल (फ़ोटो, PDF या फ़ाइल)",
 "Boleto por foto": "फ़ोटो से बोलेटो",
 "Bolinha": "गोला",
 "Bom dia": "सुप्रभात",
 "Bom dia!": "सुप्रभात!",
 "Bom dia! Seu dia no My Planner": "सुप्रभात! My Planner में आपका दिन",
 "Booking": "Booking",
 "Bora!": "चलो!",
 "Borboleta": "तितली",
 "Borracha": "रबड़",
 "Botas para neve": "बर्फ़ के जूते",
 "Brasil": "ब्राज़ील",
 "Braços acima da cabeça": "बाँहें सिर के ऊपर",
 "Brilho": "चमक",
 "Brinquedo ou livro para a viagem": "यात्रा के लिए खिलौना या किताब",
 "Busca de notas": "इनवॉइस खोज",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Querido Diário (Open Knowledge Brasil) द्वारा एकत्र किए गए नगरपालिका राजपत्रों में नाम खोजता है। सभी नगरपालिकाएँ शामिल नहीं हैं, और आधिकारिक राजपत्र DJEN का हिस्सा नहीं हैं।",
 "Buscando...": "खोज रहे हैं...",
 "Buscar": "खोजें",
 "Buscar GIF (ex.: parabéns, bom dia)": "GIF खोजें (जैसे: बधाई, सुप्रभात)",
 "Buscar cidade, país ou GMT": "शहर, देश या GMT खोजें",
 "Buscar conversa": "चैट खोजें",
 "Buscar documento, titular ou órgão": "दस्तावेज़, धारक या जारीकर्ता खोजें",
 "Buscar em {nome}": "{nome} में खोजें",
 "Buscar emoji (ex.: coração, risada)": "इमोजी खोजें (जैसे: दिल, हँसी)",
 "Buscar figurinha": "स्टिकर खोजें",
 "Buscar notas": "इनवॉइस खोजें",
 "Buscar ou digitar um alimento": "खाद्य पदार्थ खोजें या लिखें",
 "Buscar país": "देश खोजें",
 "Buscar pelo nome ou pelo texto": "नाम या टेक्स्ट से खोजें",
 "Buscar produto, loja ou observação": "उत्पाद, दुकान या टिप्पणी खोजें",
 "Buscar tarefas": "कार्य खोजें",
 "Buscar: processo, parte, tribunal, palavra...": "खोजें: मुक़दमा, पक्ष, न्यायालय, शब्द...",
 "CAIXA {n}": "बॉक्स {n}",
 "CARDS DE ANOTAÇÕES": "नोट कार्ड",
 "CARTÕES": "कार्ड",
 "CEP": "CEP (पिन कोड)",
 "CID (se o paciente pedir na declaração)": "CID (अगर मरीज़ घोषणा में चाहे)",
 "CID: {c}": "CID: {c}",
 "CNH": "CNH (ड्राइविंग लाइसेंस)",
 "CNPJ (se tiver)": "CNPJ (अगर हो)",
 "CNPJ ou CPF": "CNPJ या CPF",
 "COMPROVANTE DE PAGAMENTO": "भुगतान की रसीद",
 "COMPROVANTE DE RECEBIMENTO": "प्राप्ति की रसीद",
 "COMPROVANTES ANTERIORES": "पिछली रसीदें",
 "CONTAS DO MÊS": "इस महीने के बिल",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (ब्राज़ील)",
 "CPF de quem paga": "भुगतान करने वाले का CPF",
 "CPF do paciente": "मरीज़ का CPF",
 "CPF do pagador": "भुगतानकर्ता का CPF",
 "CPF inválido": "अमान्य CPF",
 "CPF ou CNPJ de quem recebeu": "भुगतान पाने वाले का CPF या CNPJ",
 "CPF ou senha incorretos.": "CPF या पासवर्ड गलत है।",
 "CRIAR CÔMODO": "कमरा बनाएँ",
 "CRIAR UM GRUPO": "समूह बनाएँ",
 "CRONOGRAMA ALIMENTAR": "भोजन समय-सारणी",
 "CUIDADOS PESSOAIS": "व्यक्तिगत देखभाल",
 "Cabeleireiro": "हेयरड्रेसर",
 "Cabelo": "बाल",
 "Cachorro": "कुत्ता",
 "Cactos e suculentas": "कैक्टस और सक्युलेंट",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "हर अतिरिक्त टैब: {n} दिन मुफ़्त; फिर {preco} प्रति वर्ष।",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "हर तैयार फ़ाइल {nome} में जाती है। खोले गए PDF इस डिवाइस पर नीचे की सूची में भी रहते हैं।",
 "Cada dia da semana": "सप्ताह का हर दिन",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "हर नया दस्तावेज़ उससे बाहर निकलते ही {nome} में चला जाता है। पेजों की फ़ोटो सिर्फ़ इसी डिवाइस में रहती हैं।",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "टीम के हर व्यक्ति को मीटिंग प्राप्त में मिलती है और वह एक टैप में अलर्ट के साथ उसे Planner में जोड़ सकता है।",
 "Cada pessoa do grupo recebe e decide se aceita.": "समूह के हर व्यक्ति को यह मिलेगा और वह तय करेगा कि स्वीकार करे या नहीं।",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "हर पेज में एक सारांश, कक्षा या अध्याय रहता है। पूरा होने पर उसे दोहराया हुआ चिह्नित करें।",
 "Cada página vira uma imagem JPG.": "हर पेज एक JPG इमेज बन जाता है।",
 "Cada refeição se repete nos dias dela": "हर भोजन अपने तय दिनों में दोहराया जाता है",
 "Cadastrar": "जोड़ें",
 "Cadastrar cartão de crédito": "क्रेडिट कार्ड जोड़ें",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "फ़ोटो से जोड़ें (कोर्स का पेज, प्रमाणपत्र, पर्चा)",
 "Cadastrar pela foto da capa": "कवर की फ़ोटो से जोड़ें",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "\"मेरी जानकारी\" भरें ताकि रसीदों पर आपका नाम, परिषद और नंबर आए।",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "RG, CNH, पासपोर्ट, अनुबंध और प्रमाणपत्र जोड़ें। ऐप समाप्ति से पहले सूचित करता है और एक टैप में दस्तावेज़ भेजता है।",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "कंपनी (या पेशेवर के रूप में खुद को) CNPJ या CPF, नगर और कर व्यवस्था के साथ दर्ज करें। फिर A1 प्रमाणपत्र जोड़ें, ताकि Padrão Nacional से NFS-e जारी कर सकें और जारी व प्राप्त इनवॉइस खोज सकें।",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "निर्माण कार्य दर्ज करें और उसके अंदर बजट वाले चरण, फ़ोटो वाली डायरी, कारीगर और सामग्री की डिलीवरी जोड़ें।",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "यात्रा दर्ज करें और उसके अंदर हर दिन का कार्यक्रम, बुकिंग और सामान जोड़ें। यात्रा के दौरान कार्यक्रम My Planner में दिखता है।",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "केवल अपना नाम और अपना OAB नंबर दर्ज करें।",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "बच्चों को दर्ज करें: परीक्षा, मीटिंग, डॉक्टर विज़िट और टीके हर बच्चे के अंदर रहते हैं।",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "हर पालतू को दर्ज करें: टीकाकरण कार्ड, कृमिनाशक, दवाएँ और पेट शॉप उसी के अंदर रहते हैं।",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "हर पौधे को रोशनी, मिट्टी और कितने-कितने दिन में पानी व खाद देनी है, के साथ दर्ज करें। ऐप एजेंडा में कैलेंडर बना देता है।",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "हर वाहन दर्ज करें। उसके अंदर मेंटेनेंस (किमी और तारीख के हिसाब से सूचना) और IPVA, लाइसेंसिंग व बीमा की नियत तारीखें रहती हैं।",
 "Cadastre digital ou rosto no aparelho para usar.": "उपयोग के लिए डिवाइस में फ़िंगरप्रिंट या फ़ेस दर्ज करें।",
 "Cadastre o cartão primeiro": "पहले कार्ड जोड़ें",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "फ़ाइनेंसिंग या ऋण को राशि, ब्याज और किस्तों की संख्या के साथ दर्ज करें। ऐप किस्तें और बकाया राशि निकालता है और देय तारीखों की याद दिलाता है।",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "पूरी प्रॉपर्टी या किराये पर दिया हर कमरा दर्ज करें। हर एक के अंदर बुकिंग, सफ़ाई और खर्च रहते हैं।",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "किताब के कुल पेज और रोज़ का लक्ष्य दर्ज करें। पढ़े गए पेज जोड़ने के लिए ⋮ पर टैप करें।",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "दवा और उसके समय दर्ज करें, फिर अलार्म के साथ टाइमलाइन में रखने के लिए ⋮ पर टैप करें।",
 "Cadastre os alunos da turma na aba Alunos.": "छात्र टैब में कक्षा के छात्र दर्ज करें।",
 "Cadastre os clientes para separar as horas.": "घंटे अलग-अलग रखने के लिए क्लाइंट दर्ज करें।",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "उन ग्राहकों को दर्ज करें जिन्हें आप इनवॉइस देते हैं। पता वैकल्पिक है (भरें तो CEP, IBGE कोड, सड़क, नंबर और मोहल्ला डालें)।",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "जो सेवाएँ आप सबसे ज़्यादा जारी करते हैं, उन्हें राष्ट्रीय कर कोड के साथ दर्ज करें। जारी करते समय बस टैप करें।",
 "Cadastre primeiro em {nome}.": "पहले {nome} में दर्ज करें।",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "अपना नाम, परिषद और पंजीकरण नंबर दर्ज करें। ये रसीदों और घोषणाओं पर आते हैं।",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "यहाँ चुनने के लिए कंपनी के \"सेवा प्राप्तकर्ता\" टैब में अपने ग्राहक दर्ज करें।",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "दस्तावेज़ पर आने के लिए \"मेरी जानकारी\" में अपनी पेशेवर जानकारी (नाम, परिषद और नंबर) भरें।",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "रसीद पर आने के लिए \"मेरी जानकारी\" में अपनी पेशेवर जानकारी (नाम, परिषद और नंबर) भरें।",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "अपने मरीज़ दर्ज करें। हर एक के अंदर अपॉइंटमेंट रहते हैं, प्रगति नोट्स, पर्चा, भुगतान, रसीद और बीमा के लिए घोषणा के साथ।",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "खुद को और परिवार के हर सदस्य को दर्ज करें। हर एक के अंदर डॉक्टर विज़िट, जाँचें, टीके और दवाएँ रहती हैं। संवेदनशील डेटा एन्क्रिप्टेड वॉल्ट में जाता है।",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "पंजीकरण स्वीकृति की प्रतीक्षा में है: Supabase में \"Confirm email\" बंद करें (COMO RODAR देखें)।",
 "Cadastro recebido": "पंजीकरण प्राप्त हुआ",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "पंजीकरण: नाम, CPF या ईमेल, पासवर्ड (केवल सुरक्षित रूप में रखा जाता है) और संपर्क ईमेल।",
 "Cadastros": "रजिस्टर",
 "Cadastros e comprovantes": "रजिस्टर और रसीदें",
 "Cadeira extensora": "लेग एक्सटेंशन",
 "Café": "कॉफ़ी",
 "Café da manhã": "नाश्ता",
 "Café ou bar": "कैफ़े या बार",
 "Café?": "कॉफ़ी?",
 "Cafés": "कैफ़े",
 "Caixa": "बॉक्स",
 "Caixa arquivada": "संग्रहीत बॉक्स",
 "Caixa com checklist, lista ou texto livre": "चेकलिस्ट, सूची या मुक्त टेक्स्ट वाला बॉक्स",
 "Caixa {n}": "बॉक्स {n}",
 "Caixas": "बॉक्स",
 "Caixas e cronograma da mudança.": "सामान के डिब्बे और शिफ्टिंग का कार्यक्रम।",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "कमरे के हिसाब से लेबल वाले बॉक्स, पानी, बिजली और इंटरनेट का ट्रांसफ़र, निरीक्षण और दिनों की समय-सारणी।",
 "Calculadora": "कैलकुलेटर",
 "Calculando...": "गणना हो रही है...",
 "Calendário": "कैलेंडर",
 "Calendário da planta": "पौधे का कैलेंडर",
 "Calendário do imposto": "टैक्स कैलेंडर",
 "Calendários": "कैलेंडर",
 "Calorias em atividade": "गतिविधि कैलोरी",
 "Calorias gastas em atividade (kcal)": "गतिविधि में खर्च कैलोरी (kcal)",
 "Calça térmica (segunda pele)": "थर्मल पैंट (इनर)",
 "Calças ou bermudas": "पैंट या शॉर्ट्स",
 "Cama": "बिस्तर",
 "Caminhada": "पैदल चलना",
 "Caminhão": "ट्रक",
 "Camisetas": "टी-शर्ट",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "फ़ॉर्म फ़ील्ड",
 "Cancelada": "रद्द",
 "Canceladas": "रद्द",
 "Cancelar": "रद्द करें",
 "Cancelar a NFS-e": "NFS-e रद्द करें",
 "Cancelar a NFS-e {n}?": "NFS-e {n} रद्द करें?",
 "Cancelar a nota": "इनवॉइस रद्द करें",
 "Cancelar a reunião \"{nome}\"?": "मीटिंग \"{nome}\" रद्द करें?",
 "Cancelar reunião": "मीटिंग रद्द करें",
 "Caneta": "पेन",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "सर्वर द्वारा स्वचालित कैप्चर: हर 2 घंटे में, 08:00 से 20:00 तक",
 "Captura automática: todos os dias às 08h e 12h": "स्वचालित संग्रह: हर दिन 08:00 और 12:00 बजे",
 "Card": "कार्ड",
 "Cardápio": "मेनू",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "हफ़्ते का मेनू, रेसिपी, अपने-आप बनने वाली खरीदारी सूची और पैंट्री की एक्सपायरी।",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "मेनू सिर्फ़ इस दिन के लिए। बाकी दिनों में हफ़्ते का मेनू ही रहेगा।",
 "Carga (kg)": "वज़न (kg)",
 "Carimbo": "मुहर",
 "Carnaval": "कार्निवल",
 "Carne magra": "कम चर्बी वाला मांस",
 "Carregando feriados...": "अवकाश लोड हो रहे हैं...",
 "Carregando...": "लोड हो रहा है...",
 "Carro": "कार",
 "Carta": "लेटर",
 "Carteira": "बटुआ",
 "Carteira de trabalho": "वर्क कार्ड",
 "Carteira profissional (OAB, CRC, CREA...)": "पेशेवर कार्ड (OAB, CRC, CREA...)",
 "Cartão": "कार्ड",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "संदेश का संपर्क कार्ड: फ़ोटो, फ़ोन, ईमेल और वह स्टेटस जो आप खुद जोड़ना चुनें। इसे सिर्फ़ वे लोग देख सकते हैं जो आपसे चैट करते हैं, आपके दोस्त और जो ऐप के किसी ग्रुप में आपके साथ हैं।",
 "Cartão de crédito": "क्रेडिट कार्ड",
 "Cartão de débito": "डेबिट कार्ड",
 "Cartão parcelado": "कार्ड पर किस्तें",
 "Cartões": "कार्ड",
 "Cartões de visita": "विज़िटिंग कार्ड",
 "Cartões e dinheiro": "कार्ड और नकद",
 "Casa": "घर",
 "Casa e rotina": "घर और दिनचर्या",
 "Casa, família e veículos": "घर, परिवार और वाहन",
 "Casaco leve": "हल्की जैकेट",
 "Casaco pesado": "भारी कोट",
 "Casamento": "शादी",
 "Castanhas": "मेवे",
 "Categoria": "श्रेणी",
 "Categoria de \"{d}\"": "\"{d}\" की श्रेणी",
 "Categorias": "श्रेणियाँ",
 "Caução": "सिक्योरिटी डिपॉज़िट",
 "Ceia": "रात का हल्का नाश्ता",
 "Celular": "मोबाइल",
 "Celular confirmado": "मोबाइल की पुष्टि हो गई",
 "Celular e carregador": "फ़ोन और चार्जर",
 "Certidão": "प्रमाणपत्र",
 "Certificado digital": "डिजिटल प्रमाणपत्र",
 "Certificado digital A1": "A1 डिजिटल प्रमाणपत्र",
 "Certificado ligado": "प्रमाणपत्र जुड़ा है",
 "Chamada": "हाज़िरी",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "इस दिन की हाज़िरी अभी नहीं ली गई। जो अनुपस्थित है उस पर टैप करें या सभी उपस्थित की पुष्टि करें।",
 "Chamada, notas, planos de aula e materiais.": "हाज़िरी, अंक, पाठ योजनाएँ और सामग्री।",
 "Chamadas": "कॉल",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "ऑडियो और वीडियो कॉल LiveKit के सर्वर से होकर गुज़रती हैं, सिर्फ़ कॉल के दौरान और बिना रिकॉर्डिंग के।",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "ऑडियो और वीडियो कॉल केवल कॉल के दौरान LiveKit के सर्वरों से होकर गुज़रती हैं। रिकॉर्डिंग केवल दफ़्तर की मीटिंग में होती है, जब एडमिनिस्ट्रेटर रिकॉर्ड करता है, और फ़ाइल सीधे ऐप के स्टोरेज में जाती है।",
 "Chamando...": "कॉल किया जा रहा है...",
 "Chapéu ou boné": "टोपी",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "इस डिवाइस पर AI कुंजी नहीं जोड़ी गई है (सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस)।",
 "Chave de acesso": "एक्सेस कुंजी",
 "Check-in": "चेक-इन",
 "Check-in: {d} a partir das {h}": "चेक-इन: {d}, {h} बजे से",
 "Check-in: {h} · {e}": "चेक-इन: {h} · {e}",
 "Check-out": "चेक-आउट",
 "Check-out: {d} até as {h}": "चेक-आउट: {d}, {h} बजे तक",
 "Check-out: {h} · {e}": "चेक-आउट: {h} · {e}",
 "Checklist": "चेकलिस्ट",
 "Chinelo": "चप्पल",
 "Chá de bebê": "बेबी शावर",
 "Cidade": "शहर",
 "Cidade (para a data dos recibos)": "शहर (रसीदों की तारीख के लिए)",
 "Cidade de {nome}": "{nome} शहर",
 "Cidades": "शहर",
 "Cifrão": "मुद्रा चिह्न",
 "Cinza": "ग्रे",
 "Cirurgia": "सर्जरी",
 "Ciências": "विज्ञान",
 "Clara": "हल्का",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "स्कैन किए PDF को साफ़ करता है: सफ़ेद, ग्रे या ब्लैक एंड व्हाइट बैकग्राउंड।",
 "Claro": "लाइट",
 "Classificar categorias com IA": "AI से श्रेणियाँ तय करें",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT या Gemini",
 "Cliente": "क्लाइंट",
 "Clientes": "क्लाइंट",
 "Clima esperado": "अपेक्षित मौसम",
 "Co-anfitrião": "सह-मेज़बान",
 "Cobrança": "शुल्क",
 "Cobranças": "शुल्क",
 "Coelho": "खरगोश",
 "Cofre (criptografia de ponta a ponta)": "वॉल्ट (एंड-टू-एंड एन्क्रिप्शन)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "वॉल्ट खुला है (5 मिनट इस्तेमाल न होने पर अपने-आप बंद हो जाता है)",
 "Cofre ainda não criado": "वॉल्ट अभी नहीं बना",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "पहचान पत्र, ड्राइविंग लाइसेंस, पासपोर्ट, अनुबंध और प्रमाणपत्रों के लिए एन्क्रिप्टेड वॉल्ट, समाप्ति तक की गिनती और एक टैप में भेजने की सुविधा के साथ।",
 "Cofre fechado": "वॉल्ट बंद है",
 "Cofrinho": "गुल्लक",
 "Cole aqui a chave ({ini}...)": "कुंजी यहाँ चिपकाएँ ({ini}...)",
 "Cole o link (https://...)": "लिंक पेस्ट करें (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "कोड वाले फ़ील्ड में बारकोड (या Pix कॉपी-पेस्ट कोड) पेस्ट करें या टाइप करें: ऐप राशि और देय तिथि अपने आप निकाल लेता है। आपका AI चालू होने पर यह फ़ोटो से सब कुछ पढ़ लेता है।",
 "Coloca arquivos dentro do PDF.": "PDF के अंदर फ़ाइलें रखता है।",
 "Colocar na agenda": "एजेंडा में जोड़ें",
 "Colocar na linha do tempo com alarme": "अलार्म के साथ टाइमलाइन में रखें",
 "Colocar no My Planner": "My Planner में रखें",
 "Colocar rega e adubo na agenda": "पानी और खाद एजेंडा में रखें",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "मासिक फ़ीस की राशि कक्षा (संपादित करें) या छात्र में डालें। इस महीने के पहले से बने शुल्क दोबारा नहीं बनते।",
 "Coluna": "कॉलम",
 "Colágeno": "कोलेजन",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "बायोमेट्रिक चालू होने पर यह पहले दिखता है। विफल होने पर पैटर्न या पासवर्ड का उपयोग करें।",
 "Com convênio": "बीमा के साथ",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "देश कोड और क्षेत्र कोड के साथ। उदा.: +55 41 99999-0000",
 "Com outras pessoas": "दूसरों के पास",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "समय-सीमा देने पर ऐप हिसाब लगाता है कि हर महीने कितना बचाना है। बचाया गया पैसा उस महीने \"बचाया\" में गिना जाता है।",
 "Com quem": "किसके साथ",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "हर भुगतान किए गए अपॉइंटमेंट का भुगतानकर्ता, मरीज़, तारीख और राशि। व्यक्तिगत रूप से हर एक को Receita Federal ऐप › Receita Saúde में दर्ज करें; CNPJ हो तो सेवा का इनवॉइस जारी करें।",
 "Com valor a receber": "मिलना बाकी वाले",
 "Com vencimento": "नियत तारीख वाले",
 "Combinado": "पक्का",
 "Combinado 👍": "ठीक है 👍",
 "Combustível": "ईंधन",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "महीने के तय बिलों (किराया, बिजली, इंटरनेट) और अपने कार्ड से शुरुआत करें। हर देय तिथि से पहले मैं आपको याद दिलाऊँगा।",
 "Comecei em": "शुरू किया",
 "Comentários": "टिप्पणियाँ",
 "Começa amanhã": "कल से शुरू",
 "Começa às {hora} (em {m} min)": "{hora} बजे शुरू ({m} मिनट में)",
 "Começar": "शुरू करें",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "टेम्पलेट से शुरू करें: नाश्ता, स्नैक, दोपहर का भोजन, स्नैक और रात का भोजन",
 "Começar em": "यहाँ से शुरू",
 "Começar o teste grátis": "मुफ़्त ट्रायल शुरू करें",
 "Comi outros alimentos ou quantidades": "मैंने अलग खाना या मात्रा खाई",
 "Comida": "भोजन",
 "Comidas e bebidas": "खाना और पेय",
 "Comido": "खाया",
 "Comido / alterações": "खाया / बदलाव",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "\"खाया\" में आज तक पूरे (या बदलाव वाले) चिह्नित भोजन गिने जाते हैं।",
 "Comigo": "मेरे पास",
 "Comissão da plataforma": "प्लेटफ़ॉर्म कमीशन",
 "Como apagar a sua conta e os seus dados": "अपना खाता और डेटा कैसे हटाएँ",
 "Como chegar": "कैसे पहुँचें",
 "Como ela está": "हालत कैसी है",
 "Como estou comparado ao mês passado?": "पिछले महीने की तुलना में मैं कैसा कर रहा हूँ?",
 "Como funciona": "यह कैसे काम करता है",
 "Como planejado": "योजना के अनुसार",
 "Compartilhado no grupo": "समूह में साझा",
 "Compartilhado no grupo · só leitura": "समूह में साझा · केवल पढ़ने के लिए",
 "Compartilhamento indisponível neste dispositivo.": "इस डिवाइस पर शेयर करना उपलब्ध नहीं है।",
 "Compartilhar": "साझा करें",
 "Compartilhar PDF": "PDF शेयर करें",
 "Compartilhar a limpeza": "सफ़ाई शेयर करें",
 "Compartilhar os dados": "डेटा साझा करें",
 "Compartilhar os dados com a equipe": "टीम के साथ डेटा साझा करें",
 "Compartilhar os dados com o grupo?": "समूह के साथ डेटा साझा करें?",
 "Compartilhar texto": "टेक्स्ट शेयर करें",
 "Competência (mês de referência)": "अवधि (संदर्भ माह)",
 "Competência {d}": "अवधि {d}",
 "Complemento": "अतिरिक्त पता",
 "Complete seus dados": "अपनी जानकारी पूरी करें",
 "Compra": "खरीदारी",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "मकान, वाहन और शेयरों की खरीद-बिक्री, कटौती योग्य रसीदें और टैक्स कैलेंडर।",
 "Compra feita": "खरीद लिया",
 "Compra no cartão": "कार्ड से खरीदारी",
 "Compras": "खरीदारी",
 "Compras da semana": "हफ़्ते की खरीदारी",
 "Comprimir": "कंप्रेस करें",
 "Compromisso": "अपॉइंटमेंट",
 "Compromisso da escola": "स्कूल का कार्यक्रम",
 "Comprovante": "रसीद",
 "Comprovante guardado": "रसीद सहेजी गई",
 "Comprovantes": "रसीदें",
 "Computador": "कंप्यूटर",
 "Comédia": "कॉमेडी",
 "Concedi": "मैंने दिया",
 "Concluir": "पूरा करें",
 "Concluir (esquerda)": "पूरा करें (बाएँ)",
 "Concluída": "पूरी हुई",
 "Concluído": "पूरा हुआ",
 "Concluído (%)": "पूरा हुआ (%)",
 "Concluído!": "पूरा हुआ!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "मैं सहमत हूँ कि मेरा नाम, CPF और ईमेल केवल मेरे खाते की पहचान के लिए उपयोग किए जाएँ, और मेरे कार्य व नोट्स उसमें सुरक्षित रहें। मैं किसी भी समय सेटिंग्स › सुरक्षा में खाता और सारा डेटा मिटा सकता/सकती हूँ।",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "मैं सहमत हूँ कि मेरा नाम, CPF और ई-मेल केवल मेरे खाते की पहचान के लिए उपयोग हों, और मेरे कार्य व नोट्स उसी में सुरक्षित रहें। मैं किसी भी समय सेटिंग्स में खाता और सारा डेटा मिटा सकता/सकती हूँ।",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "मैं सहमत हूँ कि मेरा नाम, दस्तावेज़ और ईमेल केवल मेरे खाते की पहचान के लिए उपयोग हों, और मेरे कार्य व नोट्स उसी में सुरक्षित रहें। मैं सेटिंग्स › सुरक्षा में कभी भी खाता और सारा डेटा मिटा सकता/सकती हूँ।",
 "Concursos": "सरकारी नौकरी परीक्षाएँ",
 "Condicionador": "कंडीशनर",
 "Condomínio": "सोसाइटी शुल्क",
 "Condomínio e IPTU": "मेंटेनेंस और संपत्ति कर",
 "Conectado": "कनेक्टेड",
 "Conectando...": "कनेक्ट हो रहा है...",
 "Conectar": "कनेक्ट करें",
 "Conectar navegador": "ब्राउज़र कनेक्ट करें",
 "Conectar o {nome}": "{nome} कनेक्ट करें",
 "Conectar relógio ou app de saúde": "घड़ी या हेल्थ ऐप कनेक्ट करें",
 "Conectar {nome}": "{nome} कनेक्ट करें",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "सेटिंग्स › Google Drive और OneDrive में {nome} कनेक्ट करें।",
 "Conferindo...": "जाँच रहे हैं...",
 "Conferir controles, chaves e Wi-Fi": "रिमोट, चाबियाँ और Wi-Fi जाँचें",
 "Conferir o prazo no sistema oficial": "आधिकारिक प्रणाली में समय-सीमा जाँचें",
 "Confete": "कॉन्फ़ेटी",
 "Configuração geral": "सामान्य सेटिंग्स",
 "Confira a senha da sua conta e tente de novo.": "अपने खाते का पासवर्ड जाँचें और फिर से कोशिश करें।",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "आधिकारिक तारीखें Receita Federal (ब्राज़ील का आयकर विभाग) की वेबसाइट पर जाँचें और ज़रूरत हो तो बदलें।",
 "Confira o código. Ele tem 6 letras e números.": "कोड जाँचें। इसमें 6 अक्षर और अंक होते हैं।",
 "Confira o e-mail ou deixe em branco.": "ई-मेल जाँचें या खाली छोड़ दें।",
 "Confira o e-mail.": "ईमेल जाँचें।",
 "Confira o prazo no sistema oficial.": "आधिकारिक प्रणाली में समय-सीमा जाँचें।",
 "Confira os 11 números.": "11 अंक जाँचें।",
 "Confira os campos antes de salvar.": "सहेजने से पहले फ़ील्ड जाँच लें।",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "जांच लें कि आपका Google खाता फ़ोन में जुड़ा है और कैलेंडर सिंक हो रहा है।",
 "Confirmada": "पक्की",
 "Confirmado": "पुष्टि की",
 "Confirmar": "पुष्टि करें",
 "Confirme a declaração sobre a empresa.": "कंपनी से संबंधित घोषणा की पुष्टि करें।",
 "Confirme o seu celular": "अपने मोबाइल की पुष्टि करें",
 "Confirme para ativar a biometria": "बायोमेट्रिक चालू करने के लिए पुष्टि करें",
 "Confirme para excluir": "हटाने की पुष्टि करें",
 "Confirme sua senha para sincronizar": "सिंक करने के लिए अपना पासवर्ड पुष्टि करें",
 "Confraternização": "मिलन समारोह",
 "Confraternização Universal": "नव वर्ष दिवस",
 "Conselho": "परिषद",
 "Consignado": "वेतन-कटौती ऋण",
 "Consulta": "डॉक्टर विज़िट",
 "Consulta ou vacina": "डॉक्टर विज़िट या टीका",
 "Consultas": "डॉक्टर विज़िट",
 "Consultório": "क्लिनिक",
 "Consumo médio: {v} km/L": "औसत माइलेज: {v} km/L",
 "Conta": "खाता",
 "Conta a pagar": "देय बिल",
 "Conta a receber": "प्राप्य राशि",
 "Conta de consumo ou tributo": "उपयोगिता बिल या टैक्स",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "गिनता है कि हर आइटम कितने दिन तय था (उसके हफ़्ते के दिनों के अनुसार) और कितने दिन पूरा चिह्नित किया गया।",
 "Conta paga": "बिल चुकाया गया",
 "Conta recebida": "राशि मिल गई",
 "Conta vence hoje": "बिल आज देय है",
 "Conta vencendo": "बिल की तारीख़ नज़दीक",
 "Contabilidade": "लेखांकन",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "साथियों को मिलाकर। बदलने के लिए मेहमान की स्थिति पर टैप करें।",
 "Contando: {cliente}": "गिनती चालू: {cliente}",
 "Contas": "बिल",
 "Contas a pagar": "देय बिल",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "देय और प्राप्य बिल, महीने के खर्च, देय तिथि की सूचना और MEI का प्रबंधन (Mestre Achado)।",
 "Contas a receber": "प्राप्य राशि",
 "Contas fixas": "तय बिल",
 "Contato": "संपर्क",
 "Contato de emergência": "आपातकालीन संपर्क",
 "Contato do encarregado de dados:": "डेटा प्रभारी अधिकारी से संपर्क:",
 "Conte a sua ideia para o app ficar melhor.": "ऐप को बेहतर बनाने के लिए अपना विचार बताएँ।",
 "Conte o que está difícil ou não funciona como deveria.": "बताएँ कि क्या मुश्किल है या ठीक से काम नहीं कर रहा।",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "बताएँ कि आपने क्या किया, क्या उम्मीद थी और क्या दिखा। अगर कोई एरर मैसेज है, तो उसे यहाँ कॉपी करें।",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "हमें समस्याएँ, एरर और सुधार के सुझाव बताएँ। आपका संदेश सीधे My Planner टीम को जाता है।",
 "Conteúdo": "सामग्री",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "आपके द्वारा बनाई गई सामग्री: कार्य, नोट्स, वित्त, दस्तावेज़, फ़ोटो, अटैचमेंट और टैब का डेटा।",
 "Conteúdo, matéria, tarefa de casa...": "विषय-वस्तु, विषय, गृहकार्य...",
 "Continuar": "जारी रखें",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "{preco} प्रति वर्ष में My Planner और नोट्स इस्तेमाल करते रहें। आपका डेटा सुरक्षित रहता है।",
 "Contratado": "तय किया",
 "Contratado: {v}": "तय किया: {v}",
 "Contrato": "अनुबंध",
 "Conversa": "चैट",
 "Conversa do grupo": "ग्रुप चैट",
 "Conversar": "चैट करें",
 "Conversar com o Mestre (precisa da sua IA)": "मास्टर से बात करें (आपका AI चाहिए)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "दोस्तों और ग्रुप से चैट करें, और ऑडियो व वीडियो कॉल करें।",
 "Converter de PDF": "PDF से बदलें",
 "Converter para PDF": "PDF में बदलें",
 "Convidado": "मेहमान",
 "Convidados": "मेहमान",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "उपस्थिति की पुष्टि वाले मेहमान, विक्रेता और ख़ास दिन की समय-सारणी।",
 "Convidados e cronograma do dia, sem os valores.": "मेहमान और दिन का कार्यक्रम, राशियों के बिना।",
 "Convidar": "आमंत्रित करें",
 "Convidar pelo WhatsApp": "WhatsApp से आमंत्रित करें",
 "Convite": "आमंत्रण",
 "Convite copiado. Cole onde quiser enviar.": "आमंत्रण कॉपी हो गया। जहाँ भेजना हो वहाँ पेस्ट करें।",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "आमंत्रण अमान्य है या एडमिन ने बदल दिया है। नया लिंक माँगें।",
 "Convite para o My Planner": "My Planner के लिए आमंत्रण",
 "Convênio": "बीमा",
 "Copiar": "कॉपी करें",
 "Copiar a lista para uma tarefa": "सूची को एक कार्य में कॉपी करें",
 "Copiar o código": "कोड कॉपी करें",
 "Copiar para hoje": "आज में कॉपी करें",
 "Copo de outro tamanho": "दूसरे साइज़ का गिलास",
 "Copo {n}": "गिलास {n}",
 "Cor": "रंग",
 "Cor do fichário": "फ़ाइल का रंग",
 "Cor do tema": "थीम का रंग",
 "Cor do tema de cada aba": "हर टैब का थीम रंग",
 "Coração": "दिल",
 "Corações": "दिल",
 "Cores das abas": "टैब के रंग",
 "Cores das conversas": "चैट के रंग",
 "Cores e opções desta aba": "इस टैब के रंग और विकल्प",
 "Corpo": "शरीर",
 "Corporativo": "कॉर्पोरेट",
 "Corpus Christi": "कॉर्पस क्रिस्टी",
 "Corredor": "गलियारा",
 "Correia dentada": "टाइमिंग बेल्ट",
 "Corrida": "दौड़",
 "Corta as bordas em branco ou partes da página.": "खाली किनारे या पेज के हिस्से काटता है।",
 "Cortesia": "निःशुल्क",
 "Coxa e sobrecoxa": "चिकन लेग और थाई",
 "Cozinha": "रसोई",
 "Creatina": "क्रिएटिन",
 "Criada em {data}": "{data} को बनाया",
 "Criado com": "इससे बनाया गया",
 "Criado em": "बनाने की तारीख",
 "Criança": "बच्चा",
 "Crianças": "बच्चे",
 "Criar": "बनाएँ",
 "Criar animada": "एनिमेटेड बनाएँ",
 "Criar conta": "खाता बनाएँ",
 "Criar do zero": "शुरू से बनाएँ",
 "Criar documento, planilha ou apresentação": "दस्तावेज़, स्प्रेडशीट या प्रेज़ेंटेशन बनाएँ",
 "Criar em outro app": "दूसरे ऐप में बनाएँ",
 "Criar escritório": "ऑफ़िस बनाएँ",
 "Criar fichário": "फ़ाइल बनाएँ",
 "Criar figurinha": "स्टिकर बनाएँ",
 "Criar grupo": "समूह बनाएँ",
 "Criar grupo e convidar pessoas": "समूह बनाएँ और लोगों को आमंत्रित करें",
 "Criar minha chave de API": "मेरी API कुंजी बनाएँ",
 "Criar o cofre": "वॉल्ट बनाएँ",
 "Criar o grupo e convidar": "समूह बनाएँ और आमंत्रित करें",
 "Criar os prazos do IR de {ano}": "{ano} की आयकर समय-सीमाएँ बनाएँ",
 "Criar uma meta (viagem, reserva, carro...)": "लक्ष्य बनाएँ (यात्रा, बचत कोष, कार...)",
 "Criar uma senha nova": "नया पासवर्ड बनाएँ",
 "Criar {n} tarefa(s)": "{n} कार्य बनाएँ",
 "Criação do Estado de MS": "MS राज्य स्थापना दिवस",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "स्थानांतरण बनाएँ, ऐप ट्रांसफ़र की सूची (बिजली, पानी, इंटरनेट...) खुद बना देगा। फिर कमरों के हिसाब से बॉक्स, निरीक्षण और दिनों की समय-सारणी दर्ज करें।",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "हर क्लाइंट का फ़ोल्डर बनाएँ, लिंक से क्लाइंट को आमंत्रित करें (वह सिर्फ़ अपना फ़ोल्डर देखता है) और दोनों ओर से दस्तावेज़ भेजें: इनवॉइस, कर चालान, पेरोल, स्टेटमेंट, अनुबंध।",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "कक्षा (या मेंटरिंग, ट्रेनिंग, कोर्स समूह) बनाएँ और उसके अंदर छात्र, हाज़िरी, अंक, पाठ योजनाएँ, सामग्री और शुल्क जोड़ें।",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "कक्षा बनाएँ और उसके अंदर छात्र, हाज़िरी, अंकों वाले मूल्यांकन और पाठ योजनाएँ जोड़ें।",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "घर के काम (बाथरूम साफ़ करना, बिस्तर की चादर बदलना...) आवृत्ति के साथ बनाएँ। देरी होने पर ऐप याद दिलाएगा, My Planner को भरे बिना।",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "इस विषय के लिए चेकलिस्ट, सूची, मुक्त पाठ या ड्रॉइंग वाले कार्ड बनाएँ। हटाने के लिए दाएँ और संग्रह के लिए बाएँ स्वाइप करें।",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "ऑफ़िस बनाएँ, टीम को बुलाएँ (ऐप के दोस्त या लिंक से आमंत्रण), और संदेश व दस्तावेज़ भेजें, मीटिंग तय करें और वीडियो मीटिंग करें। एडमिन होने के नाते आप मीटिंग रिकॉर्ड कर सकते हैं।",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "इवेंट बनाएँ और उसके अंदर उपस्थिति की पुष्टि वाली मेहमानों की सूची, विक्रेता और दिन की समय-सारणी जोड़ें।",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "समूह बनाएँ और लिंक भेजें: जो भी जुड़ेगा उसे तारीख, स्थान, सूचनाएँ और आपके भेजे सब कुछ मिलेगा, और वह स्वीकार, संपादित या अस्वीकार कर सकेगा।",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "समूह बनाएँ और लिंक भेजें: जो जुड़ेगा वह आपके चुने गए रोल के अनुसार देख और भाग ले सकेगा। केवल एडमिन ही लोगों को जोड़ या हटा सकते हैं।",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "समूह बनाएँ और लिंक भेजें: जो जुड़ेगा वह यहाँ की हर चीज़ देखेगा और भाग लेगा (जोड़ना, संपादित करना, फ़ोटो डालना)। केवल एडमिन ही लोगों को जोड़ या हटा सकते हैं।",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "अपना खाता बनाएँ। आपका डेटा क्लाउड और इस डिवाइस पर सुरक्षित रहता है।",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "एक फ़ाइल बनाएँ (जैसे: पीएचडी, अंग्रेज़ी, प्रतियोगी परीक्षा) और उसके अंदर विषय व पेज।",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "एक समूह बनाएँ (कक्षा, मरीज़, टीम, मेहमान, ग्राहक), आमंत्रण लिंक भेजें और अपॉइंटमेंट, सामग्री और सूचनाएँ भेजें। हर व्यक्ति जो मिला उसे स्वीकारता, संपादित करता या अस्वीकारता है।",
 "Crie um perfil com nome e, se for advogado, a OAB.": "नाम के साथ एक प्रोफ़ाइल बनाएँ और, यदि आप वकील हैं, तो OAB नंबर भी।",
 "Criptografado no cofre, só neste dispositivo": "तिजोरी में एन्क्रिप्टेड, सिर्फ़ इस डिवाइस पर",
 "Criptomoedas": "क्रिप्टोकरेंसी",
 "Cronograma": "समय-सारणी",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "भोजन समय-सारणी, चरण-दर-चरण व्यक्तिगत देखभाल और दिन का पानी।",
 "Cronograma do dia": "दिन की समय-सारणी",
 "Cronograma físico-financeiro": "भौतिक-वित्तीय समय-सारणी",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "हर चरण की भौतिक-वित्तीय समय-सारणी, पहले और बाद वाली कार्य डायरी, कारीगर और डिलीवरी।",
 "Cronômetro de horas": "घंटों का टाइमर",
 "Crédito empresarial": "व्यावसायिक ऋण",
 "Créditos": "क्रेडिट",
 "Cuida das reservas, da limpeza e das despesas.": "बुकिंग, सफ़ाई और खर्च संभालता है।",
 "Cuidado": "देखभाल",
 "Cuidado pessoal": "व्यक्तिगत देखभाल",
 "Cuidados": "देखभाल",
 "Cupom do mercado": "किराना रसीद",
 "Cupom do mercado (foto)": "किराना रसीद (फ़ोटो)",
 "Cupom lançado": "रसीद दर्ज हुई",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "कोर्स",
 "Cursos": "कोर्स",
 "Cursos livres e certificações": "स्वतंत्र कोर्स और सर्टिफ़िकेशन",
 "Cuscuz": "मक्के का कुसकुस",
 "CÓDIGO PARA PAGAR": "भुगतान कोड",
 "CÔMODOS": "कमरे",
 "Câmera": "कैमरा",
 "Câmera e galeria": "कैमरा और गैलरी",
 "Câmera não liberada": "कैमरे की अनुमति नहीं है",
 "Código IBGE do município": "नगर का IBGE कोड",
 "Código IBGE do município (7 números)": "नगर का IBGE कोड (7 अंक)",
 "Código NBS (9 números, opcional)": "NBS कोड (9 अंक, वैकल्पिक)",
 "Código copiado": "कोड कॉपी हो गया",
 "Código da reserva (localizador)": "बुकिंग कोड (PNR)",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "बारकोड, डिजिटल लाइन या Pix कॉपी-पेस्ट (वैकल्पिक)",
 "Código de indicação": "रेफ़रल कोड",
 "Código de indicação (opcional)": "रेफ़रल कोड (वैकल्पिक)",
 "Código de quem convidou você": "आपको आमंत्रित करने वाले का कोड",
 "Código de tributação nacional (6 números)": "राष्ट्रीय कर कोड (6 अंक)",
 "Código de tributação nacional (6 números, ex.: 171901)": "राष्ट्रीय कर कोड (6 अंक, जैसे: 171901)",
 "Código do amigo": "दोस्त का कोड",
 "Código do convite": "आमंत्रण कोड",
 "Código do procedimento (TUSS ou do plano)": "प्रक्रिया कोड (TUSS या बीमा योजना का)",
 "Código errado. Confira e tente de novo.": "गलत कोड। जाँचें और फिर से कोशिश करें।",
 "Código não encontrado. Confira as letras e os números.": "कोड नहीं मिला। अक्षर और अंक जाँचें।",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "कोड पहचाना नहीं गया। अंक जाँचें (बोलेटो: 47 या 48 अंक)।",
 "Código: {c}": "कोड: {c}",
 "Cópia automática toda semana": "हर हफ़्ते अपने-आप बैकअप",
 "Cópia criada.": "कॉपी बन गई।",
 "Cópia de segurança": "बैकअप",
 "Cópia feita": "बैकअप हो गया",
 "Cópia restaurada.": "बैकअप रीस्टोर हो गया।",
 "Cômodo": "कमरा",
 "Cômodo ou quarto": "कमरा",
 "Cômodos da casa e as tarefas de cada um.": "घर के कमरे और हर कमरे के कार्य।",
 "DAS de {mes} pago": "{mes} का DAS चुकाया गया",
 "DAS de {mes}: vence dia {dia}": "{mes} का DAS: {dia} तारीख़ को देय",
 "DAS do MEI": "MEI का DAS",
 "DECLARAÇÃO DE ATENDIMENTO": "उपचार घोषणा-पत्र",
 "DICA DO MESTRE ACHADO": "MESTRE ACHADO की सलाह",
 "DPS nº {n}, série {s}": "DPS नं. {n}, सीरीज़ {s}",
 "Da galeria ou dos arquivos": "गैलरी या फ़ाइलों से",
 "Da meta de passos": "कदम लक्ष्य का",
 "Dados compartilhados": "साझा डेटा",
 "Dados compartilhados com o grupo": "समूह के साथ साझा डेटा",
 "Dados compartilhados · seu papel: {p}": "साझा डेटा · आपकी भूमिका: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "आपके द्वारा स्वयं दर्ज किया गया स्वास्थ्य डेटा केवल आपके लिए और उन लोगों के लिए प्रोसेस किया जाता है जिनके साथ आप साझा करते हैं, आपकी सहमति से (art. 11, I)।",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "डिवाइस डेटा: भाषा, देश और टाइम ज़ोन (तारीखों, अवकाशों और मुद्रा के लिए), डिवाइस मॉडल और फ़ोन सूचनाओं के लिए कोड।",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "घड़ी और स्वास्थ्य डेटा का उपयोग विज्ञापन के लिए नहीं किया जाता और किसी के साथ साझा नहीं किया जाता। आप कभी भी डिस्कनेक्ट करके अनुमति वापस ले सकते हैं।",
 "Dança": "नृत्य",
 "Dar ciência": "सूचना दें",
 "Dar ciência da operação?": "लेन-देन की सूचना दें?",
 "Data": "तारीख",
 "Data (embarque ou check-in)": "तारीख (प्रस्थान या चेक-इन)",
 "Data agendada": "तय तारीख",
 "Data da aplicação": "लगाने की तारीख",
 "Data da compra": "ख़रीद की तिथि",
 "Data da entrega": "डिलीवरी की तारीख",
 "Data da venda": "बिक्री की तारीख",
 "Data de nascimento": "जन्म तिथि",
 "Data do empréstimo": "उधार की तारीख",
 "Data do pagamento": "भुगतान की तारीख",
 "Data em que foi feita": "किए जाने की तारीख",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "सुझाई गई तारीख़ में 2 कार्य दिवसों की गुंजाइश है। आधिकारिक प्रणाली में जाँच लें।",
 "De": "से",
 "De uma foto": "फ़ोटो से",
 "De {de} para {para} ({p}% menor).": "{de} से {para} ({p}% छोटा)।",
 "Declaração": "घोषणा पत्र",
 "Declaração de atendimento": "उपचार घोषणा-पत्र",
 "Declaração para reembolso (PDF)": "प्रतिपूर्ति के लिए घोषणा-पत्र (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "मैं घोषित करता/करती हूँ कि यह कंपनी मेरी है या ऐसे क्लाइंट की है जिसने निगरानी की अनुमति दी है।",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "मैं प्रतिपूर्ति के उद्देश्य से{conv} घोषणा करता/करती हूँ कि मरीज़ {nome}{cpf}{cart} का {data} को{hora} मेरे द्वारा {tipo} के रूप में उपचार किया गया।",
 "Defina a meta de aulas por dia ou por semana em Editar.": "संपादित करें में प्रति दिन या प्रति सप्ताह पाठ का लक्ष्य तय करें।",
 "Defina a meta de páginas por dia em Editar.": "संपादित करें में प्रति दिन पेज का लक्ष्य तय करें।",
 "Defina um horário": "समय तय करें",
 "Defina um horário para usar pausas.": "ब्रेक इस्तेमाल करने के लिए समय तय करें।",
 "Demaquilante ou água micelar": "मेकअप रिमूवर या माइसेलर वॉटर",
 "Demolição": "तोड़फोड़",
 "Demonstração": "डेमो",
 "Dentista": "दंत चिकित्सक",
 "Dependentes": "आश्रित",
 "Depois": "बाद में",
 "Depois da aula": "कक्षा के बाद",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "हटाने के बाद कार्य वापस नहीं आते। पुष्टि के लिए अपने खाते का पासवर्ड डालें।",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "डाउनलोड के बाद फ़ाइल खोलें और इंस्टॉल करें पर टैप करें। अगर मोबाइल पूछे, तो इस स्रोत से ऐप इंस्टॉल करने की अनुमति दें।",
 "Depois de criar": "बनाने के बाद",
 "Depois de {nome}. Toque para pular.": "{nome} के बाद। छोड़ने के लिए टैप करें।",
 "Depois é só ajustar horários e o que comer em cada um.": "फिर बस समय और हर समय क्या खाना है, यह बदल लें।",
 "Desarquivar": "संग्रह से निकालें",
 "Desbloquear": "अनलॉक करें",
 "Desbloquear com": "इससे अनलॉक करें",
 "Desbloquear com biometria": "बायोमेट्रिक से अनलॉक करें",
 "Desbloquear o My Planner": "My Planner अनलॉक करें",
 "Desbloqueio do app": "ऐप अनलॉक",
 "Descanso": "आराम",
 "Descartadas": "ख़ारिज",
 "Descartar": "ख़ारिज करें",
 "Descartar este tempo?": "यह समय ख़ारिज करें?",
 "Descobrir lugares em {d}": "{d} में जगहें खोजें",
 "Desconectar": "डिस्कनेक्ट करें",
 "Desconectar o {nome}?": "{nome} डिस्कनेक्ट करें?",
 "Desconto": "छूट",
 "Desconto de {v}": "{v} की छूट",
 "Descontos obtidos": "मिली छूट",
 "Descrição": "विवरण",
 "Descrição (cliente, nota fiscal...)": "विवरण (ग्राहक, बिल...)",
 "Descrição do serviço (sai na nota)": "सेवा का विवरण (इनवॉइस पर छपेगा)",
 "Descrição que sai na nota": "इनवॉइस पर छपने वाला विवरण",
 "Desenhar a assinatura": "हस्ताक्षर बनाएँ",
 "Desenhar com caneta ou dedo": "पेन या उंगली से ड्रॉ करें",
 "Desenhe a assinatura e escolha a página e o lugar.": "हस्ताक्षर बनाएँ और पेज व जगह चुनें।",
 "Desenhe a assinatura primeiro.": "पहले हस्ताक्षर बनाएँ।",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "उँगली या पेन (S Pen, Apple Pencil या टैबलेट पेन) से ड्रॉ करें।",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "उँगली या पेन से बनाएँ। बोर्ड को स्क्रॉल करने के लिए ले जाएँ पर टैप करें।",
 "Desenhe de novo para confirmar.": "पुष्टि के लिए दोबारा बनाएँ।",
 "Desenhe o seu padrão": "अपना पैटर्न बनाएँ",
 "Desenhe pelo menos uma tarja.": "कम से कम एक पट्टी बनाएँ।",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "कम से कम 4 बिंदुओं को जोड़कर पैटर्न बनाएँ।",
 "Desenho": "ड्रॉइंग",
 "Desenho com caneta ou dedo": "पेन या उँगली से ड्रॉइंग",
 "Desenho incorreto": "गलत पैटर्न",
 "Desenho padrão": "पैटर्न",
 "Desenho padrão salvo.": "पैटर्न सहेजा गया।",
 "Desenvolvimento": "शोल्डर प्रेस",
 "Desfazer": "पूर्ववत करें",
 "Desfazer amizade": "दोस्ती खत्म करें",
 "Desligar": "बंद करें",
 "Desligar a sincronização?": "सिंक बंद करें?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "दूसरे दिन देखने के लिए दाएँ-बाएँ स्वाइप करें (60 दिन आगे तक)। सिर्फ़ उस दिन का मेनू बनाने के लिए किसी भोजन पर टैप करें। हटाने के लिए दाईं ओर खींचें।",
 "Desmarcado": "रद्द किया गया",
 "Desmarcar como recebida": "प्राप्त का निशान हटाएँ",
 "Desmarcar feita hoje": "आज पूरा होने का निशान हटाएँ",
 "Desmarcar grupo": "समूह का चयन हटाएँ",
 "Desmarcar pagamento": "भुगतान का निशान हटाएँ",
 "Desodorante": "डियोडरेंट",
 "Despensa": "भंडार कक्ष",
 "Despesa": "खर्च",
 "Despesas": "खर्च",
 "Destino": "गंतव्य",
 "Detalhes": "विवरण",
 "Devolver até": "लौटाने की आख़िरी तारीख",
 "Devolver: {i} ({p})": "लौटाना: {i} ({p})",
 "Devolvido": "लौटा दिया",
 "Devolvidos": "लौटाए गए",
 "Dia": "दिन",
 "Dia a dia": "रोज़मर्रा",
 "Dia da mudança": "स्थानांतरण का दिन",
 "Dia de vencimento do DAS": "DAS की देय तिथि",
 "Dia do Trabalho": "मज़दूर दिवस",
 "Dia do vencimento": "देय दिन",
 "Dia em que a fatura fecha": "कार्ड बिल बनने का दिन",
 "Dia planejado": "तय दिन",
 "Dia {d} de {total}": "दिन {d} / {total}",
 "Diagnóstico": "निदान",
 "Dias e horários": "दिन और समय",
 "Dias específicos": "विशेष दिन",
 "Dias úteis": "कार्य दिवस",
 "Dias: {dias}": "दिन: {dias}",
 "Dicas e observações": "सुझाव और टिप्पणियाँ",
 "Diesel": "डीज़ल",
 "Diferença": "अंतर",
 "Digitado": "हाथ से",
 "Digitar": "टाइप करें",
 "Digitar à mão": "हाथ से दर्ज करें",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "वॉल्ट पासवर्ड डालें। 5 मिनट इस्तेमाल न होने पर यह अपने-आप बंद हो जाता है।",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "मिनट (90) या घंटे और मिनट (1:30 या 01:30) में लिखें और ठीक है पर टैप करें।",
 "Digite no formato HH:MM, por exemplo 13:30.": "HH:MM प्रारूप में लिखें, जैसे 13:30।",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "कोड डालें और 10 दिनों तक सभी टैब अनलॉक पाएँ। अगर कोड नहीं है, तो खाली छोड़ दें।",
 "Digite o nome da tarefa.": "कार्य का नाम लिखें।",
 "Dinheiro": "पैसे",
 "Dinheiro e documentos": "पैसे और दस्तावेज़",
 "Direita": "दाएँ",
 "Direito": "क़ानून",
 "Direito Administrativo": "प्रशासनिक विधि",
 "Direito Civil": "सिविल विधि",
 "Direito Constitucional": "संवैधानिक विधि",
 "Direito Empresarial": "वाणिज्यिक विधि",
 "Direito Penal": "आपराधिक विधि",
 "Direito Tributário": "कर विधि",
 "Direito do Trabalho": "श्रम विधि",
 "Direto": "सीधे",
 "Disciplina": "विषय",
 "Dispensar": "हटाएँ",
 "Dispensar o aviso": "सूचना हटाएँ",
 "Dispensar todas": "सभी हटाएँ",
 "Disponibilizada em": "उपलब्ध कराया गया",
 "Disponível no app novo": "नए ऐप में उपलब्ध",
 "Distância": "दूरी",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "कोर्स को विषयों या मॉड्यूल में बाँटें। हर एक में बताएँ कि आप किस पाठ पर रुके और नोट कार्ड बनाएँ।",
 "Dividir": "बाँटें",
 "Dividir entre (nenhum marcado = todos)": "किनके बीच बाँटें (कोई न चुना = सभी)",
 "Divisão das despesas": "खर्च का बँटवारा",
 "Diária": "प्रति रात किराया",
 "Diária padrão": "सामान्य प्रति रात किराया",
 "Diário": "डायरी",
 "Diários municipais": "नगरपालिका राजपत्र",
 "Do celular, do Google Drive ou do OneDrive": "मोबाइल, Google Drive या OneDrive से",
 "Do cliente": "क्लाइंट से",
 "Do escritório": "ऑफ़िस से",
 "Doações": "दान",
 "Docs": "डॉक्स",
 "Documento": "दस्तावेज़",
 "Documento (fundo branco)": "दस्तावेज़ (सफ़ेद बैकग्राउंड)",
 "Documento do veículo (CRLV)": "वाहन दस्तावेज़ (CRLV)",
 "Documento pessoal": "निजी दस्तावेज़",
 "Documento vence hoje": "दस्तावेज़ आज समाप्त हो रहा है",
 "Documento vencendo": "दस्तावेज़ समाप्त होने वाला है",
 "Documento: {o}": "दस्तावेज़: {o}",
 "Documentos": "दस्तावेज़",
 "Documentos (contrato, nota, recibo...)": "दस्तावेज़ (अनुबंध, इनवॉइस, रसीद...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "दस्तावेज़ (पासपोर्ट, पहचान पत्र, ड्राइविंग लाइसेंस)",
 "Documentos e autorização das crianças": "बच्चों के दस्तावेज़ और अनुमति पत्र",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "सुरक्षित दस्तावेज़, जाँचें, स्वास्थ्य इतिहास और 🔒 वाली अन्य फ़ील्ड यहीं डिवाइस पर वॉल्ट पासवर्ड से एन्क्रिप्ट होती हैं (AES-256)। सपोर्ट भी इन्हें नहीं पढ़ सकता। पासवर्ड के बिना यह डेटा वापस नहीं पाया जा सकता।",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "दस्तावेज़, रसीदें, नोटबुक और बोर्ड, कई पेजों के साथ",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "दस्तावेज़, मीटिंग और रिकॉर्डिंग सभी के लिए मिट जाएँगी। बातचीत संदेश में बनी रहेगी।",
 "Documentário": "डॉक्यूमेंट्री",
 "Doenças, cirurgias e observações": "बीमारियाँ, सर्जरी और टिप्पणियाँ",
 "Dois dedos ou toque duplo para ampliar": "बड़ा करने के लिए दो उंगलियाँ या डबल टैप",
 "Domingo": "रविवार",
 "Dono da obra": "निर्माण का मालिक",
 "Dose": "खुराक",
 "Dose (ex.: 1 cápsula, 5 g)": "खुराक (जैसे: 1 कैप्सूल, 5 g)",
 "Dose única": "एकल खुराक",
 "Drama": "ड्रामा",
 "Duplicar": "डुप्लिकेट करें",
 "Duplicar tarefa": "कार्य की प्रति बनाएँ",
 "Duração": "अवधि",
 "Duração de cada sessão": "हर सत्र की अवधि",
 "Duração {dur}": "अवधि {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "क्या 3 हज़ार की चीज़ 10 किस्तों में ले सकता हूँ?",
 "Débito automático": "ऑटो डेबिट",
 "Débito, Pix ou dinheiro": "डेबिट, Pix या नकद",
 "Dê um nome ao cartão.": "कार्ड को एक नाम दें।",
 "Dê um nome ao cuidado.": "देखभाल को एक नाम दें।",
 "Dê um nome ao cômodo.": "कमरे को एक नाम दें।",
 "Dê um nome ao fichário.": "फ़ाइल को एक नाम दें।",
 "Dê um nome ao grupo.": "समूह को एक नाम दें।",
 "Dê um nome ao suplemento.": "सप्लीमेंट का नाम दें।",
 "Dê um nome ao treino.": "वर्कआउट का नाम दें।",
 "Dê um nome à conta.": "बिल को नाम दें।",
 "Dê um nome à matéria.": "विषय को एक नाम दें।",
 "Dê um nome à meta.": "लक्ष्य को एक नाम दें।",
 "Dê um nome à refeição.": "भोजन को एक नाम दें।",
 "Dê um nome à tarefa.": "कार्य को एक नाम दें।",
 "E-MAIL (OPCIONAL)": "ईमेल (वैकल्पिक)",
 "E-mail": "ईमेल",
 "E-mail (recebe a nota)": "ईमेल (इनवॉइस यहाँ भेजा जाएगा)",
 "E-mail de contato": "संपर्क ईमेल",
 "E-mail do responsável": "अभिभावक का ईमेल",
 "E-mail inválido": "अमान्य ई-मेल",
 "E-mail inválido.": "अमान्य ई-मेल।",
 "E-mail ou WhatsApp para resposta (opcional)": "जवाब के लिए ईमेल या WhatsApp (वैकल्पिक)",
 "E-mail para contato (opcional)": "संपर्क ई-मेल (वैकल्पिक)",
 "E-mail salvo.": "ईमेल सहेजा गया।",
 "EM ATRASO": "बकाया",
 "ENTRAR COM UM CÓDIGO": "कोड से जुड़ें",
 "ENVIADOS": "भेजे गए",
 "ESCOLHA AS ATIVIDADES": "गतिविधियाँ चुनें",
 "ESTA SEMANA": "इस सप्ताह",
 "EXERCÍCIO FÍSICO": "व्यायाम",
 "Economia": "अर्थशास्त्र",
 "Edita tudo": "सब कुछ संपादित करता है",
 "Edita tudo: etapas, orçamento, diário e entregas.": "सब कुछ संपादित करता है: चरण, बजट, डायरी और डिलीवरी।",
 "Editar": "संपादित करें",
 "Editar cartão": "कार्ड संपादित करें",
 "Editar compra": "खरीदारी संपादित करें",
 "Editar cômodo": "कमरा संपादित करें",
 "Editar desenho": "ड्रॉइंग संपादित करें",
 "Editar documento": "दस्तावेज़ संपादित करें",
 "Editar fichário": "फ़ाइल संपादित करें",
 "Editar garantia": "वारंटी संपादित करें",
 "Editar matéria": "विषय संपादित करें",
 "Editar meta": "लक्ष्य संपादित करें",
 "Editar perfil": "प्रोफ़ाइल संपादित करें",
 "Editar tarefa": "कार्य संपादित करें",
 "Editar {nome}": "{nome} संपादित करें",
 "Educação": "शिक्षा",
 "Educação Física": "शारीरिक शिक्षा",
 "Efeito de scanner": "स्कैनर इफ़ेक्ट",
 "Ela sai da lista e dos Recebidos da equipe.": "यह सूची से और टीम के प्राप्त से हट जाएगी।",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "यह \"मेरे स्टिकर\" में भी सहेजा जाता है ताकि आप इसे फिर से भेज सकें।",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "यह ऋण और फ़ाइनेंसिंग टैब से आता है। यहाँ भुगतान हुआ चिह्नित करें या अनुबंध देखने के लिए टैब खोलें।",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "यह इनवॉइस (NF) टैब से आता है। पैसा आने पर इसे प्राप्त चिह्नित करें।",
 "Eleitorais": "चुनावी",
 "Eletrodoméstico": "घरेलू उपकरण",
 "Eletrodomésticos": "घरेलू उपकरण",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "घरेलू उपकरण, इलेक्ट्रॉनिक्स और फ़र्नीचर: बिल, सर्विस सेंटर और वारंटी ख़त्म होने से 15 दिन पहले सूचना।",
 "Eletrônico": "इलेक्ट्रॉनिक",
 "Elétrica": "बिजली का काम",
 "Elétrico": "इलेक्ट्रिक",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "संपादित करें में लिस्टिंग के कैलेंडर (iCal) का लिंक पेस्ट करें। Airbnb में: कैलेंडर › उपलब्धता › कैलेंडर कनेक्ट करें › कैलेंडर एक्सपोर्ट करें। Booking में: दरें और उपलब्धता › कैलेंडर सिंक करें।",
 "Em aberto": "बाकी",
 "Em alta": "ट्रेंडिंग",
 "Em andamento": "चल रहा है",
 "Em atraso": "बकाया",
 "Em branco": "खाली",
 "Em casa": "घर पर",
 "Em cima": "ऊपर",
 "Em construção": "निर्माणाधीन",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "सब अपडेट है। ऐप खुलने पर सुधार अपने आप आ जाते हैं।",
 "Em limpeza": "सफ़ाई जारी",
 "Em quais páginas": "किन पेजों पर",
 "Em qual agenda criar os eventos:": "इवेंट किस कैलेंडर में बनाएं:",
 "Em qual página e onde": "किस पेज पर और कहां",
 "Em tratamento": "इलाज जारी",
 "Em um horário específico": "किसी तय समय पर",
 "Em uso: {ia}": "उपयोग में: {ia}",
 "Em {n} dia(s)": "{n} दिन में",
 "Embaixo": "नीचे",
 "Embaixo à esquerda": "नीचे बाईं ओर",
 "Emissão": "जारी",
 "Emissão +": "जारी +",
 "Emissão: {data}": "जारी: {data}",
 "Emitida": "जारी",
 "Emitida em {data}": "{data} को जारी",
 "Emitida ou recebida": "जारी या प्राप्त",
 "Emitidas": "जारी",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "जारी: {v} · प्राप्त: {r} · {n} इनवॉइस",
 "Emitir": "जारी करें",
 "Emitir NFS-e": "NFS-e जारी करें",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "A1 प्रमाणपत्र से Padrão Nacional द्वारा NFS-e जारी करें, जारी और प्राप्त इनवॉइस खोजें और XML, स्प्रेडशीट व PDF निर्यात करें।",
 "Emitir a nota de verdade?": "असली इनवॉइस जारी करें?",
 "Emitir no ambiente de teste?": "टेस्ट परिवेश में जारी करें?",
 "Emojis": "इमोजी",
 "Emojis animados": "एनिमेटेड इमोजी",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "एनिमेटेड इमोजी: Google का Noto (CC BY 4.0)।",
 "Emojis, GIFs e figurinhas": "इमोजी, GIF और स्टिकर",
 "Empresa": "कंपनी",
 "Empresa de mudança": "पैकर्स एंड मूवर्स",
 "Empresa ou pessoa": "कंपनी या व्यक्ति",
 "Empresa, hotel ou voo": "कंपनी, होटल या फ़्लाइट",
 "Empresas": "कंपनियाँ",
 "Emprestei": "मैंने उधार दिया",
 "Empréstimo": "उधार",
 "Empréstimo entre pessoas": "व्यक्तियों के बीच ऋण",
 "Empréstimo pessoal": "पर्सनल लोन",
 "Empréstimos": "उधार",
 "Empréstimos & Financiamentos": "ऋण और फ़ाइनेंसिंग",
 "Encaminhada para {nome}.": "{nome} को फ़ॉरवर्ड किया गया।",
 "Encaminhar": "फ़ॉरवर्ड करें",
 "Encaminhar para": "किसे फ़ॉरवर्ड करें",
 "Encerrar e salvar": "समाप्त करें और सहेजें",
 "Encontrada para {perfil}": "{perfil} के लिए मिला",
 "Endereço": "पता",
 "Endereço (opcional)": "पता (वैकल्पिक)",
 "Endereço (se for presencial)": "पता (अगर व्यक्तिगत रूप से हो)",
 "Endereço atual": "मौजूदा पता",
 "Endereço da escola": "स्कूल का पता",
 "Endereço da oficina": "वर्कशॉप का पता",
 "Endereço de quem está com o item": "जिसके पास वस्तु है उसका पता",
 "Endereço do consultório": "क्लिनिक का पता",
 "Endereço do imóvel": "संपत्ति का पता",
 "Endereço do laboratório": "लैब का पता",
 "Endereço do veterinário": "पशु चिकित्सक का पता",
 "Endereço no trabalho e na escola": "ऑफ़िस और स्कूल में पता",
 "Endereço nos Correios e entregas": "डाक और डिलीवरी में पता",
 "Endereço nos bancos e cartões": "बैंकों और कार्डों में पता",
 "Endereço novo": "नया पता",
 "Endereço ou nome do lugar": "पता या जगह का नाम",
 "Endereço ou terminal": "पता या टर्मिनल",
 "Energia": "ऊर्जा",
 "Enfermeiro": "नर्स",
 "Engenharia": "इंजीनियरिंग",
 "Engenheiro ou arquiteto": "इंजीनियर या आर्किटेक्ट",
 "Enquadre o documento e toque no botão": "दस्तावेज़ को फ़्रेम में रखें और बटन पर टैप करें",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "चेहरा फ़्रेम में रखें और बटन टैप करें। 🔄 कैमरा बदलता है।",
 "Ensino Fundamental": "प्राथमिक और माध्यमिक शिक्षा",
 "Ensino Médio e ENEM": "हाई स्कूल और ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "मैंने समझ लिया है और इन शर्तों पर मॉनिटर इस्तेमाल करने के लिए सहमत हूँ।",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "सीधे Planner में जुड़ता है, समय, दिनों और आइटम सूची के साथ। अगर वह समय पहले से भरा है, तो आप चुनें: बदलें, दोनों रखें या रद्द करें।",
 "Entrada": "आय",
 "Entrada (imóvel novo)": "प्रवेश (नया घर)",
 "Entrada de dinheiro": "पैसे की आमद",
 "Entrando...": "लॉग इन हो रहा है...",
 "Entrar": "लॉग इन करें",
 "Entrar com CPF e senha": "CPF और पासवर्ड से लॉग इन करें",
 "Entrar com outra conta": "दूसरे खाते से लॉग इन करें",
 "Entrar de novo": "फिर से साइन इन करें",
 "Entrar na chamada": "कॉल में शामिल हों",
 "Entrar na reunião": "मीटिंग में शामिल हों",
 "Entrar na sala online": "ऑनलाइन रूम में जाएँ",
 "Entrar no grupo": "समूह से जुड़ें",
 "Entrar no navegador?": "ब्राउज़र में लॉग इन करें?",
 "Entre com seu CPF e sua senha.": "अपने CPF और पासवर्ड से लॉग इन करें।",
 "Entre com seu e-mail e sua senha.": "अपने ईमेल और पासवर्ड से लॉग इन करें।",
 "Entre na sua conta de novo.": "कृपया फिर से साइन इन करें।",
 "Entre na sua conta para usar as notas fiscais.": "इनवॉइस इस्तेमाल करने के लिए अपने खाते में लॉग इन करें।",
 "Entre no app com o seu e-mail e a senha nova.": "अपने ईमेल और नए पासवर्ड से ऐप में लॉग इन करें।",
 "Entrega de material": "सामग्री की डिलीवरी",
 "Entrega prevista": "अनुमानित डिलीवरी",
 "Entregas": "डिलीवरी",
 "Entregue": "जमा किया",
 "Entrou": "आया",
 "Entrou no total da semana.": "सप्ताह के कुल में जोड़ दिया गया।",
 "Enviada": "भेजा गया",
 "Enviado": "भेज दिया गया",
 "Enviado para o Planner": "Planner में भेजा गया",
 "Enviado pelo cliente": "क्लाइंट ने भेजा",
 "Enviado pelo escritório": "ऑफ़िस ने भेजा",
 "Enviado por {quem} no grupo {g}": "{quem} ने समूह {g} में भेजा",
 "Enviando {f} de {n}...": "{n} में से {f} भेजी जा रही है...",
 "Enviando...": "भेजा जा रहा है...",
 "Enviar": "भेजें",
 "Enviar \"{nome}\"": "\"{nome}\" भेजें",
 "Enviar \"{nome}\" para…": "\"{nome}\" को भेजें…",
 "Enviar \"{titulo}\" para": "\"{titulo}\" यहाँ भेजें",
 "Enviar ao grupo": "समूह को भेजें",
 "Enviar convite": "आमंत्रण भेजें",
 "Enviar convite para {nome}": "{nome} को निमंत्रण भेजें",
 "Enviar convite pelo WhatsApp": "WhatsApp से निमंत्रण भेजें",
 "Enviar documento": "दस्तावेज़ भेजें",
 "Enviar instruções ao hóspede": "मेहमान को निर्देश भेजें",
 "Enviar o convite": "निमंत्रण भेजें",
 "Enviar ou copiar o código": "कोड भेजें या कॉपी करें",
 "Enviar ou imprimir a etiqueta": "लेबल भेजें या प्रिंट करें",
 "Enviar para Estudos": "पढ़ाई में भेजें",
 "Enviar para My Planner": "My Planner में भेजें",
 "Enviar para a equipe": "टीम को भेजें",
 "Enviar para o My Planner": "My Planner में भेजें",
 "Enviar para o Planner": "Planner में भेजें",
 "Enviar para o grupo": "समूह को भेजें",
 "Enviar para o grupo de estudos": "अध्ययन समूह को भेजें",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "इस डिवाइस की {n} फ़ाइल(ें) {nome} पर भेजें",
 "Enviar para um grupo": "किसी समूह को भेजें",
 "Enviar para {g}": "{g} को भेजें",
 "Enviar para…": "यहाँ भेजें…",
 "Enviar por e-mail": "ईमेल से भेजें",
 "Enviar relatório": "रिपोर्ट भेजें",
 "Enviar relatório para a equipe": "टीम को रिपोर्ट भेजें",
 "Enviar também as tarefas que já existem (de hoje em diante)": "पहले से मौजूद टास्क भी भेजें (आज से आगे के)",
 "Enviar tarefas do My Planner para a agenda": "My Planner के टास्क कैलेंडर में भेजें",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "क्लाइंट को कर चालान, इनवॉइस और रिपोर्ट भेजें, या देखें कि उसने क्या भेजा। हर दस्तावेज़ में फ़ोटो, PDF और लिंक जोड़े जा सकते हैं।",
 "Enxaguante": "माउथवॉश",
 "Episódio": "एपिसोड",
 "Equipe": "टीम",
 "Equipe ({n})": "टीम ({n})",
 "Equipe de limpeza": "सफ़ाई टीम",
 "Equipe do consultório": "क्लिनिक की टीम",
 "Equipe do imóvel (limpeza e co-anfitrião)": "प्रॉपर्टी की टीम (सफ़ाई और को-होस्ट)",
 "Erro": "एरर",
 "Erro na emissão": "जारी करने में त्रुटि",
 "Erro: {erro}": "त्रुटि: {erro}",
 "Erros registrados neste dispositivo ({n})": "इस डिवाइस पर दर्ज त्रुटियाँ ({n})",
 "Escanear documento": "दस्तावेज़ स्कैन करें",
 "Escanear o verso": "पिछला हिस्सा स्कैन करें",
 "Escanear para PDF": "स्कैन करके PDF बनाएँ",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "दस्तावेज़, रसीदें, नोटबुक और बोर्ड स्कैन करें: किनारे और परछाइयां ठीक, कई पेज, पहचान पत्र आगे और पीछे, हस्ताक्षर, और PDF फ़ोन, Google Drive या OneDrive में सेव।",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "स्कैन करें, इमेज को साफ़ बनाएं, फ़ोल्डरों में व्यवस्थित करें और PDF को WhatsApp, ईमेल या Drive से भेजें। आपका AI चालू होने पर ऐप टेक्स्ट पढ़ता है, सारांश बनाता है और दस्तावेज़ के बारे में सवालों के जवाब देता है।",
 "Escola": "स्कूल",
 "Escolha a aba:": "टैब चुनें:",
 "Escolha a data do compromisso.": "अपॉइंटमेंट की तारीख चुनें।",
 "Escolha a imagem.": "इमेज चुनें।",
 "Escolha a matéria": "विषय चुनें",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "फ़ोन का फ़ोल्डर चुनें (जैसे: Documents)। ऐप अपने आप वहां सेव करेगा।",
 "Escolha a página": "पेज चुनें",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "कम से कम एक न्यायालय चुनें या \"सभी न्यायालय\" पर निशान लगाएँ।",
 "Escolha ao menos uma agenda.": "कम से कम एक कैलेंडर चुनें।",
 "Escolha o PDF": "PDF चुनें",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "कंपनी के A1 प्रमाणपत्र की .pfx (या .p12) फ़ाइल चुनें और उसका पासवर्ड डालें। यह आपके वॉल्ट में एन्क्रिप्ट होकर रहता है।",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "NFS-e, NF-e या CT-e की .xml फ़ाइल चुनें।",
 "Escolha o fichário": "फ़ाइल चुनें",
 "Escolha o grupo para enviar: {t}": "भेजने के लिए समूह चुनें: {t}",
 "Escolha os PDFs": "PDF फ़ाइलें चुनें",
 "Escolha os arquivos.": "फ़ाइलें चुनें।",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "चुनें कि Planner और 🎉 अवकाश बटन में कौन-से अवकाश दिखें।",
 "Escolha para quem enviar.": "चुनें कि किसे भेजना है।",
 "Escolha pelo menos um dia.": "कम से कम एक दिन चुनें।",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "PDF में मौजूद कम से कम एक पेज चुनें (जैसे: 1-3, 5)।",
 "Escolha quem participa:": "चुनें कि कौन शामिल होगा:",
 "Escolher": "चुनें",
 "Escolher a imagem": "इमेज चुनें",
 "Escolher a pasta": "फ़ोल्डर चुनें",
 "Escolher agendas": "कैलेंडर चुनें",
 "Escolher alimento": "खाद्य पदार्थ चुनें",
 "Escolher arquivo": "फ़ाइल चुनें",
 "Escolher arquivos": "फ़ाइलें चुनें",
 "Escolher arquivos do Drive ou do OneDrive": "Drive या OneDrive से फ़ाइलें चुनें",
 "Escolher as imagens e criar o PDF": "इमेज चुनें और PDF बनाएँ",
 "Escolher da galeria": "गैलरी से चुनें",
 "Escolher da galeria ou arquivo (foto ou PDF)": "गैलरी या फ़ाइल से चुनें (फ़ोटो या PDF)",
 "Escolher data": "तिथि चुनें",
 "Escolher fuso": "टाइम ज़ोन चुनें",
 "Escolher hora": "समय चुनें",
 "Escolher horário": "समय चुनें",
 "Escolher o certificado": "प्रमाणपत्र चुनें",
 "Escolher outro": "दूसरा चुनें",
 "Escolher pessoas": "लोग चुनें",
 "Escolher tribunais": "न्यायालय चुनें",
 "Escolher ícone": "आइकन चुनें",
 "Esconder da equipe (só administradores)": "टीम से छिपाएँ (केवल एडमिन)",
 "Esconder detalhes": "विवरण छिपाएँ",
 "Esconder o texto completo": "पूरा टेक्स्ट छिपाएँ",
 "Escondido de {n} pessoa(s)": "{n} व्यक्ति(यों) से छिपा",
 "Escondido de: {n}": "इनसे छिपा: {n}",
 "Escondidos no Planner.": "Planner में छिपे हुए।",
 "Escova e pasta de dente": "टूथब्रश और टूथपेस्ट",
 "Escovar os dentes": "दाँत ब्रश करें",
 "Escreva aqui": "यहाँ लिखें",
 "Escreva e dê Enter (ex.: lavar a máquina)": "लिखें और Enter दबाएँ (जैसे: मशीन धोना)",
 "Escreva em uma ou em todas as páginas.": "एक पेज या सभी पेजों पर लिखें।",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "इनवॉइस के विवरण में \"रद्द करने का कारण\" लिखें (कम से कम 15 अक्षर) और फिर यहाँ टैप करें।",
 "Escreva o resumo, tópicos, dúvidas...": "सारांश, बिंदु, प्रश्न लिखें...",
 "Escreva o texto da marca d'água.": "वॉटरमार्क का टेक्स्ट लिखें।",
 "Escreva o texto.": "टेक्स्ट लिखें।",
 "Escreva o título.": "शीर्षक लिखें।",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "टेक्स्ट लिखें या पेस्ट करें। \"# \" से शुरू होने वाली लाइन शीर्षक बन जाती है।",
 "Escreva ou cole um texto e gere o PDF.": "टेक्स्ट लिखें या पेस्ट करें और PDF बनाएँ।",
 "Escritório": "दफ़्तर",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "दफ़्तर: टीम के दस्तावेज़ और मीटिंग। केवल दफ़्तर का एडमिनिस्ट्रेटर ही मीटिंग रिकॉर्ड कर सकता है, और रिकॉर्डिंग के दौरान मीटिंग में मौजूद सभी लोगों को \"रिकॉर्ड हो रहा है\" सूचना दिखती है। रिकॉर्डिंग दफ़्तर के दस्तावेज़ों में रहती है और जब तक एडमिनिस्ट्रेटर उसे टीम के लिए उपलब्ध न करे, केवल उसे ही दिखती है।",
 "Escuro": "डार्क",
 "Espanhol": "स्पेनिश",
 "Espaço": "प्रॉपर्टी",
 "Espaço livre, dados de cada aba e anexos": "खाली जगह, हर टैब का डेटा और अटैचमेंट",
 "Especialidade": "विशेषज्ञता",
 "Espécie": "प्रजाति",
 "Esquadro": "गुनिया",
 "Esqueci a senha": "पासवर्ड भूल गए",
 "Esquerda": "बाएँ",
 "Esse código é o seu.": "यह कोड आपका ही है।",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "यह आपका अपना कोड है। जिसने आपको ऐप सुझाया, उसका कोड इस्तेमाल करें।",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "इस पते ने इनवॉइस सर्वर की तरह जवाब नहीं दिया। जाँचें और फिर से कोशिश करें।",
 "Esta aba ainda não está no seu plano.": "यह टैब अभी आपके प्लान में नहीं है।",
 "Esta e todas as futuras": "यह और आगे के सभी",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "इस टूल को PDF के पेज देखने होते हैं, जो नए ऐप (वर्ज़न 0.50) में आता है। ब्राउज़र इस्तेमाल करें या नया APK इंस्टॉल करें।",
 "Esta imagem foi guardada em outro dispositivo.": "यह छवि किसी दूसरे डिवाइस में सहेजी गई है।",
 "Esta janela pode ser fechada.": "आप यह विंडो बंद कर सकते हैं।",
 "Esta pessoa ainda não preencheu o cartão de contato.": "इस व्यक्ति ने अभी तक अपना संपर्क कार्ड नहीं भरा है।",
 "Esta semana: {a} de {m} aulas ({p}%)": "इस सप्ताह: {m} में से {a} पाठ ({p}%)",
 "Esta senha é de outra conta.": "यह पासवर्ड किसी दूसरे खाते का है।",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "इस कार्य का कोई समय नहीं है: \"शुरू होने पर\" और \"शुरू होने से पहले\" लागू नहीं होते। \"किसी तय समय पर\" का उपयोग करें।",
 "Esta tarefa se repete. O que excluir?": "यह कार्य दोहराया जाता है। क्या हटाना है?",
 "Esta tela teve um problema": "इस स्क्रीन में समस्या आई",
 "Estado (UF) do registro": "पंजीकरण का राज्य (UF)",
 "Estado de Mato Grosso do Sul": "Mato Grosso do Sul राज्य",
 "Estado de São Paulo": "São Paulo राज्य",
 "Estado do Paraná": "Paraná राज्य",
 "Estados": "राज्य",
 "Estaduais": "राज्य",
 "Estadual": "राज्य",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "ये टैब इसी क्रम में नीचे के बार में दिखते हैं। My Planner, टैब और सेटिंग्स हमेशा रहते हैं। बाकी टैब यहीं टैब स्क्रीन पर रहते हैं।",
 "Estatística": "सांख्यिकी",
 "Este CPF já tem cadastro. Use \"Entrar\".": "यह CPF पहले से पंजीकृत है। \"लॉग इन करें\" का उपयोग करें।",
 "Este PDF está no dispositivo onde foi aberto.": "यह PDF उसी डिवाइस पर है जहाँ इसे खोला गया था।",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "यह PDF उसी डिवाइस पर है जहाँ इसे खोला गया था। वहीं खोलें, या Drive या OneDrive में सहेजी कॉपी फिर से खोलें।",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "यह PDF पासवर्ड से सुरक्षित है। जिस प्रोग्राम में यह बना था, वहाँ पासवर्ड हटाकर फिर कोशिश करें।",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "इस PDF में फ़ॉर्म फ़ील्ड नहीं हैं। इस पर लिखने के लिए \"टेक्स्ट जोड़ें\" इस्तेमाल करें।",
 "Este ano": "इस साल",
 "Este dispositivo": "यह डिवाइस",
 "Este dispositivo não consegue abrir o arquivo.": "यह डिवाइस फ़ाइल नहीं खोल सकता।",
 "Este dispositivo não consegue compartilhar arquivos.": "यह डिवाइस फ़ाइलें साझा नहीं कर सकता।",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "इस डिवाइस में स्वास्थ्य डेटा नहीं है। आप हाथ से दर्ज कर सकते हैं।",
 "Este arquivo foi guardado em outro dispositivo.": "यह फ़ाइल किसी दूसरे डिवाइस में सहेजी गई है।",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "यह फ़ाइल फ़ोन में सहेजी गई है। फ़ोन के ऐप से खोलें।",
 "Este arquivo não é um backup do My Planner.": "यह फ़ाइल My Planner का बैकअप नहीं है।",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "यह फ़ोन ऐप बंद होने पर अभी सूचनाएँ नहीं पाता। ऐप {v} या नया संस्करण इंस्टॉल करें (सर्वर सूचनाओं वाला APK)। ऐप खुला होने पर सूचनाएँ पहले से काम करती हैं।",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "यह प्रमाणपत्र {doc} का है, जो कंपनी के CNPJ/CPF ({emp}) से अलग है।",
 "Este fichário ainda não tem matérias.": "इस फ़ाइल में अभी कोई विषय नहीं है।",
 "Este grupo já está cheio.": "यह समूह पहले से भरा है।",
 "Este mês": "इस महीने",
 "Este mês: emitidas {e} · recebidas {r}": "इस महीने: जारी {e} · प्राप्त {r}",
 "Este mês: {h}": "इस महीने: {h}",
 "Este navegador": "यह ब्राउज़र",
 "Este país só tem feriados nacionais.": "इस देश में केवल राष्ट्रीय अवकाश हैं।",
 "Esteira": "ट्रेडमिल",
 "Esteticista": "ब्यूटीशियन",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "मैं अपना एजेंडा, वित्त और बहुत कुछ व्यवस्थित करने के लिए My Planner इस्तेमाल कर रहा हूँ। ऐप डाउनलोड करें और खाता बनाते समय मेरा कोड {codigo} डालें, ताकि 10 दिनों तक सभी टैब अनलॉक मिलें।",
 "Estratégia": "रणनीति",
 "Estrela": "तारा",
 "Estudando": "पढ़ाई जारी",
 "Estudar agora": "अभी पढ़ें",
 "Estudar {nome}": "{nome} पढ़ें",
 "Estudar: {c}": "पढ़ाई: {c}",
 "Estudo": "अध्ययन",
 "Estudos": "पढ़ाई",
 "Estudos e exatas": "पढ़ाई और विज्ञान",
 "Estudos, lazer e viagens": "पढ़ाई, मनोरंजन और यात्रा",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "यह संपत्ति और आयकर › कटौती योग्य रसीदें में है। वहाँ रसीद की फ़ोटो और भुगतान पाने वाले का CPF या CNPJ जोड़ें।",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "यह पेज \"{titulo}\" में और \"फ़ाइलें देखें\" में है।",
 "Etanol": "इथेनॉल",
 "Etapa": "चरण",
 "Etapa do cronograma": "समय-सारणी का चरण",
 "Etapas": "चरण",
 "Evento": "इवेंट",
 "Eventos": "इवेंट",
 "Eventos & Celebrações": "इवेंट और उत्सव",
 "Evolução (no cofre)": "प्रगति नोट्स (वॉल्ट में)",
 "Ex.: 08:00 e 20:00": "उदा.: 08:00 और 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "उदा.: 08:00, 14:00 और 20:00",
 "Ex.: 09/2026": "जैसे: 09/2026",
 "Ex.: 1 comprimido": "उदा.: 1 गोली",
 "Ex.: 1-3, 4-10, 11-": "जैसे: 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "जैसे: 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "जैसे: 171901 (कंसल्टिंग), 010101 (प्रोग्रामिंग)",
 "Ex.: 40 sacos de cimento": "उदा.: सीमेंट की 40 बोरियाँ",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "जैसे: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "उदा.: कक्षा 8 B",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "जैसे: कमर की स्ट्रेचिंग, 1,800 kcal डाइट",
 "Ex.: Aniversário de 30 anos da Ana": "उदा.: Ana का 30वाँ जन्मदिन",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "जैसे: बीच वाला अपार्टमेंट, सुइट 1, आउटहाउस",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "उदा.: X स्ट्रीट का अपार्टमेंट, PETR4 के 100 शेयर",
 "Ex.: Aula de revisão, Consulta de retorno": "उदा.: रिवीज़न क्लास, फ़ॉलो-अप अपॉइंटमेंट",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "उदा.: कैटरिंग, DJ, सजावट, फ़ोटोग्राफ़र",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "जैसे: गोपनीय, कॉपी, ड्राफ़्ट",
 "Ex.: Cardiologista": "उदा.: हृदय रोग विशेषज्ञ",
 "Ex.: Consultoria mensal": "जैसे: मासिक कंसल्टिंग",
 "Ex.: Costela-de-adão da sala": "उदा.: लिविंग रूम का मॉन्स्टेरा",
 "Ex.: DAS de setembro, Extrato do Itaú": "जैसे: सितंबर का DAS, Itaú स्टेटमेंट",
 "Ex.: Desmontar os móveis do quarto": "उदा.: बेडरूम का फ़र्नीचर खोलना",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "उदा.: उपलब्ध · शाम 6 बजे तक क्लास में · चलो घूमने!",
 "Ex.: Eletricista, loja de material": "उदा.: इलेक्ट्रीशियन, बिल्डिंग मटेरियल की दुकान",
 "Ex.: Entrada dos noivos": "उदा.: दूल्हा-दुल्हन का प्रवेश",
 "Ex.: Financiamento do carro": "जैसे: कार लोन",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "जैसे: फ़िज़ियोथेरेपिस्ट, न्यूट्रिशनिस्ट, कार्डियोलॉजिस्ट",
 "Ex.: Furadeira, livro, R$ 200": "उदा.: ड्रिल मशीन, किताब, R$ 200",
 "Ex.: Hemograma": "उदा.: CBC (रक्त जाँच)",
 "Ex.: IPVA 2027, parcela 1": "उदा.: IPVA 2027, किस्त 1",
 "Ex.: Lisboa, Portugal": "उदा.: लिस्बन, पुर्तगाल",
 "Ex.: Mala da Ana": "उदा.: Ana का सूटकेस",
 "Ex.: Mensalidade de outubro, material": "जैसे: अक्टूबर की फ़ीस, सामग्री",
 "Ex.: Netflix, cinema": "उदा.: Netflix, सिनेमा",
 "Ex.: Notas de compra de setembro": "जैसे: सितंबर के खरीद इनवॉइस",
 "Ex.: Onix 2022": "उदा.: Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "उदा.: टेस्ट 1, समूह कार्य",
 "Ex.: Prova de matemática": "उदा.: गणित की परीक्षा",
 "Ex.: Pôr do sol no Tejo": "उदा.: टेजो नदी पर सूर्यास्त",
 "Ex.: Reforma da cozinha": "उदा.: रसोई का नवीनीकरण",
 "Ex.: TAP TP 108": "उदा.: TAP TP 108",
 "Ex.: Torre de Belém": "उदा.: बेलें टावर",
 "Ex.: Troca da fiação da sala": "उदा.: लिविंग रूम की वायरिंग बदलना",
 "Ex.: V10, antirrábica": "उदा.: V10, रेबीज़ टीका",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "उदा.: जेरोनिमोस मठ की सैर",
 "Ex.: cerâmica 30 cm": "उदा.: 30 सेमी टाइल",
 "Ex.: kg, pacotes, latas": "उदा.: kg, पैकेट, डिब्बे",
 "Ex.: seg e qua, 07:30": "उदा.: सोम और बुध, 07:30",
 "Ex.: troquei o arroz por batata doce": "जैसे: चावल की जगह शकरकंद खाई",
 "Ex.: varanda, sala": "उदा.: बालकनी, बैठक",
 "Exame": "जाँच",
 "Exame da OAB": "OAB परीक्षा",
 "Exames": "जाँचें",
 "Excel": "Excel",
 "Excluir": "हटाएँ",
 "Excluir \"{nome}\"?": "\"{nome}\" हटाएँ?",
 "Excluir \"{titulo}\"?": "\"{titulo}\" हटाएँ?",
 "Excluir a caixa?": "बॉक्स हटाएँ?",
 "Excluir a compra": "खरीदारी हटाएँ",
 "Excluir a compra?": "खरीदारी हटाएँ?",
 "Excluir a meta \"{m}\"?": "लक्ष्य \"{m}\" हटाएँ?",
 "Excluir cartão": "कार्ड हटाएँ",
 "Excluir conta": "बिल हटाएँ",
 "Excluir cuidado": "देखभाल हटाएँ",
 "Excluir cômodo": "कमरा हटाएँ",
 "Excluir esta página?": "यह पेज हटाएं?",
 "Excluir fichário": "फ़ाइल हटाएँ",
 "Excluir matéria": "विषय हटाएँ",
 "Excluir o cartão \"{c}\"?": "कार्ड \"{c}\" हटाएँ?",
 "Excluir o documento": "दस्तावेज़ हटाएं",
 "Excluir o fichário {nome}": "फ़ाइल {nome} हटाएँ",
 "Excluir página": "पेज हटाएँ",
 "Excluir refeição": "भोजन हटाएँ",
 "Excluir suplemento": "सप्लीमेंट हटाएँ",
 "Excluir tarefa": "कार्य हटाएँ",
 "Excluir tarefa repetida": "दोहराने वाला कार्य हटाएँ",
 "Excluir tarefa?": "कार्य हटाएँ?",
 "Excluir treino": "वर्कआउट हटाएँ",
 "Excluir {nome}?": "{nome} हटाएँ?",
 "Excluídas em definitivo 30 dias depois do descarte.": "हटाए जाने के 30 दिन बाद स्थायी रूप से मिटा दिए जाते हैं।",
 "Executivo e profissional": "कार्यकारी और पेशेवर",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "अनुबंध का पालन (art. 7º, V), सेवा देने के लिए; सहमति (art. 7º, I), कैमरा, गैलरी, माइक्रोफ़ोन और लोकेशन के लिए; कानूनी दायित्व का पालन (art. 7º, II); और वैध हित (art. 7º, IX), सुरक्षा और धोखाधड़ी रोकने के लिए।",
 "Exemplos: 13:30, 1330, 9:05": "उदाहरण: 13:30, 1330, 9:05",
 "Exercício": "व्यायाम",
 "Exercício físico": "व्यायाम",
 "Experimente grátis por {n} dias": "{n} दिन मुफ़्त आज़माएँ",
 "Explique o motivo (para cancelar)": "कारण बताएँ (रद्द करने के लिए)",
 "Exportar arquivo": "फ़ाइल एक्सपोर्ट करें",
 "Exportar para o contador": "अकाउंटेंट के लिए निर्यात करें",
 "Extrair páginas": "पेज निकालें",
 "Extras (pet, check-in tardio...)": "अतिरिक्त (पालतू जानवर, देर से चेक-इन...)",
 "Extrato": "स्टेटमेंट",
 "Extrato bancário": "बैंक स्टेटमेंट",
 "Extrato do banco (foto ou PDF)": "बैंक स्टेटमेंट (फ़ोटो या PDF)",
 "Extrato importado": "स्टेटमेंट इम्पोर्ट हो गया",
 "Extrato por foto": "फ़ोटो से स्टेटमेंट",
 "FRASE": "स्टेटस",
 "FRÁGIL": "नाज़ुक",
 "Fabricante ou estendida: {n} meses": "निर्माता या विस्तारित: {n} महीने",
 "Facultativo": "वैकल्पिक",
 "Falar com a limpeza": "सफ़ाई वाले से बात करें",
 "Fale conosco": "हमसे संपर्क करें",
 "Falta": "अनुपस्थित",
 "Falta XML": "XML नहीं है",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "इनवॉइस सर्वर अभी चालू नहीं है: कंप्यूटर पर 13-LIGAR-NOTAS.bat पर डबल-क्लिक करें और जो पता दिखे उसे यहाँ चिपकाएँ।",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Health Connect नहीं है, यह Google का ऐप है जो घड़ियों और हेल्थ ऐप्स का डेटा इकट्ठा करता है।",
 "Faltam": "बाकी",
 "Faltam {ml} ({n} copo(s))": "{ml} बाकी ({n} गिलास)",
 "Faltam {n} dia(s) do seu período grátis": "आपकी मुफ़्त अवधि के {n} दिन बाकी हैं",
 "Faltam {n} dias": "{n} दिन बाकी",
 "Faltou": "नहीं आए",
 "Família": "परिवार",
 "Fantasia": "फ़ैंटेसी",
 "Fatura": "कार्ड बिल",
 "Fatura com vencimento em {d}.": "{d} को देय कार्ड बिल।",
 "Fatura de {mes}": "{mes} का कार्ड बिल",
 "Fatura de {mes}: vence {data}": "{mes} का कार्ड बिल: देय {data}",
 "Fatura do cartão (foto ou PDF)": "कार्ड बिल (फ़ोटो या PDF)",
 "Fatura importada": "कार्ड बिल इम्पोर्ट हुआ",
 "Fatura paga (toque para desfazer)": "बिल चुकाया गया (पूर्ववत करने के लिए टैप करें)",
 "Fatura {c}": "{c} कार्ड बिल",
 "Faturamento em {ano}: {v} de {lim}": "{ano} में कारोबार: {lim} में से {v}",
 "Faturas dos cartões": "कार्ड बिल",
 "Fazer agora, passo a passo": "अभी करें, चरण-दर-चरण",
 "Fazer com este PDF": "इस PDF के साथ करें",
 "Fazer cópia agora": "अभी बैकअप लें",
 "Fecha dia {f} · vence dia {v}": "{f} तारीख को बंद · {v} तारीख को देय",
 "Fecha {f} · vence {v}": "बंद {f} · देय {v}",
 "Fechar": "बंद करें",
 "Fechar o cofre": "वॉल्ट बंद करें",
 "Feche e abra o app de novo": "ऐप बंद करके फिर खोलें",
 "Federais": "संघीय",
 "Feijão": "बीन्स",
 "Feita em {data}": "{data} को पूरा",
 "Feita hoje": "आज पूरा",
 "Feitas": "हो गईं",
 "Feitas (não se repetem) · {n}": "पूरे (दोहराते नहीं) · {n}",
 "Feito": "हो गया",
 "Feito!": "हो गया!",
 "Feliz aniversário": "जन्मदिन मुबारक",
 "Feminino": "स्त्री",
 "Feminino e suave": "स्त्रैण और कोमल",
 "Feriado escolar": "स्कूल की छुट्टी",
 "Feriado estadual": "राज्य अवकाश",
 "Feriado estadual: {nome}": "राज्य अवकाश: {nome}",
 "Feriado municipal": "नगर अवकाश",
 "Feriado municipal: {nome}": "नगरपालिका अवकाश: {nome}",
 "Feriado nacional": "राष्ट्रीय अवकाश",
 "Feriado nacional: {nome}": "राष्ट्रीय अवकाश: {nome}",
 "Feriado regional": "क्षेत्रीय अवकाश",
 "Feriado regional: {nome}": "क्षेत्रीय अवकाश: {nome}",
 "Feriados": "अवकाश",
 "Feriados nacionais": "राष्ट्रीय अवकाश",
 "Feriados no planner": "प्लानर में अवकाश",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "अवकाश, विनिमय दरें, आर्टिफ़िशियल इंटेलिजेंस के सुझाव और बिलों व रसीदों की स्वचालित रीडिंग में गलतियाँ हो सकती हैं। इस्तेमाल से पहले जाँच लें।",
 "Ferramenta": "औज़ार",
 "Ferramentas": "औज़ार",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "हर पौधे का रिकॉर्ड, गमला बदलना और एजेंडा में पानी व खाद का कैलेंडर।",
 "Ficha preenchida": "फ़ॉर्म भर दिया गया",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "फ़ाइलें, विषय और पेज, पढ़ाई का टाइमर और साप्ताहिक लक्ष्य।",
 "Ficção": "कथा साहित्य",
 "Figurinha": "स्टिकर",
 "Figurinhas": "स्टिकर",
 "Filme": "फ़िल्म",
 "Filme ou série": "फ़िल्म या सीरीज़",
 "Filmes e séries": "फ़िल्में और सीरीज़",
 "Filosofia": "दर्शनशास्त्र",
 "Filtros": "फ़िल्टर",
 "Fim": "समाप्ति",
 "Fim (vazio = uso contínuo)": "अंत (खाली = लगातार उपयोग)",
 "Fim da garantia": "वारंटी समाप्ति",
 "Fim da garantia:": "वारंटी समाप्ति:",
 "Fim da pausa. Continue: {tarefa}": "ब्रेक ख़त्म। जारी रखें: {tarefa}",
 "Fim de semana": "सप्ताहांत",
 "Fim previsto": "अनुमानित समाप्ति",
 "Fina": "पतला",
 "Finados": "मृतक स्मृति दिवस",
 "Finalizador": "फ़िनिशिंग प्रोडक्ट",
 "Financeiro": "वित्त",
 "Financeiro: {gasto} de {orcado} ({p}%)": "वित्तीय: {orcado} में से {gasto} ({p}%)",
 "Financiamento": "लोन",
 "Financiamento de veículo": "वाहन लोन",
 "Financiamento imobiliário": "होम लोन",
 "Financiamentos": "फ़ाइनेंसिंग",
 "Financiamentos e empréstimos": "फ़ाइनेंसिंग और ऋण",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "किस्तों, ब्याज, बकाया राशि और रसीदों के साथ फ़ाइनेंसिंग और ऋण; उधार दी गई चीज़ें फ़ोटो और वापसी की याद के साथ।",
 "Finanças": "वित्त",
 "Finanças {p}": "वित्त {p}",
 "Finanças · {p}": "वित्त · {p}",
 "Fins de semana": "सप्ताहांत",
 "Fio dental": "डेंटल फ़्लॉस",
 "Flex": "फ़्लेक्स",
 "Flexão de braço": "पुश-अप",
 "Flor": "फूल",
 "Flutua": "तैरना",
 "Foguete": "रॉकेट",
 "Fogão": "चूल्हा",
 "Foi no cartão de crédito? Lançar como compra no cartão": "क्रेडिट कार्ड से भुगतान किया? कार्ड खरीदारी के रूप में दर्ज करें",
 "Foi para {destino}.": "{destino} पर भेजा गया।",
 "Foi para {destino}. Quer tirar daqui?": "{destino} पर भेजा गया। यहाँ से हटाएँ?",
 "Folha de pagamento": "पेरोल",
 "Fone": "ईयरपीस",
 "Fone de ouvido": "ईयरफ़ोन",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "स्रोत: ब्राज़ील, संघीय अवकाश अधिसूचना और हर राज्य के कानूनों के आधार पर ऐप में गणना। अन्य देश: सार्वजनिक डेटाबेस Nager.Date (date.nager.at), इंटरनेट से डाउनलोड करके डिवाइस पर सहेजा गया।",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "स्रोत: ब्राज़ील के लिए, संघीय अवकाश अधिसूचना, हर राज्य के कानूनों और राजधानियों के आधिकारिक कैलेंडर के आधार पर ऐप में गणना। अन्य देश: सार्वजनिक डेटाबेस Nager.Date (date.nager.at), इंटरनेट से डाउनलोड करके डिवाइस में सहेजा गया।",
 "Forma": "तरीका",
 "Forma das parcelas": "किस्तों का तरीका",
 "Forma de pagamento": "भुगतान का तरीका",
 "Forma de pagamento: {f}.": "भुगतान का तरीका: {f}।",
 "Formas": "आकृतियाँ",
 "Formato": "फ़ॉर्मैट",
 "Formatos": "आकृतियाँ",
 "Formatura": "दीक्षांत समारोह",
 "Fornecedor": "विक्रेता",
 "Fornecedores": "विक्रेता",
 "Forte": "गहरा",
 "Foto": "फ़ोटो",
 "Foto da galeria": "गैलरी से फ़ोटो",
 "Foto do contato": "संपर्क की फ़ोटो",
 "Foto inteira": "पूरी फ़ोटो",
 "Foto ou PDF (lido pela sua IA)": "फ़ोटो या PDF (आपका AI पढ़ेगा)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "घर छोड़ते और नए घर में जाते समय निरीक्षण में हर कमरे की फ़ोटो लें। घर लौटाते समय ये फ़ोटो आपकी रक्षा करती हैं।",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "डॉक्टर, दंत चिकित्सक, स्कूल और पेंशन की हर रसीद भुगतान करते ही फ़ोटो ले लें। साल के अंत में सब तैयार रहेगा।",
 "Fotos": "फ़ोटो",
 "Fotos JPG, PNG e outras viram um PDF.": "JPG, PNG और दूसरी फ़ोटो एक PDF बन जाती हैं।",
 "Fotos de {d}": "{d} की फ़ोटो",
 "Fotos do espaço pronto": "तैयार जगह की फ़ोटो",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "इस रिकॉर्ड की फ़ोटो और फ़ाइलें समूह के फ़ोल्डर में भी जाती हैं, ताकि सदस्य उन्हें खोल सकें।",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "फ़ोटो और फ़ाइलें केवल इसी डिवाइस पर सहेजी जाती हैं। दस्तावेज़ का डेटा आपके खाते में सुरक्षित रहता है।",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "फ़ोटो और फ़ाइलें इसी डिवाइस पर रहती हैं (और सेटिंग्स में जुड़ा हो तो आपके Drive या OneDrive में भी)।",
 "Fotos e notas": "फ़ोटो और नोट्स",
 "Fotos e vídeos": "फ़ोटो और वीडियो",
 "Fotos, arquivos e links": "फ़ोटो, फ़ाइलें और लिंक",
 "Fraldas e lenços": "डायपर और वाइप्स",
 "Francês": "फ़्रेंच",
 "Frango com osso": "हड्डी वाला चिकन",
 "Frango sem osso": "बोनलेस चिकन",
 "Frase (opcional, ex.: Bom dia!)": "वाक्य (वैकल्पिक, जैसे: सुप्रभात!)",
 "Freelancer & Projetos": "फ़्रीलांसर और प्रोजेक्ट",
 "Freezer": "फ़्रीज़र",
 "Freios": "ब्रेक",
 "Frente": "आगे",
 "Frente do documento": "दस्तावेज़ का आगे का भाग",
 "Frente e verso na mesma folha": "आगे और पीछे एक ही पेज पर",
 "Frente pronta": "सामने का हिस्सा तैयार",
 "Frequência": "आवृत्ति",
 "Frio": "ठंडा",
 "Fruta": "फल",
 "Frágil": "नाज़ुक",
 "Fundação e estrutura": "नींव और ढाँचा",
 "Fundo": "बैकग्राउंड",
 "Fundos e renda fixa": "फ़ंड और फ़िक्स्ड इनकम",
 "Fuso": "समय क्षेत्र",
 "Fuso horário": "समय क्षेत्र",
 "Fuso horário do destino": "गंतव्य का टाइम ज़ोन",
 "Futebol": "फ़ुटबॉल",
 "Física": "भौतिकी",
 "Físico (obra pronta): {p}%": "भौतिक (पूरा काम): {p}%",
 "GASTOS POR CATEGORIA": "श्रेणी के अनुसार खर्च",
 "GIF guardado nos seus GIFs.": "GIF आपके GIF में सहेजा गया।",
 "Garagem": "गैराज",
 "Garantia": "वारंटी",
 "Garantia até {data}.": "{data} तक वारंटी।",
 "Garantia legal": "क़ानूनी वारंटी",
 "Garantia vencendo": "वारंटी समाप्त होने वाली है",
 "Garantias": "वारंटी",
 "Garrafa de água": "पानी की बोतल",
 "Gasolina": "पेट्रोल",
 "Gasto": "खर्च",
 "Gasto até agora": "अब तक ख़र्च",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "{v} का खर्च दर्ज हुआ। आपकी खरीदारी सूची के लिए {n} कीमत(ें) सहेजी गईं।",
 "Gasto neste mês: {v}": "इस महीने खर्च: {v}",
 "Gasto: {v}": "ख़र्च: {v}",
 "Gastos": "ख़र्चे",
 "Gastos por categoria": "श्रेणी के अनुसार खर्च",
 "Gato": "बिल्ली",
 "Geladeira": "फ़्रिज",
 "Geografia": "भूगोल",
 "Gerado por": "इससे जनरेट किया गया",
 "Gerando QR Code...": "QR कोड बन रहा है...",
 "Gerar PDF": "PDF बनाएँ",
 "Gerar as cobranças do mês": "इस महीने के शुल्क बनाएँ",
 "Gerar as parcelas": "किस्तें बनाएँ",
 "Gerar lista da mala": "सामान की सूची बनाएँ",
 "Gerar pelo cardápio e pela despensa": "मेनू और पैंट्री से बनाएँ",
 "Gesso e forro": "जिप्सम और फ़ॉल्स सीलिंग",
 "Gira todas as páginas ou só as escolhidas.": "सभी पेज या सिर्फ़ चुने हुए पेज घुमाता है।",
 "Girar": "घुमाएं",
 "Google Drive e OneDrive": "Google Drive और OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive, OneDrive और Google कैलेंडर: केवल तभी जब आप कनेक्ट करें, और केवल आपकी फ़ाइलें और इवेंट सहेजने के लिए।",
 "Gorro, cachecol e luvas": "ऊनी टोपी, मफ़लर और दस्ताने",
 "Gota": "बूँद",
 "Graduação e Pós": "स्नातक और स्नातकोत्तर",
 "Grande": "बड़ा",
 "Gravando": "रिकॉर्ड हो रहा है",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "जब आप कहें, तब आवाज़ से रिमाइंडर और नोट्स रिकॉर्ड करना। माइक्रोफ़ोन केवल आपके टैप करने पर चालू होता है।",
 "Gravar reunião": "मीटिंग रिकॉर्ड करें",
 "Gravação de áudio": "ऑडियो रिकॉर्डिंग",
 "Gravações das reuniões": "मीटिंग की रिकॉर्डिंग",
 "Grossa": "मोटा",
 "Grupo": "समूह",
 "Grupo com convite (turma, equipe, convidados)": "आमंत्रण वाला समूह (कक्षा, टीम, मेहमान)",
 "Grupo criado": "ग्रुप बनाया गया",
 "Grupo da família": "परिवार समूह",
 "Grupo da mudança (família e ajudantes)": "शिफ़्टिंग समूह (परिवार और सहायक)",
 "Grupo da obra (equipe)": "निर्माण समूह (टीम)",
 "Grupo da turma (convidar alunos)": "कक्षा समूह (छात्रों को आमंत्रित करें)",
 "Grupo da viagem (convidar quem vai)": "यात्रा समूह (साथ जाने वालों को आमंत्रित करें)",
 "Grupo de cuidado (família ou profissional)": "देखभाल समूह (परिवार या पेशेवर)",
 "Grupo de estudos (convidar colegas)": "अध्ययन समूह (साथियों को आमंत्रित करें)",
 "Grupo de leitura (convidar)": "पठन समूह (आमंत्रित करें)",
 "Grupo do cliente": "क्लाइंट समूह",
 "Grupo do evento (convidar)": "इवेंट समूह (आमंत्रित करें)",
 "Grupos": "समूह",
 "Grupos de estudo": "अध्ययन समूह",
 "Grupos de {aba}": "{aba} के समूह",
 "Grupos desta aba: {n}": "इस टैब के समूह: {n}",
 "Grupos e convites": "समूह और आमंत्रण",
 "Grátis no lançamento": "लॉन्च में मुफ़्त",
 "Guarda-chuva": "छाता",
 "Guardada nas suas figurinhas.": "आपके स्टिकर में सहेजा गया।",
 "Guardado": "बचाया गया",
 "Guardado até agora: {v}": "अब तक बचाया: {v}",
 "Guardado em outro dispositivo": "दूसरे डिवाइस में सहेजा गया",
 "Guardado na pasta \"{pasta}\" do celular.": "मोबाइल के \"{pasta}\" फ़ोल्डर में सहेजा गया।",
 "Guardado no cofre, com criptografia de ponta a ponta.": "वॉल्ट में एंड-टू-एंड एन्क्रिप्शन के साथ सहेजा गया।",
 "Guardado no {nome}.": "{nome} में सहेजा गया।",
 "Guardado {onde} em {quando}": "{quando} को {onde} में सेव किया गया",
 "Guardando...": "सहेजा जा रहा है...",
 "Guardar": "बचाएँ",
 "Guardar como recibo do IR": "IR (आयकर) रसीद के रूप में सहेजें",
 "Guardar dinheiro": "पैसे बचाएँ",
 "Guardar e enviar": "सेव करें और भेजें",
 "Guardar na meta": "लक्ष्य में जोड़ें",
 "Guardar nas minhas figurinhas": "मेरे स्टिकर में सहेजें",
 "Guardar nos meus GIFs": "मेरे GIF में सहेजें",
 "Guardar o PDF {onde}": "PDF {onde} में सेव करें",
 "Guardar os PDFs em": "PDF यहां सेव करें",
 "Guardar os arquivos prontos em": "तैयार फ़ाइलें यहाँ सहेजें",
 "Guardar sozinho cada arquivo pronto": "हर तैयार फ़ाइल अपने आप सहेजें",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "जो पर्चे और निर्देश आप अक्सर देते हैं, उन्हें सहेजें। अपॉइंटमेंट में ⋮ › टेम्पलेट इस्तेमाल करें पर टैप करें।",
 "Guarde seus documentos num lugar só": "अपने दस्तावेज़ एक ही जगह रखें",
 "Guarde {v} por mês até {d}": "{d} तक हर महीने {v} बचाएँ",
 "Guardou": "बचाया",
 "Guia de imposto": "कर चालान",
 "Gás": "गैस",
 "Gênero ou categoria": "शैली या श्रेणी",
 "HISTÓRICO DOS DADOS": "डेटा का इतिहास",
 "HOJE": "आज",
 "Hall de entrada": "प्रवेश हॉल",
 "Halteres": "डम्बल",
 "Hexágono": "षट्भुज",
 "Hidratante": "मॉइस्चराइज़र",
 "Hidratante labial": "लिप बाम",
 "Hidráulica": "प्लंबिंग",
 "Higiene bucal": "मुँह की सफ़ाई",
 "Higienizar": "साफ़ करें",
 "História": "इतिहास",
 "Histórico": "इतिहास",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "परिवार का स्वास्थ्य इतिहास, सुरक्षित जाँचें, टीके, डॉक्टर विज़िट और टाइमलाइन में दवा के अलार्म।",
 "Hmm...": "हम्म...",
 "Hoje": "आज",
 "Hoje: {a} de {m} aulas ({p}%)": "आज: {m} में से {a} पाठ ({p}%)",
 "Hoje: {n} página(s)": "आज: {n} पेज",
 "Hora": "समय",
 "Hora da pausa": "ब्रेक का समय",
 "Hora de voltar": "लौटने का समय",
 "Hora de voltar!": "लौटने का समय!",
 "Hora do check-in": "चेक-इन का समय",
 "Hora do check-out": "चेक-आउट का समय",
 "Horas": "घंटे",
 "Horas de sono": "नींद के घंटे",
 "Horário": "समय",
 "Horário de check-in": "चेक-इन का समय",
 "Horário de check-out": "चेक-आउट का समय",
 "Horário do lembrete": "रिमाइंडर का समय",
 "Horário inválido": "अमान्य समय",
 "Horário ocupado": "समय पहले से भरा है",
 "Horários": "समय",
 "Horários (remédio diário)": "समय (रोज़ की दवा)",
 "Hospedados agora": "अभी ठहरे हुए",
 "Hospedagem": "ठहरना",
 "Hospital ou pronto-socorro de referência": "पसंदीदा अस्पताल या इमरजेंसी",
 "Hotel": "होटल",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "My Planner Web का नया संस्करण उपलब्ध है। उपयोग के लिए रीलोड करें।",
 "Híbrido": "हाइब्रिड",
 "Hóspede": "मेहमान",
 "Hóspede ({c})": "मेहमान ({c})",
 "Hóspedes (máximo)": "अधिकतम मेहमान",
 "IA ligada": "AI चालू",
 "IA não ligada": "AI बंद",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "AI बंद है। सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस में चालू करें।",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "सेवा प्राप्तकर्ता द्वारा ISS रोका गया",
 "Ida": "जाना",
 "Identidade": "पहचान पत्र",
 "Idioma": "भाषा",
 "Idiomas": "भाषाएँ",
 "Ilimitados": "असीमित",
 "Imagem": "छवि",
 "Imagem escolhida (trocar)": "इमेज चुनी गई (बदलें)",
 "Imagem guardada no {nome}. Toque para abrir.": "इमेज {nome} में सहेजी गई। खोलने के लिए टैप करें।",
 "Imagens para PDF": "इमेज से PDF",
 "Imagens {data}": "इमेज {data}",
 "Imperdíveis": "ज़रूर देखें",
 "Imperdível": "ज़रूर देखें",
 "Importar": "इम्पोर्ट",
 "Importar XML de nota": "इनवॉइस का XML आयात करें",
 "Importar arquivo": "फ़ाइल इम्पोर्ट करें",
 "Importar backup?": "बैकअप इम्पोर्ट करें?",
 "Importar extrato": "स्टेटमेंट इम्पोर्ट करें",
 "Importar extrato do banco (OFX ou CSV)": "बैंक स्टेटमेंट इम्पोर्ट करें (OFX या CSV)",
 "Importar fatura": "कार्ड बिल इम्पोर्ट करें",
 "Importar fotos": "फ़ोटो इंपोर्ट करें",
 "Importar reservas do Airbnb, Booking...": "Airbnb, Booking... से बुकिंग इंपोर्ट करें",
 "Importar {n} lançamento(s)": "{n} प्रविष्टि(याँ) इम्पोर्ट करें",
 "Imóveis e espaços": "प्रॉपर्टी और जगहें",
 "Imóvel": "मकान",
 "Imóvel inteiro": "पूरी प्रॉपर्टी",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "पूरी प्रॉपर्टी या कमरे के हिसाब से: Airbnb, Booking या सीधी बुकिंग, चेक-आउट पर सफ़ाई, खर्च, ऑक्यूपेंसी और महीने का मुनाफ़ा।",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "इसमें इनवॉइस (NF) टैब में जारी इनवॉइस के {v} शामिल हैं।",
 "Independência do Brasil": "ब्राज़ील स्वतंत्रता दिवस",
 "Indicação": "रेफ़रल",
 "Indique e ganhe": "रेफ़र करें और पाएँ",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "My Planner दोस्तों और परिवार को सुझाएँ। जो आपके कोड से खाता बनाएगा, उसे 10 दिनों तक सभी टैब अनलॉक मिलेंगे।",
 "Infantil": "बाल साहित्य",
 "Informações do PDF": "PDF की जानकारी",
 "Informe a descrição e o valor.": "विवरण और राशि दर्ज करें।",
 "Informe de quantos em quantos dias regar ou adubar.": "बताएँ कि कितने-कितने दिन में पानी या खाद देनी है।",
 "Informe o nome do produto.": "उत्पाद का नाम दर्ज करें।",
 "Informe o rótulo e o nome.": "लेबल और नाम दर्ज करें।",
 "Informe o total de aulas da matéria em Editar.": "संपादित करें में विषय के कुल पाठ लिखें।",
 "Informe o valor.": "राशि दर्ज करें।",
 "Informe os horários": "समय बताएँ",
 "Informe quanto quer juntar.": "बताएँ कि कितना जमा करना है।",
 "Informe seu nome.": "अपना नाम दर्ज करें।",
 "Informática": "कंप्यूटर",
 "Inglês": "अंग्रेज़ी",
 "Ingredientes (um por linha)": "सामग्री (हर लाइन में एक)",
 "Inscrição municipal (se tiver)": "नगर पंजीकरण (अगर हो)",
 "Inspeção": "वाहन निरीक्षण",
 "Instalar ou atualizar o Health Connect": "Health Connect इंस्टॉल या अपडेट करें",
 "Instruções, receita, observações...": "निर्देश, विधि, टिप्पणियाँ...",
 "Insumos (papel, sabonete, café)": "ज़रूरी सामान (टॉयलेट पेपर, साबुन, कॉफ़ी)",
 "Inteligência artificial": "आर्टिफ़िशियल इंटेलिजेंस",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "आर्टिफ़िशियल इंटेलिजेंस (Claude, ChatGPT या Gemini): केवल तभी जब आप चालू करें, आपकी अपनी कुंजी से, जो सिर्फ़ डिवाइस में रहती है। सवाल का टेक्स्ट सीधे चुनी गई सेवा को जाता है।",
 "Intensidade": "तीव्रता",
 "Internação": "अस्पताल में भर्ती",
 "Internet": "इंटरनेट",
 "Intimação": "न्यायिक सूचना",
 "Intimação com prazo": "समय-सीमा वाली न्यायिक सूचना",
 "Investimento": "निवेश",
 "Investimentos": "निवेश",
 "Início": "आरंभ",
 "Início {ini} · Fim {fim} · Duração {dur}": "शुरुआत {ini} · समाप्ति {fim} · अवधि {dur}",
 "Iogurte": "दही",
 "Ir para Ajustes (exportar meus dados)": "सेटिंग्स पर जाएँ (मेरा डेटा निर्यात करें)",
 "Ir para hoje": "आज पर जाएँ",
 "Ir para o My Planner Web": "My Planner Web पर जाएँ",
 "Italiano": "इतालवी",
 "Item": "आइटम",
 "Item da despensa": "पैंट्री का सामान",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "सुरक्षित आइटम: फ़ोटो और फ़ाइलें तिजोरी में एन्क्रिप्ट होती हैं, सिर्फ़ इस डिवाइस पर (Drive या OneDrive पर नहीं जातीं)।",
 "Itens": "सामान",
 "Itens de higiene (xampu, sabonete)": "स्वच्छता का सामान (शैम्पू, साबुन)",
 "Jantar": "रात का भोजन",
 "Japonês": "जापानी",
 "Jaqueta impermeável": "वाटरप्रूफ़ जैकेट",
 "Jogo": "गेम",
 "Jovem e divertido": "युवा और मज़ेदार",
 "Juntar PDFs": "PDF जोड़ें",
 "Juros": "ब्याज",
 "Juros ainda por vir: {v}": "आगे का ब्याज: {v}",
 "Juros ao mês": "मासिक ब्याज",
 "JÁ RESPONDIDOS": "जवाब दिए गए",
 "Já aberta na casa nova": "नए घर में खोल दिया",
 "Já enviado para a turma": "कक्षा को भेजा जा चुका",
 "Já está compacto": "पहले से कॉम्पैक्ट है",
 "Já está no Planner": "पहले से Planner में है",
 "Já está pago": "भुगतान हो चुका है",
 "Já há horários deste item no My Planner": "इस आइटम के समय पहले से My Planner में हैं",
 "Já pago: {v}": "चुकाया जा चुका: {v}",
 "Já tenho o app: abrir nele": "मेरे पास ऐप है: उसमें खोलें",
 "Já tenho o app: abrir o convite nele": "मेरे पास ऐप है: आमंत्रण उसमें खोलें",
 "Já visitei": "जा चुके",
 "Kit de primeiros socorros": "फ़र्स्ट एड किट",
 "Kkkk": "हाहा",
 "Kkkkk": "हाहाहा",
 "Km de hoje no painel": "आज डैशबोर्ड पर किमी",
 "Km no dia": "उस दिन किमी",
 "Km no painel": "डैशबोर्ड पर किमी",
 "LANÇAMENTOS": "प्रविष्टियाँ",
 "LINHA DO TEMPO": "टाइमलाइन",
 "Laboratório": "लैब",
 "Lanche": "नाश्ता",
 "Lanche da manhã": "सुबह का स्नैक",
 "Lanche da tarde": "शाम का स्नैक",
 "Lanches e água": "स्नैक्स और पानी",
 "Lançamentos": "एंट्रियाँ",
 "Lavanderia": "कपड़े धोने का कमरा",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "लॉन्ड्री, ज़रूरी सामान, मरम्मत, बिल और शुल्क। ये महीने के मुनाफ़े में गिने जाते हैं।",
 "Lavar o rosto com sabonete facial": "फ़ेस वॉश से चेहरा धोएँ",
 "Lazer": "मनोरंजन",
 "Leg press": "लेग प्रेस",
 "Legenda": "कैप्शन",
 "Legislação Específica": "विशिष्ट विधान",
 "Legumes": "सब्ज़ियाँ",
 "Leia hoje para começar uma sequência": "सिलसिला शुरू करने के लिए आज पढ़ें",
 "Leite": "दूध",
 "Leitura": "पठन",
 "Leitura automática do texto": "पाठ का स्वचालित पठन",
 "Leitura da IA": "AI द्वारा पठन",
 "Leitura, Cursos & Mídia": "पढ़ना, कोर्स और मीडिया",
 "Lembrete": "रिमाइंडर",
 "Lembrete de hoje": "आज का रिमाइंडर",
 "Lembrete de renovação no Planner": "Planner में नवीनीकरण रिमाइंडर",
 "Lembrete no Planner": "Planner में रिमाइंडर",
 "Lembrete no planner": "प्लानर में रिमाइंडर",
 "Lembrete pelo WhatsApp": "WhatsApp पर रिमाइंडर",
 "Lembrete: começa às {hora}": "रिमाइंडर: {hora} बजे शुरू होगा",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "हम हर संदेश पढ़ते हैं। ज़रूरत हो तो आपके ईमेल पर जवाब देते हैं।",
 "Lendo": "पढ़ रहे हैं",
 "Lendo a fatura...": "कार्ड बिल पढ़ा जा रहा है...",
 "Lendo a página": "पेज पढ़ा जा रहा है",
 "Lendo o boleto...": "बोलेटो पढ़ा जा रहा है...",
 "Lendo o cupom...": "रसीद पढ़ी जा रही है...",
 "Lendo o documento...": "दस्तावेज़ पढ़ा जा रहा है...",
 "Lendo o extrato...": "स्टेटमेंट पढ़ा जा रहा है...",
 "Lendo o relógio...": "घड़ी पढ़ी जा रही है...",
 "Lendo o texto": "टेक्स्ट पढ़ा जा रहा है",
 "Ler a fatura": "कार्ड बिल पढ़ें",
 "Ler a publicação inteira": "पूरा प्रकाशन पढ़ें",
 "Ler com a minha IA": "मेरे AI से पढ़ें",
 "Ler de novo": "फिर से पढ़ें",
 "Ler de novo agora": "अभी फिर से पढ़ें",
 "Ler o texto": "टेक्स्ट पढ़ें",
 "Ler o texto completo": "पूरा टेक्स्ट पढ़ें",
 "Ler publicação inteira": "पूरा प्रकाशन पढ़ें",
 "Ler sozinho as publicações novas": "नए प्रकाशन अपने आप पढ़ें",
 "Leve": "हल्की",
 "Leve (sem perder qualidade)": "हल्का (क्वालिटी खोए बिना)",
 "Li e aceito os termos e a política de privacidade": "मैंने शर्तें और गोपनीयता नीति पढ़ ली हैं और स्वीकार करता/करती हूँ",
 "Li mais {n} páginas": "{n} पेज और पढ़े",
 "Liberada pelo suporte": "सहायता टीम द्वारा खोला गया",
 "Liberar para a equipe": "टीम के लिए खोलें",
 "Liberar para a turma em": "कक्षा के लिए खोलने की तारीख",
 "Liberar para o grupo": "समूह के लिए खोलें",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "अनुमतियाँ और क्रेडिट आपके CPF से जुड़े हैं। सिंक करने पर अपडेट होते हैं।",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "QR कोड पढ़ने के लिए मोबाइल की सेटिंग्स में My Planner को कैमरे की अनुमति दें।",
 "Libere a câmera para o My Planner nas configurações do celular.": "फ़ोन की सेटिंग्स में My Planner को कैमरा की अनुमति दें।",
 "Libere outras abas em Ajustes › Compras.": "सेटिंग्स › खरीदारी में दूसरे टैब अनलॉक करें।",
 "Licenciamento": "लाइसेंसिंग",
 "Lidas hoje": "आज पढ़े",
 "Lido": "पढ़ ली",
 "Ligando. Toque para atender.": "कॉल आ रही है। जवाब देने के लिए टैप करें।",
 "Ligar": "कॉल करें",
 "Ligar certificado": "प्रमाणपत्र जोड़ें",
 "Ligar para a assistência": "सर्विस सेंटर को कॉल करें",
 "Ligar para {nome}": "{nome} को कॉल करें",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "यह टूल इस्तेमाल करने के लिए सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस (Claude, ChatGPT या Gemini) में अपना AI चालू करें।",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "टेक्स्ट पढ़ने, सारांश बनाने और दस्तावेज़ के बारे में पूछने के लिए सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस में अपना AI चालू करें।",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस में अपना AI चालू करें।",
 "Ligue o certificado A1 da empresa primeiro.": "पहले कंपनी का A1 प्रमाणपत्र जोड़ें।",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "फ़ोटो और फ़ाइलें सहेजने (जो किसी भी डिवाइस पर खुलेंगी) और पूरा बैकअप रखने के लिए अपना Google Drive या OneDrive कनेक्ट करें।",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "इसे चालू करें ताकि समूह एक ही डेटा (निर्माण, यात्रा, कक्षा, संपत्ति, क्लिनिक) पर काम करे, हर व्यक्ति अपनी भूमिका के साथ।",
 "Ligue pelo menos 4 pontos.": "कम से कम 4 बिंदु जोड़ें।",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "वार्षिक सीमा सेटिंग्स › टैब › वित्त टैब में बदली जा सकती है। हमेशा अपने अकाउंटेंट से पुष्टि करें।",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "खोज की सीमा पूरी हो गई। 1 मिनट बाद फिर कोशिश करें।",
 "Limite de energia por dia": "प्रतिदिन ऊर्जा सीमा",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "MEI की वार्षिक कारोबार सीमा (मौजूदा राशि अपने अकाउंटेंट से पुष्टि करें)।",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "आज के संदेशों की सीमा पूरी हो गई। कल कोशिश करें।",
 "Limite diário": "दैनिक सीमा",
 "Limite livre: {v} de {l}": "उपलब्ध लिमिट: {l} में से {v}",
 "Limite total (opcional)": "कुल लिमिट (वैकल्पिक)",
 "Limpar": "साफ़ करें",
 "Limpar a agenda": "एजेंडा साफ़ करें",
 "Limpar banheiro": "बाथरूम साफ़ करें",
 "Limpar cozinha e louça": "रसोई और बर्तन साफ़ करें",
 "Limpar feitos": "पूरे हुए हटाएँ",
 "Limpeza": "सफ़ाई",
 "Limpeza após {h}": "{h} के बाद सफ़ाई",
 "Limpeza final": "अंतिम सफ़ाई",
 "Limpeza · {e}": "सफ़ाई · {e}",
 "Limpeza: {e}": "सफ़ाई: {e}",
 "Limpezas": "सफ़ाई",
 "Linha do tempo, tarefas, energia e alertas.": "टाइमलाइन, कार्य, ऊर्जा और अलर्ट।",
 "Link": "लिंक",
 "Link (Drive, OneDrive, Dropbox)": "लिंक (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "लिंक कॉपी हो गया। जहाँ भेजना हो वहाँ पेस्ट करें।",
 "Link da aula ou reunião online (opcional)": "क्लास या ऑनलाइन मीटिंग का लिंक (वैकल्पिक)",
 "Link da nota fiscal (Drive ou OneDrive)": "बिल का लिंक (Drive या OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Drive या OneDrive फ़ोल्डर का लिंक (वैकल्पिक)",
 "Link da reserva": "बुकिंग लिंक",
 "Link da sala online (Meet, Zoom...)": "ऑनलाइन रूम का लिंक (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "दूसरे कैलेंडर का लिंक (iCal)",
 "Link do calendário do Airbnb (iCal)": "Airbnb कैलेंडर का लिंक (iCal)",
 "Link do calendário do Booking (iCal)": "Booking कैलेंडर का लिंक (iCal)",
 "Link inválido": "अमान्य लिंक",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "सामग्री के लिंक (Drive, वीडियो, PDF), हर पंक्ति में एक",
 "Links: {n}": "लिंक: {n}",
 "Lista": "सूची",
 "Lista da mala": "सामान की सूची",
 "Lista de compras": "खरीदारी सूची",
 "Lista de exercícios": "अभ्यास सूची",
 "Lista rápida": "त्वरित सूची",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "त्वरित सूचियाँ और बॉक्स जो कार्य बन जाते हैं या दूसरे टैब में जाते हैं।",
 "Literatura": "साहित्य",
 "Litros": "लीटर",
 "Livre": "खाली",
 "Livro": "किताब",
 "Livros": "किताबें",
 "Local": "स्थान",
 "Local ou endereço": "जगह या पता",
 "Local: {l}": "जगह: {l}",
 "Localização (país e fuso horário)": "लोकेशन (देश और टाइम ज़ोन)",
 "Logo, foto ou rubrica nas páginas.": "पेजों पर लोगो, फ़ोटो या छोटे हस्ताक्षर।",
 "Loja (opcional)": "दुकान (वैकल्पिक)",
 "Lote": "बैच",
 "Lua": "चाँद",
 "Lugar": "जगह",
 "Lugar para visitar": "घूमने की जगह",
 "Lugares": "जगहें",
 "Luz": "बिजली",
 "Luz indireta": "अप्रत्यक्ष रोशनी",
 "Luz, água, gás e internet": "बिजली, पानी, गैस और इंटरनेट",
 "Lápis": "पेंसिल",
 "Língua Portuguesa": "पुर्तगाली भाषा",
 "MAIS ADIANTE": "आगे",
 "MAIS USADOS": "सबसे ज़्यादा इस्तेमाल",
 "ME ou EPP do Simples": "Simples का ME या EPP",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: {ano} में टर्नओवर {v} (सीमा {l})।",
 "MEMBROS ({n})": "सदस्य ({n})",
 "METAS": "लक्ष्य",
 "MS": "MS",
 "Mais": "और",
 "Mais abas": "और टैब",
 "Mais cidades entram nas próximas versões.": "अगले संस्करणों में और शहर जुड़ेंगे।",
 "Mais emojis": "और इमोजी",
 "Mais ferramentas": "और टूल",
 "Mais figurinhas animadas (KLIPY)": "और एनिमेटेड स्टिकर (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "इस टैब के और विकल्प अगले संस्करणों में आएँगे।",
 "Mais uma": "एक और",
 "Mala": "सामान",
 "Mala ({clima}, {n} dias)": "सामान ({clima}, {n} दिन)",
 "Mamadeiras e leite": "दूध की बोतलें और दूध",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "हमने नंबर {tel} के WhatsApp पर 6 अंकों का कोड भेजा है।",
 "Mandar as orientações pelo WhatsApp": "निर्देश WhatsApp पर भेजें",
 "Mandar de novo": "फिर से भेजें",
 "Mandar e-mail": "ईमेल भेजें",
 "Mandar lembrete": "रिमाइंडर भेजें",
 "Mandar meu código": "मेरा कोड भेजें",
 "Mandar o acerto para o grupo": "हिसाब समूह में भेजें",
 "Mandar para quem limpa (WhatsApp)": "सफ़ाई वाले को भेजें (WhatsApp)",
 "Mandarim": "मंदारिन",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "खाते के पहचान नंबर के साथ हटाने का अनुरोध ईमेल करें। हम 15 दिनों में जवाब देते हैं।",
 "Manter": "रखें",
 "Manter ambas": "दोनों रखें",
 "Manter ambos": "दोनों रखें",
 "Manter aqui também": "यहाँ भी रखें",
 "Manter tarefas": "टास्क रखें",
 "Manutenção": "मेंटेनेंस",
 "Manutenções": "मेंटेनेंस",
 "Mapas (Apple)": "Apple Maps",
 "Marca d'água": "वॉटरमार्क",
 "Marca-texto": "हाइलाइटर",
 "Marcado": "चुना हुआ",
 "Marcado como feito hoje.": "आज के लिए पूरा चिह्नित किया गया।",
 "Marcar como concluída ({dia})": "पूरा हुआ चिह्नित करें ({dia})",
 "Marcar como devolvido": "लौटाया गया चिह्नित करें",
 "Marcar como feita hoje": "आज पूरा चिह्नित करें",
 "Marcar como lido": "पढ़ा हुआ मार्क करें",
 "Marcar como paga": "भुगतान हुआ चिह्नित करें",
 "Marcar como pago": "भुगतान हुआ चिह्नित करें",
 "Marcar como quitado": "चुकता चिह्नित करें",
 "Marcar como recebida": "प्राप्त चिह्नित करें",
 "Marcar como recebida?": "प्राप्त के रूप में चिह्नित करें?",
 "Marcar como recebido": "मिल गया चिह्नित करें",
 "Marcar como visto": "देखा गया चिह्नित करें",
 "Marcar e avisar a equipe": "तय करें और टीम को बताएँ",
 "Marcar esta conta como paga?": "इस बिल को चुकाया गया चिह्नित करें?",
 "Marcar fatura como paga": "कार्ड बिल को चुकाया चिह्नित करें",
 "Marcar grupo": "समूह चुनें",
 "Marcar reunião": "मीटिंग तय करें",
 "Marcenaria": "बढ़ईगीरी",
 "Margem": "मार्जिन",
 "Marketing": "मार्केटिंग",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "गैलरी बनाने के लिए डायरी की फ़ोटो को पहले या बाद में चिह्नित करें।",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "वे दिन चुनें जिनमें आप पढ़ते हैं और हर दिन का समय। हर दिन एक कार्य बन जाता है जो हर हफ़्ते दोहराया जाता है और इस आइटम से जुड़ा होता है।",
 "Marque um ou mais estados.": "एक या अधिक राज्य चुनें।",
 "Martelo": "हथौड़ा",
 "Masculino": "पुरुष",
 "Masculino e minimalista": "पुरुषोचित और मिनिमल",
 "Matemática": "गणित",
 "Materiais": "सामग्री",
 "Material": "सामग्री",
 "Matrícula, placa, código ou CNPJ": "रजिस्ट्रेशन, नंबर प्लेट, कोड या CNPJ",
 "Matéria ou material": "विषय या सामग्री",
 "Matéria ou módulo": "विषय या मॉड्यूल",
 "Matérias": "विषय",
 "Meia-sombra": "आंशिक छाया",
 "Melhorando a imagem...": "इमेज बेहतर की जा रही है...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "नए सुधार डाउनलोड हो चुके हैं। बस कुछ सेकंड लगेंगे और आपका डेटा बना रहेगा।",
 "Membros": "सदस्य",
 "Menos de 1 minuto": "1 मिनट से कम",
 "Mensagem": "संदेश",
 "Mensagem apagada": "संदेश हटा दिया गया",
 "Mensagem enviada. Obrigado!": "संदेश भेज दिया गया। धन्यवाद!",
 "Mensagem ou observações": "संदेश या टिप्पणियाँ",
 "Mensagens": "संदेश",
 "Mensagens que você envia em Fale conosco.": "हमसे संपर्क करें में आपके भेजे गए संदेश।",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "संदेश: आपकी दोस्तों की सूची, चैट, और भेजी गई फ़ोटो व फ़ाइलें सर्वर पर सहेजी जाती हैं ताकि दूसरे डिवाइस तक पहुँच सकें। ऑडियो और वीडियो कॉल रिकॉर्ड नहीं की जातीं।",
 "Mensalidade de {m}": "{m} की मासिक फ़ीस",
 "Mensalidade ou valor por aluno": "मासिक फ़ीस या प्रति छात्र राशि",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "मासिक फ़ीस, एकल कक्षाएँ और सामग्री। कक्षा के ⋮ में \"इस महीने के शुल्क बनाएँ\" हर छात्र के लिए एक शुल्क बनाता है।",
 "Mercado": "किराना",
 "Mesa flexora": "लेग कर्ल",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "साइट सुपरवाइज़र",
 "Meta": "लक्ष्य",
 "Meta 100% batida": "लक्ष्य 100% पूरा",
 "Meta atingida": "लक्ष्य पूरा",
 "Meta atingida!": "लक्ष्य पूरा!",
 "Meta da semana: {dur}": "हफ़्ते का लक्ष्य: {dur}",
 "Meta de aulas": "पाठ का लक्ष्य",
 "Meta de aulas batida": "पाठ का लक्ष्य पूरा",
 "Meta de copos por dia": "प्रतिदिन गिलासों का लक्ष्य",
 "Meta de páginas por dia": "रोज़ के पेजों का लक्ष्य",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "पेजों का लक्ष्य, प्रगति, किताबों और देखी जाने वाली फ़िल्मों व सीरीज़ का सारांश, और कोर्स की क्लास।",
 "Meta diária": "दैनिक लक्ष्य",
 "Meta por dia": "प्रतिदिन लक्ष्य",
 "Meta por semana:": "साप्ताहिक लक्ष्य:",
 "Meta {meta} · copo de {copo} · {n} copos": "लक्ष्य {meta} · {copo} का गिलास · {n} गिलास",
 "Metas": "लक्ष्य",
 "Metodologia Científica": "शोध पद्धति",
 "Meu caderno": "मेरी नोटबुक",
 "Meu cartão de contato": "मेरा संपर्क कार्ड",
 "Meu plano": "मेरा प्लान",
 "Meus GIFs ({n})": "मेरे GIF ({n})",
 "Meus PDFs": "मेरे PDF",
 "Meus dados": "मेरी जानकारी",
 "Meus dados profissionais": "मेरी पेशेवर जानकारी",
 "Microchip": "माइक्रोचिप",
 "Microfone": "माइक्रोफ़ोन",
 "Microscópio": "माइक्रोस्कोप",
 "Militares estaduais": "राज्य सैन्य",
 "Minha Casa": "मेरा घर",
 "Minha conta": "मेरा खाता",
 "Minhas anotações do livro": "मेरे किताब के नोट्स",
 "Minhas figurinhas": "मेरे स्टिकर",
 "Minutos": "मिनट",
 "Minutos de exercício": "व्यायाम के मिनट",
 "Mirante": "व्यू पॉइंट",
 "Mirantes": "व्यू पॉइंट",
 "Modelo": "मॉडल",
 "Modelo de prescrição": "पर्चे का टेम्पलेट",
 "Modelos": "टेम्पलेट",
 "Modificado em": "बदलने की तारीख",
 "Modo": "मोड",
 "Modo de preparo": "बनाने की विधि",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "सुरक्षित मोड: ऐप दोबारा खोलने तक स्वचालित कार्य बंद",
 "Moeda": "मुद्रा",
 "Moeda: {m}": "मुद्रा: {m}",
 "Moedas": "सिक्के",
 "Momento do evento": "इवेंट का पल",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "नाम और OAB नंबर से इलेक्ट्रॉनिक न्यायिक राजपत्र (DJEN) का मॉनिटर।",
 "Monitor ou co-professor": "मॉनिटर या सह-शिक्षक",
 "Montando o PDF: página {n} de {total}...": "PDF बन रहा है: पेज {n} / {total}...",
 "Montar a mala pelo clima ({n} dias)": "मौसम के हिसाब से सामान तैयार करें ({n} दिन)",
 "Monte o cronograma alimentar para ver o relatório.": "रिपोर्ट देखने के लिए भोजन समय-सारणी बनाएँ।",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "दिन-ब-दिन यात्रा कार्यक्रम बनाएँ। यात्रा के दौरान यह My Planner की टाइमलाइन में दिखता है।",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "नीचे अपनी भोजन समय-सारणी और देखभाल बनाएँ। आज के आइटम यहाँ चिह्नित करने के लिए दिखेंगे।",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "नीचे अपनी भोजन समय-सारणी, देखभाल, वर्कआउट और सप्लीमेंट बनाएँ। आज का सब कुछ यहाँ निशान लगाने के लिए दिखेगा।",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "तैयार गतिविधियों से अपने वर्कआउट बनाएँ: जिम मशीनें, घर पर व्यायाम, पैदल चलना, दौड़, योग, पिलाटेस...",
 "Mostrando as 120 mais recentes.": "सबसे हाल की 120 दिखाई जा रही हैं।",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "सिर्फ़ यात्रा कार्यक्रम दिख रहा है। दिन के {n} कार्य छिपे हैं।",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "आप जहाँ हैं उसके हिसाब से सही तारीखें, समय, मुद्रा और अवकाश दिखाना। हम GPS का उपयोग नहीं करते।",
 "Mostrar menos": "कम दिखाएँ",
 "Mostrar só o roteiro durante a viagem": "यात्रा के दौरान सिर्फ़ यात्रा कार्यक्रम दिखाएँ",
 "Motivo do cancelamento": "रद्द करने का कारण",
 "Moto": "मोटरसाइकिल",
 "Mover": "ले जाएँ",
 "Mover para hoje": "आज पर ले जाएँ",
 "Mudança": "स्थानांतरण",
 "Mudança: {para}": "स्थानांतरण: {para}",
 "Mudanças": "स्थानांतरण",
 "Mudar e-mail": "ईमेल बदलें",
 "Mudar o nome": "नाम बदलें",
 "Mudar senha": "पासवर्ड बदलें",
 "Mudo": "म्यूट",
 "Muitas tentativas": "बहुत अधिक प्रयास",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "बहुत अधिक गलत प्रयास। {s} सेकंड बाद फिर से कोशिश करें।",
 "Muitas tentativas. Aguarde alguns minutos.": "बहुत अधिक प्रयास। कुछ मिनट प्रतीक्षा करें।",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "बहुत बढ़िया: इस महीने आप {v} बचा चुके हैं। बड़ी रकम से ज़्यादा ज़रूरी है नियमितता।",
 "Multa": "जुर्माना",
 "Multa e juros": "विलंब शुल्क और ब्याज",
 "Multa e juros de {v}": "{v} का विलंब शुल्क और ब्याज",
 "Multa e juros estimados: {v}": "अनुमानित जुर्माना और ब्याज: {v}",
 "Multas e juros pagos": "चुकाया गया विलंब शुल्क और ब्याज",
 "Mundo": "दुनिया",
 "Municipal": "नगरपालिका",
 "Município da prestação (IBGE), se for outro": "सेवा का नगर (IBGE), अगर अलग हो",
 "Município da prestação (código IBGE, 7 números)": "सेवा का नगर (IBGE कोड, 7 अंक)",
 "Mural": "सूचना बोर्ड",
 "Museu": "संग्रहालय",
 "Museus": "संग्रहालय",
 "My Planner (vira tarefa)": "My Planner (कार्य बनेगा)",
 "My Planner bloqueado": "My Planner लॉक है",
 "Máxima": "अधिकतम",
 "Média": "मध्यम",
 "Média para aprovação": "पास होने का औसत",
 "Média · repouso {n}": "औसत · आराम {n}",
 "Médico": "डॉक्टर",
 "Médico ou clínica": "डॉक्टर या क्लिनिक",
 "Médio": "मध्यम",
 "Mês": "महीना",
 "Mês a mês": "महीने-दर-महीने",
 "Mês atual": "इस महीने",
 "Mês passado": "पिछला महीना",
 "Móveis e enxoval": "फ़र्नीचर और बिस्तर-चादरें",
 "Móvel": "फ़र्नीचर",
 "Música": "संगीत",
 "NAS ABAS": "टैब में",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: SEFAZ दो खोजों के बीच 1 घंटे का अंतर माँगता है। अगली खोज {h} के बाद।",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: उत्पादों के इनवॉइस खोजने के लिए कंपनी का राज्य (UF) डालें।",
 "NFS-e emitida": "NFS-e जारी हुआ",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "वार (वैकल्पिक):",
 "Na agenda": "एजेंडा में",
 "Na agenda em {data}": "{data} को एजेंडा में",
 "Na barra": "बार में",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "डेमो में इनवॉइस सर्वर नहीं है। अपने खाते से ऐप इस्तेमाल करें।",
 "Na hora": "तुरंत",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "ब्रेक के समय स्क्रीन पर उलटी गिनती के साथ एक बड़ी सूचना दिखती है।",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "टाइमलाइन में टाइमर पर टैप करने से भी यह पेज खुलता है।",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "मोबाइल के \"{pasta}\" फ़ोल्डर में। हर तैयार फ़ाइल वहीं जाती है।",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "फ़ोन के \"{pasta}\" फ़ोल्डर में। हर नया दस्तावेज़ उससे बाहर निकलते ही वहां चला जाता है।",
 "Na prévia de demonstração não há chamadas de verdade.": "डेमो प्रीव्यू में असली कॉल नहीं होतीं।",
 "Na prévia de demonstração não há gravação de verdade.": "डेमो प्रीव्यू में असली रिकॉर्डिंग नहीं होती।",
 "Na prévia de demonstração os arquivos não abrem.": "डेमो प्रीव्यू में फ़ाइलें नहीं खुलतीं।",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "स्टोर संस्करण में खरीदारी Google Play या App Store से होगी। अभी यह स्विच परीक्षण के लिए सदस्यता का सिमुलेशन करता है।",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "स्टोर वाले संस्करण में यह बटन Google Play या App Store की ख़रीद खोलता है।",
 "Nacional": "राष्ट्रीय",
 "Nada a gerar": "बनाने को कुछ नहीं",
 "Nada encontrado.": "कुछ नहीं मिला।",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "बिना अनुमति किसी के एजेंडा में कुछ नहीं जुड़ता: हर व्यक्ति स्वीकारता, संपादित करता या अस्वीकारता है।",
 "Nada foi registrado.": "कुछ भी दर्ज नहीं हुआ।",
 "Nada lançado neste mês.": "इस महीने कोई प्रविष्टि नहीं।",
 "Nada no mês": "इस महीने कुछ नहीं",
 "Nada no roteiro deste dia.": "इस दिन के कार्यक्रम में कुछ नहीं।",
 "Nada para apagar com esse filtro.": "इस फ़िल्टर से हटाने के लिए कुछ नहीं है।",
 "Nada para comprar": "ख़रीदने को कुछ नहीं",
 "Nada para enviar.": "भेजने के लिए कुछ नहीं।",
 "Nada planejado para este dia": "इस दिन के लिए कुछ योजना नहीं है",
 "Nada planejado para hoje. Bom dia!": "आज के लिए कुछ योजना नहीं है। सुप्रभात!",
 "Nada por aqui.": "यहाँ कुछ नहीं है।",
 "Nada recebido ainda.": "अभी तक कुछ नहीं मिला।",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "चैट में हर व्यक्ति आपका नाम और आपके भेजे संदेश देखता है। आप किसी संदेश को सभी के लिए हटा सकते हैं, ग्रुप छोड़ सकते हैं या किसी को ब्लॉक कर सकते हैं।",
 "Nascimento": "जन्म",
 "Natal": "क्रिसमस",
 "Natação": "तैराकी",
 "Navegador conectado": "ब्राउज़र कनेक्ट हो गया",
 "Negrito": "बोल्ड",
 "Negócios": "व्यवसाय",
 "Nenhum": "कोई नहीं",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "इस अवधि में कोई XML नहीं (या वे किसी दूसरे डिवाइस पर सहेजे गए)।",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "जोड़ने के लिए कोई दोस्त नहीं। WhatsApp से आमंत्रित करें या संदेश में दोस्त जोड़ें (दोस्त का कोड)।",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "इस विषय के पेजों में कोई फ़ाइल, छवि या लिंक नहीं है।",
 "Nenhum arquivo.": "कोई फ़ाइल नहीं।",
 "Nenhum atendimento pago neste mês.": "इस महीने कोई भुगतान किया गया अपॉइंटमेंट नहीं।",
 "Nenhum cartão": "कोई कार्ड नहीं",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "अभी तक कोई रसीद सहेजी नहीं गई। बिल चुकाने के बाद उस पर टैप करें और रसीद की फ़ोटो, PDF या स्क्रीनशॉट जोड़ें।",
 "Nenhum cômodo ainda": "अभी कोई कमरा नहीं",
 "Nenhum dia": "कोई दिन नहीं",
 "Nenhum documento ainda.": "अभी कोई दस्तावेज़ नहीं।",
 "Nenhum documento neste filtro.": "इस फ़िल्टर में कोई दस्तावेज़ नहीं।",
 "Nenhum e-mail cadastrado": "कोई ईमेल दर्ज नहीं है",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "कोई त्रुटि दर्ज नहीं। अगर ऐप अपने-आप बंद हो या किसी स्क्रीन में समस्या आए, तो त्रुटि यहाँ दिखेगी ताकि आप टीम को भेज सकें।",
 "Nenhum feriado neste ano.": "इस वर्ष कोई अवकाश नहीं।",
 "Nenhum fichário ainda": "अभी कोई फ़ाइल नहीं",
 "Nenhum grupo ainda.": "अभी कोई समूह नहीं।",
 "Nenhum item em {nome}": "{nome} में कोई आइटम नहीं",
 "Nenhum lançamento encontrado": "कोई प्रविष्टि नहीं मिली",
 "Nenhum país encontrado.": "कोई देश नहीं मिला।",
 "Nenhum selecionado": "कोई चयनित नहीं",
 "Nenhuma (plano gratuito)": "कोई नहीं (मुफ़्त प्लान)",
 "Nenhuma aba encontrada.": "कोई टैब नहीं मिला।",
 "Nenhuma aba fixada além do My Planner.": "My Planner के अलावा कोई टैब पिन नहीं है।",
 "Nenhuma aba liberada para receber": "कोई अनलॉक टैब इसे प्राप्त नहीं कर सकता",
 "Nenhuma agenda encontrada": "कोई कैलेंडर नहीं मिला",
 "Nenhuma agenda para trazer": "लाने के लिए कोई कैलेंडर नहीं",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "इस प्रकाशन में कोई सुनवाई या समय-सीमा नहीं मिली।",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "कोई संग्रहीत बॉक्स नहीं। संग्रहीत करने के लिए बॉक्स को बाईं ओर स्वाइप करें।",
 "Nenhuma compra encontrada": "कोई खरीदारी नहीं मिली",
 "Nenhuma compra nesta fatura.": "इस कार्ड बिल में कोई खरीदारी नहीं।",
 "Nenhuma conta a pagar cadastrada.": "कोई देय बिल नहीं जोड़ा गया।",
 "Nenhuma conta a receber cadastrada.": "कोई प्राप्य राशि नहीं जोड़ी गई।",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "इस महीने कोई बिल नहीं। जोड़ने के लिए + दबाएँ (किराया, बिजली, कार्ड...)।",
 "Nenhuma cópia de segurança ainda.": "अभी तक कोई बैकअप नहीं।",
 "Nenhuma cópia encontrada.": "कोई बैकअप नहीं मिला।",
 "Nenhuma garantia ativa. Cadastre com o +.": "कोई सक्रिय वारंटी नहीं। + से जोड़ें।",
 "Nenhuma garantia vencida.": "कोई समाप्त वारंटी नहीं।",
 "Nenhuma mensagem ainda. Diga oi! 👋": "अभी कोई संदेश नहीं। हाय कहें! 👋",
 "Nenhuma nota neste período.": "इस अवधि में कोई इनवॉइस नहीं।",
 "Nenhuma opção ainda.": "अभी कोई विकल्प नहीं।",
 "Nenhuma publicação nova.": "कोई नया प्रकाशन नहीं।",
 "Nenhuma refeição neste dia.": "इस दिन कोई भोजन नहीं।",
 "Nenhuma reunião marcada.": "कोई मीटिंग तय नहीं है।",
 "Nesse ritmo, termina em {d}": "इस गति से आप {d} को पूरा करेंगे",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "लॉन्च के इस चरण में सभी टैब मुफ़्त और खुले हैं।",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "परीक्षण के इस चरण में पासवर्ड सहायता टीम रीसेट करती है। अपना CPF या ईमेल बताते हुए {email} पर लिखें।",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "परीक्षण के इस चरण में पासवर्ड सहायता टीम रीसेट करती है। अपना CPF बताते हुए {email} पर लिखें।",
 "Neve": "बर्फ़",
 "Ninguém deve nada a ninguém.": "किसी पर किसी का कुछ बाकी नहीं।",
 "Ninguém entrou ainda. Envie o convite.": "अभी तक कोई नहीं जुड़ा। आमंत्रण भेजें।",
 "Ninguém usou o seu código ainda.": "अभी तक किसी ने आपका कोड इस्तेमाल नहीं किया।",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Android पर ऐप सिर्फ़ चुनी गई फ़ाइल का शॉर्टकट रखता है: फ़ाइल वहीं रहती है (Drive, OneDrive, Downloads) और फ़ोन के ऐप में खुलती है। कुछ भी कॉपी नहीं होता। यह विकल्प कैमरे से ली गई फ़ोटो पर लागू होता है।",
 "No Google Drive ou OneDrive: {n}": "Google Drive या OneDrive में: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "Google Drive में ऐप केवल वही फ़ाइलें देख सकता है जो उसने खुद My Planner फ़ोल्डर में बनाई हैं। Google APIs से मिली जानकारी का इस्तेमाल Google API सेवाओं की उपयोगकर्ता डेटा नीति के अनुसार होता है, जिसमें सीमित इस्तेमाल से जुड़ी शर्तें भी शामिल हैं: आपकी अनुमति या कानूनी बाध्यता के बिना कुछ भी बेचा नहीं जाता, विज्ञापन के लिए इस्तेमाल नहीं किया जाता और लोगों द्वारा पढ़ा नहीं जाता।",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "अपनी घड़ी के ऐप (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...) में \"Health Connect\" या \"Health Connect के साथ सिंक करें\" विकल्प चालू करें।",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "नए ऐप (वर्ज़न 0.49) में फ़ोन पेज के किनारे खुद ढूंढ लेता है। इस वर्ज़न में 4 कोनों को उंगली से एडजस्ट करें।",
 "No centro": "बीच में",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "कंप्यूटर पर {url} खोलें, ऊपर वाले बटन पर टैप करें और कैमरा स्क्रीन के QR कोड की ओर करें।",
 "No dia (opcional):": "तारीख (वैकल्पिक):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "iPhone पर ऐप \"Files में सेव करें\" खोलता है ताकि आप फ़ोल्डर चुन सकें (iCloud Drive भी हो सकता है)।",
 "No início": "शुरू होने पर",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "सुरक्षित मोड में ऐप स्वचालित कार्यों (सूचनाएँ, Google कैलेंडर, प्रकाशन, संदेश और घड़ी) के बिना खुलता है। आपका डेटा नहीं बदलता और अगली बार खोलने पर सब सामान्य हो जाता है।",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "ब्राउज़र में पेज तभी तक रहते हैं जब तक यह पेज खुला है।",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "ब्राउज़र में, Drive, OneDrive या Dropbox की फ़ाइल का लिंक पेस्ट करें (पढ़ाई या दस्तावेज़ में, लिंक विकल्प)। फ़ोन पर, फ़ाइल बटन में पहले से Drive और OneDrive दिखते हैं।",
 "No navegador, o PDF é baixado para o computador.": "ब्राउज़र में PDF कंप्यूटर पर डाउनलोड होता है।",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "ब्राउज़र में केवल छोटी छवियाँ (200 KB तक) सहेजी जा सकती हैं। दूसरी फ़ाइलों के लिए Drive, OneDrive या Dropbox का लिंक जोड़ें, या फ़ोन पर ऐप इस्तेमाल करें।",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "दूसरे ऐप में फ़ाइल का लिंक कॉपी करें (शेयर › लिंक कॉपी करें) और इस पेज पर बने लिंक ब्लॉक में पेस्ट करें।",
 "No ritmo atual, o ano fecha em {v}.": "मौजूदा रफ़्तार से साल {v} पर खत्म होगा।",
 "No seu fuso: {hora}{dia}": "आपके समय क्षेत्र में: {hora}{dia}",
 "Nome": "नाम",
 "Nome (cliente ou fornecedor)": "नाम (ग्राहक या आपूर्तिकर्ता)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "नाम (उदा.: कक्षा 8 B, क्लिनिक के मरीज़, आना का जन्मदिन)",
 "Nome (ex.: Almoço)": "नाम (जैसे: दोपहर का भोजन)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "नाम (जैसे: मिला किराया, ग्राहक X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "नाम (जैसे: किराया, बिजली, इंटरनेट)",
 "Nome (ex.: Doutorado UFPR)": "नाम (जैसे: पीएचडी UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "नाम (उदा.: Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "नाम (जैसे: रात की स्किनकेयर)",
 "Nome (ex.: Treino A)": "नाम (जैसे: वर्कआउट A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "नाम (उदा.: छुट्टियों की यात्रा, आपातकालीन कोष)",
 "Nome (ex.: Vitamina C)": "नाम (जैसे: विटामिन C)",
 "Nome (opcional)": "नाम (वैकल्पिक)",
 "Nome (opcional, ex.: CNH do Walter)": "नाम (वैकल्पिक, जैसे: Walter का CNH)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "नाम (बदल सकते हैं, जैसे: \"अंगूर का जूस\")",
 "Nome completo": "पूरा नाम",
 "Nome curto": "छोटा नाम",
 "Nome da lista": "सूची का नाम",
 "Nome da matéria": "विषय का नाम",
 "Nome da obra": "निर्माण कार्य का नाम",
 "Nome da pasta (ex.: Recibos, Contratos)": "फ़ोल्डर का नाम (जैसे: रसीदें, अनुबंध)",
 "Nome da tarefa": "कार्य का नाम",
 "Nome da tarefa (ex.: Academia)": "कार्य का नाम (जैसे: जिम)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "कार्य का नाम (जैसे: बाथरूम साफ़ करना)",
 "Nome do PDF (opcional)": "PDF का नाम (वैकल्पिक)",
 "Nome do conselho": "परिषद का नाम",
 "Nome do cômodo": "कमरे का नाम",
 "Nome do documento": "दस्तावेज़ का नाम",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "ऑफ़िस का नाम (जैसे: Ravasco Contabilidade)",
 "Nome do evento": "इवेंट का नाम",
 "Nome do grupo (ex.: Família)": "ग्रुप का नाम (जैसे: परिवार)",
 "Nome do modelo": "टेम्पलेट का नाम",
 "Nome ou modelo": "नाम या मॉडल",
 "Nome ou razão social": "नाम या कंपनी का नाम",
 "Nome, subtarefa ou anotação": "नाम, उप-कार्य या नोट",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "समूहों में, हर व्यक्ति अपनी जोड़ी गई चीज़ों के लिए ज़िम्मेदार है। समूह का एडमिन तय करता है कि कौन शामिल होगा।",
 "Nossa Senhora Aparecida": "Nossa Senhora Aparecida",
 "Nossa Senhora da Luz dos Pinhais": "Nossa Senhora da Luz dos Pinhais",
 "Nota cancelada": "इनवॉइस रद्द हुआ",
 "Nota fiscal": "इनवॉइस",
 "Nota fiscal emitida": "इनवॉइस जारी हुआ",
 "Nota fiscal, certificado de garantia e fotos": "बिल, वारंटी कार्ड और फ़ोटो",
 "Nota importada": "आयात किया गया इनवॉइस",
 "Notas": "इनवॉइस",
 "Notas Fiscais": "इनवॉइस (NF)",
 "Notebook e carregador": "लैपटॉप और चार्जर",
 "Nova avaliação": "नया मूल्यांकन",
 "Nova caixa (ex.: Compras, Ideias)": "नया बॉक्स (जैसे: ख़रीदारी, विचार)",
 "Nova conversa": "नई चैट",
 "Nova garantia": "नई वारंटी",
 "Nova matéria": "नया विषय",
 "Nova meta": "नया लक्ष्य",
 "Nova pasta": "नया फ़ोल्डर",
 "Nova página": "नया पेज",
 "Nova página com esta caixa": "इस बॉक्स से नया पेज",
 "Nova refeição": "नया भोजन",
 "Nova tarefa": "नया कार्य",
 "Nova tarefa da casa": "नया घर का काम",
 "Nova tarefa neste cômodo": "इस कमरे में नया कार्य",
 "Novas": "नए",
 "Novo": "नया",
 "Novo alerta:": "नया अलर्ट:",
 "Novo cartão": "नया कार्ड",
 "Novo cartão de crédito": "नया क्रेडिट कार्ड",
 "Novo cuidado": "नई देखभाल",
 "Novo documento": "नया दस्तावेज़",
 "Novo e-mail": "नया ईमेल",
 "Novo fichário": "नई फ़ाइल",
 "Novo grupo": "नया ग्रुप",
 "Novo item": "नया आइटम",
 "Novo perfil": "नई प्रोफ़ाइल",
 "Novo suplemento": "नया सप्लीमेंट",
 "Novo treino": "नया वर्कआउट",
 "Novo: {nome}": "नया: {nome}",
 "Novos": "नए",
 "Num período": "किसी अवधि में",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "हर बॉक्स पर नंबर डालें और कमरा व सामान लिखें। कौन-सी चीज़ कहाँ है, ढूँढने के लिए खोज का इस्तेमाल करें।",
 "Nº": "नं.",
 "Não": "नहीं",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "रसीद में कुल राशि नहीं मिली। ज़्यादा साफ़ फ़ोटो आज़माएँ।",
 "Não consegue entrar?": "लॉगिन नहीं हो रहा?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "\"{nome}\" नहीं खुल सका। PDF ठीक करें टूल आज़माएँ।",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "कॉल कनेक्ट नहीं हो सकी। इंटरनेट जाँचें और फिर कोशिश करें।",
 "Não deu certo: {msg}": "नहीं हो सका: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "इस PDF को और छोटा नहीं किया जा सका ({tam})।",
 "Não dá para tirar todas as páginas.": "सभी पेज नहीं हटाए जा सकते।",
 "Não encontrei texto neste PDF.": "इस PDF में कोई टेक्स्ट नहीं मिला।",
 "Não encontrei texto neste documento.": "इस दस्तावेज़ में कोई टेक्स्ट नहीं मिला।",
 "Não foi possível": "संभव नहीं हुआ",
 "Não foi possível abrir": "खोला नहीं जा सका",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "सहेजा गया प्रमाणपत्र नहीं खुल सका। प्रमाणपत्र फिर से जोड़ें।",
 "Não foi possível abrir.": "खोला नहीं जा सका।",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "इस देश के अवकाश डाउनलोड नहीं हो सके। अपना इंटरनेट जाँचें।",
 "Não foi possível conectar": "कनेक्ट नहीं हो सका",
 "Não foi possível conectar o {nome}": "{nome} कनेक्ट नहीं हो सका",
 "Não foi possível consultar o DJEN agora.": "अभी DJEN से जानकारी नहीं ली जा सकी।",
 "Não foi possível continuar": "आगे नहीं बढ़ सके",
 "Não foi possível criar um evento na agenda: {msg}": "कैलेंडर में इवेंट नहीं बन सका: {msg}",
 "Não foi possível entrar.": "लॉग इन नहीं हो सका।",
 "Não foi possível enviar": "भेजा नहीं जा सका",
 "Não foi possível enviar.": "भेजा नहीं जा सका।",
 "Não foi possível guardar: {erro}": "सहेजा नहीं जा सका: {erro}",
 "Não foi possível ler o arquivo.": "फ़ाइल पढ़ी नहीं जा सकी।",
 "Não foi possível ler o calendário. Confira o link em Editar.": "कैलेंडर नहीं पढ़ा जा सका। संपादित करें में लिंक जाँचें।",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "अभी खोज नहीं हो सकी। बाद में अपने आप फिर कोशिश होगी।",
 "Não foi possível reiniciar sozinho.": "अपने-आप दोबारा शुरू नहीं हो सका।",
 "Não foi possível sincronizar com a agenda: {msg}": "कैलेंडर के साथ सिंक नहीं हो सका: {msg}",
 "Não foi possível trocar a foto": "फ़ोटो बदली नहीं जा सकी",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "ऐप बंद होने पर सूचना मिलने की गारंटी नहीं है। जाँच ऐप खोलने पर (हर 6 घंटे में) या \"अभी जाँचें\" पर होती है।",
 "Não identificado": "पहचान नहीं हुई",
 "Não marcada como feita": "पूरा चिह्नित नहीं",
 "Não optante pelo Simples": "Simples में शामिल नहीं",
 "Não se repete": "दोहराया नहीं जाता",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "ऐप का उपयोग गैरकानूनी गतिविधियों, बिना अनुमति दूसरों की सामग्री रखने या दूसरे लोगों के डेटा तक पहुँचने की कोशिश के लिए न करें।",
 "Não vai": "नहीं आएँगे",
 "Não vence": "समाप्त नहीं होता",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "हम आपका डेटा नहीं बेचते और आपकी सामग्री का उपयोग विज्ञापन के लिए नहीं करते।",
 "Não é possível adicionar esta pessoa.": "इस व्यक्ति को नहीं जोड़ा जा सकता।",
 "Não é um XML de nota fiscal": "यह इनवॉइस का XML नहीं है",
 "Número": "नंबर",
 "Número (opcional)": "नंबर (वैकल्पिक)",
 "Número da OAB": "OAB नंबर",
 "Número da caixa": "बॉक्स नंबर",
 "Número da carteirinha": "कार्ड नंबर",
 "Número da guia do convênio": "बीमा फ़ॉर्म नंबर",
 "Número da parcela": "किस्त नंबर",
 "Número de hóspedes": "मेहमानों की संख्या",
 "Número de parcelas": "किस्तों की संख्या",
 "Número do contrato": "अनुबंध नंबर",
 "Número do registro": "पंजीकरण नंबर",
 "Número na chamada": "हाज़िरी नंबर",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "नंबर {n}। XML इनवॉइस में सहेज लिया गया। PDF देखने के लिए उस पर टैप करें।",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "नंबर, जारी करने वाली संस्था और टिप्पणियाँ क्लाउड पर जाने से पहले डिवाइस पर एन्क्रिप्ट होती हैं (AES-256)।",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "नंबर, जारी करने वाली संस्था, नोट्स, फ़ोटो और PDF डिवाइस पर एन्क्रिप्ट (AES-256) होते हैं। सुरक्षित फ़ाइलें सिर्फ़ इसी डिवाइस पर रहती हैं।",
 "Número: {n}": "नंबर: {n}",
 "Números de página": "पेज नंबर",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT यहाँ PDF नहीं पढ़ता। पेज की फ़ोटो या स्क्रीनशॉट लें, या सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस में Claude या Gemini इस्तेमाल करें।",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "DAS {dia} तारीख़ को देय है। वित्त में भुगतान हुआ चिह्नित करें।",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "सर्वर पर ऑफ़िस अभी चालू नहीं किया गया है। कंप्यूटर पर 29-SERVIDOR-0.45.bat चलाएँ (सिर्फ़ एक बार)।",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Mestre Achado आपके पैसों का ध्यान रखता है: बिल, कार्ड और कार्ड बिल, श्रेणी के अनुसार बजट, लक्ष्य, फ़ोटो से स्टेटमेंट और रसीद, रिपोर्ट और MEI।",
 "O Mestre está pensando...": "मास्टर सोच रहे हैं...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner आपके Drive में \"My Planner\" फ़ोल्डर बनाता है और केवल वही देखता है जो उसने खुद वहाँ सहेजा है।",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner आपके डेटा के साथ कंप्यूटर पर खुल गया है।",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner घड़ी का डेटा {fonte} से पढ़ता है, जहाँ घड़ी और स्वास्थ्य व व्यायाम ऐप्स सब कुछ सेव करते हैं।",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner आपके एजेंडा, कार्यों, वित्त, दस्तावेज़ों और जीवन के अन्य क्षेत्रों को व्यवस्थित करता है। इसे Walter Ravasco da Costa प्रदान करते हैं, जो ऐप में प्रोसेस किए जाने वाले व्यक्तिगत डेटा के नियंत्रक हैं।",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner आपके OneDrive में केवल ऐप्स › My Planner फ़ोल्डर का उपयोग करता है।",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "PDF और इमेज इस डिवाइस और क्लाउड से हटा दी जाएंगी।",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "PDF 15 MB से बड़ा हो गया है। अगर WhatsApp या ईमेल इसे न ले, तो \"छोटी फ़ाइल\" चालू करें।",
 "O QUE COMER": "क्या खाएँ",
 "O QUE OS MEMBROS PODEM": "सदस्य क्या कर सकते हैं",
 "O QUE VOCÊ MANDA": "आप जो भेजते हैं",
 "O QUE VOCÊ RECEBE": "आपको जो मिलता है",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "लॉग इन अब भी CPF से होता है। ईमेल का उपयोग सहायता टीम आपसे संपर्क करने के लिए करती है।",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "समूह का एडमिन अपॉइंटमेंट, सामग्री और सूचनाएँ भेज सकेगा। आपकी स्वीकृति के बिना आपके एजेंडा में कुछ नहीं जुड़ेगा।",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "जब तक दवा ली गई चिह्नित न हो, अलार्म हर 2 मिनट में फिर बजता है (4 बार तक)।",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "ऐप व्यवस्थित करने में मदद करता है, लेकिन डॉक्टरों, वकीलों, अकाउंटेंट या अन्य पेशेवरों की सलाह की जगह नहीं लेता। ज़रूरी समय-सीमाएँ, राशियाँ और तारीखें जाँच लें।",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "ऐप देय तिथि से 3 दिन पहले और उसी दिन सुबह 9 बजे सूचित करता है।",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "ऐप आपके दर्ज किए गए नामों और OAB नंबर से CNJ की सार्वजनिक सेवा (DJEN) में खोज करता है। हर जाँच पर यह डेटा उस सेवा को भेजा जाता है।",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "My Planner ऐप और सर्वर आपके दर्ज किए गए नामों और OAB नंबरों के साथ CNJ की सार्वजनिक सेवा (DJEN) से और, यदि आप चुनें, तो Querido Diário (नगरपालिका आधिकारिक राजपत्र) से जानकारी लेते हैं। हर जाँच पर यह डेटा इन सेवाओं को भेजा जाता है।",
 "O app fechou sozinho {n} vezes seguidas": "ऐप लगातार {n} बार अपने-आप बंद हुआ",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "इस डिवाइस पर इंस्टॉल ऐप का संस्करण {v} है। ऑडियो और वीडियो कॉल के लिए ऐप 0.35 या नया (नया APK) इंस्टॉल करें। संदेश पहले से काम कर रहे हैं।",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "ऐप बंद नहीं हुआ और आपका डेटा सुरक्षित है। फिर कोशिश करें या टीम को ठीक करने के लिए रिपोर्ट भेजें।",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "ऐप खोलते समय और बैकग्राउंड से लौटने पर ऐप अनलॉक माँगता है।",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "ऐप खुलते समय अनलॉक माँगता है। जल्दी से ऐप या स्क्रीन बदलने पर दोबारा नहीं माँगता; अगर फ़ोन लॉक हो जाए या ऐप नीचे दी गई समय-सीमा से ज़्यादा देर स्क्रीन से बाहर रहे, तो माँगता है।",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "ऐप केवल पढ़ता है (कदम, दूरी, कैलोरी, व्यायाम, धड़कन और नींद) और आपके स्वास्थ्य डेटा को कभी नहीं बदलता। हर दिन के कुल आंकड़े आपके खाते में रहते हैं ताकि वे वेबसाइट और दूसरे फ़ोन पर भी दिखें।",
 "O app volta a pedir a senha para desbloquear.": "ऐप अनलॉक के लिए फिर से पासवर्ड माँगेगा।",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "यह ऐप 18 वर्ष से अधिक उम्र के लोगों के लिए है। बच्चों का डेटा केवल माता-पिता या अभिभावक ही दर्ज कर सकते हैं।",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "फ़ाइल केवल इस डिवाइस पर रही। {nome} में सहेजा नहीं जा सका: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "फ़ाइल अब उस जगह पर नहीं है (हटाई या खिसकाई गई)।",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "फ़ाइल अब उस जगह पर नहीं है (हटाई, खिसकाई गई या उसके ऐप ने अनुमति हटा दी)। फिर से अटैच करें।",
 "O arquivo passa de 15 MB.": "फ़ाइल 15 MB से बड़ी है।",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "फ़ाइल 15 MB से बड़ी है। \"छोटी फ़ाइल\" चालू करें और फिर से कोशिश करें।",
 "O arquivo passa de 25 MB.": "फ़ाइल 25 MB से बड़ी है।",
 "O arquivo passa de 50 MB.": "फ़ाइल 50 MB से बड़ी है।",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "फ़ाइल इस फ़ोन से हट जाएगी। Drive, OneDrive में सेव की गई या किसी को भेजी गई कॉपी वहीं रहेंगी।",
 "O arquivo sai do escritório para todos.": "यह फ़ाइल सभी के लिए ऑफ़िस से हट जाएगी।",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "सूचना सुबह 9 बजे आती है, और समाप्ति के दिन फिर से।",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "डेटाबेस अभी तैयार नहीं है। Supabase में supabase/schema.sql फ़ाइल चलाएँ।",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "कार्ड {c} की {p}% लिमिट इस्तेमाल हो चुकी है। फ़िलहाल इस पर नई किस्तें न लें।",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "स्क्रीन लॉक होने पर फ़ोन ऐप को सूचित नहीं करता, इसलिए ऐप बाहर बिताया गया समय गिनता है। 1 मिनट पर, फ़ोन लॉक करके बाद में लौटने पर बायोमेट्रिक माँगा जाएगा; किसी संदेश का जल्दी जवाब देने पर नहीं।",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "मोबाइल सिर्फ़ यह पुष्टि करने के लिए है कि खाता आपका है (साइन अप करते समय और नंबर बदलते समय WhatsApp पर कोड)। एक खाते में एक नंबर।",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "सर्वर पर साझाकरण अभी चालू नहीं हुआ है। कंप्यूटर पर C:\\MyPlanner फ़ोल्डर खोलें और 12-LIGAR-COMPARTILHAMENTO.bat पर डबल-क्लिक करें (केवल एक बार)।",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "कंप्यूटर आपके खाते के साथ My Planner खोलेगा। ऐसा केवल भरोसेमंद कंप्यूटरों पर करें।",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "आमंत्रण में ऐप और सबसे नए APK का लिंक होता है। लिंक से जुड़ने वाला सीधे ऑफ़िस में पहुँचता है।",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "रेफ़रल कोड केवल खाते के पहले 30 दिनों में मान्य है।",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "पैटर्न केवल इसी डिवाइस पर सुरक्षित रूप से सहेजा जाता है। पैटर्न भूलने पर भी पासवर्ड काम करता रहेगा।",
 "O dinheiro gasto está à frente do andamento da obra.": "ख़र्च हुआ पैसा काम की प्रगति से आगे है।",
 "O documento não tem páginas.": "दस्तावेज़ में कोई पेज नहीं है।",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "स्टेटमेंट इसी डिवाइस पर पढ़ा जाता है। समान राशि और नज़दीकी तारीख वाले देय बिल अपने-आप भुगतान हुए चिह्नित हो जाते हैं।",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "स्टेटमेंट यहीं डिवाइस पर पढ़ा जाता है। समान राशि और नज़दीकी तारीख वाले देय बिल अपने-आप चुकाए हुए मान लिए जाते हैं। कार्ड बिल का भुगतान दो बार नहीं गिना जाता।",
 "O governo recusou a nota": "सरकार ने इनवॉइस अस्वीकार किया",
 "O governo recusou a nota.": "सरकार ने इनवॉइस अस्वीकार किया।",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "भाषा केवल इस डिवाइस पर लागू होती है। आपके लिखे डेटा का अनुवाद नहीं होता।",
 "O item vinculado foi apagado ou movido.": "जुड़ा हुआ आइटम मिटा दिया गया या हटा दिया गया।",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "जुड़ा हुआ आइटम मिटा दिया गया या हटा दिया गया। दूसरा चुनने के लिए कार्य संपादित करें।",
 "O link antigo deixa de funcionar.": "पुराना लिंक काम करना बंद कर देगा।",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "पुराना लिंक काम करना बंद कर देगा। जो पहले से समूह में हैं वे बने रहेंगे।",
 "O link deve começar com https://": "लिंक https:// से शुरू होना चाहिए",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "ब्राउज़र प्लेटफ़ॉर्म का कैलेंडर नहीं पढ़ने देता। फ़ोन के ऐप से इंपोर्ट करें।",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "बेसिक प्लान और टैब की ट्रायल अवधि सेटिंग्स > खरीदारी में दिखाए गए नियमों के अनुसार चलती हैं। रेफ़रल लाभ प्रति खाता एक बार मिलते हैं।",
 "O que acontece": "क्या होगा",
 "O que apagar": "क्या हटाना है",
 "O que comprou": "क्या ख़रीदा",
 "O que fazer": "क्या करना है",
 "O que foi comido:": "क्या खाया:",
 "O que foi feito": "क्या काम हुआ",
 "O que foi visto": "क्या पढ़ाया गया",
 "O que funcionou, o que ajustar, metodologias, resumos...": "क्या काम किया, क्या सुधारना है, तरीके, सारांश...",
 "O que já foi guardado continua nos lançamentos como investimento.": "जो पहले बचाया जा चुका है, वह एंट्रियों में निवेश के रूप में रहेगा।",
 "O que levar ou estudar": "क्या ले जाना या पढ़ना है",
 "O que o app pode usar": "ऐप क्या इस्तेमाल कर सकता है",
 "O que o médico disse": "डॉक्टर ने क्या कहा",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "आपके समूहों ने जो भेजा। स्वीकार किए गए अपॉइंटमेंट My Planner में जाते हैं; सामग्री और सूचनाएँ नोट्स में जाती हैं।",
 "O que precisa": "क्या चाहिए",
 "O que tem dentro": "अंदर क्या है",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "आपने जो उधार दिया या लिया: फ़ोटो, किसके पास है और लौटाने की सूचना।",
 "O que é apagado": "क्या हटाया जाता है",
 "O quê": "क्या",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "फ़ोन में Google Drive, OneDrive और Dropbox इंस्टॉल हों तो चयनकर्ता उन्हें दिखाता है। ऐप सिर्फ़ शॉर्टकट रखता है: फ़ाइल वहीं रहती है और फ़ोन के ऐप में खुलती है।",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "फ़ोन में Google Drive, OneDrive और Dropbox इंस्टॉल हों तो वे चयनकर्ता में दिखते हैं। चुनी गई फ़ाइल इसी डिवाइस में सहेजी जाती है।",
 "O servidor ainda não buscou para os seus perfis.": "सर्वर ने अभी तक आपकी प्रोफ़ाइलों के लिए खोज नहीं की है।",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "सर्वर अभी संदेशों के लिए तैयार नहीं है। 17-LIGAR-MENSAGENS.bat चलाएँ।",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "सर्वर अभी रेफ़रल के लिए तैयार नहीं है। बाद में फिर से कोशिश करें।",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "सर्वर अभी संपर्क कार्ड के लिए तैयार नहीं है। 19-LIGAR-CONTATO.bat चलाएँ।",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "सर्वर अभी साझा डेटा के लिए तैयार नहीं है। कंप्यूटर पर C:\\MyPlanner फ़ोल्डर खोलें और 15-LIGAR-GRUPOS-COLABORATIVOS.bat पर डबल-क्लिक करें (सिर्फ़ एक बार)।",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "सर्वर अभी Drive और OneDrive के लिए तैयार नहीं है (COMO RODAR, संस्करण 0.14 देखें)।",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "सर्वर अभी वेब पहुँच के लिए तैयार नहीं है (supabase/migracao-0.6.sql चलाएँ)।",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "सर्वर में अभी \"qr-login\" फ़ंक्शन नहीं है। COMO RODAR में संस्करण 0.6 का चरण देखें।",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "कॉल सर्वर ने LiveKit की कुंजी अस्वीकार कर दी। एडमिन के कंप्यूटर पर 30-CONSERTAR-CHAMADAS.bat चलाएँ।",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "इनवॉइस सर्वर ने अनपेक्षित जवाब दिया (HTTP {s})। पता जाँचें।",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "सर्वर हर 2 घंटे में, 08:00 से 20:00 तक (ब्रासीलिया समय), ऐप बंद होने पर भी स्वचालित कैप्चर करता है। कैप्चर किए गए प्रकाशन ऐप खोलने पर दिखते हैं। आप \"अभी जाँचें\" का भी उपयोग कर सकते हैं।",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "सर्वर हर दिन 08:00 और 12:00 बजे (ब्रासीलिया समय) स्वचालित संग्रह करता है, ऐप बंद होने पर भी। संग्रहित प्रकाशन ऐप खोलने पर दिखाई देते हैं। आप \"अभी जाँचें\" का भी उपयोग कर सकते हैं।",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "सर्वर ने एक्सेस अस्वीकार कर दिया: Supabase के \"nuvem\" फ़ंक्शन में \"Verify JWT\" बंद करें (32-LIGAR-DRIVE-ONEDRIVE.bat यह पहले से करता है)।",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "सर्वर ने पहुँच अस्वीकार कर दी: Supabase के \"nuvem\" फ़ंक्शन में \"Verify JWT\" बंद करें (9-LIGAR-DRIVE-ONEDRIVE.bat यह पहले से करता है)।",
 "O seu papel no grupo não permite incluir aqui.": "समूह में आपकी भूमिका यहाँ जोड़ने की अनुमति नहीं देती।",
 "O site deve começar com https://": "वेबसाइट https:// से शुरू होनी चाहिए",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "गिलास का डिफ़ॉल्ट साइज़ ({copo}) पानी वाले कार्ड में \"बदलें\" से बदलें।",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "थीम टैब के रंग बदलती है (आइकन वही रहते हैं) और लाइट व डार्क दोनों मोड में लागू होती है। बाद में भी आप सेटिंग्स > टैब में किसी टैब का रंग बदल सकते हैं।",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "कार्य का समय बीतने के साथ टाइमर रंग से भरता जाता है। उस पर टैप करने से कार्य का लिंक खुलता है।",
 "O teste grátis terminou": "मुफ़्त ट्रायल खत्म हो गया",
 "O texto": "टेक्स्ट",
 "O texto do PDF num arquivo .docx para editar.": "PDF का टेक्स्ट बदलने लायक .docx फ़ाइल में।",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "टेक्स्ट PDF के अंदर छिपा भी रहता है: आप PDF रीडर में उसे खोज और कॉपी कर सकते हैं।",
 "O tom escolhido fica para os próximos emojis.": "चुना गया रंग अगले इमोजी के लिए भी रहेगा।",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "कुल My Planner में सबसे ऊपर दिखता है। सीमा पार होने पर बिजली का निशान लाल हो जाता है। \"आराम\" वाले कार्य 0 गिने जाते हैं।",
 "OAB (opcional, para advogados)": "OAB (वैकल्पिक, वकीलों के लिए)",
 "OBS": "नोट",
 "OCR: texto pesquisável": "OCR: खोजने लायक टेक्स्ट",
 "OK": "ठीक है",
 "OU ESCOLHER CÔMODO…": "या कमरा चुनें…",
 "Objetivos": "उद्देश्य",
 "Objeto": "वस्तु",
 "Objetos": "वस्तुएँ",
 "Objetos e valores": "चीज़ें और पैसे",
 "Obra": "निर्माण कार्य",
 "Obras": "निर्माण कार्य",
 "Obras & Reformas": "निर्माण और नवीनीकरण",
 "Obrigado": "धन्यवाद",
 "Obrigado!": "धन्यवाद!",
 "Observações": "टिप्पणियाँ",
 "Observações (alergias, ração...)": "टिप्पणियाँ (एलर्जी, खाना...)",
 "Observações (chave Pix, conta para depósito...)": "टिप्पणियाँ (Pix कुंजी, जमा के लिए खाता...)",
 "Observações (código de barras, chave Pix...)": "टिप्पणी (बारकोड, Pix कुंजी...)",
 "Observações (dados bancários, PIX...)": "टिप्पणियाँ (बैंक विवरण, PIX...)",
 "Observações (estado do item...)": "टिप्पणियाँ (वस्तु की हालत...)",
 "Observações (garantia, seguro, CET...)": "टिप्पणियाँ (गारंटी, बीमा, कुल लागत...)",
 "Observações (nº de série, modelo...)": "टिप्पणियाँ (सीरियल नं., मॉडल...)",
 "Observações (onde está o original, categoria da CNH...)": "टिप्पणियाँ (मूल कहाँ है, CNH की श्रेणी...)",
 "Observações (recibo de entrega, número...)": "टिप्पणियाँ (डिलीवरी रसीद, नंबर...)",
 "Observações (restrição alimentar...)": "टिप्पणियाँ (खान-पान की पाबंदी...)",
 "Ocultar texto (tarja)": "टेक्स्ट छिपाएँ (काली पट्टी)",
 "Ocupado": "भरा हुआ",
 "Oficina": "वर्कशॉप",
 "Ofício": "लीगल",
 "Oi!": "हाय!",
 "Oi! Tudo certo para sábado?": "नमस्ते! शनिवार की सब तैयारी हो गई?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "नमस्ते {pessoa}! आपकी दी हुई {coisa} अभी मेरे पास है। लौटाने के लिए कब ठीक रहेगा?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "नमस्ते {pessoa}! कैसे हैं? बस याद दिलाना था कि {data} को मैंने आपको {coisa} दी थी। क्या आप {quando} लौटा सकते हैं?",
 "Oi?!": "क्या?!",
 "Olá!": "नमस्ते!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "नमस्ते! मैं Mestre Achado हूँ। अपने खर्च, बिल, कार्ड और लक्ष्यों के बारे में पूछें: मैं आपके ही आँकड़ों से जवाब दूँगा।",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "नमस्ते! याद दिलाना था कि {ref} ({v}) का भुगतान {d} को देय है। धन्यवाद!",
 "Olá! Preciso de assistência técnica para: {item}": "नमस्ते! मुझे इसके लिए तकनीकी सहायता चाहिए: {item}",
 "Olá, {nome}!": "नमस्ते {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "नमस्ते, {nome}! आपका स्वागत है।",
 "Ombros: girar para trás": "कंधे: पीछे की ओर घुमाएँ",
 "Omelete": "ऑमलेट",
 "Onde": "कहाँ",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "AI कहाँ मदद करता है: प्रकाशन (सुनवाई और समय-सीमाएँ), दस्तावेज़ (फ़ोटो से फ़ॉर्म भरना) और नोट्स (बॉक्स को कार्यों में बदलना)।",
 "Onde assistir": "कहाँ देखें",
 "Onde eu mais gastei este mês?": "इस महीने मैंने सबसे ज़्यादा कहाँ खर्च किया?",
 "Onde fica": "कहाँ है",
 "Onde guardar fotos e arquivos novos": "नई फ़ोटो और फ़ाइलें कहाँ सहेजें",
 "Onde na página": "पेज पर कहाँ",
 "Ontem": "बीता कल",
 "Organizar": "व्यवस्थित करें",
 "Organizar barra": "बार व्यवस्थित करें",
 "Organizar com IA": "AI से व्यवस्थित करें",
 "Organizar com IA (vira tarefas)": "AI से व्यवस्थित करें (कार्य बनें)",
 "Organizar páginas": "पेज व्यवस्थित करें",
 "Orgulho e vibrante": "गर्व और जीवंत",
 "Origem": "स्रोत",
 "Origem da reserva": "बुकिंग का स्रोत",
 "Original": "मूल",
 "Orquídeas": "ऑर्किड",
 "Orçado": "अनुमानित",
 "Orçamento": "बजट",
 "Orçamento do mês": "महीने का बजट",
 "Orçamento por categoria": "श्रेणी के अनुसार बजट",
 "Orçamento total": "कुल बजट",
 "Orçamento: {v}": "बजट: {v}",
 "Os alertas precisam de um horário.": "अलर्ट के लिए समय ज़रूरी है।",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "जो अटैचमेंट सिर्फ़ इस डिवाइस में हैं, वे दूसरे डिवाइस पर नहीं दिखते और फ़ोन बदलने पर खो जाते हैं। कॉपी रखने के लिए सेटिंग्स में Google Drive या OneDrive कनेक्ट करें।",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "वहाँ पहले से मौजूद फ़ाइलें और बैकअप वहीं रहेंगे। My Planner बस नई चीज़ें सहेजना बंद कर देगा।",
 "Os arquivos guardados neste dispositivo também serão apagados.": "इस डिवाइस पर सहेजी गई फ़ाइलें भी मिट जाएँगी।",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "आपके Google Drive, OneDrive या फ़ोन की फ़ाइलें आपके पास रहती हैं। कानून द्वारा रखे जाने वाले रिकॉर्ड (जैसे एक्सेस लॉग) कानूनी अवधि तक रखे जा सकते हैं और फिर हटा दिए जाते हैं।",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "समूह की सूचनाएँ अभी सर्वर पर चालू नहीं हुई हैं। कंप्यूटर पर 15-LIGAR-GRUPOS-COLABORATIVOS.bat पर डबल-क्लिक करें (सिर्फ़ एक बार)।",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "My Planner के लिए सूचनाएँ बंद हैं। सेटिंग्स खोलें पर टैप करें और सूचनाएँ चालू करें।",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "फ़ोन पर सूचनाएँ इंस्टॉल किए गए ऐप (Android या iPhone) में काम करती हैं।",
 "Os campos do formulário viram parte da página.": "फ़ॉर्म के फ़ील्ड पेज का हिस्सा बन जाते हैं।",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "मौजूदा डेटा फ़ाइल के डेटा से बदल दिया जाएगा, यहाँ और क्लाउड में।",
 "Os dados continuam salvos na nuvem.": "डेटा क्लाउड में सुरक्षित रहता है।",
 "Os dados da aba ainda são só seus": "इस टैब का डेटा अभी केवल आपका है",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "टैब {aba} का डेटा टीम को दिखने लगेगा, हर व्यक्ति को आपकी चुनी गई भूमिका के अनुसार।",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "इस समूह का डेटा अभी उपलब्ध नहीं कराया गया है। समूह बनाने वाले व्यक्ति से अपडेटेड My Planner खोलने को कहें: ऐप इसे अपने आप उपलब्ध कर देगा।",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "इस समूह का डेटा अभी खोला नहीं गया है। समूह बनाने वाले से कहें कि वे My Planner अपडेट करें और समूह खोलें: वहाँ खोलने का बटन दिखेगा।",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "वॉल्ट का डेटा क्लाउड पर जाने से पहले यहीं डिवाइस पर एन्क्रिप्ट होता है (AES-256)। सपोर्ट भी इसे नहीं पढ़ सकता। वॉल्ट पासवर्ड भूल गए तो यह डेटा वापस नहीं पाया जा सकता।",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "जब तक खाता मौजूद है, डेटा सहेजा रहता है। खाता हटाने पर डेटा हटा दिया जाता है, सिवाय उसके जिसे कानूनन रखना ज़रूरी हो।",
 "Os desenhos não conferem. Comece de novo.": "पैटर्न मेल नहीं खाते। फिर से शुरू करें।",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "ये तारीखें बैंक के ऐप या कार्ड बिल में होती हैं। बिल बनने के बाद की खरीदारी अगले बिल में जाती है।",
 "Os emojis que você usar aparecem aqui.": "आप जो इमोजी इस्तेमाल करेंगे, वे यहाँ दिखेंगे।",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "सर्वर पर समूह अभी चालू नहीं हुए हैं। कंप्यूटर पर C:\\MyPlanner फ़ोल्डर खोलें और 11-LIGAR-GRUPOS.bat पर डबल-क्लिक करें (सिर्फ़ एक बार)।",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "सर्वर पर समूह अभी चालू नहीं किए गए हैं। Supabase में supabase\\migracao-0.21.sql चलाएँ (COMO RODAR देखें)।",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "जगहें Google Maps, Waze या मानचित्र में खुलती हैं, जैसा सेटिंग्स में चुना गया है।",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "सदस्य हमेशा एडमिन को देखते हैं और सिर्फ़ वही पाते हैं जो उन्हें भेजा गया है।",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "अन्य सदस्य डेटा नहीं देख पाएँगे (उनके डिवाइस से कॉपी हट जाएगी)। सब कुछ आपके पास रहेगा।",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "प्रोफ़ाइलें और परिणाम आपके My Planner खाते में रहते हैं।",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "प्रोफ़ाइल, OAB और न्यायालय प्रकाशन टैब के अंदर रहते हैं। स्वचालित खोज सर्वर पर 08:00 और 12:00 बजे (ब्रासीलिया समय) चलती है।",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "कीमतें सहेजी जाती हैं और भोजन और पैंट्री टैब की खरीदारी सूची में पिछली खरीद की कीमत के रूप में दिखती हैं।",
 "Os resultados deste perfil também serão apagados.": "इस प्रोफ़ाइल के परिणाम भी मिटा दिए जाएँगे।",
 "Os termos foram atualizados": "शर्तें अपडेट हो गई हैं",
 "Ou digite (ex.: 2 ovos mexidos)": "या लिखें (जैसे: 2 अंडों की भुर्जी)",
 "Ou escreva o prato": "या व्यंजन लिखें",
 "Ou escreva o seu": "या अपना लिखें",
 "Outra": "अन्य",
 "Outra aba…": "दूसरा टैब…",
 "Outra atividade (digite e dê Enter)": "अन्य गतिविधि (लिखें और Enter दबाएँ)",
 "Outro": "अन्य",
 "Outro (ml)": "अन्य (ml)",
 "Outro valor": "अन्य राशि",
 "Outros": "अन्य",
 "Outros países": "अन्य देश",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "अन्य घड़ियाँ (Garmin, Samsung, Xiaomi, Amazfit...): घड़ी के ऐप में, डेटा Health ऐप (Apple Health) को भेजने का विकल्प चालू करें।",
 "Ovo": "अंडा",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "भुगतान हुआ, प्राप्त, गोपनीय, स्वीकृत या आपका टेक्स्ट, तारीख के साथ।",
 "PARA ACERTAR": "हिसाब बराबर करें",
 "PARA QUEM": "किसे",
 "PARA {refeicao}": "{refeicao} के लिए",
 "PASSO A PASSO": "चरण-दर-चरण",
 "PASSO {n}": "चरण {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "डिजिटल टेक्स्ट वाला PDF: ब्राउज़र में तुरंत। स्कैन किया PDF (फ़ोटो): आपका AI हर पेज पढ़ता है।",
 "PDF grande": "बड़ा PDF",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF फ़ोन के \"{pasta}\" फ़ोल्डर में सेव हो गया।",
 "PDF guardado no {nome}.": "PDF {nome} में सेव हो गया।",
 "PDF numa página só": "एक ही पेज में PDF",
 "PDF para Word": "PDF से Word",
 "PDF para imagens": "PDF से इमेज",
 "PDF para texto": "PDF से टेक्स्ट",
 "PDFs arquivados ({n})": "संग्रहीत PDF ({n})",
 "PDFs juntados {data}": "जोड़े गए PDF {data}",
 "PEDIDOS RECEBIDOS": "मिले हुए अनुरोध",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX कॉपी-पेस्ट",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "आगे के कार्ड बिल (पहले से तय)",
 "Paciente": "मरीज़",
 "Paciente ou aluno": "मरीज़ या छात्र",
 "Pacientes": "मरीज़",
 "Padrão": "डिफ़ॉल्ट",
 "Padrão da aba": "टैब का डिफ़ॉल्ट",
 "Paga": "चुकाई गई",
 "Paga (toque para desfazer)": "चुकाया गया (पूर्ववत करने के लिए टैप करें)",
 "Pagador": "भुगतानकर्ता",
 "Pagamento já contado": "पहले से गिना गया भुगतान",
 "Pagar": "भुगतान",
 "Pagar parcela {n}/{t} · {c}": "किस्त {n}/{t} चुकाएँ · {c}",
 "Pagas": "चुकाई गईं",
 "Pago": "भुगतान हुआ",
 "Pago com": "भुगतान का तरीका",
 "Pago: {p} · Falta pagar: {f}": "भुगतान: {p} · बाकी: {f}",
 "Pagos": "भुगतान हुए",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "{v} का भुगतान किया? अगर छूट, विलंब शुल्क या ब्याज लगा हो, तो भुगतान की गई राशि दर्ज करें। क्या अभी रसीद सहेजें?",
 "Paguei outro valor (desconto, multa ou juros)": "मैंने अलग राशि चुकाई (छूट, विलंब शुल्क या ब्याज)",
 "Paixão de Cristo": "गुड फ़्राइडे",
 "Palavras-chave (separe com vírgula)": "कीवर्ड (कॉमा से अलग करें)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "लक्ष्य \"{m}\" समय पर पूरा करने के लिए हर महीने {v} चाहिए। समय-सीमा बढ़ाना या छोटी राशि से शुरू करना ठीक रहेगा।",
 "Para clareza, firmo o presente.": "स्पष्टता के लिए मैं इस पर हस्ताक्षर करता/करती हूँ।",
 "Para comprar": "खरीदने के लिए",
 "Para continuar, digite a senha do app.": "जारी रखने के लिए ऐप का पासवर्ड दर्ज करें।",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "बात करने के लिए सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस में अपना AI (Claude, ChatGPT या Gemini) चालू करें।",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "खर्च बाँटने के लिए \"कौन जा रहा है\" में नाम कॉमा से अलग करके लिखें (यात्रा संपादित करें)।",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "इनवॉइस जारी करने और खोजने के लिए एक बार इनवॉइस सर्वर चालू करें: कंप्यूटर पर 13-LIGAR-NOTAS.bat पर डबल-क्लिक करें और जो पता दिखे (जो .netlify.app पर खत्म होता है) उसे यहाँ चिपकाएँ।",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "अपने अधिकारों का उपयोग करने के लिए, ऐप में हमसे संपर्क करें इस्तेमाल करें या नीचे दिए ईमेल पर लिखें। हम 15 दिनों के भीतर जवाब देते हैं।",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "ऑडियो और वीडियो कॉल के लिए ऐप का नया वर्ज़न (0.35) इंस्टॉल करें। संदेश पहले से काम कर रहे हैं।",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "ऐप को चलाने के लिए: डिवाइसों के बीच आपका डेटा सहेजना और सिंक करना, अलर्ट भेजना, आपके चुने हुए समूहों के साथ साझा करना और सपोर्ट देना।",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "PDF को {nome} में सेव करने के लिए सेटिंग्स › Google Drive और OneDrive में अपना अकाउंट कनेक्ट करें।",
 "Para hoje": "आज के लिए",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "फ़ोटो या PDF पढ़ने के लिए सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस में अपना AI (Claude, ChatGPT या Gemini) चालू करें। OFX या CSV स्टेटमेंट बिना AI के चलता है।",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "घड़ी को अपने आप पढ़ने के लिए, ऐप का नया वर्ज़न (0.33) इंस्टॉल करें। तब तक, आप हाथ से दर्ज कर सकते हैं।",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "घड़ी पढ़ने के लिए, फ़ोन पर ऐप से कनेक्ट करें। नंबर यहाँ भी दिखेंगे।",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "घड़ी पढ़ने के लिए, My Planner को गतिविधि डेटा की अनुमति दें।",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "टेक्स्ट पढ़ने, सारांश बनाने और सवाल पूछने के लिए सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस में अपना AI चालू करें (Claude, ChatGPT या Gemini)।",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "चालू करने के लिए फ़ोन पर ऐप इस्तेमाल करें (सेटिंग्स > Google कैलेंडर)। इसके बाद सब कुछ यहां भी दिखेगा।",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "चालू करने के लिए फ़ोन पर ऐप इस्तेमाल करें (सेटिंग्स › सामान्य सेटिंग्स › Google कैलेंडर)। इसके बाद सब कुछ यहां भी दिखेगा।",
 "Para monitorar a OAB, informe o número e a UF.": "OAB की निगरानी के लिए नंबर और राज्य (UF) दर्ज करें।",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "दोबारा न पूछने के लिए, सेटिंग्स › सामान्य सेटिंग्स में ऐप चुनें।",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "स्वास्थ्य पेशेवरों के लिए: मरीज़, वॉल्ट में प्रगति नोट्स, टेम्पलेट वाले पर्चे, वित्त, रसीद और प्रतिपूर्ति के लिए PDF घोषणा-पत्र।",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "स्वास्थ्य पेशेवरों के लिए: मरीज़, प्रगति नोट्स, टेम्पलेट वाले पर्चे, बीमा सहित वित्त, रसीद और प्रतिपूर्ति के लिए घोषणा-पत्र।",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "आपके खाते की सुरक्षा के लिए, हम WhatsApp पर एक कोड से आपके मोबाइल की एक बार पुष्टि करते हैं। यह फिर से तभी माँगा जाता है जब आप नंबर बदलते हैं।",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "जो प्रॉपर्टी या कमरा कम समय के लिए किराये पर देते हैं (Airbnb, Booking या सीधे): बुकिंग, सफ़ाई, खर्च और हर महीने का मुनाफ़ा।",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "इवेंट का शेड्यूल, स्थान और सूचनाएँ फ़ोन पर पाने के लिए समूह से जुड़ें: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "सिंक करने के लिए, फ़ोन की सेटिंग में My Planner को कैलेंडर की अनुमति दें।",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "सिस्टम को पहले से दी गई अनुमति (कैमरा, फ़ोटो, माइक्रोफ़ोन) वापस लेने के लिए फ़ोन की सेटिंग्स भी इस्तेमाल करें।",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "अधिक पूरी जानकारी के लिए सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस में अपना AI चालू करें।",
 "Parabéns": "बधाई",
 "Parabéns!": "बधाई हो!",
 "Parada": "स्थिर",
 "Parar": "रोकें",
 "Parar de compartilhar?": "साझा करना बंद करें?",
 "Parar e salvar": "रोकें और सहेजें",
 "Parar gravação": "रिकॉर्डिंग रोकें",
 "Parcela": "किस्त",
 "Parcela de financiamento": "लोन की किस्त",
 "Parcela {n}/{t}": "किस्त {n}/{t}",
 "Parcela {n}/{t} · {c}": "किस्त {n}/{t} · {c}",
 "Parcelas": "किस्तें",
 "Parcelas a pagar nos próximos meses": "अगले महीनों में देय किस्तें",
 "Parcelas recalculadas": "किस्तें फिर से गणना की गईं",
 "Parece que foi impresso e escaneado.": "ऐसा लगता है जैसे प्रिंट करके स्कैन किया गया हो।",
 "Parei": "छोड़ दिया",
 "Parei na aula": "रुका हुआ पाठ",
 "Parei na aula...": "मैं इस पाठ पर रुका...",
 "Pares de meia": "मोज़ों के जोड़े",
 "Parque ou natureza": "पार्क या प्रकृति",
 "Parques": "पार्क",
 "Parte": "पक्ष",
 "Partes": "पक्षकार",
 "Participa": "प्रतिभागी",
 "Participantes": "प्रतिभागी",
 "Participação em empresa": "कंपनी में हिस्सेदारी",
 "Passa do limite do MEI: fale com seu contador.": "MEI की सीमा पार हो रही है: अपने अकाउंटेंट से बात करें।",
 "Passaporte": "पासपोर्ट",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "सिर्फ़ वह हिस्सा मिटाने के लिए ड्रॉइंग पर उँगली फेरें।",
 "Passeio": "सैर",
 "Passeios": "सैर-सपाटे",
 "Passo a passo": "चरण-दर-चरण",
 "Passos": "कदम",
 "Passos, exercício, calorias, batimentos e sono": "कदम, व्यायाम, कैलोरी, धड़कन और नींद",
 "Passou do orçamento": "बजट से ज़्यादा",
 "Passou do orçamento em {v}": "बजट से {v} ज़्यादा",
 "Pasta": "फ़ोल्डर",
 "Patrimônio": "संपत्ति",
 "Patrimônio & Imposto de Renda": "संपत्ति और आयकर",
 "Patrimônio pelo valor de compra: {v}": "ख़रीद मूल्य पर संपत्ति: {v}",
 "Pausa (s)": "आराम (सेकंड)",
 "Pausa de {m} min": "{m} मिनट का ब्रेक",
 "Pausado": "रुका हुआ",
 "Pausar": "रोकें",
 "Pausas": "ब्रेक",
 "Pausas de estudo": "पढ़ाई के ब्रेक",
 "Pauta (opcional)": "एजेंडा (वैकल्पिक)",
 "Paz": "शांति",
 "Pediatra": "बाल रोग विशेषज्ञ",
 "Pedido": "अनुरोध",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "{nome} को अनुरोध भेजा गया। स्वीकार होते ही आप चैट कर सकेंगे।",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "अनुरोध भेजा गया। सामने वाले के स्वीकार करते ही आप चैट कर सकेंगे।",
 "Pedidos de documentos": "दस्तावेज़ अनुरोध",
 "Pedir de novo depois de": "इतने समय बाद फिर माँगें",
 "Peguei emprestado": "मैंने उधार लिया",
 "Peito de frango": "चिकन ब्रेस्ट",
 "Peixe": "मछली",
 "Pela última compra: cerca de {v}": "पिछली खरीद के अनुसार: लगभग {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "इस महीने अभी देय बिलों के हिसाब से {v} कम पड़ेंगे। नया खर्च करने से पहले देखें कि क्या टाला या घटाया जा सकता है।",
 "Pendente": "बाकी",
 "Pensão alimentícia": "गुज़ारा भत्ता",
 "Pequena": "छोटा",
 "Pequeno": "छोटा",
 "Percentual de tributos do Simples (para sair na nota)": "Simples के करों का प्रतिशत (इनवॉइस पर छपेगा)",
 "Perguntar ao Mestre": "मास्टर से पूछें",
 "Perguntar sempre": "हमेशा पूछें",
 "Pergunte ao Mestre...": "मास्टर से पूछें...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "दस्तावेज़ के बारे में पूछें (जैसे: समय-सीमा क्या है?)",
 "Permissões": "अनुमतियाँ",
 "Personalizado": "कस्टम",
 "Perto do limite do orçamento": "बजट सीमा के क़रीब",
 "Período": "अवधि",
 "Período da meta": "लक्ष्य की अवधि",
 "Pescoço: inclinar para os lados": "गर्दन: दोनों ओर झुकाएँ",
 "Peso": "वज़न",
 "Peso na média": "औसत में भार",
 "Pesquisar no mapa": "मैप पर खोजें",
 "Pessoa": "व्यक्ति",
 "Pessoa de contato": "संपर्क व्यक्ति",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "आपके समूहों के लोग केवल वही देखते हैं जो समूह में साझा किया गया हो।",
 "Pet": "पालतू",
 "Pet & Família": "पालतू और परिवार",
 "Pet shop": "पेट शॉप",
 "Pet shop ou clínica": "पेट शॉप या क्लिनिक",
 "Pets": "पालतू",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "क्लाइंट से समय-सीमा के साथ दस्तावेज़ माँगें। वह अनुरोध पाता है, फ़ाइल जोड़ता है और जमा किया चिह्नित करता है।",
 "Pijamas": "पजामे",
 "Pilates": "पिलाटेस",
 "Pintura": "पेंटिंग",
 "Pix copia e cola": "Pix कॉपी-पेस्ट",
 "Placa": "नंबर प्लेट",
 "Planejado": "योजना",
 "Planejado e comido": "योजना और खाया",
 "Planilha": "स्प्रेडशीट",
 "Planilha (Excel)": "स्प्रेडशीट (Excel)",
 "Planilha do mês para o Receita Saúde": "Receita Saúde के लिए महीने की शीट",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "बेसिक प्लान: My Planner + नोट्स",
 "Plano de aula": "पाठ योजना",
 "Plano de saúde": "स्वास्थ्य बीमा",
 "Planos de aula": "पाठ योजनाएँ",
 "Planta": "पौधा",
 "Plantas": "पौधे",
 "Plantas & Jardim": "पौधे और बगीचा",
 "Plataforma ou escola": "प्लेटफ़ॉर्म या संस्थान",
 "Pneus novos": "नए टायर",
 "Podcast": "पॉडकास्ट",
 "Pode confirmar sua presença respondendo esta mensagem?": "क्या आप इस संदेश का जवाब देकर अपनी उपस्थिति की पुष्टि कर सकते हैं?",
 "Polichinelo": "जंपिंग जैक",
 "Polo ativo": "वादी पक्ष",
 "Polo passivo": "प्रतिवादी पक्ष",
 "Política de privacidade (LGPD)": "गोपनीयता नीति (LGPD)",
 "Política de privacidade, LGPD e permissões": "गोपनीयता नीति, LGPD और अनुमतियाँ",
 "Política de privacidade, LGPD e termos": "गोपनीयता नीति, LGPD और शर्तें",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "यात्रा की फ़ोटो और वीडियो यहाँ डालें। समूह में सभी इन्हें देखते हैं और सभी अपनी फ़ोटो डाल सकते हैं।",
 "Ponte de glúteos": "ग्लूट ब्रिज",
 "Ponto facultativo": "वैकल्पिक अवकाश",
 "Ponto facultativo: {nome}": "वैकल्पिक अवकाश: {nome}",
 "Ponto turístico": "पर्यटन स्थल",
 "Pontos turísticos": "पर्यटन स्थल",
 "Por dia": "प्रति दिन",
 "Por faixas": "रेंज के हिसाब से",
 "Por mês": "प्रति माह",
 "Por nome": "नाम से",
 "Por semana": "प्रति हफ़्ता",
 "Portal": "पोर्टल",
 "Portal do Cliente": "क्लाइंट पोर्टल",
 "Portal do cliente (convidar o cliente)": "क्लाइंट पोर्टल (क्लाइंट को आमंत्रित करें)",
 "Português": "पुर्तगाली",
 "Porão": "तहख़ाना",
 "Porções": "सर्विंग",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "खाली जगह कम है: नई फ़ोटो और अटैचमेंट शायद सहेजे न जाएँ। जगह खाली करें या अटैचमेंट Google Drive या OneDrive में रखें।",
 "Praia": "समुद्र तट",
 "Prancha": "प्लैंक",
 "Prato do cardápio": "मेनू का व्यंजन",
 "Prato principal": "मुख्य व्यंजन",
 "Prazo": "समय-सीमा",
 "Prazo (pagamento ou entrega)": "समय-सीमा (भुगतान या डिलीवरी)",
 "Prazo até {fim} · fazer em {dia}": "समय-सीमा {fim} तक · {dia} को करें",
 "Prazo final: {fim}": "अंतिम तिथि: {fim}",
 "Prazo: {d}": "समय-सीमा: {d}",
 "Prazo: {t}": "समय-सीमा: {t}",
 "Prazos criados": "समय-सीमाएँ बनाई गईं",
 "Precisa da sua IA": "आपका AI चाहिए",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "विवरण, राष्ट्रीय कर कोड (6 अंक) और राशि भरें।",
 "Preenche os campos do PDF e, se quiser, trava.": "PDF के फ़ील्ड भरता है और चाहें तो लॉक करता है।",
 "Preencher formulário": "फ़ॉर्म भरें",
 "Preencher pela foto com a minha IA": "मेरे AI से फ़ोटो द्वारा भरें",
 "Preencher pela nota fiscal com a minha IA": "मेरे AI से बिल पढ़कर भरें",
 "Preparando a conversa da equipe...": "टीम की बातचीत तैयार हो रही है...",
 "Preparando a página {n} de {total}...": "पेज {n} / {total} तैयार हो रहा है...",
 "Preparando o arquivo": "फ़ाइल तैयार हो रही है",
 "Prescrição, conduta e orientações": "पर्चा, उपचार योजना और निर्देश",
 "Presente": "उपस्थित",
 "Presença": "उपस्थिति",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "कॉपी करने के लिए कोड को दबाकर रखें, या भेजें पर टैप करके \"कॉपी करें\" चुनें।",
 "Pressione e segure o código para copiar.": "कॉपी करने के लिए कोड को दबाकर रखें।",
 "Pressione e segure um lançamento para apagar.": "मिटाने के लिए किसी प्रविष्टि को दबाकर रखें।",
 "Pressione e segure um perfil para removê-lo.": "प्रोफ़ाइल हटाने के लिए उसे दबाकर रखें।",
 "Preto e branco": "ब्लैक एंड व्हाइट",
 "Previdência privada": "निजी पेंशन",
 "Preço ou ingresso": "कीमत या टिकट",
 "Price": "Price (समान किस्तें)",
 "Primeira": "पहला",
 "Primeira cota ou cota única do IR": "आयकर की पहली किस्त या एकमुश्त",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "पहली किस्त {mes} के कार्ड बिल में, जो {data} को देय है।",
 "Prioridade": "प्राथमिकता",
 "Privacidade": "गोपनीयता",
 "Privacidade e termos": "गोपनीयता और शर्तें",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "निजता: विश्लेषण होने वाला पाठ या चित्र आपकी कुंजी से सीधे इस डिवाइस से चुनी गई AI कंपनी को जाता है। My Planner कोई प्रति नहीं रखता।",
 "Problema": "समस्या",
 "Problemas, erros e sugestões": "समस्याएँ, एरर और सुझाव",
 "Procedimento": "प्रक्रिया",
 "Procedimento: {c}": "प्रक्रिया: {c}",
 "Processo": "मुक़दमा",
 "Processo Civil": "सिविल प्रक्रिया",
 "Processo Penal": "आपराधिक प्रक्रिया",
 "Processo do Trabalho": "श्रम प्रक्रिया",
 "Processo não informado": "मुक़दमा संख्या नहीं दी गई",
 "Proclamação da República": "गणराज्य घोषणा दिवस",
 "Procurando a folha...": "पन्ना ढूंढ रहे हैं...",
 "Procurando atualização...": "अपडेट खोजा जा रहा है...",
 "Procurar aba": "टैब खोजें",
 "Procurar atualização agora": "अभी अपडेट खोजें",
 "Procurar documento": "दस्तावेज़ खोजें",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "टूल खोजें (जैसे: जोड़ें, हस्ताक्षर, कंप्रेस)",
 "Produto": "उत्पाद",
 "Produto (ex.: Geladeira)": "उत्पाद (जैसे: फ़्रिज)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "उत्पाद, बिल, सर्विस सेंटर और समाप्ति से पहले सूचना।",
 "Produção (vale de verdade)": "प्रोडक्शन (असली, मान्य)",
 "Produção restrita (teste)": "सीमित प्रोडक्शन (टेस्ट)",
 "Produção restrita (teste, não vale)": "सीमित प्रोडक्शन (टेस्ट, मान्य नहीं)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "सीमित प्रोडक्शन: सरकार का टेस्ट परिवेश। इनवॉइस मान्य नहीं होते। प्रोडक्शन पर जाने से पहले (संपादित करें में) यहाँ सब कुछ टेस्ट करें।",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "प्रोडक्शन: जारी किए गए इनवॉइस असली और मान्य हैं, और नगरपालिका व Receita को जाते हैं।",
 "Produção: vale de verdade": "प्रोडक्शन: असली, मान्य",
 "Professor": "शिक्षक",
 "Professor & Mentoria": "शिक्षक और मेंटरिंग",
 "Professor(a)": "शिक्षक",
 "Profissionais": "कारीगर",
 "Profissional": "कारीगर",
 "Profissional assistente": "सहायक प्रोफ़ेशनल",
 "Profissional ou fornecedor": "कारीगर या विक्रेता",
 "Profissional ou local": "विशेषज्ञ या जगह",
 "Profissão ou especialidade": "पेशा या विशेषज्ञता",
 "Profissões": "पेशे",
 "Programação": "प्रोग्रामिंग",
 "Progresso geral": "कुल प्रगति",
 "Projeto e licenças": "डिज़ाइन और अनुमतियाँ",
 "Projetos": "प्रोजेक्ट",
 "Prontas": "तैयार",
 "Pronto": "हो गया",
 "Pronto! Todas as abas estão liberadas até {data}.": "हो गया! सभी टैब {data} तक अनलॉक हैं।",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "हो गया। स्क्रीन लॉक करें और 1 मिनट प्रतीक्षा करें: अलर्ट आवाज़ के साथ दिखना चाहिए।",
 "Prontuário, evolução e prescrições, sem o financeiro.": "मेडिकल रिकॉर्ड, प्रगति और पर्चे, वित्त के बिना।",
 "Protegendo a chave...": "कुंजी सुरक्षित की जा रही है...",
 "Proteger no cofre": "वॉल्ट में सुरक्षित करें",
 "Protegido": "सुरक्षित",
 "Protegido no cofre": "वॉल्ट में सुरक्षित",
 "Protegidos pelo cofre: {n}": "वॉल्ट से सुरक्षित: {n}",
 "Protetor solar": "सनस्क्रीन",
 "Protocolo": "प्रोटोकॉल नंबर",
 "Prova": "परीक्षा",
 "Próxima": "अगला",
 "Próxima até a data": "अगला, इस तारीख तक",
 "Próxima com quantos km": "अगला, इतने किमी पर",
 "Próxima dose": "अगली खुराक",
 "Próxima: {data}": "अगला: {data}",
 "Próxima: {d} · {v}": "अगली: {d} · {v}",
 "Próximas": "आगामी",
 "Próximo": "अगला",
 "Próximo ano": "अगला वर्ष",
 "Próximo número da DPS": "अगला DPS नंबर",
 "Próximos 7 dias": "अगले 7 दिन",
 "Próximos vencimentos ({n})": "आने वाली देय तिथियाँ ({n})",
 "Publicação": "प्रकाशन",
 "Publicações": "प्रकाशन",
 "Pula": "उछलना",
 "Pulsa": "धड़कना",
 "Punho": "मुट्ठी",
 "Puxada frontal": "लैट पुलडाउन",
 "PÁGINAS": "पेज",
 "PÔR NA BARRA": "बार में रखें",
 "Pág. {n}": "पेज {n}",
 "Página": "पेज",
 "Página 1": "पेज 1",
 "Página 1 de 10": "पेज 1 / 10",
 "Página em branco no fim": "आख़िर में खाली पेज",
 "Página em que estou": "मैं इस पेज पर हूँ",
 "Página escaneada": "पेज स्कैन हो गया",
 "Página inteira": "पूरा पेज",
 "Página {a} de {n}": "पेज {a} / {n}",
 "Página {n}": "पेज {n}",
 "Página {n} de {total}": "पेज {n} / {total}",
 "Página: {titulo}": "पेज: {titulo}",
 "Páginas": "पेज",
 "Páginas, tamanho, autor, datas e campos.": "पेज, आकार, लेखक, तारीखें और फ़ील्ड।",
 "Pássaro": "पक्षी",
 "Pão francês": "ब्रेड रोल",
 "Pão integral": "होल व्हीट ब्रेड",
 "Pôr a data de hoje": "आज की तारीख डालें",
 "Pôr as parcelas no My Planner": "किस्तें My Planner में डालें",
 "Pôr na barra": "बार में रखें",
 "Pôr no roteiro da viagem": "यात्रा कार्यक्रम में जोड़ें",
 "Pôr uma foto": "फ़ोटो लगाएँ",
 "Quadro": "बोर्ड",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Kanban बोर्ड, क्लाइंट के हिसाब से घंटों का टाइमर और My Planner में समय-सीमाएँ।",
 "Quais contas vencem nos próximos dias?": "अगले कुछ दिनों में कौन-से बिल देय हैं?",
 "Quais páginas ficam no PDF novo": "नए PDF में कौन से पेज रहेंगे",
 "Quais páginas sair": "कौन से पेज हटाने हैं",
 "Qual IA": "कौन-सा AI",
 "Qualidade alta": "हाई क्वालिटी",
 "Qualidade boa (menor)": "अच्छी क्वालिटी (छोटी)",
 "Quantidade": "मात्रा",
 "Quanto cortar de cada lado (% da página)": "हर तरफ़ से कितना काटें (पेज का %)",
 "Quanto já tem guardado (opcional)": "अब तक कितना बचाया है (वैकल्पिक)",
 "Quanto paga por limpeza": "प्रति सफ़ाई कितना देते हैं",
 "Quanto preciso guardar por mês para as minhas metas?": "अपने लक्ष्यों के लिए मुझे हर महीने कितना बचाना होगा?",
 "Quanto quer juntar": "कितना जमा करना है",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "हर श्रेणी में हर महीने अधिकतम कितना खर्च करना चाहते हैं। नियंत्रण न करना हो तो खाली छोड़ें।",
 "Quarta": "बुधवार",
 "Quarta-feira de Cinzas (até 14h)": "ऐश वेडनसडे (14 बजे तक)",
 "Quarto": "बेडरूम",
 "Quarto das crianças": "बच्चों का कमरा",
 "Quarto de casal": "मुख्य शयनकक्ष",
 "Quarto de hóspedes": "अतिथि कक्ष",
 "Quarto infantil": "बच्चों का कमरा",
 "Queijo": "चीज़",
 "Queixa principal": "मुख्य शिकायत",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "जो भी लिंक खोलेगा वह My Planner डाउनलोड करेगा (या ब्राउज़र में उपयोग करेगा), साइन इन करेगा और समूह का हिस्सा बन जाएगा।",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "जो भी आपके कोड से खाता बनाएगा, वह बिना अनुरोध के यहाँ सीधे आपका दोस्त बन जाएगा।",
 "Quem enviou": "किसने भेजा",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "जो लोग ऐप में आपके साथ किसी ग्रुप (क्लास, परिवार, यात्रा...) में हैं, वे दोस्त बने बिना भी चैट कर सकते हैं। दोस्ती खत्म करने या ब्लॉक करने के लिए किसी दोस्त को दबाकर रखें।",
 "Quem faz a limpeza": "सफ़ाई कौन करता है",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "भुगतान कौन करता है, अगर मरीज़ नहीं (माँ, पिता, अभिभावक)",
 "Quem pagou": "किसने भुगतान किया",
 "Quem recebeu (médico, escola...)": "किसे भुगतान किया (डॉक्टर, स्कूल...)",
 "Quem vai": "कौन जा रहा है",
 "Quem vai limpar": "सफ़ाई कौन करेगा",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "कौन देख सकता है: सिर्फ़ वे लोग जो आपसे चैट करते हैं, आपके दोस्त और जो ऐप के किसी ग्रुप में आपके साथ हैं। जो नहीं दिखाना चाहते, उसे खाली छोड़ दें।",
 "Quente": "गर्म",
 "Quer escanear mais uma página?": "एक और पेज स्कैन करना है?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "क्या अभी रसीद सहेजना चाहते हैं? फ़ोटो, PDF या Pix का स्क्रीनशॉट।",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "स्क्रीनशॉट भेजना चाहते हैं? ईमेल से भेजें और इमेज अटैच करें।",
 "Quer trocar pelos novos ou manter os dois?": "क्या नए वालों से बदलना है या दोनों रखने हैं?",
 "Quero assistir": "देखना है",
 "Quero ir": "जाना है",
 "Quero ler": "पढ़ना है",
 "Quero ver": "देखना है",
 "Quilometragem atual": "मौजूदा किमी",
 "Quilometragem: {km}": "किमी: {km}",
 "Quinta": "गुरुवार",
 "Quintal": "आँगन",
 "Quitado": "चुकता",
 "Quitados": "चुकता",
 "Química": "रसायन विज्ञान",
 "RECIBO": "रसीद",
 "RG / Carteira de identidade": "RG / पहचान पत्र",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "RG, CNH, पासपोर्ट, अनुबंध और प्रमाणपत्र, समाप्ति से पहले सूचना और एक टैप में भेजने की सुविधा के साथ।",
 "Raciocínio Lógico": "तार्किक क्षमता",
 "Razão social ou nome": "कंपनी का नाम या नाम",
 "Razão social ou nome do consultório": "कंपनी या क्लिनिक का नाम",
 "Razão social ou nome fantasia": "कंपनी का पंजीकृत नाम या व्यापारिक नाम",
 "Raça": "नस्ल",
 "Realizado": "हो गया",
 "Recado": "संदेश",
 "Recalcular": "फिर से गणना करें",
 "Recalcular as parcelas em aberto": "बाकी किस्तें फिर से गणना करें",
 "Recalcular as parcelas?": "किस्तें फिर से गणना करें?",
 "Receber": "प्राप्त करें",
 "Receber de volta: {i} ({p})": "वापस लेना: {i} ({p})",
 "Receber o código no WhatsApp": "WhatsApp पर कोड पाएँ",
 "Receber parcela {n}/{t} · {c}": "किस्त {n}/{t} प्राप्त करें · {c}",
 "Recebeu um convite?": "आमंत्रण मिला है?",
 "Recebeu um código?": "कोई कोड मिला है?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "मैंने {pagador}{doc} से {valor}{extenso} की राशि प्राप्त की, जो {data} को किए गए {tipo}{paciente} के लिए है।",
 "Recebi outro valor": "मुझे अलग राशि मिली",
 "Recebida": "प्राप्त",
 "Recebida (toque para desfazer)": "प्राप्त (पूर्ववत करने के लिए टैप करें)",
 "Recebidas": "मिल गईं",
 "Recebido": "मिल गया",
 "Recebido: {v}": "प्राप्त: {v}",
 "Recebidos": "प्राप्त",
 "Recebidos dos grupos": "समूहों से प्राप्त",
 "Recebimento": "प्राप्ति",
 "Receita": "रेसिपी",
 "Receitas": "रेसिपी",
 "Recibo": "रसीद",
 "Recibo em PDF": "PDF रसीद",
 "Recibo emitido": "रसीद जारी हुई",
 "Recibo guardado": "रसीद सहेजी गई",
 "Recibos dedutíveis": "कटौती योग्य रसीदें",
 "Recomendada": "सुझाया गया",
 "Recomeçar": "फिर से शुरू करें",
 "Recortar": "क्रॉप",
 "Recortar margens": "मार्जिन काटें",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "क्रॉप, घुमाना और फ़िल्टर नए ऐप (वर्ज़न 0.49) में आएंगे।",
 "Recusada": "अस्वीकृत",
 "Recusado": "अस्वीकृत",
 "Recusar": "अस्वीकारें",
 "Redação": "निबंध लेखन",
 "Refazer": "दोबारा करें",
 "Refeição": "भोजन",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "आज के लिए तय भोजन, व्यायाम, देखभाल और सप्लीमेंट",
 "Referente a": "किसके लिए",
 "Referência": "संदर्भ",
 "Reforço": "बूस्टर",
 "Regar a cada quantos dias": "कितने दिनों में पानी दें",
 "Regar hoje": "आज पानी दें",
 "Regar: {p}": "पानी दें: {p}",
 "Regional": "क्षेत्रीय",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "डायरी, चरण और डिलीवरी दर्ज करता है, राशियाँ देखे बिना।",
 "Registrar venda/serviço do MEI": "MEI की बिक्री/सेवा दर्ज करें",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "हर अपॉइंटमेंट दर्ज करें: प्रगति नोट्स वॉल्ट में एन्क्रिप्ट होकर रहते हैं। पर्चा टेम्पलेट से लिया जा सकता है।",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "मकान, वाहन और निवेश की ख़रीद-बिक्री सबूतों के साथ दर्ज करें। टैक्स भरते समय बहुत काम आता है।",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "समय-सारणी से जो अलग हुआ उसे दर्ज करें (खाना बदला, भोजन बदला)। यह साप्ताहिक रिपोर्ट में आएगा।",
 "Registro": "रिकॉर्ड",
 "Registro clínico": "चिकित्सा रिकॉर्ड",
 "Registro de horas": "घंटों का रिकॉर्ड",
 "Registro do diário": "डायरी की प्रविष्टि",
 "Regiões com feriado próprio (marque as suas):": "अपने अवकाश वाले क्षेत्र (अपने क्षेत्र चुनें):",
 "Regras da casa": "घर के नियम",
 "Regras da casa:": "घर के नियम:",
 "Reguei": "पानी दिया",
 "Reguei hoje": "आज पानी दिया",
 "Reiniciar": "दोबारा शुरू करें",
 "Reiniciar o app": "ऐप दोबारा शुरू करें",
 "Relatório": "रिपोर्ट",
 "Relatório da semana": "साप्ताहिक रिपोर्ट",
 "Relatório em PDF ou Excel": "PDF या Excel में रिपोर्ट",
 "Relatório enviado. Obrigado!": "रिपोर्ट भेज दी गई। धन्यवाद!",
 "Relatórios": "रिपोर्ट",
 "Relatórios do Bem-Estar": "सेहत की रिपोर्ट",
 "Relatórios gerados ({n})": "बनाई गई रिपोर्ट ({n})",
 "Relaxar": "आराम",
 "Religião": "धर्म",
 "Relógio": "घड़ी",
 "Relógio e apps de saúde": "घड़ी और हेल्थ ऐप्स",
 "Remada baixa": "सीटेड रो",
 "Remover": "हटाएँ",
 "Remover \"{nome}\"?": "\"{nome}\" हटाएँ?",
 "Remover anotações": "एनोटेशन हटाएँ",
 "Remover este bloco?": "यह ब्लॉक हटाएँ?",
 "Remover páginas": "पेज हटाएँ",
 "Remover vínculo": "लिंक हटाएँ",
 "Remover {nome}?": "{nome} को हटाएँ?",
 "Remédio": "दवा",
 "Remédio contínuo": "लगातार ली जाने वाली दवा",
 "Remédio na linha do tempo": "टाइमलाइन में दवा",
 "Remédios": "दवाएँ",
 "Remédios de uso contínuo": "लगातार ली जाने वाली दवाएँ",
 "Renavam ou chassi": "Renavam या चेसिस नंबर",
 "Renegociado": "दोबारा तय किया गया",
 "Renomear": "नाम बदलें",
 "Renomear com IA": "AI से नाम बदलें",
 "Renomear ou trocar ícone": "नाम या आइकन बदलें",
 "Renomear pasta": "फ़ोल्डर का नाम बदलें",
 "Renomear, ícone ou cor": "नाम, आइकन या रंग बदलें",
 "Renovar: {nome}": "नवीनीकरण: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "फ़ाइल को अंदर से दोबारा व्यवस्थित करता है। फ़ोटो वाले PDF में कम मदद करता है।",
 "Reparar PDF": "PDF ठीक करें",
 "Repelente": "मच्छर भगाने की क्रीम",
 "Repete": "दोहराएँ",
 "Repetir a cada quantos dias": "कितने दिनों में दोहराएँ",
 "Repetições": "दोहराव",
 "Repita a senha": "पासवर्ड दोबारा लिखें",
 "Repita a senha do cofre": "वॉल्ट पासवर्ड दोबारा डालें",
 "Repita a senha nova": "नया पासवर्ड दोबारा लिखें",
 "Replantio": "गमला बदलना",
 "Replantios": "गमला बदलना",
 "Repor papel higiênico, sabonete e café": "टॉयलेट पेपर, साबुन और कॉफ़ी भरें",
 "Representatividade": "प्रतिनिधित्व",
 "Reserva": "बुकिंग",
 "Reservas": "बुकिंग",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "बुकिंग, सफ़ाई, आय और खर्च \"किराया और होमस्टे\" टैब में",
 "Respirar fundo 5 vezes": "5 बार गहरी साँस लें",
 "Respondendo a {nome}": "{nome} को जवाब दे रहे हैं",
 "Responder": "जवाब दें",
 "Responsável": "ज़िम्मेदार व्यक्ति",
 "Responsável (imobiliária, vistoriador)": "ज़िम्मेदार (एजेंसी, निरीक्षक)",
 "Resposta da SEFAZ": "SEFAZ का जवाब",
 "Resta {tempo}": "{tempo} बाकी",
 "Restam {ml} = {n} copo(s) de {copo}": "बाकी {ml} = {copo} के {n} गिलास",
 "Restaurante": "रेस्टोरेंट",
 "Restaurantes": "रेस्टोरेंट",
 "Restaurar": "रीस्टोर करें",
 "Restaurar esta cópia?": "यह बैकअप रीस्टोर करें?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "रीस्टोर करने पर यहाँ और आपके खाते में मौजूद सारा वर्तमान डेटा बैकअप के डेटा से बदल जाएगा।",
 "Restaurar uma cópia": "बैकअप रीस्टोर करें",
 "Resultado": "नतीजा",
 "Resultado nas vendas: {v}": "बिक्री का नतीजा: {v}",
 "Resumir": "सारांश",
 "Resumir e perguntar": "सारांश और सवाल",
 "Resumo": "सारांश",
 "Resumo (falta o XML completo)": "सारांश (पूरा XML नहीं है)",
 "Resumo da manhã": "सुबह का सारांश",
 "Resumo da pasta": "फ़ोल्डर का सारांश",
 "Resumo e opinião": "सारांश और राय",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "सारांश, श्रेणी के अनुसार खर्च, बिल, कार्ड बिल, लक्ष्य और सभी एंट्रियाँ। अकाउंटेंट को भेजने या IR (आयकर) के लिए रखने में उपयोगी।",
 "Retirar": "निकालें",
 "Retirar da meta": "लक्ष्य से निकालें",
 "Retorno": "फ़ॉलो-अप",
 "Reunião": "मीटिंग",
 "Reunião agora": "अभी मीटिंग",
 "Reunião de equipe": "टीम मीटिंग",
 "Reuniões": "मीटिंग",
 "Revestimento e pisos": "क्लैडिंग और फ़र्श",
 "Revisão": "सर्विसिंग",
 "Revolução Constitucionalista": "संवैधानिक क्रांति दिवस",
 "Rico em matéria orgânica": "जैविक पदार्थ से भरपूर",
 "Rodízio de pneus": "टायर रोटेशन",
 "Roedor": "कुतरने वाला जीव",
 "Romance": "रोमांस",
 "Rosca direta": "बाइसेप्स कर्ल",
 "Rota": "रास्ता",
 "Rota passando pelos {n} lugares que faltam": "बाकी {n} जगहों से होकर रास्ता",
 "Rotas e mapas": "रास्ते और मानचित्र",
 "Roteiro": "यात्रा कार्यक्रम",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "हर दिन का कार्यक्रम जो यात्रा के दौरान टाइमलाइन में आता है, मौसम के हिसाब से सामान, बुकिंग और टाइम ज़ोन।",
 "Rotina": "दिनचर्या",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "चरण-दर-चरण दिनचर्याएँ: स्किनकेयर, स्ट्रेचिंग, बाल... टेम्पलेट चुनने या अपना बनाने के लिए \"+ देखभाल\" पर टैप करें।",
 "Roupa": "कपड़े",
 "Roupa social": "फ़ॉर्मल कपड़े",
 "Roupas de banho": "तैराकी के कपड़े",
 "Roupas extras das crianças": "बच्चों के अतिरिक्त कपड़े",
 "Roupas íntimas": "अंडरवियर",
 "Rua": "सड़क",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "सड़क, नंबर, मोहल्ला, शहर (या जगह का नाम)",
 "Régua": "स्केल",
 "Réptil": "सरीसृप",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "लेबल (जैसे: मेरा नाम, क्लाइंट की कंपनी)",
 "SAC": "SAC (समान मूलधन)",
 "SEM HORÁRIO": "बिना समय",
 "SEU MÊS EM NÚMEROS": "आपका महीना आँकड़ों में",
 "SEU TREINO": "आपका वर्कआउट",
 "SEUS GRUPOS DO APP": "ऐप में आपके ग्रुप",
 "SP": "SP",
 "SUBTAREFA": "उप-कार्य",
 "SUBTAREFAS": "उप-कार्य",
 "SUPLEMENTAÇÃO": "सप्लीमेंट",
 "Sabonete facial": "फ़ेस वॉश",
 "Sabão para lavar roupa": "कपड़े धोने का साबुन",
 "Sacada": "बालकनी",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "सिर्फ़ इस ऐप की सूची से हटता है। Drive, OneDrive या मोबाइल फ़ोल्डर में सहेजी कॉपी वहीं रहती है।",
 "Sai só da lista. O arquivo continua onde foi salvo.": "सिर्फ़ सूची से हटेगी। फ़ाइल जहाँ सेव है वहीं रहेगी।",
 "Sair": "लॉग आउट",
 "Sair da conta?": "खाते से लॉग आउट करें?",
 "Sair do escritório": "ऑफ़िस छोड़ें",
 "Sair do escritório?": "ऑफ़िस छोड़ें?",
 "Sair do grupo": "समूह छोड़ें",
 "Sair do grupo?": "समूह छोड़ें?",
 "Sair sem baixar": "डाउनलोड किए बिना बाहर जाएं",
 "Saiu": "गया",
 "Sala": "कक्षा",
 "Sala de estar": "बैठक",
 "Sala de jantar": "भोजन कक्ष",
 "Sala virtual": "वर्चुअल कक्ष",
 "Salada": "सलाद",
 "Saldo": "शेष",
 "Saldo depois desta parcela": "इस किस्त के बाद बकाया",
 "Saldo devedor: {v}": "बकाया राशि: {v}",
 "Saldo do mês": "महीने का शेष",
 "Salvar": "सहेजें",
 "Salvar backup do My Planner": "My Planner का बैकअप सहेजें",
 "Salvar cuidado": "देखभाल सहेजें",
 "Salvar cômodo": "कमरा सहेजें",
 "Salvar e colocar no My Planner": "सहेजें और My Planner में रखें",
 "Salvar e sincronizar": "सेव करें और सिंक करें",
 "Salvar e testar": "सहेजें और जाँचें",
 "Salvar endereço": "पता सहेजें",
 "Salvar no My Planner": "My Planner में सहेजें",
 "Salvar refeição": "भोजन सहेजें",
 "Salvar suplemento": "सप्लीमेंट सहेजें",
 "Salvar tarefa": "कार्य सहेजें",
 "Salvar treino": "वर्कआउट सहेजें",
 "Sanduíche natural": "हेल्दी सैंडविच",
 "Santo Antônio": "Santo Antônio",
 "Sapato confortável": "आरामदायक जूते",
 "Saudade": "याद आ रही है",
 "Saída (imóvel antigo)": "निकास (पुराना घर)",
 "Saída de praia": "बीच कवर-अप",
 "Saúde": "स्वास्थ्य",
 "Saúde & Prontuário": "स्वास्थ्य और मेडिकल रिकॉर्ड",
 "Saúde (médicos, dentistas, exames, plano)": "स्वास्थ्य (डॉक्टर, दंत चिकित्सक, जाँचें, हेल्थ प्लान)",
 "Saúde e bem-estar": "स्वास्थ्य और सेहत",
 "Scanner": "स्कैनर",
 "Scanner PDF": "PDF स्कैनर",
 "Sci-Fi": "साइंस फ़िक्शन",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "अगर कुछ काम न करे तो ऐप दोबारा शुरू करें। आपका डेटा सुरक्षित है।",
 "Se der tempo": "समय मिले तो",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "अगर इस नीति में कोई अहम बदलाव होता है, तो ऐप आपको बताएगा और फिर से आपकी स्वीकृति माँगेगा।",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "अगर यह अलर्ट दिखा, तो अपॉइंटमेंट अलर्ट काम कर रहे हैं।",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "अगर {email} से कोई खाता मौजूद है, तो हमने नया पासवर्ड बनाने का लिंक भेज दिया है। स्पैम फ़ोल्डर भी देखें।",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "अगर अलर्ट देर से आए या न दिखे: ऐप की सेटिंग्स में नोटिफ़िकेशन चालू रखें, बैटरी \"अप्रतिबंधित\" रखें और \"अलार्म और रिमाइंडर\" की अनुमति दें।",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "अगर घड़ी कनेक्ट है, तो डेटा होने पर उसके नंबर हाथ से दर्ज नंबरों की जगह ले लेते हैं।",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "अगर आप घड़ी कनेक्ट करते हैं: कदम, दूरी, कैलोरी, व्यायाम, धड़कन और नींद के रोज़ाना कुल आंकड़े, Health Connect (Android) या Health ऐप (iPhone) से पढ़े जाते हैं। ऐप केवल पढ़ता है और इस डेटा को कभी नहीं बदलता।",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "अगर आपने यह टैब पहले इस्तेमाल किया है, तो कुछ भी मिटाया नहीं गया: सदस्यता लेने पर सब पहले जैसा लौट आएगा।",
 "Secretária ou recepção": "सचिव या रिसेप्शन",
 "Seg a sex": "सोम से शुक्र",
 "Seguir": "आगे",
 "Segunda": "सोमवार",
 "Segurança": "सुरक्षा",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "क्रम बदलने के लिए दबाकर खींचें। ↻ घुमाता है, ⧉ डुप्लिकेट करता है और ✕ पेज हटाता है।",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "किसी चैट में GIF को दबाकर रखें और \"सहेजें\" पर टैप करें, ताकि वह यहाँ दिखे।",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "जगह बदलने के लिए कमरे को दबाकर रखें। कमरा खुला हो तो किसी कार्य को दबाकर दूसरे कमरे में छोड़ें, वह वहाँ चला जाएगा।",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "क्रम बदलने के लिए फ़ाइल, विषय या पेज को दबाकर रखें। किसी विषय को दूसरी फ़ाइल में छोड़ें, वह वहाँ चला जाएगा।",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "किसी चैट को म्यूट या संग्रहीत करने के लिए उसे दबाकर रखें। संग्रहीत चैट में संदेश आते-जाते रहते हैं, लेकिन सूचना नहीं मिलती।",
 "Seguro": "बीमा",
 "Seguro da casa": "गृह बीमा",
 "Seguro viagem": "यात्रा बीमा",
 "Selecionar": "चुनें",
 "Sem": "नहीं",
 "Sem alerta": "कोई अलर्ट नहीं",
 "Sem categoria": "कोई श्रेणी नहीं",
 "Sem comprovante": "रसीद नहीं",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "इनवॉइस सर्वर से कनेक्शन नहीं। इंटरनेट और सर्वर का पता जाँचें।",
 "Sem conexão com o servidor. Confira a internet.": "सर्वर से कनेक्शन नहीं है। इंटरनेट जाँचें।",
 "Sem conexão com os GIFs agora.": "अभी GIF से कनेक्शन नहीं है।",
 "Sem cômodo": "कोई कमरा नहीं",
 "Sem data de fim": "कोई समाप्ति तिथि नहीं",
 "Sem exercícios": "कोई व्यायाम नहीं",
 "Sem fatura em {mes}": "{mes} में कोई कार्ड बिल नहीं",
 "Sem fim": "कोई अंत नहीं",
 "Sem horário": "बिना समय",
 "Sem internet ou servidor ainda não preparado.": "इंटरनेट नहीं है या सर्वर अभी तैयार नहीं है।",
 "Sem internet. Envia quando voltar.": "इंटरनेट नहीं है। वापस आने पर भेज दिया जाएगा।",
 "Sem internet. Tente de novo.": "इंटरनेट नहीं है। फिर से कोशिश करें।",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "इसके बिना पट्टी सिर्फ़ ढकती है: नीचे का टेक्स्ट फ़ाइल में रहता है और कॉपी किया जा सकता है।",
 "Sem itens": "कोई आइटम नहीं",
 "Sem juros": "बिना ब्याज",
 "Sem limite": "कोई सीमा नहीं",
 "Sem link de calendário": "कैलेंडर लिंक नहीं",
 "Sem margem": "बिना मार्जिन",
 "Sem nome": "बिना नाम",
 "Sem número na primeira página (capa)": "पहले पेज (कवर) पर नंबर नहीं",
 "Sem pasta": "कोई फ़ोल्डर नहीं",
 "Sem pausas": "कोई ब्रेक नहीं",
 "Sem permissão": "अनुमति नहीं",
 "Sem prazo": "कोई समय-सीमा नहीं",
 "Sem recibo": "रसीद नहीं बनी",
 "Sem tarefas": "कोई कार्य नहीं",
 "Sem texto.": "कोई पाठ नहीं।",
 "Sem tomador identificado": "सेवा प्राप्तकर्ता की पहचान नहीं",
 "Sem título": "बिना शीर्षक",
 "Sem validade": "कोई वैधता नहीं",
 "Semana": "सप्ताह",
 "Semana completa": "पूरा हफ़्ता",
 "Semana de {de} a {ate}": "{de} से {ate} तक का सप्ताह",
 "Semanal": "साप्ताहिक",
 "Semanal · dias úteis": "साप्ताहिक · कार्य दिवस",
 "Semanal · todos os dias": "साप्ताहिक · हर दिन",
 "Semanal · {dias}": "साप्ताहिक · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "ये हमेशा दिखते हैं, वैकल्पिक अवकाशों (कार्निवल, ऐश वेडनेसडे और कॉर्पस क्रिस्टी) के साथ।",
 "Senha": "पासवर्ड",
 "Senha (8 caracteres ou mais)": "पासवर्ड (8 या अधिक अक्षर)",
 "Senha alterada.": "पासवर्ड बदल दिया गया।",
 "Senha atual": "मौजूदा पासवर्ड",
 "Senha atual do cofre": "मौजूदा वॉल्ट पासवर्ड",
 "Senha da conta": "खाते का पासवर्ड",
 "Senha do certificado": "प्रमाणपत्र का पासवर्ड",
 "Senha do cofre": "वॉल्ट पासवर्ड",
 "Senha do cofre alterada.": "वॉल्ट पासवर्ड बदल दिया गया।",
 "Senha do cofre incorreta.": "वॉल्ट पासवर्ड गलत है।",
 "Senha incorreta": "गलत पासवर्ड",
 "Senha incorreta.": "गलत पासवर्ड।",
 "Senha nova (8 caracteres ou mais)": "नया पासवर्ड (8 या अधिक अक्षर)",
 "Senha nova do cofre (6 caracteres ou mais)": "नया वॉल्ट पासवर्ड (6 या अधिक अक्षर)",
 "Senha, biometria, bloqueio e privacidade": "पासवर्ड, बायोमेट्रिक, लॉक और गोपनीयता",
 "Senha, e-mail e formas de desbloquear": "पासवर्ड, ईमेल और अनलॉक के तरीके",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "आय विवरण इकट्ठा करें (बैंक, नियोक्ता, ब्रोकर)",
 "Servidor de notas": "इनवॉइस सर्वर",
 "Servidor não configurado (lib/config.ts).": "सर्वर कॉन्फ़िगर नहीं है (lib/config.ts)।",
 "Servidor não configurado.": "सर्वर कॉन्फ़िगर नहीं है।",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "सर्वर कॉन्फ़िगर नहीं है: lib/config.ts में Supabase का डेटा नहीं है।",
 "Serviço": "सेवा",
 "Serviço não prestado": "सेवा नहीं दी गई",
 "Serviços": "सेवाएँ",
 "Será excluída em 1 dia": "1 दिन में हटा दिया जाएगा",
 "Será excluída em {n} dias": "{n} दिनों में हटा दिया जाएगा",
 "Será excluída hoje": "आज हटा दिया जाएगा",
 "Sessão": "सत्र",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "आपकी पहुँच अभी स्वीकृत होनी बाकी है। कुछ देर बाद लॉग इन करने की कोशिश करें।",
 "Seu código": "आपका कोड",
 "Seu código de amigo": "आपका दोस्त कोड",
 "Seu código para amigos ganharem 10 dias com todas as abas": "आपका कोड, जिससे दोस्तों को 10 दिनों तक सभी टैब मिलें",
 "Seu nome": "आपका नाम",
 "Seu papel: {p}": "आपकी भूमिका: {p}",
 "Seu papel: {p}. {d}": "आपकी भूमिका: {p}। {d}",
 "Seu scanner de bolso": "आपका पॉकेट स्कैनर",
 "Seus dados continuam salvos na nuvem.": "आपका डेटा क्लाउड में सुरक्षित रहता है।",
 "Seus dados na nuvem do My Planner": "My Planner क्लाउड में आपका डेटा",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "आपका डेटा आपका है: हम इसे बेचते नहीं और विज्ञापन के लिए इस्तेमाल नहीं करते। आप जब चाहें सब कुछ एक्सपोर्ट या हटा सकते हैं।",
 "Seus {n} meses grátis terminaram": "आपके {n} महीने मुफ़्त खत्म हो गए",
 "Sexta": "शुक्रवार",
 "Sextou": "शुक्रवार",
 "Sextou!": "आखिर शुक्रवार!",
 "Shampoo": "शैम्पू",
 "Show ou passeio": "शो या सैर",
 "Silenciar avisos": "सूचनाएँ म्यूट करें",
 "Sim": "हाँ",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "{data} को सिंक हुआ",
 "Sincronizando pelo dispositivo {nome}": "डिवाइस {nome} से सिंक हो रहा है",
 "Sincronizando...": "सिंक हो रहा है...",
 "Sincronizar agora": "अभी सिंक करें",
 "Sincronização parada: confirme sua senha. Nada se perde.": "सिंक रुका हुआ है: अपना पासवर्ड पुष्टि करें। कुछ भी नहीं खोएगा।",
 "Site da assistência": "सर्विस सेंटर की वेबसाइट",
 "Site da assistência (https://...)": "सर्विस सेंटर की वेबसाइट (https://...)",
 "Site ou ingresso online": "वेबसाइट या ऑनलाइन टिकट",
 "Situação": "स्थिति",
 "Situação agora": "अभी की स्थिति",
 "Skincare da manhã": "सुबह की स्किनकेयर",
 "Skincare da noite": "रात की स्किनकेयर",
 "Slides": "स्लाइड",
 "Smileys e pessoas": "स्माइली और लोग",
 "Sobremesa": "मिठाई",
 "Sobrou no mês": "महीने में बचा",
 "Sociologia": "समाजशास्त्र",
 "Sofá": "सोफ़ा",
 "Sol": "सूरज",
 "Sol pleno": "पूरी धूप",
 "Solo ou substrato": "मिट्टी या मिश्रण",
 "Solte numa matéria para mover a página para lá:": "पेज को वहाँ ले जाने के लिए किसी विषय पर छोड़ें:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "क़ानूनी और निर्माता की वारंटी जोड़ी जाती है। वारंटी पत्र में जाँचें। 15 और 3 दिन पहले सूचना देता है।",
 "Sombra": "छाया",
 "Somente esta tarefa": "केवल यह कार्य",
 "Sono": "नींद",
 "Sono da noite": "रात की नींद",
 "Sopa": "सूप",
 "Sou MEI": "मैं MEI हूँ",
 "Status": "स्थिति",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "क्लाउड से आपका कनेक्शन समाप्त हो गया (ऐसा तब होता है जब ऐप लंबे समय तक नहीं खोला गया हो या किसी दूसरे डिवाइस पर पासवर्ड बदला गया हो)। कुछ भी नहीं खोएगा: पुष्टि करते ही यहाँ का डेटा भेज दिया जाएगा।",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "आपकी पूरी टीम एक ही जगह: बातचीत, दस्तावेज़, रिकॉर्डिंग वाली वीडियो मीटिंग और लिंक से आमंत्रण।",
 "Sua rotina em um só lugar": "आपकी दिनचर्या एक ही जगह",
 "Sua senha": "आपका पासवर्ड",
 "Suas abas": "आपके टैब",
 "Substituir": "बदलें",
 "Substrato usado": "इस्तेमाल किया गया मिश्रण",
 "Subtarefa {n}": "उप-कार्य {n}",
 "Suco": "जूस",
 "Sugerir nome": "नाम सुझाएँ",
 "Sugestão": "सुझाव",
 "Sugestões de {categoria}": "{categoria} के सुझाव",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: ऑपरेटर के रूप में खाता और सिंक किया गया डेटा सहेजता है। सर्वर ब्राज़ील के बाहर हो सकते हैं, LGPD के art. 33 की गारंटियों के साथ।",
 "Superiores": "उच्च",
 "Supino reto": "बेंच प्रेस",
 "Suplemento": "सप्लीमेंट",
 "Suspense": "सस्पेंस",
 "Suíte": "अटैच्ड बाथरूम वाला कमरा",
 "Sábado": "शनिवार",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "60 से ज़्यादा फ़ाइलें बनेंगी। \"हर N पेज पर\" इस्तेमाल करें।",
 "Série": "सीरीज़",
 "Série da DPS": "DPS सीरीज़",
 "Série e turma": "कक्षा और सेक्शन",
 "Séries": "सेट",
 "Sérum": "सीरम",
 "Símbolos": "प्रतीक",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "सिर्फ़ ऑफ़िस की टीम देख सकती है। हर फ़ाइल 50 MB तक।",
 "Só acompanha": "केवल देखता है",
 "Só acompanha, sem valores": "केवल देखता है, राशियों के बिना",
 "Só administradores": "केवल एडमिन",
 "Só em {data}": "सिर्फ़ {data}",
 "Só leitura": "केवल पढ़ने के लिए",
 "Só mandar para a aba Estudos (sem escolher página)": "सिर्फ़ पढ़ाई टैब में भेजें (पेज चुने बिना)",
 "Só neste dispositivo": "केवल इस डिवाइस पर",
 "Só neste dispositivo: {n}": "सिर्फ़ इस डिवाइस में: {n}",
 "Só o código": "केवल कोड",
 "Só o dia {data}": "सिर्फ़ {data} का दिन",
 "Só os dados (texto)": "केवल डेटा (टेक्स्ट)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "आपके AI को सिर्फ़ वित्त के कुल आँकड़े भेजे जाते हैं। यह निवेश की सलाह नहीं है।",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "सिर्फ़ आपके लिए: अध्ययन, पढ़ाने की रणनीतियाँ और हर कक्षा में क्या चला या नहीं चला। छात्र इसे नहीं देखते।",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "सिर्फ़ एक फ़ोन ही कैलेंडर से सिंक होता है। इस फ़ोन पर बदलने के लिए नीचे टैप करें।",
 "Só uma vez": "सिर्फ़ एक बार",
 "Só uma vez (abrir a ficha da tarefa)": "सिर्फ़ एक बार (कार्य का कार्ड खोलें)",
 "Só áudio": "केवल ऑडियो",
 "Sótão": "अटारी",
 "TAREFAS DA CASA": "घर के काम",
 "TELEFONE (OPCIONAL)": "फ़ोन (वैकल्पिक)",
 "TRAZER PARA O MY PLANNER": "MY PLANNER में लाएं",
 "TV por assinatura": "पे टीवी",
 "Tabela": "तालिका",
 "Talvez": "शायद",
 "Tamanho": "आकार",
 "Tamanho da foto": "फ़ोटो का साइज़",
 "Tamanho da página": "पेज का आकार",
 "Tamanho das páginas": "पेजों का आकार",
 "Tamanho do arquivo": "फ़ाइल का आकार",
 "Tamanho do copo": "गिलास का आकार",
 "Também procurar nos Diários Oficiais dos municípios": "नगरपालिकाओं के आधिकारिक राजपत्रों में भी खोजें",
 "Também serão excluídos {n} item(ns) dentro dele.": "इसके अंदर के {n} आइटम भी हटा दिए जाएँगे।",
 "Tapioca": "टैपिओका क्रेप",
 "Tarefa": "कार्य",
 "Tarefa da casa": "घर का काम",
 "Tarefa de casa": "होमवर्क",
 "Tarefa duplicada": "कार्य की प्रति बनाई गई",
 "Tarefa ou entrega": "कार्य या डिलीवरी",
 "Tarefa para {nome}": "{nome} के लिए कार्य",
 "Tarefas da casa": "घर के काम",
 "Tarefas e itens de todas as abas": "सभी टैब के कार्य और आइटम",
 "Tarefas novas do My Planner vão para: {agenda}": "My Planner के नए टास्क यहां जाएंगे: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "जो दोहराए जाने वाले कार्य अवधि से आगे जाते हैं, वे बाकी दिनों में बने रहते हैं; केवल चुने गए दिन हटते हैं।",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "CPF, रकम और नामों पर काली पट्टियाँ। सच में मिटाता है।",
 "Tartaruga": "कछुआ",
 "Taxa de limpeza": "सफ़ाई शुल्क",
 "Taxa de limpeza cobrada do hóspede": "मेहमान से लिया गया सफ़ाई शुल्क",
 "Taxas e anúncios": "शुल्क और विज्ञापन",
 "Te amo": "आई लव यू",
 "Tecnologia": "टेक्नोलॉजी",
 "Tela cheia": "फ़ुल स्क्रीन",
 "Teleconsulta": "टेली-परामर्श",
 "Telefone": "फ़ोन",
 "Telefone da assistência": "सर्विस सेंटर का फ़ोन",
 "Telefone da empresa": "कंपनी का फ़ोन",
 "Telefone da escola": "स्कूल का फ़ोन",
 "Telefone da limpeza": "सफ़ाई वाले का फ़ोन",
 "Telefone de emergência": "आपातकालीन फ़ोन",
 "Telefone do veterinário": "पशु चिकित्सक का फ़ोन",
 "Telhado": "छत",
 "Tem anexos": "अटैचमेंट हैं",
 "Tem certeza?": "क्या आप पक्का हैं?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "आपके {n} बिल की देय तिथि निकल चुकी है, कुल {v}। पहले वे चुकाएँ जिन पर ब्याज सबसे ज़्यादा है, जैसे कार्ड और ओवरड्राफ़्ट।",
 "Tema": "विषय",
 "Tempo de preparo": "बनाने का समय",
 "Temporada": "सीज़न",
 "Temporizador (direita)": "टाइमर (दाएँ)",
 "Tenta consertar um PDF que não abre direito.": "ठीक से न खुलने वाले PDF को ठीक करने की कोशिश करता है।",
 "Tentar de novo": "फिर से कोशिश करें",
 "Tente uma foto mais nítida, com a página inteira.": "पूरा पेज दिखाती हुई ज़्यादा साफ़ फ़ोटो आज़माएँ।",
 "Termina às {hora}": "{hora} बजे समाप्त",
 "Terminar até": "कब तक पूरा करें",
 "Terminei em": "ख़त्म किया",
 "Terminou": "ख़त्म हो गई",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "{data} को खत्म हुआ। कुछ भी मिटाया नहीं गया: सदस्यता लेने पर सब पहले जैसा लौट आएगा।",
 "Termos de uso": "उपयोग की शर्तें",
 "Termos de uso e privacidade": "उपयोग की शर्तें और गोपनीयता",
 "Terror": "हॉरर",
 "Terça": "मंगलवार",
 "Testando...": "टेस्ट हो रहा है...",
 "Testar alerta (1 minuto)": "अलर्ट जाँचें (1 मिनट)",
 "Testar aviso": "सूचना टेस्ट करें",
 "Teste de alerta do Planner": "Planner अलर्ट परीक्षण",
 "Teste grátis até {data} ({n} dia(s))": "{data} तक मुफ़्त ट्रायल ({n} दिन)",
 "Teste grátis: {n} dia(s)": "मुफ़्त ट्रायल: {n} दिन",
 "Teste terminado": "ट्रायल खत्म",
 "Teste terminou em {data}": "ट्रायल {data} को खत्म हुआ",
 "Teste: aviso feito pelo próprio celular.": "टेस्ट: फ़ोन द्वारा स्वयं बनाई गई सूचना।",
 "Texto": "टेक्स्ट",
 "Texto completo": "पूरा टेक्स्ट",
 "Texto copiado. Cole onde quiser enviar.": "टेक्स्ट कॉपी हो गया। जहाँ भेजना हो वहाँ पेस्ट करें।",
 "Texto do documento": "दस्तावेज़ का टेक्स्ट",
 "Texto extra do convite (traje, presentes...)": "निमंत्रण का अतिरिक्त संदेश (ड्रेस कोड, उपहार...)",
 "Texto livre": "मुक्त पाठ",
 "Texto ou recado": "टेक्स्ट या संदेश",
 "Texto para PDF": "टेक्स्ट से PDF",
 "Texto {data}": "टेक्स्ट {data}",
 "Tipo": "प्रकार",
 "Tipo sanguíneo": "ब्लड ग्रुप",
 "Tira as páginas que você não quer.": "जो पेज नहीं चाहिए उन्हें हटाता है।",
 "Tira autor, programas, comandos escondidos e anexos.": "लेखक, प्रोग्राम, छिपे कमांड और अटैचमेंट हटाता है।",
 "Tira comentários, destaques e desenhos de outros programas.": "दूसरे प्रोग्रामों की टिप्पणियाँ, हाइलाइट और ड्रॉइंग हटाता है।",
 "Tira o texto do PDF (arquivo .txt).": "PDF से टेक्स्ट निकालता है (.txt फ़ाइल)।",
 "Tiradentes": "Tiradentes",
 "Tirar": "हटाएँ",
 "Tirar a assinatura": "हस्ताक्षर हटाएं",
 "Tirar a foto": "फ़ोटो हटाएँ",
 "Tirar a foto agora": "अभी फ़ोटो लें",
 "Tirar admin": "एडमिन हटाएँ",
 "Tirar alarmes do My Planner": "My Planner से अलार्म हटाएँ",
 "Tirar arquivos anexados": "अटैच की गई फ़ाइलें हटाएँ",
 "Tirar comentários, destaques e links": "टिप्पणियाँ, हाइलाइट और लिंक हटाएँ",
 "Tirar da agenda": "एजेंडा से हटाएँ",
 "Tirar da barra": "बार से हटाएँ",
 "Tirar daqui": "यहाँ से हटाएँ",
 "Tirar das minhas figurinhas?": "मेरे स्टिकर से हटाएँ?",
 "Tirar de administrador": "एडमिन से हटाएँ",
 "Tirar do escritório": "ऑफ़िस से निकालें",
 "Tirar dos meus GIFs?": "मेरे GIF से हटाएँ?",
 "Tirar este copo": "यह गिलास हटाएँ",
 "Tirar foto": "फ़ोटो लें",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "बिलों, रसीदों और दस्तावेज़ों की फ़ोटो लेना और गैलरी से फ़ोटो व वीडियो चुनना।",
 "Tirar o desenho padrão?": "पैटर्न हटाएँ?",
 "Tirar o lixo": "कचरा बाहर निकालें",
 "Tire a foto e a sua IA preenche a ficha": "फ़ोटो लें और आपका AI फ़ॉर्म भर देगा",
 "Titular (de quem é o documento)": "धारक (दस्तावेज़ किसका है)",
 "Titular: {nome}": "धारक: {nome}",
 "Toalha de praia": "बीच टॉवल",
 "Tocar os pés": "पैर छुएँ",
 "Toda a agenda": "पूरा एजेंडा",
 "Toda semana": "हर हफ़्ते",
 "Todas": "सभी",
 "Todas (passadas, esta e futuras)": "सभी (पिछले, यह और आगे के)",
 "Todas ({n})": "सभी ({n})",
 "Todas as abas liberadas até {data}.": "सभी टैब {data} तक अनलॉक हैं।",
 "Todas as capitais. Marque uma ou mais cidades.": "सभी राजधानियाँ। एक या अधिक शहर चुनें।",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "PDF के सभी टूल: जोड़ना, बाँटना, व्यवस्थित करना, हस्ताक्षर, मुहर, काली पट्टी, पेज नंबर, फ़ॉर्म, कंप्रेस, कन्वर्ट, OCR और AI। मोबाइल, Google Drive या OneDrive में सहेजें।",
 "Todas as ferramentas ficam na tela da aba.": "सभी टूल इस टैब की स्क्रीन पर हैं।",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "यात्रा की सभी फ़ोटो यहाँ हैं: जो आप एल्बम में डालते हैं और यात्रा कार्यक्रम, जगहों और बुकिंग की फ़ोटो।",
 "Todas as plantas estão regadas.": "सभी पौधों को पानी मिल चुका है।",
 "Todas as páginas, uma embaixo da outra.": "सभी पेज, एक के नीचे एक।",
 "Todo ano": "हर साल",
 "Todo dia": "हर दिन",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "हर दिन चुने गए समय पर: दिन में कितने कार्य हैं, पहला कार्य और कुल ऊर्जा।",
 "Todo mês": "हर महीने",
 "Todo mês · dia {d}": "हर महीने · तारीख़ {d}",
 "Todo o histórico": "पूरा इतिहास",
 "Todos": "सभी",
 "Todos ({n})": "सभी ({n})",
 "Todos do grupo": "समूह के सभी लोग",
 "Todos do grupo veem": "समूह के सभी लोग देखते हैं",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "मीटिंग में सभी को \"रिकॉर्ड हो रहा है\" सूचना दिखती है। फ़ाइल ऑफ़िस के दस्तावेज़ में जाती है और जब तक आप टीम के लिए न खोलें, सिर्फ़ आपको दिखती है।",
 "Todos os cuidados": "सारी देखभाल",
 "Todos os dias": "हर दिन",
 "Todos os suplementos": "सारे सप्लीमेंट",
 "Todos os treinos": "सारे वर्कआउट",
 "Todos os tribunais": "सभी न्यायालय",
 "Todos presentes": "सभी उपस्थित",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "सभी समूह से बाहर हो जाएँगे। हर व्यक्ति ने जो पहले स्वीकार किया है वह उसके एजेंडा में रहेगा।",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "सभी एक ही डेटा पर काम करते हैं, हर कोई अपनी भूमिका के अनुसार। बदलने के लिए सदस्य में हर व्यक्ति की भूमिका पर टैप करें।",
 "Tomador": "सेवा प्राप्तकर्ता",
 "Tomador (quem contratou)": "सेवा प्राप्तकर्ता (जिसने सेवा ली)",
 "Tomadores": "सेवा प्राप्तकर्ता",
 "Tomei": "मैंने लिया",
 "Toque aqui ou no + para criar uma tarefa": "कार्य बनाने के लिए यहाँ या + पर टैप करें",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "\"मेरा खाता और सारा डेटा हटाएँ\" पर टैप करें और पुष्टि करें।",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "+ › नया क्रेडिट कार्ड पर टैप करें और बिल बनने व देय होने के दिन भरें।",
 "Toque em Ajustes e depois em Segurança.": "सेटिंग्स पर टैप करें, फिर सुरक्षा पर।",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "कनेक्ट करें पर टैप करें और Apple की स्क्रीन पर वे आइटम चालू करें जिन्हें My Planner पढ़ सकता है।",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "कनेक्ट करें पर टैप करें और Health Connect की स्क्रीन पर My Planner को डेटा पढ़ने की अनुमति दें।",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "उन लोगों पर टैप करें जिन्हें यह कार्ड (और इसके अंदर की चीज़ें) नहीं देखना चाहिए। उदा.: सरप्राइज़ उपहार।",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "खोलने के लिए किसी टैब पर टैप करें। लॉक किए गए टैब सदस्यता लेने का तरीका दिखाते हैं।",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "खोलने के लिए किसी टैब को दबाएँ। हर अतिरिक्त टैब 10 दिन मुफ़्त आज़मा सकते हैं।",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "खोलने के लिए किसी टैब पर टैप करें। टैब को नीचे के बार में रखने या हटाने के लिए 📌 पर टैप करें। हर अतिरिक्त टैब 10 दिन तक मुफ़्त आज़माया जा सकता है।",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "खोलने के लिए किसी क्षेत्र पर टैप करें। लॉक वाले क्षेत्र सदस्यता लेने का तरीका दिखाते हैं।",
 "Toque no desenho para continuar desenhando.": "ड्रॉइंग जारी रखने के लिए उस पर टैप करें।",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "वह चुनें जो यह समूह साझा करेगा। इसके अंदर का सब कुछ (यात्रा कार्यक्रम, फ़ोटो, बुकिंग...) साथ जाएगा और सभी भाग लेंगे।",
 "Toque nos PDFs na ordem em que devem ficar.": "PDF पर उसी क्रम में टैप करें जिसमें उन्हें रहना है।",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "मात्रा बदलने के लिए गिलास पर टैप करें; दूसरे साइज़ के गिलास के लिए + दबाकर रखें।",
 "Toque num feriado para adicioná-lo ao Planner.": "किसी अवकाश को Planner में जोड़ने के लिए उस पर टैप करें।",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "श्रेणी बदलने, IR रसीद सहेजने या हटाने के लिए किसी एंट्री पर टैप करें।",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "श्रेणी बदलने के लिए किसी प्रविष्टि पर टैप करें। मिटाने के लिए दबाकर रखें।",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "संपादित करने के लिए किसी प्रोफ़ाइल पर टैप करें। हटाने के लिए दबाकर रखें।",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "किसी टेक्स्ट, ड्रॉइंग या चेकलिस्ट को टैप करें और पेज पर कहीं भी खींचें।",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "क्रॉप करने, घुमाने या फ़िल्टर बदलने के लिए किसी पेज पर टैप करें। क्रम बदलने के लिए दबाकर रखें और खींचें।",
 "Toque numa tarefa para copiar ou mover para hoje.": "किसी कार्य पर टैप करके उसे आज में कॉपी करें या ले जाएँ।",
 "Toque onde quer a checklist.": "जहाँ चेकलिस्ट चाहिए वहाँ टैप करें।",
 "Toque onde quer escrever.": "जहाँ लिखना है वहाँ टैप करें।",
 "Toque para abrir": "खोलने के लिए टैप करें",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "फ़ोन के ऐप में खोलने के लिए टैप करें। सूची से हटाने के लिए दाएँ स्वाइप करें।",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "खोलने के लिए टैप करें, नाम बदलने के लिए दबाकर रखें। संग्रहीत करने के लिए बाएँ या हटाने के लिए दाएँ स्वाइप करें।",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "खोलने के लिए टैप करें। सूची से हटाने के लिए दाईं ओर स्वाइप करें।",
 "Toque para aceitar ou recusar.": "स्वीकार या अस्वीकार करने के लिए टैप करें।",
 "Toque para aceitar, editar ou recusar.": "स्वीकारने, संपादित करने या अस्वीकारने के लिए टैप करें।",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "अभी लागू करने के लिए टैप करें। या ऐप दोबारा खोलने पर यह अपने आप लागू हो जाएगा।",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "डाउनलोड करके ऊपर से इंस्टॉल करने के लिए टैप करें। आपका डेटा बना रहेगा।",
 "Toque para conversar": "चैट करने के लिए टैप करें",
 "Toque para enviar o emoji animado": "एनिमेटेड इमोजी भेजने के लिए टैप करें",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "भेजने के लिए टैप करें। सहेजने या हटाने के लिए दबाकर रखें।",
 "Toque para escolher": "चुनने के लिए टैप करें",
 "Toque para fechar": "बंद करने के लिए टैप करें",
 "Toque para gerar um novo QR Code": "नया QR कोड बनाने के लिए टैप करें",
 "Tornar admin": "एडमिन बनाएँ",
 "Tornar administrador": "एडमिन बनाएँ",
 "Tosa": "ग्रूमिंग",
 "Totais por alimento": "खाद्य पदार्थ के अनुसार कुल",
 "Total": "कुल",
 "Total bruto": "कुल राशि",
 "Total das reservas: {v}": "बुकिंग का कुल: {v}",
 "Total de aulas": "कुल क्लास",
 "Total de capítulos": "कुल अध्याय",
 "Total de módulos": "कुल मॉड्यूल",
 "Total de páginas": "कुल पेज",
 "Total de recibos: {v}": "रसीदों का कुल: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "कुल: {n}। हर टैब में {lim} तक टेक्स्ट हो सकता है (फ़ोटो और फ़ाइलें नहीं गिनी जातीं: वे डिवाइस या आपके Drive में रहती हैं)।",
 "Total: {v}": "कुल: {v}",
 "Trabalhando...": "काम हो रहा है...",
 "Trabalho": "श्रम",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "अपने Google कैलेंडर के इवेंट My Planner में लाएं और यहीं से बदलें: बदलाव कैलेंडर में भी पहुंच जाएंगे।",
 "Trans": "ट्रांस",
 "Transferir: {s}": "ट्रांसफ़र: {s}",
 "Transferência": "ट्रांसफ़र",
 "Transferências": "ट्रांसफ़र",
 "Transporte": "परिवहन",
 "Tratamento": "इलाज",
 "Travar depois de preencher": "भरने के बाद लॉक करें",
 "Trazer todas para hoje": "सभी को आज पर लाएँ",
 "Trazer tudo para hoje?": "सब कुछ आज पर लाएँ?",
 "Trecho ou ideia": "अंश या विचार",
 "Treino": "वर्कआउट",
 "Trem ou ônibus": "ट्रेन या बस",
 "Treme": "काँपना",
 "Tribunais": "न्यायालय",
 "Trilha": "ट्रेकिंग",
 "Triste": "उदास",
 "Triângulo": "त्रिभुज",
 "Troca de óleo": "ऑयल बदलना",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "ऑयल बदलना, टायर रोटेशन, किमी के हिसाब से सर्विसिंग, IPVA, लाइसेंसिंग और बीमा।",
 "Trocador portátil": "पोर्टेबल चेंजिंग मैट",
 "Trocar": "बदलें",
 "Trocar a categoria": "श्रेणी बदलें",
 "Trocar a foto": "फ़ोटो बदलें",
 "Trocar a pasta": "फ़ोल्डर बदलें",
 "Trocar a senha do cofre": "वॉल्ट पासवर्ड बदलें",
 "Trocar número": "नंबर बदलें",
 "Trocar o certificado": "प्रमाणपत्र बदलें",
 "Trocar o código": "कोड बदलें",
 "Trocar o código?": "कोड बदलें?",
 "Trocar o desenho": "पैटर्न बदलें",
 "Trocar o emoji": "इमोजी बदलें",
 "Trocar o modelo": "मॉडल बदलें",
 "Trocar o número": "नंबर बदलें",
 "Trocar o número do celular": "मोबाइल नंबर बदलें",
 "Trocar por:": "इससे बदलें:",
 "Trocar roupa de cama e toalhas": "चादरें और तौलिये बदलें",
 "Tríceps na polia": "ट्राइसेप्स पुशडाउन",
 "Tubo de ensaio": "टेस्ट ट्यूब",
 "Tudo": "सब",
 "Tudo certo": "सब ठीक है",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "यहाँ सब ठीक है। रोज़ के खर्च दर्ज करते रहें ताकि मैं देख सकूँ कि पैसा कहाँ जा रहा है।",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "सब कुछ पहले से आपके खाते में सुरक्षित है। फ़ाइल एक अतिरिक्त प्रति है जिसे आप जहाँ चाहें रख सकते हैं।",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "\"{nome}\" के अंदर की हर चीज़ समूह को दिखने लगेगी, हर व्यक्ति को आपकी चुनी गई भूमिका के अनुसार (नए लोग सबसे सीमित भूमिका से शुरू करते हैं)।",
 "Tudo! Já comprei os ingressos.": "सब हो गया! मैंने टिकट भी ले लिए।",
 "Turma": "कक्षा",
 "Turma (opcional)": "कक्षा (वैकल्पिक)",
 "Turmas": "कक्षाएँ",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "कक्षाएँ और समूह (पढ़ाई, मेंटरिंग, ट्रेनिंग): छात्र, हाज़िरी, अंक, योजनाएँ, सामग्री, शुल्क और आपकी नोटबुक।",
 "Turmas, alunos, chamada, notas e planos de aula.": "कक्षाएँ, छात्र, हाज़िरी, अंक और पाठ योजनाएँ।",
 "Turmas, pacientes, equipes e convidados": "कक्षाएँ, मरीज़, टीमें और मेहमान",
 "Técnico": "तकनीकी",
 "Título": "शीर्षक",
 "Título (ex.: Capítulo 3)": "शीर्षक (जैसे: अध्याय 3)",
 "Título (opcional)": "शीर्षक (वैकल्पिक)",
 "Título da caixa": "बॉक्स का शीर्षक",
 "Título de eleitor": "मतदाता पहचान पत्र",
 "Título, autor, assunto e palavras-chave.": "शीर्षक, लेखक, विषय और कीवर्ड।",
 "Tô chegando": "आ रहा हूँ",
 "Tônico": "टोनर",
 "UF": "UF",
 "Uau": "वाह",
 "Uhuul!": "हुर्रे!",
 "Um PDF novo só com as páginas escolhidas.": "सिर्फ़ चुने हुए पेजों वाला नया PDF।",
 "Um texto clarinho na diagonal de todas as páginas.": "सभी पेजों पर तिरछा हल्का टेक्स्ट।",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "हर क्लाइंट के लिए एक फ़ोल्डर: आप दोनों ओर से दस्तावेज़ भेजते हैं और हर क्लाइंट सिर्फ़ अपना फ़ोल्डर देखता है।",
 "Uma página por arquivo": "हर फ़ाइल में एक पेज",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "हर फ़ाइल में एक पेज, हर N पेज पर या रेंज के हिसाब से।",
 "Unicórnio": "यूनिकॉर्न",
 "Unidade": "इकाई",
 "Universal": "सामान्य",
 "União": "एकता",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "फ़ोन में पहले से मौजूद Google खाते का इस्तेमाल होता है। My Planner कभी आपका Google पासवर्ड नहीं मांगता।",
 "Usado: {u} · livre: {v} · limite {l}": "इस्तेमाल: {u} · उपलब्ध: {v} · लिमिट {l}",
 "Usar": "इस्तेमाल करें",
 "Usar \"{nome}\"": "\"{nome}\" इस्तेमाल करें",
 "Usar biometria": "बायोमेट्रिक का उपयोग करें",
 "Usar desenho padrão": "पैटर्न का उपयोग करें",
 "Usar este celular": "यह फ़ोन इस्तेमाल करें",
 "Usar este nome": "यह नाम इस्तेमाल करें",
 "Usar modelo: {m}": "टेम्पलेट इस्तेमाल करें: {m}",
 "Usar no navegador (My Planner Web)": "ब्राउज़र में उपयोग करें (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "पहले से जुड़ी फ़ाइल इस्तेमाल करें ({nome})",
 "Usar o código": "कोड इस्तेमाल करें",
 "Usar senha": "पासवर्ड का उपयोग करें",
 "Usar {ia}": "{ia} इस्तेमाल करें",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "अगली बार लॉग इन करते समय, यहाँ और My Planner Web पर, नया पासवर्ड इस्तेमाल करें।",
 "Use a senha para desbloquear.": "अनलॉक करने के लिए पासवर्ड का उपयोग करें।",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "प्रकाशन, दस्तावेज़ और नोट्स पढ़ने और शेड्यूल सुझाने के लिए अपना AI इस्तेमाल करें। Planner में कुछ भी जोड़ने से पहले आप हमेशा पुष्टि करते हैं।",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "अपना खाता बनाते समय यह कोड डालें और 10 दिनों तक सभी टैब अनलॉक पाएँ।",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "अपने बैंक के ऐप या वेबसाइट से डाउनलोड किया गया OFX (सबसे अच्छा) या CSV स्टेटमेंट इस्तेमाल करें।",
 "Use o seu planner no computador, sincronizado com o celular.": "अपना प्लानर कंप्यूटर पर इस्तेमाल करें, मोबाइल के साथ सिंक।",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Google Drive, Google Docs, OneDrive या SharePoint का https लिंक इस्तेमाल करें।",
 "Uso": "उपयोग",
 "Uso próprio": "निजी इस्तेमाल",
 "VRBO": "VRBO",
 "Vacina": "टीका",
 "Vacina {nome}: {pet}": "{nome} टीका: {pet}",
 "Vacina: {nome}": "टीका: {nome}",
 "Vacinas": "टीके",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "पालतुओं के टीके और दवाएँ, पेट शॉप, और बच्चों के स्कूल व स्वास्थ्य की दिनचर्या।",
 "Vai na viagem": "यात्रा पर जा रहा है",
 "Vale até {d}": "{d} तक मान्य",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "पढ़ाई और दस्तावेज़ पर लागू। क्लाउड में होने पर फ़ाइल किसी भी डिवाइस पर और My Planner Web में खुलती है (प्रति फ़ाइल 15 MB तक)।",
 "Vale quantos pontos": "कितने अंक का",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "यह सिर्फ़ आप पर लागू होता है। प्रति व्यक्ति हर 3 मिनट में अधिकतम एक सूचना, भले ही वह कई चीज़ें जोड़े।",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "एक बार मान्य, आपके खाते के पहले 30 दिनों में।",
 "Validade": "वैधता",
 "Validade do certificado A1": "A1 प्रमाणपत्र की वैधता",
 "Validade: {data}": "वैधता: {data}",
 "Valor": "राशि",
 "Valor ({m})": "राशि ({m})",
 "Valor a pagar": "देय राशि",
 "Valor combinado": "तय राशि",
 "Valor combinado por atendimento": "प्रति अपॉइंटमेंट तय राशि",
 "Valor da hora": "प्रति घंटा दर",
 "Valor da parcela (1ª)": "किस्त की राशि (पहली)",
 "Valor da venda": "बिक्री मूल्य",
 "Valor de costume": "सामान्य राशि",
 "Valor do atendimento: {v}{pago}.": "उपचार शुल्क: {v}{pago}।",
 "Valor emprestado ou financiado": "उधार या फ़ाइनेंस की गई राशि",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "अंतिम कीमत Google Play या App Store तय करते हैं, आपके देश की मुद्रा में।",
 "Valor maior que o guardado nesta meta.": "राशि इस लक्ष्य में बचाई गई रकम से ज़्यादा है।",
 "Valor padrão da consulta ou sessão": "परामर्श या सत्र की सामान्य फ़ीस",
 "Valor pago": "भुगतान की गई राशि",
 "Valor pago (com multa ou desconto)": "चुकाई गई राशि (जुर्माना या छूट सहित)",
 "Valor pago (opcional)": "भुगतान की गई राशि (वैकल्पिक)",
 "Valor pago: {v}": "भुगतान की गई राशि: {v}",
 "Valor que este aluno paga (se for diferente)": "यह छात्र कितना देता है (अगर अलग हो)",
 "Valor recebido": "प्राप्त राशि",
 "Valor recebido: {v}": "प्राप्त राशि: {v}",
 "Valor total da compra": "खरीदारी की कुल राशि",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "राशियाँ और क्लिनिकल डेटा केवल उन्हीं को दिखते हैं जिनकी भूमिका अनुमति देती है। आप जब चाहें बंद कर सकते हैं: डेटा आपके पास रहेगा।",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "ये राशियाँ अपने अकाउंटेंट से मिलान करें। कटौती के नियम हर साल बदलते हैं।",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "चलो My Planner पर बात करें? कोड {codigo} से मुझे दोस्त के रूप में जोड़ें (संदेश टैब > दोस्त)।",
 "Vaso": "गमला",
 "Veja os planos em Ajustes › Compras.": "प्लान सेटिंग्स › खरीदारी में देखें।",
 "Vem da aba Empréstimos & Financiamentos": "ऋण और फ़ाइनेंसिंग टैब से",
 "Vence em {data}.": "{data} को समाप्त होगा।",
 "Vence em {fim} (data informada na publicação).": "{fim} को समाप्त (प्रकाशन में बताई गई तारीख़)।",
 "Vence em {n} dia(s)": "{n} दिन में समाप्त",
 "Vence hoje": "आज समाप्त",
 "Vence {data}": "देय {data}",
 "Vencendo": "समाप्त होने वाले",
 "Venceu há {n} dia(s)": "{n} दिन पहले समाप्त",
 "Vencidas": "समाप्त",
 "Vencidos": "समाप्त",
 "Vencimento": "देय तिथि",
 "Vencimento (guias e boletos)": "नियत तारीख (चालान और boleto)",
 "Vencimento da 1ª parcela": "पहली किस्त की देय तारीख",
 "Vencimentos": "नियत तारीखें",
 "Venda": "बिक्री",
 "Venda/serviço do MEI": "MEI की बिक्री/सेवा",
 "Vendidos": "बिक चुके",
 "Ver": "देखें",
 "Ver a lista de membros": "सदस्यों की सूची देखना",
 "Ver a rota": "रास्ता देखें",
 "Ver arquivos": "फ़ाइलें देखें",
 "Ver detalhes do erro": "त्रुटि का विवरण देखें",
 "Ver e editar": "देखें और बदलें",
 "Ver em Compras": "खरीदारी में देखें",
 "Ver mais": "और देखें",
 "Ver mais páginas": "और पेज देखें",
 "Ver no My Planner": "My Planner में देखें",
 "Ver o dia": "दिन देखें",
 "Ver os feriados do ano": "साल भर के अवकाश देखें",
 "Ver participantes": "प्रतिभागी देखें",
 "Ver páginas": "पेज देखें",
 "Ver todos": "सभी देखें",
 "Ver todos ({n})": "सभी देखें ({n})",
 "Ver {nome}": "{nome} देखें",
 "Verificar agora": "अभी जाँचें",
 "Vermífugo": "कृमिनाशक",
 "Vermífugo ou remédio": "कृमिनाशक या दवा",
 "Vermífugos e remédios": "कृमिनाशक और दवाएँ",
 "Verso": "पीछे",
 "Verso do documento": "दस्तावेज़ का पीछे का भाग",
 "Versão do PDF": "PDF वर्ज़न",
 "Versão instalada": "इंस्टॉल किया गया संस्करण",
 "Versão {versao} disponível": "संस्करण {versao} उपलब्ध है",
 "Versão {v}": "वर्शन {v}",
 "Veterinário": "पशु चिकित्सक",
 "Veterinário ou clínica": "पशु चिकित्सक या क्लिनिक",
 "Veículo": "वाहन",
 "Veículo e acessórios": "वाहन और एक्सेसरीज़",
 "Veículos": "वाहन",
 "Veículos & Manutenção": "वाहन और मेंटेनेंस",
 "Vi mais um episódio": "एक और एपिसोड देखा",
 "Viagem": "यात्रा",
 "Viagens": "यात्राएँ",
 "Viagens & Lazer": "यात्रा और मनोरंजन",
 "Viagens e lugares": "यात्रा और जगहें",
 "Vida noturna": "नाइटलाइफ़",
 "Vidros e esquadrias": "शीशे और खिड़की-दरवाज़े",
 "Vigente": "चालू",
 "Vigentes": "चालू",
 "Virar": "पलटें",
 "Virar a câmera": "कैमरा बदलें",
 "Virar tarefa (levar à assistência)": "कार्य बनाएँ (सर्विस सेंटर ले जाना)",
 "Visita domiciliar": "घर पर विज़िट",
 "Visitados": "देखी गईं",
 "Visto": "देख ली",
 "Vistoria": "निरीक्षण",
 "Vistoria: {i}": "निरीक्षण: {i}",
 "Vistorias": "निरीक्षण",
 "Visualizar feriados": "अवकाश देखें",
 "Vitamina": "विटामिन",
 "Vitamina D": "विटामिन D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "विटामिन, व्हे, क्रिएटिन... हर एक की आवृत्ति के साथ। आज का सब कुछ \"आज\" में निशान लगाने के लिए दिखेगा।",
 "Você": "आप",
 "Você aceitou os termos em {data}.": "आपने {data} को शर्तें स्वीकार कीं।",
 "Você ainda não tem amigos no app. Adicione pelo código.": "ऐप में अभी आपका कोई दोस्त नहीं है। कोड से जोड़ें।",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "आपके पास अभी कोई फ़ाइल नहीं है। पढ़ाई टैब में एक बनाएँ।",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "आप बातचीत, दस्तावेज़ और मीटिंग नहीं देख पाएँगे।",
 "Você deve: {v}": "आपको देना है: {v}",
 "Você entrou no grupo": "आप समूह से जुड़ गए",
 "Você entrou no grupo \"{nome}\".": "आप समूह \"{nome}\" में शामिल हो गए।",
 "Você está convidado(a) para: {evento}": "आप आमंत्रित हैं: {evento}",
 "Você foi convidado para o My Planner": "आपको My Planner में आमंत्रित किया गया है",
 "Você foi convidado para o grupo": "आपको समूह में आमंत्रित किया गया है",
 "Você juntou {v} para \"{m}\".": "आपने \"{m}\" के लिए {v} जमा किए।",
 "Você já tem todas as abas.": "आपके पास सभी टैब हैं।",
 "Você já usou um código de indicação nesta conta.": "आप इस खाते में पहले ही एक रेफ़रल कोड इस्तेमाल कर चुके हैं।",
 "Você ligou": "आपने कॉल किया",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "आप किसी भी समय फ़ोन ऐप या वेबसाइट पर अपना खाता हटा सकते हैं:",
 "Você não tem permissão para isso neste grupo.": "इस समूह में आपको इसकी अनुमति नहीं है।",
 "Você não vê os outros membros deste grupo.": "आप इस समूह के अन्य सदस्यों को नहीं देख सकते।",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "आप कभी भी सेटिंग्स > सुरक्षा में खाता हटा सकते हैं। इससे क्लाउड और डिवाइस का डेटा हमेशा के लिए हट जाता है।",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "आप ये कर सकते हैं: पुष्टि करना कि हम आपका डेटा प्रोसेस करते हैं या नहीं, उस तक पहुँचना, उसे सुधारना, पोर्टेबिलिटी माँगना (सेटिंग्स > सामान्य सेटिंग्स में फ़ाइल एक्सपोर्ट करें), हटाने का अनुरोध करना, जानना कि हम किसके साथ साझा करते हैं, सहमति वापस लेना और ANPD में शिकायत करना।",
 "Você recebe (líquido)": "आपको मिलता है (शुद्ध)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "आप अपने पासवर्ड और अपने खाते में होने वाली गतिविधियों के लिए ज़िम्मेदार हैं। पंजीकरण में सही जानकारी दें।",
 "Volta": "वापसी",
 "Volta ou check-out": "वापसी या चेक-आउट",
 "Volta às {hora}": "{hora} बजे वापसी",
 "Voltar": "वापस",
 "Voltar ao cardápio da semana neste dia": "इस दिन हफ़्ते का मेनू वापस लाएँ",
 "Voltar ao cálculo": "गणना पर वापस",
 "Voltar ao foco": "फ़ोकस पर वापस",
 "Voltar ao padrão": "डिफ़ॉल्ट पर लौटें",
 "Voltar ao planejado": "योजना पर लौटें",
 "Voltar para Anotações": "नोट्स पर वापस",
 "Voltar para as cores do My Planner": "My Planner के रंगों पर वापस जाएँ",
 "Voltar para novas": "नए पर वापस",
 "Voltar para o QR Code": "QR कोड पर वापस",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "फ़ोन पर My Planner ऐप पर वापस जाएँ। सेटिंग्स स्क्रीन अपने-आप अपडेट हो जाएगी।",
 "Voo": "फ़्लाइट",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "फ़्लाइट, होटल, कार और सैर एक ही जगह, कोड और रसीद के साथ।",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "सेटिंग्स में जाएँ और \"ब्राउज़र कनेक्ट करें\" पर टैप करें।",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "सेटिंग्स › सामान्य सेटिंग्स में जाएँ और \"ब्राउज़र कनेक्ट करें\" पर टैप करें।",
 "Várias páginas por folha": "हर शीट पर कई पेज",
 "Vários PDFs num só, na ordem que você escolher.": "कई PDF एक में, आपके चुने क्रम में।",
 "Vê as aulas e os materiais liberados.": "उपलब्ध कराई गई कक्षाएँ और सामग्री देखता है।",
 "Vê as etapas e registra o diário.": "चरण देखता है और डायरी में दर्ज करता है।",
 "Vê e altera tudo, inclusive os valores.": "राशियों सहित सब कुछ देखता और बदलता है।",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "अपने फ़ोल्डर के दस्तावेज़ देखता और भेजता है, और अनुरोधों का जवाब देता है।",
 "Vê o andamento, sem os valores e sem alterar.": "प्रगति देखता है, राशियों के बिना और बिना बदलाव के।",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "चेक-इन और चेक-आउट देखता है और पूरी हुई सफ़ाई चिह्नित करता है, राशियों के बिना।",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "सब कुछ देखता है और खर्च, जगहें, यात्रा कार्यक्रम और सामान दर्ज करता है।",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "सब कुछ देखता है, जोड़ता है, संपादित करता है, टिप्पणी करता है और फ़ोटो डालता है। बस समूह में लोगों को जोड़ या हटा नहीं सकता।",
 "Vê tudo, inclusive os valores, sem alterar.": "राशियों सहित सब कुछ देखता है, बिना बदलाव के।",
 "Vídeo": "वीडियो",
 "Vínculo": "लिंक",
 "Vínculo perdido": "लिंक टूट गया",
 "WhatsApp da assistência": "सर्विस सेंटर का WhatsApp",
 "Whey": "व्हे प्रोटीन",
 "Wi-Fi (rede e senha)": "Wi-Fi (नेटवर्क और पासवर्ड)",
 "Yoga": "योग",
 "Zumbi e Consciência Negra": "Zumbi और अश्वेत चेतना दिवस",
 "Zzz": "Zzz",
 "a cada {n} dias": "हर {n} दिन",
 "a pagar": "देय",
 "a receber": "मिलना बाकी",
 "a receber {v}": "मिलना बाकी {v}",
 "a reserva": "बुकिंग",
 "a última execução falhou; avise o suporte": "पिछला रन विफल रहा; सहायता टीम को बताएँ",
 "abr": "अप्रैल",
 "abril": "अप्रैल",
 "acabou": "ख़त्म",
 "achatado": "फ़्लैट",
 "administra": "एडमिन",
 "ago": "अग",
 "agosto": "अगस्त",
 "ajustado": "समायोजित",
 "algo novo": "कुछ नया",
 "alterou": "ने बदला",
 "amanhã": "कल",
 "anual": "वार्षिक",
 "apagou": "ने हटाया",
 "aplicada em {d}": "{d} को लगाया",
 "app {v} · atualização {p} de {data}": "ऐप {v} · अपडेट {p}, {data}",
 "assinado": "हस्ताक्षरित",
 "atrasada": "देर से",
 "atrasada há {n} dia(s)": "{n} दिन से देरी",
 "até": "तक",
 "até {data}": "{data} तक",
 "até {d}": "{d} तक",
 "aula {a} de {n}": "पाठ {a} / {n}",
 "avisos silenciados": "सूचनाएँ म्यूट हैं",
 "caixa": "बॉक्स",
 "colher(es)": "चम्मच",
 "coluna": "कॉलम",
 "com anexos": "अटैचमेंट सहित",
 "com imagem": "इमेज सहित",
 "com tarjas": "पट्टी सहित",
 "com texto": "टेक्स्ट सहित",
 "com {p}": "{p} के पास",
 "como planejado": "योजना के अनुसार",
 "comprado em {data}": "{data} को ख़रीदा",
 "comprado em {d} por {v}": "{d} को {v} में ख़रीदा",
 "comprimido": "कंप्रेस्ड",
 "comprovante": "रसीद",
 "concha(s)": "कलछी",
 "confirmados": "पुष्टि",
 "consulta recusada": "जाँच अस्वीकार हुई",
 "contratado": "तय",
 "contínuo": "लगातार",
 "copo(s)": "गिलास",
 "corridos": "कैलेंडर दिवस",
 "criou o grupo": "ने ग्रुप बनाया",
 "de": "/",
 "de Anotações": "नोट्स से",
 "de {meta} passos": "{meta} कदमों में से",
 "de {n}": "/ {n}",
 "de {p}": "{p} से",
 "dentro / fora do planejado": "योजना के अनुसार / योजना से बाहर",
 "desconto {v}": "छूट {v}",
 "desfazer": "पूर्ववत करें",
 "destino": "गंतव्य",
 "deve {v}": "देना है {v}",
 "devolvido em {d}": "{d} को लौटाया",
 "dez": "दिस",
 "dezembro": "दिसंबर",
 "dia": "दिन",
 "dias": "दिन",
 "dias com a meta batida": "लक्ष्य पूरा हुए दिन",
 "dias com a meta de passos": "कदमों का लक्ष्य पूरा हुए दिन",
 "digital": "फ़िंगरप्रिंट",
 "diária média": "औसत प्रति रात किराया",
 "do cliente": "क्लाइंट से",
 "do escritório": "ऑफ़िस से",
 "dom": "रवि",
 "domingo": "रविवार",
 "e mais {n}": "और {n} अन्य",
 "em aberto": "लंबित",
 "em atraso": "देरी से",
 "em {n} dias": "{n} दिन में",
 "emitida": "जारी",
 "entregue": "जमा किया",
 "entrou no escritório": "ऑफ़िस में शामिल हुए",
 "enviado": "भेजा गया",
 "escaneado": "स्कैन",
 "escolha": "चुनें",
 "este": "यह वाला",
 "este dispositivo": "यह डिवाइस",
 "este item": "यह आइटम",
 "exercícios concluídos": "पूरे हुए व्यायाम",
 "falta {v}": "बाकी {v}",
 "faltam {km}": "{km} बाकी",
 "fatia(s)": "स्लाइस",
 "faturamento": "कुल आय",
 "feita em {d}": "{d} को किया",
 "feito {dur}": "{dur} पूरा",
 "fev": "फ़र",
 "fevereiro": "फ़रवरी",
 "frequência {p}%": "उपस्थिति {p}%",
 "gasto {v}": "ख़र्च {v}",
 "girado": "घुमाया गया",
 "guardado": "सहेजा गया",
 "higienizado": "साफ़ किया गया",
 "hoje": "आज",
 "hora fixa no dia": "दिन का तय समय",
 "há {n} dias": "{n} दिन पहले",
 "iPhone ou computador: {link}": "iPhone या कंप्यूटर: {link}",
 "incluiu": "ने जोड़ा",
 "jan": "जन",
 "janeiro": "जनवरी",
 "jul": "जुल",
 "julho": "जुलाई",
 "jun": "जून",
 "junho": "जून",
 "já importado": "पहले से इम्पोर्ट किया हुआ",
 "liberar em {d}": "{d} को खुलेगा",
 "ligou o compartilhamento": "ने साझाकरण चालू किया",
 "linha": "पंक्ति",
 "lucro líquido": "शुद्ध मुनाफ़ा",
 "mai": "मई",
 "maio": "मई",
 "mar": "मार्च",
 "marca d'água": "वॉटरमार्क",
 "marcada por {nome}": "{nome} द्वारा तय",
 "março": "मार्च",
 "menos de 1 ano": "1 साल से कम",
 "mensalidade": "मासिक फ़ीस",
 "meta batida!": "लक्ष्य पूरा!",
 "metadados": "मेटाडेटा",
 "min": "मिनट",
 "min antes": "मिनट पहले",
 "min antes do início": "मिनट शुरू होने से पहले",
 "min · {de} às {ate}": "मिनट · {de} से {ate}",
 "multa e juros {v}": "विलंब शुल्क और ब्याज {v}",
 "média {m}": "औसत {m}",
 "mês(es)": "महीने",
 "na nuvem": "क्लाउड में",
 "na pasta \"{pasta}\"": "\"{pasta}\" फ़ोल्डर",
 "na pasta escolhida": "चुने गए फ़ोल्डर में",
 "neste dispositivo": "इस डिवाइस",
 "neste celular": "इस फ़ोन पर",
 "no Planner": "Planner में",
 "no {nome}": "{nome}",
 "nos próximos dias": "अगले कुछ दिनों में",
 "nov": "नव",
 "novembro": "नवंबर",
 "numerado": "नंबर सहित",
 "nunca verificado": "कभी जाँचा नहीं गया",
 "não vão": "नहीं आएँगे",
 "o documento mudou depois disso: guarde de novo": "इसके बाद दस्तावेज़ बदल गया: फिर से सेव करें",
 "ocupação": "ऑक्यूपेंसी",
 "ontem": "कल",
 "organizado": "व्यवस्थित",
 "orçando": "कोटेशन जारी",
 "out": "अक्टू",
 "outubro": "अक्टूबर",
 "paga": "चुकाया",
 "paga em {d}": "{d} को चुकाई गई",
 "pago": "भुगतान हुआ",
 "pago em {d}": "{d} को भुगतान हुआ",
 "pago por {p}": "{p} ने भुगतान किया",
 "pagou {v}": "{v} चुकाया",
 "parcela {a} de {n}": "{n} में से किस्त {a}",
 "parece já lançado": "शायद पहले से दर्ज",
 "parte {n}": "भाग {n}",
 "passos por dia (média)": "रोज़ के कदम (औसत)",
 "passou {km}": "{km} ज़्यादा",
 "pausa {p}": "आराम {p}",
 "pausado": "रुका हुआ",
 "peso {n}": "भार {n}",
 "pesquisável": "खोजने योग्य",
 "por dia": "प्रति दिन",
 "por dia (média)": "प्रति दिन (औसत)",
 "por dia disponível": "प्रति उपलब्ध दिन",
 "por semana": "प्रति सप्ताह",
 "por {p}": "{p} द्वारा",
 "porção(ões)": "हिस्सा(से)",
 "preenchido": "भरा हुआ",
 "primeira às {hora}: {tarefa}": "पहला {hora} बजे: {tarefa}",
 "produção": "प्रोडक्शन",
 "próxima em {data}": "अगली बार {data} को",
 "próxima rega {d}": "अगली बार पानी {d}",
 "publicação": "प्रकाशन",
 "página de estudo": "अध्ययन पेज",
 "página única": "एक पेज",
 "páginas": "पेज",
 "páginas {p}": "पेज {p}",
 "qua": "बुध",
 "quarta": "बुधवार",
 "quarta-feira": "बुधवार",
 "qui": "गुरु",
 "quinta": "गुरुवार",
 "quinta-feira": "गुरुवार",
 "quitada": "चुकता",
 "recebe {v}": "पाना है {v}",
 "recebida": "प्राप्त",
 "reconhecimento facial": "चेहरा पहचान",
 "recortado": "काटा गया",
 "refeições feitas": "किए गए भोजन",
 "rega a cada {n} dias": "हर {n} दिन में पानी",
 "regar hoje": "आज पानी दें",
 "reparado": "ठीक किया गया",
 "retorno {d}": "फ़ॉलो-अप {d}",
 "saldo {v}": "शेष {v}",
 "seg": "सोम",
 "segunda": "सोमवार",
 "segunda-feira": "सोमवार",
 "sem anotações": "बिना एनोटेशन",
 "sem as páginas {p}": "पेज {p} के बिना",
 "sem cliente": "कोई क्लाइंट नहीं",
 "sem dias previstos": "कोई तय दिन नहीं",
 "sem horário": "कोई समय नहीं",
 "sem meta": "कोई लक्ष्य नहीं",
 "sem resposta": "कोई जवाब नहीं",
 "sem tempo": "कोई समय नहीं",
 "semana(s)": "हफ़्ते",
 "set": "सित",
 "setembro": "सितंबर",
 "seu@email.com": "aap@email.com",
 "sex": "शुक्र",
 "sexta": "शुक्रवार",
 "sexta-feira": "शुक्रवार",
 "sáb": "शनि",
 "sábado": "शनिवार",
 "talvez": "शायद",
 "tarefa da casa": "घर का काम",
 "tarefa: {t}": "कार्य: {t}",
 "taxas e despesas": "शुल्क और खर्च",
 "ter": "मंगल",
 "termina em {d}": "{d} को ख़त्म",
 "terça": "मंगलवार",
 "terça-feira": "मंगलवार",
 "teste": "टेस्ट",
 "todas": "सभी",
 "todo ano em {d}": "हर साल {d} को",
 "todo dia {d}": "हर महीने {d} तारीख को",
 "todos": "सभी",
 "toque para abrir": "खोलने के लिए टैप करें",
 "toque para pausar": "रोकने के लिए टैप करें",
 "toque para ver o contato": "संपर्क देखने के लिए टैप करें",
 "toque para voltar a hoje": "आज पर लौटने के लिए टैप करें",
 "treinos concluídos": "पूरे हुए वर्कआउट",
 "uma vez em {d}": "एक बार, {d} को",
 "unidade(s)": "नग",
 "vale {n}": "{n} अंक का",
 "vence em {n} dias": "{n} दिन में देय",
 "vence {d}": "देय {d}",
 "venceu em {data}": "{data} को समाप्त हुआ",
 "vencido": "समय निकल गया",
 "vendido com ganho de {v}": "{v} के लाभ पर बेचा",
 "vendido com perda de {v}": "{v} के नुकसान पर बेचा",
 "verificado {quando}": "जाँचा गया {quando}",
 "você": "आप",
 "você administra": "आप एडमिन हैं",
 "xícara(s)": "कप",
 "{aba} bloqueada": "{aba} लॉक है",
 "{aba} está bloqueada": "{aba} लॉक है",
 "{aba}, em \"Anotações recebidas\"": "{aba}, \"प्राप्त नोट्स\" में",
 "{a} aula(s) feita(s)": "{a} पाठ पूरे",
 "{a} de {n} aulas": "{n} में से {a} पाठ",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} बजट के {p}% तक पहुँच गया ({l} में से {g})।",
 "{c} confirmados de {n} convidados": "{n} मेहमानों में से {c} की पुष्टि",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} इस महीने के बजट के {p}% पर है। महीना ख़त्म होने में अभी {dias} दिन बाकी हैं।",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} पिछले पूरे महीने से {v} ज़्यादा हो चुका है। देखें कि कहीं कुछ असामान्य तो नहीं।",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} बजट से पार हो चुका है: {l} में से {g}। महीना बदलने तक यह खर्च रोकें।",
 "{c} passou do orçamento: {g} de {l}.": "{c} बजट से पार: {l} में से {g}।",
 "{de} paga {v} para {para}": "{de}, {para} को {v} देंगे",
 "{de} às {ate}": "{de} से {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia}, {d} {mes} {a}",
 "{dia}, {d} {mes}": "{dia}, {d} {mes}",
 "{dia}, {d}/{m}": "{dia}, {d}/{m}",
 "{dur} na semana": "सप्ताह में {dur}",
 "{dur} registrados": "{dur} दर्ज",
 "{d}/{n} notas": "{d}/{n} अंक",
 "{feito} de {meta}": "{meta} में से {feito}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{n} में से {f} हो गए",
 "{f}/{n} transferências feitas": "{f}/{n} ट्रांसफ़र हो गए",
 "{hora} em {fuso}": "{fuso} में {hora}",
 "{h} este mês": "इस महीने {h}",
 "{h} h": "{h} घं",
 "{h} h {m} min": "{h} घं {m} मिनट",
 "{h} no seu relógio": "आपकी घड़ी में {h}",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} जुड़ गया। आपके खाते में {n} मॉडल उपलब्ध हैं।",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: API कुंजी अमान्य है या अनुमति नहीं है।",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: उपयोग की सीमा पूरी हो गई। अपने API खाते का बैलेंस या सीमा जाँचें।",
 "{item}: em {n} dias ({data}).": "{item}: {n} दिन में ({data})।",
 "{item}: hoje ({data}).": "{item}: आज ({data})।",
 "{item}: termina em {n} dias ({data}).": "{item}: {n} दिन में समाप्त ({data})।",
 "{item}: vence em {n} dias ({data}).": "{item}: {n} दिन में समाप्त ({data})।",
 "{item}: vence hoje ({data}).": "{item}: आज समाप्त ({data})।",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: {data} को देय था और अभी तक पूरा चिह्नित नहीं हुआ।",
 "{livre} livres de {total}": "{total} में से {livre} खाली",
 "{m} min": "{m} मिनट",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} अब आपके दोस्त हैं। आप चैट कर सकते हैं।",
 "{nome} conectado!": "{nome} कनेक्ट हो गया!",
 "{nome} ligou": "{nome} ने कॉल किया",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "{novas} नए, {atualizadas} अपडेट हुए, {enviadas} भेजे गए, {removidas} हटाए गए",
 "{n} ITEM(NS)": "{n} आइटम",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "आपके प्लान में {n} टैब · हर एक के रंग और विकल्प",
 "{n} aba(s) para comprar": "खरीदने के लिए {n} टैब",
 "{n} adicionada(s)": "{n} जोड़े गए",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "आने वाले दिनों के लिए इस मोबाइल पर {n} अलर्ट शेड्यूल किए गए हैं।",
 "{n} aluno(s)": "{n} छात्र",
 "{n} anexo(s)": "{n} अटैचमेंट",
 "{n} ano(s)": "{n} वर्ष",
 "{n} arquivo(s)": "{n} फ़ाइलें",
 "{n} atendimento(s)": "{n} अपॉइंटमेंट",
 "{n} atrasada(s)": "{n} देरी से",
 "{n} atrasado(s)": "{n} देर से",
 "{n} caixa(s)": "{n} बॉक्स",
 "{n} caixa(s) frágil(eis)": "{n} नाज़ुक बॉक्स",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} बॉक्स · {a} नए घर में खोले गए",
 "{n} cancelada(s).": "{n} रद्द किए गए।",
 "{n} cartão(ões) abertos": "{n} खुले कार्ड",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{d} की देय तारीख वाले {n} शुल्क बनाए गए।",
 "{n} com vencimento": "{n} नियत तारीख वाले",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "कार्ड {c} में {n} खरीदारी। आगे की किस्तें अगले कार्ड बिलों में दिख रही हैं।",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n} बिल अपने-आप भुगतान हुए चिह्नित किए गए।",
 "{n} copo(s), {ml} de {meta}": "{n} गिलास, {meta} में से {ml}",
 "{n} de {meta} copos": "{meta} में से {n} गिलास",
 "{n} de {total}": "{total} में से {n}",
 "{n} de {total} dias": "{total} में से {n} दिन",
 "{n} de {total} hoje": "आज {total} में से {n}",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "वित्त में पढ़ी गई रसीदों से, {t} में से {n} आइटम की कीमत मिली।",
 "{n} dia(s)": "{n} दिन",
 "{n} dia(s) seguido(s) lendo": "लगातार {n} दिन से पढ़ रहे हैं",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "दोहराए जाने वाले कार्यों से {n} दिन हटाए गए",
 "{n} dias": "{n} दिन",
 "{n} dias grátis": "{n} दिन मुफ़्त",
 "{n} dias grátis para testar": "आज़माने के लिए {n} दिन मुफ़्त",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} दिन ({tipo}): {pub} को प्रकाशित, गिनती {ini} से, {fim} को समाप्त।",
 "{n} documento(s)": "{n} दस्तावेज़",
 "{n} em atraso": "{n} बकाया",
 "{n} etapa(s) atrasada(s)": "{n} चरण देर से",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n} हटाए गए आइटम फ़ोन के सिंक होने का इंतज़ार कर रहे हैं।",
 "{n} falta(s)": "{n} अनुपस्थिति",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "समूह में {n} रिकॉर्ड। सदस्य में हर व्यक्ति की भूमिका चुनें।",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "समूह के सभी लोगों की यात्रा की {n} फ़ोटो और वीडियो। यात्रा कार्यक्रम, जगहों और बुकिंग की फ़ोटो भी यहाँ दिखती हैं।",
 "{n} item(ns) adicionado(s).": "{n} आइटम जोड़े गए।",
 "{n} item(ns) com outras pessoas": "{n} चीज़ें दूसरों के पास",
 "{n} item(ns) no Planner.": "Planner में {n} आइटम।",
 "{n} lançamento(s) encontrado(s)": "{n} प्रविष्टि(याँ) मिलीं",
 "{n} lançamento(s) novo(s).": "{n} नई प्रविष्टि(याँ)।",
 "{n} lembrete(s) colocado(s) no My Planner.": "My Planner में {n} रिमाइंडर जोड़े गए।",
 "{n} livro(s) lido(s) este ano": "इस साल {n} किताबें पढ़ीं",
 "{n} marcado(s)": "{n} चुने गए",
 "{n} matéria(s)": "{n} विषय",
 "{n} membro(s) · abrir a conversa do grupo": "{n} सदस्य · ग्रुप चैट खोलें",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "खाता बनाने से {n} महीने मुफ़्त; फिर {preco} प्रति वर्ष।",
 "{n} min": "{n} मिनट",
 "{n} min antes": "{n} मिनट पहले",
 "{n} módulo(s)": "{n} मॉड्यूल",
 "{n} noite(s)": "{n} रात",
 "{n} nota(s) nova(s).": "{n} नए इनवॉइस।",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "इस डिवाइस पर XML के बिना {n} इनवॉइस शामिल नहीं किए गए।",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} इनवॉइस · जारी {e} · प्राप्त {r}",
 "{n} nova(s)": "{n} नए",
 "{n} novo(s) do cliente": "क्लाइंट से {n} नए",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} नए: स्वीकारें, संपादित करें या अस्वीकारें।",
 "{n} parcela(s) colocada(s) no My Planner.": "{n} किस्तें My Planner में डाली गईं।",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "{n} बाकी किस्तें फिर से बनाई गईं। चुकाई गई किस्तें वैसी ही रहीं।",
 "{n} parcela(s) em atraso": "{n} किस्तें बकाया",
 "{n} parcela(s) em atraso: {v}": "{n} किस्तें बकाया: {v}",
 "{n} participantes · toque para ver": "{n} प्रतिभागी · देखने के लिए टैप करें",
 "{n} passo(s)": "{n} चरण",
 "{n} pausa(s)": "{n} ब्रेक",
 "{n} pedido(s) de amizade": "{n} दोस्ती अनुरोध",
 "{n} pedido(s) em aberto": "{n} खुले अनुरोध",
 "{n} pessoa(s)": "{n} व्यक्ति",
 "{n} pessoa(s) já entraram com o seu código.": "{n} लोग आपके कोड से जुड़ चुके हैं।",
 "{n} pessoas": "{n} लोग",
 "{n} por folha": "प्रति शीट {n}",
 "{n} porções": "{n} सर्विंग",
 "{n} publicação(ões) nova(s).": "{n} नए प्रकाशन।",
 "{n} publicações novas": "{n} नए प्रकाशन",
 "{n} página(s)": "{n} पेज",
 "{n} página(s) · {r} revisada(s)": "{n} पेज · {r} दोहराए गए",
 "{n} páginas": "{n} पेज",
 "{n} recebido(s) dos seus grupos": "आपके समूहों से {n} प्राप्त",
 "{n} recebido(s) para responder": "जवाब के लिए {n} प्राप्त",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} भोजन, उस दिन के मेनू के साथ",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n} नई या बदली गई बुकिंग।",
 "{n} resultado(s) em todas as publicações": "सभी प्रकाशनों में {n} परिणाम",
 "{n} selecionado(s): {lista}": "{n} चयनित: {lista}",
 "{n} tarefa(s)": "{n} कार्य",
 "{n} tarefa(s) apagada(s) por inteiro": "{n} कार्य पूरी तरह हटाए गए",
 "{n} tarefa(s) criada(s)": "{n} कार्य बनाए गए",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n} घर के काम My Planner से हट गए हैं और अब सिर्फ़ मेरा घर में हैं। किसी एक को Planner में लाने के लिए कार्य खोलें और \"My Planner में भेजें\" पर टैप करें।",
 "{n} tarefa(s) de ontem sem concluir": "कल के {n} कार्य अधूरे",
 "{n} tarefa(s) dos últimos dias sem concluir": "पिछले दिनों के {n} कार्य अधूरे",
 "{n} tarefa(s) hoje": "आज {n} कार्य",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n} बाकी कार्य आज की सूची में चले जाएँगे।",
 "{n} tarjas no documento": "दस्तावेज़ में {n} काली पट्टियाँ",
 "{n} treino(s), cada um nos dias dele": "{n} वर्कआउट, हर एक अपने दिनों में",
 "{n} tribunais": "{n} न्यायालय",
 "{n}x de {v}": "{n}x {v}",
 "{n}º alerta": "{n}वाँ अलर्ट",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} भेजी गई(ं), {falhas} में त्रुटि। बाद में फिर कोशिश करें।",
 "{ok} enviado(s).": "{ok} भेजी गई(ं)।",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{d} में से {o} रातें भरी हुईं। एक महीने से दूसरे में जाने वाली बुकिंग रातों के हिसाब से बाँटी जाती हैं।",
 "{preco} por ano": "{preco} प्रति वर्ष",
 "{p} de {t} parcelas pagas ({pct}%)": "{t} में से {p} किस्तें चुकाई गईं ({pct}%)",
 "{p} presentes · {f} faltas": "{p} उपस्थित · {f} अनुपस्थित",
 "{p}% da meta de {m} páginas": "{m} पेज के लक्ष्य का {p}%",
 "{p}% feito": "{p}% हो गया",
 "{p}% ocupado no mês": "महीने में {p}% भरा",
 "{p}% pronta": "{p}% तैयार",
 "{p}/{t} pagas": "{p}/{t} चुकाई गईं",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} ने आपको My Planner में समूह \"{grupo}\" में आमंत्रित किया है। जुड़ने के लिए लिंक पर टैप करें (ऐप शुरू करने के लिए मुफ़्त है): {link}\nआमंत्रण कोड: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} और अन्य लोगों ने समूह में {n} आइटम जोड़े।",
 "{quem} incluiu {item} no grupo.": "{quem} ने समूह में {item} जोड़ा।",
 "{servico} do veículo": "वाहन की {servico}",
 "{s} de {a}": "{a} में से {s}",
 "{tarefa}: volte às {hora}": "{tarefa}: {hora} बजे वापस आएँ",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (प्रति)",
 "{uso} usados de {total} reservados para o site": "साइट के लिए आरक्षित {total} में से {uso} इस्तेमाल हुए",
 "{v} · atualização de {data}": "{v} · {data} का अपडेट",
 "{v}/hora": "{v}/घंटा",
 "À direita": "दाईं ओर",
 "À vista": "एकमुश्त",
 "Às": "समय",
 "Às {hora}": "{hora} बजे",
 "ÁGUA": "पानी",
 "Ácido": "अम्लीय",
 "Água": "पानी",
 "Água hoje": "आज का पानी",
 "Área externa": "बाहरी क्षेत्र",
 "Áreas": "क्षेत्र",
 "Áudio": "ऑडियो",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "यह केवल एक सहायता है और आधिकारिक माध्यमों पर न्यायिक सूचनाओं की निगरानी का विकल्प नहीं है। समय-सीमाएँ आधिकारिक प्रणाली में जाँचनी चाहिए।",
 "Ética Profissional": "व्यावसायिक नैतिकता",
 "Ícone e aba": "आइकन और टैब",
 "Óculos de sol": "धूप का चश्मा",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "जारीकर्ता (जैसे: DETRAN-MS, संघीय पुलिस)",
 "Órgão emissor: {nome}": "जारीकर्ता: {nome}",
 "Ômega 3": "ओमेगा 3",
 "Última": "आख़िरी",
 "Última adubação": "आख़िरी खाद",
 "Última aplicação": "आख़िरी खुराक",
 "Última busca do servidor para você: {quando}": "आपके लिए सर्वर की आख़िरी खोज: {quando}",
 "Última cópia de segurança: {data}": "पिछला बैकअप: {data}",
 "Última rega": "आख़िरी बार पानी",
 "Última sincronização: {quando}": "पिछला सिंक: {quando}",
 "Última: {data}": "अंतिम: {data}",
 "Último dia para entregar a declaração do IR": "आयकर रिटर्न भरने का आख़िरी दिन",
 "Último erro: {m}": "पिछली त्रुटि: {m}",
 "Últimos 30 dias": "पिछले 30 दिन",
 "Últimos 7 dias": "पिछले 7 दिन",
 "íris": "आइरिस",
 "última vez em {data}": "पिछली बार {data} को",
 "último em {d}": "आख़िरी: {d}",
 "úteis": "कार्य दिवस",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ My Planner का रंग है। यह चुनाव इस डिवाइस और आपके खाते की सभी चैट पर लागू होता है।",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} कॉल कर रहे हैं (वीडियो)",
 "📆 Conectar a agenda deste celular": "📆 इस फ़ोन का कैलेंडर जोड़ें",
 "📞 {nome} está ligando (áudio)": "📞 {nome} कॉल कर रहे हैं (ऑडियो)",
 "Link bloqueado por segurança.": "सुरक्षा के लिए लिंक रोका गया।",
 "Este arquivo não é uma imagem válida.": "यह फ़ाइल मान्य चित्र नहीं है।",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "सर्वर की स्वचालित खोज पहले 5 प्रोफ़ाइल देखती है। बाकी तब जाँचे जाते हैं जब आप \"अभी जाँचें\" पर टैप करते हैं।",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "यह स्क्रीन यात्रा की टाइमलाइन दिखाती है, जिसमें वे गतिविधियाँ और जगहें हैं जिनका दिन तय है। किसी जगह की पूरी जानकारी जोड़ने या बदलने के लिए जगहें टैब इस्तेमाल करें।",
 "Para a viagem {d}": "यात्रा {d} के लिए",
 "sem nome": "बिना नाम",
 "Foi para a viagem {d}.": "यात्रा {d} में ले जाया गया।",
 "Orçamento total (se não for detalhar)": "कुल बजट (अगर विवरण नहीं देना है)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "दिन-ब-दिन यात्रा कार्यक्रम बनाएँ। जिन जगहों का दिन तय है, वे अपने आप यहाँ आ जाती हैं। यात्रा के दौरान, यात्रा कार्यक्रम My Planner की टाइमलाइन में दिखता है।",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "जगह में दिन और समय तय करें ताकि वह अपने आप यात्रा कार्यक्रम में दिखे।",
 "No roteiro": "यात्रा कार्यक्रम में",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "\"{nome}\" {data} के यात्रा कार्यक्रम में है। दिन या समय बदलने के लिए जगह को संपादित करें।",
 "Para o roteiro desta viagem": "इस यात्रा के कार्यक्रम के लिए",
 "Orçamento e gastos": "बजट और ख़र्चे",
 "Parada (cidade)": "पड़ाव (शहर)",
 "Item da categoria": "श्रेणी की मद",
 "Orçamento da viagem inteira": "पूरी यात्रा का बजट",
 "Orçamento geral da viagem": "यात्रा का कुल बजट",
 "Previsto {p} · gasto {g}": "अनुमानित {p} · खर्च {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "यहाँ यात्रा के वे ख़र्चे रहते हैं जो किसी पड़ाव के नहीं हैं (उदा.: टिकट, बीमा)। हर पड़ाव का अपना बजट होता है।",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "हर श्रेणी में कितना ख़र्च करना चाहते हैं, यह भरें। ख़र्चे दर्ज करने पर ऐप दिखाता है कि कितना इस्तेमाल हो चुका है।",
 "Orçamento por parada": "हर पड़ाव का बजट",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "एक से ज़्यादा शहर जाएँगे? पड़ाव जोड़ें (पड़ाव टैब): हर एक को अपना बजट मिलता है और उन तारीख़ों के ख़र्चे अपने आप उसमें जुड़ जाते हैं।",
 "Coloque o valor do gasto.": "ख़र्च की राशि भरें।",
 "Orçamento de {c}": "{c} का बजट",
 "Lançar um gasto nesta parada": "इस पड़ाव में ख़र्च दर्ज करें",
 "Lançar gasto": "ख़र्च दर्ज करें",
 "Orçamento e gastos da parada": "पड़ाव का बजट और ख़र्चे",
 "Gastos lançados ({n})": "दर्ज ख़र्चे ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "किसी ख़र्च को ठीक करने या हटाने के लिए यात्रा का बजट और ख़र्चे टैब इस्तेमाल करें।",
 "Paradas": "पड़ाव",
 "Cidade ou lugar": "शहर या जगह",
 "Ex.: Porto": "उदा.: पोर्टो",
 "Chegada": "पहुँचना",
 "Saída": "रवाना होना",
 "Onde vai ficar": "कहाँ ठहरेंगे",
 "gasto {g} de {p}": "{p} में से {g} खर्च",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "एक से ज़्यादा शहर जाएँगे? हर पड़ाव को तारीख़ों के साथ जोड़ें। हर एक को अपना बजट मिलता है (ठहरना, खाना, परिवहन...) और उन तारीख़ों के ख़र्चे अपने आप उसमें जुड़ जाते हैं।",
 "Café da tarde": "शाम की चाय",
 "Outros / Lanches": "अन्य / नाश्ता",
 "Gasto {v}": "खर्च {v}",
 "Gasto {g} de {p} · {a} acima": "{p} में से {g} खर्च · {a} ज़्यादा",
 "Gasto {g} de {p}": "{p} में से {g} खर्च",
 "Tirar \"{nome}\" do orçamento?": "\"{nome}\" को बजट से हटाएँ?",
 "Os gastos já lançados nela continuam na lista de gastos.": "इसमें पहले से दर्ज ख़र्चे ख़र्चों की सूची में बने रहेंगे।",
 "Previsto para {nome}": "{nome} के लिए अनुमानित",
 "Tirar {nome}": "{nome} हटाएँ",
 "Nome do item (ex.: Jantar especial)": "मद का नाम (उदा.: ख़ास डिनर)",
 "Adicionar item": "मद जोड़ें",
 "Detalhar em itens": "मदों में बाँटें",
 "Nova categoria (ex.: Seguro, Presentes)": "नई श्रेणी (उदा.: बीमा, उपहार)",
 "Voltar às categorias sugeridas?": "सुझाई गई श्रेणियों पर वापस जाएँ?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "इस सूची की अनुमानित राशियाँ मिट जाएँगी। दर्ज ख़र्चे बने रहेंगे।",
 "Voltar às categorias sugeridas": "सुझाई गई श्रेणियों पर वापस जाएँ",
 "Previsto": "अनुमानित",
 "Ainda pode gastar": "अभी ख़र्च कर सकते हैं",
 "Passou do previsto": "अनुमान से ज़्यादा",
 "Não foi possível buscar o câmbio": "विनिमय दर नहीं मिल सकी",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "इंटरनेट नहीं है या {m} तालिका में नहीं है। यात्रा संपादित करें और दर खुद भरें।",
 "Câmbio de {m} ainda não definido": "{m} की विनिमय दर अभी तय नहीं",
 "Câmbio de hoje": "आज की दर",
 "Atualizado em {d}": "{d} को अपडेट किया गया",
 "Valor em {m}": "{m} में राशि",
 "Moeda do destino": "गंतव्य की मुद्रा",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "विनिमय दर: गंतव्य मुद्रा की 1 इकाई आपकी मुद्रा में कितनी है",
 "Sem dia marcado": "कोई दिन तय नहीं",
 "Valor na moeda do destino": "गंतव्य मुद्रा में राशि",
 "Tirar só desta lista ou excluir de vez?": "सिर्फ़ इस सूची से हटाएँ या हमेशा के लिए मिटाएँ?",
 "Excluir de vez": "हमेशा के लिए मिटाएँ",
 "Relatório da viagem (PDF)": "यात्रा रिपोर्ट (PDF)",
 "Planilha da viagem (Excel)": "यात्रा स्प्रेडशीट (Excel)",
 "Geral da viagem": "पूरी यात्रा",
 "Viagem {d}": "यात्रा {d}",
 "Quem vai: {p}": "कौन जा रहा है: {p}",
 "Outros gastos": "अन्य ख़र्चे",
 "Orçamento · {n}": "बजट · {n}",
 "Código": "कोड",
 "Pagou": "किसने भुगतान किया",
 "Permissão internacional para dirigir": "अंतरराष्ट्रीय ड्राइविंग परमिट",
 "Vacina (certificado)": "वैक्सीन (प्रमाणपत्र)",
 "Autorização de viagem de menor": "नाबालिग की यात्रा अनुमति",
 "Vence antes da volta": "वापसी से पहले समाप्त",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "वापसी के 6 महीने से कम बाद समाप्त (कई देश स्वीकार नहीं करते)",
 "A lista básica já está aqui.": "बुनियादी सूची पहले से यहाँ है।",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} दस्तावेज़ जिनकी वैधता यात्रा में बाधा बन सकती है",
 "Lista básica: passaporte de cada um e seguro viagem": "बुनियादी सूची: हर व्यक्ति का पासपोर्ट और यात्रा बीमा",
 "Lista básica: identidade de cada um": "बुनियादी सूची: हर व्यक्ति का पहचान पत्र",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "हर दस्तावेज़ की वैधता डालें: ऐप समाप्त होने से पहले सूचना देता है और जाँचता है कि पासपोर्ट वापसी के 6 महीने बाद तक वैध है या नहीं। दस्तावेज़ों की फ़ोटो वॉल्ट में सुरक्षित रहती हैं।",
 "De quem": "किसका",
 "Número (protegido no cofre)": "नंबर (वॉल्ट में सुरक्षित)",
 "Está em mãos": "हाथ में है",
 "Válido até {d}": "{d} तक वैध",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "पासपोर्ट, वीज़ा, यात्रा बीमा, वैक्सीन, नाबालिग अनुमति... वैधता और फ़ोटो के साथ। हाथ में आने पर चिह्नित करें।",
 "acerto entre os viajantes (não entra no orçamento)": "यात्रियों के बीच हिसाब (बजट में नहीं)",
 "Só gastos": "सिर्फ़ ख़र्चे",
 "Acertos": "हिसाब",
 "Marcar como pago?": "भुगतान हुआ मार्क करें?",
 "{de} já pagou {v} para {para}?": "क्या {de} ने {para} को {v} दे दिए?",
 "Já pagou": "दे दिए",
 "Acerto: {de} pagou {para}": "हिसाब: {de} ने {para} को दिया",
 "Conferir minhas assinaturas": "मेरी सदस्यताएँ जाँचें",
 "Gerenciar ou cancelar assinaturas na loja": "स्टोर में सदस्यताएँ प्रबंधित या रद्द करें",
 "Restaurar compras": "खरीदारी बहाल करें",
 "Procurando...": "खोज रहे हैं...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n} सदस्यता मिली और अनलॉक हुई।",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "वार्षिक सदस्यता, अपने आप नवीनीकृत होती है। नवीनीकरण से 24 घंटे पहले तक स्टोर की सदस्यताओं में कभी भी रद्द करें।",
 "Assinaturas da loja": "स्टोर सदस्यताएँ",
 "Gerenciar assinaturas (App Store)": "सदस्यताएँ प्रबंधित करें (App Store)",
 "Gerenciar assinaturas (Google Play)": "सदस्यताएँ प्रबंधित करें (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "सदस्यता फ़ोन ऐप में ली जाती है (Google Play या App Store) और यहाँ वेबसाइट पर भी चलती है।",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "यह सदस्यता अभी स्टोर में उपलब्ध नहीं है। बाद में फिर कोशिश करें।",
 "Assinatura feita": "सदस्यता हो गई",
 "Já assinei no celular: conferir": "मैंने फ़ोन पर पहले ही सदस्यता ले ली: जाँचें",
 "Nenhuma assinatura encontrada nesta conta da loja.": "इस स्टोर खाते में कोई सदस्यता नहीं मिली।",
 "Confira a internet e tente de novo. Nada foi cobrado.": "इंटरनेट जाँचें और फिर कोशिश करें। कुछ भी नहीं काटा गया।",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} अनलॉक हुआ। आपके दूसरे डिवाइस और वेबसाइट पर भी चलता है।",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "सदस्यता लेने के लिए Google Play या App Store से My Planner अपडेट करें।",
 "Assinada, renova em {data}": "सदस्य, {data} को नवीनीकरण",
 "Não deu para assinar agora": "अभी सदस्यता नहीं हो सकी",
 "Assinar por {preco} por ano": "{preco} प्रति वर्ष में सदस्यता लें",
 "\"{nome}\" foi para o Mural, em Conquistas.": "\"{nome}\" मूरल में, उपलब्धियों में चला गया।",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "\"{nome}\" अब आपकी दिनचर्या का हिस्सा है। यह मूरल में, उपलब्धियों में चला गया।",
 "\"{nome}\" voltou para o lugar.": "\"{nome}\" अपनी जगह पर वापस आ गया।",
 "1 ano": "1 साल",
 "1 mês": "1 महीना",
 "A IA não achou o valor no comprovante.": "AI को रसीद में राशि नहीं मिली।",
 "A cada {n} dias": "हर {n} दिन में",
 "A carta está vazia": "पत्र खाली है",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "पत्र {d} तक लॉक रहता है। तब तक इसे दोबारा पढ़ा या संपादित नहीं किया जा सकता। कुछ बदलना हो तो एक और पत्र लिखें।",
 "A lixeira está vazia.": "ट्रैश खाली है।",
 "A mesma do app e do celular": "ऐप और फ़ोन वाला ही",
 "A mesma forma de desbloqueio do app e do celular": "ऐप और फ़ोन वाला ही अनलॉक तरीका",
 "A senha do diário precisa ter 6 caracteres ou mais.": "डायरी का पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।",
 "A senha precisa ter 6 caracteres ou mais.": "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।",
 "A turma ainda não tem grupo": "कक्षा का अभी कोई समूह नहीं है",
 "AS 4 BOLINHAS DE COR": "4 रंगीन बिंदु",
 "Aberta em {d}": "{d} को खोला गया",
 "Abra a aba para poder restaurar": "रीस्टोर करने के लिए टैब खोलें",
 "Abra o diário primeiro": "पहले डायरी खोलें",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "बायोमेट्रिक, फ़ेस रिकग्निशन या ऐप के पासवर्ड से खुलती है। डायरी का पासवर्ड हर डिवाइस पर सिर्फ़ पहली बार पूछा जाता है।",
 "Abre em {d}": "{d} को खुलेगा",
 "Abrir carta para o futuro": "भविष्य का पत्र खोलें",
 "Abrir em {aba}": "{aba} में खोलें",
 "Abrir o Diário": "डायरी खोलें",
 "Abrir o diário": "डायरी खोलें",
 "Abrir {aba}": "{aba} खोलें",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "बिना कुछ बदले संपत्ति, बुकिंग, ऑक्युपेंसी, खर्च और मुनाफ़ा देखता है।",
 "Adicionar foto": "फ़ोटो जोड़ें",
 "Apaga tudo o que está no quadro desta página.": "इस पेज के बोर्ड पर मौजूद सब कुछ मिटा देता है।",
 "Apagar o desenho?": "ड्रॉइंग मिटाएँ?",
 "Apagar o diário": "डायरी मिटाएँ",
 "Apagar para todos?": "सबके लिए मिटाएँ?",
 "Aplicar a todas as páginas desta matéria": "इस विषय के सभी पेजों पर लागू करें",
 "Aplicar a todas as páginas desta pasta": "इस फ़ोल्डर के सभी पेजों पर लागू करें",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "हैंडआउट, अभ्यास सूची, स्लाइड, वीडियो, लिंक और सूचनाएँ। ⋮ › कक्षा को भेजें से हर छात्र को यह अपने ऐप में मिलता है।",
 "Aquarela": "वॉटरकलर",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "यहाँ बिना किसी शुल्क के वह दिखता है जो समूहों ने आपके साथ साझा किया है। अपने डेटा के साथ टैब इस्तेमाल करने के लिए टैब की सदस्यता लें।",
 "Arquivados": "संग्रहीत",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "हटाने के लिए दाईं ओर, संग्रहीत करने के लिए बाईं ओर खींचें।",
 "As cobranças desta aula extra já existem.": "इस अतिरिक्त कक्षा के शुल्क पहले से मौजूद हैं।",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "अंक सिर्फ़ हर छात्र को ही जाते हैं। इसके लिए समूह में व्यक्ति का नाम पंजीकरण में छात्र या अभिभावक के नाम जैसा ही होना चाहिए।",
 "Atestado": "मेडिकल प्रमाणपत्र",
 "Atestados": "मेडिकल प्रमाणपत्र",
 "Até quando (opcional)": "कब तक (वैकल्पिक)",
 "Até {d}": "{d} तक",
 "Aula extra": "अतिरिक्त कक्षा",
 "Aula extra (fora dos dias de aula)": "अतिरिक्त कक्षा (कक्षा के दिनों के अलावा)",
 "Aula extra de {d}": "{d} की अतिरिक्त कक्षा",
 "Avaliação de {d}": "{d} का मूल्यांकन",
 "Avaliação salva": "मूल्यांकन सेव हुआ",
 "Avançar": "आगे बढ़ें",
 "Aviso da revisão do mês": "महीने की समीक्षा की सूचना",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "महीने के आखिरी दिन सूचना: \"क्यों न अपने महीने की समीक्षा करें? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "डायरी की किसी सामग्री के बिना सूचना: \"आपका दिन कैसा रहा? ✍️\"",
 "Avulsa": "एकल",
 "Avulsas": "एकल",
 "Azul": "नीला",
 "Baixar na App Store": "App Store से डाउनलोड करें",
 "Baixar na Google Play": "Google Play से डाउनलोड करें",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "स्टोर से My Planner डाउनलोड करें: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "बायोमेट्रिक, फ़ेस रिकग्निशन या ऐप का पासवर्ड। डायरी का पासवर्ड हर डिवाइस पर पहली बार के लिए सेव रहता है।",
 "Branco": "सफ़ेद",
 "Buscando o clima…": "मौसम खोजा जा रहा है…",
 "Básicas": "बुनियादी",
 "COMO ESTOU": "मैं कैसा/कैसी हूँ",
 "COMO O DIÁRIO ABRE": "डायरी कैसे खुलती है",
 "COR DA FOLHA": "शीट का रंग",
 "Caixinha no My Planner": "My Planner में गुल्लक",
 "Caixinha {m}": "गुल्लक {m}",
 "Carta de {d}": "{d} का पत्र",
 "Carta guardada": "पत्र सुरक्षित रखा गया",
 "Carta para o futuro": "भविष्य के लिए पत्र",
 "Carta trancada": "लॉक पत्र",
 "Cartas abertas podem ser lidas, mas não editadas.": "खोले गए पत्र पढ़े जा सकते हैं, पर संपादित नहीं किए जा सकते।",
 "Cartas para o Futuro": "भविष्य के लिए पत्र",
 "Cartões arquivados": "संग्रहीत कार्ड",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "{tempo} पहले की {nome} का एक पत्र आया है 💌",
 "Chegou! Toque para abrir 💌": "आ गया! खोलने के लिए टैप करें 💌",
 "Cinza-escuro": "गहरा स्लेटी",
 "Clara (segue o tema)": "हल्की (थीम के अनुसार)",
 "Claras e pastel (boas para folha escura)": "हल्के और पेस्टल (गहरी शीट के लिए अच्छे)",
 "Clima (toque para preencher)": "मौसम (भरने के लिए टैप करें)",
 "Clima automático": "स्वचालित मौसम",
 "Clima do dia": "आज का मौसम",
 "Cobrar a aula extra": "अतिरिक्त कक्षा का शुल्क लें",
 "Cobrar a aula extra dos presentes": "उपस्थित छात्रों से अतिरिक्त कक्षा का शुल्क लें",
 "Cobrar a turma toda": "पूरी कक्षा से शुल्क लें",
 "Cole um link que comece com https://": "https:// से शुरू होने वाला लिंक पेस्ट करें",
 "Coloque o valor da aula extra na turma (Editar).": "कक्षा (संपादित करें) में अतिरिक्त कक्षा की राशि डालें।",
 "Coloque o valor.": "राशि डालें।",
 "Colunas": "कॉलम",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "आपका AI चालू होने पर (सेटिंग्स › आर्टिफ़िशियल इंटेलिजेंस), ऐप फ़ोटो से राशि, तारीख और विवरण पढ़ लेता है।",
 "Como cuidei de mim hoje?": "आज मैंने अपना ख्याल कैसे रखा?",
 "Como foi o seu dia? ✍️": "आपका दिन कैसा रहा? ✍️",
 "Compartilhar este projeto (convidar)": "यह प्रोजेक्ट साझा करें (आमंत्रित करें)",
 "Compartilhar o texto": "टेक्स्ट साझा करें",
 "Completa": "पूरा",
 "Comprovante (foto, PDF ou print)": "रसीद (फ़ोटो, PDF या स्क्रीनशॉट)",
 "Comprovante anexado": "रसीद संलग्न है",
 "Comprovante de pagamento (foto ou PDF)": "भुगतान की रसीद (फ़ोटो या PDF)",
 "Concluído: hábito formado": "पूरा हुआ: आदत बन गई",
 "Concluídos": "पूरे हुए",
 "Configurar o Diário": "डायरी सेट करें",
 "Confirmar pagamento": "भुगतान की पुष्टि करें",
 "Confirmar recebimento": "प्राप्ति की पुष्टि करें",
 "Conquistas": "उपलब्धियाँ",
 "Contas arquivadas": "संग्रहीत खाते",
 "Continuar escrevendo": "लिखना जारी रखें",
 "Copiado ✓": "कॉपी हो गया ✓",
 "Copiar código": "कोड कॉपी करें",
 "Copiar link": "लिंक कॉपी करें",
 "Cor atual": "मौजूदा रंग",
 "Cor {n}": "रंग {n}",
 "Creme": "क्रीम",
 "Criada em {d}": "{d} को बनाया गया",
 "Criar as cobranças": "शुल्क बनाएँ",
 "Criar o grupo da turma": "कक्षा का समूह बनाएँ",
 "Criar o meu diário": "अपनी डायरी बनाएँ",
 "Crie a senha do diário (6 ou mais)": "डायरी का पासवर्ड बनाएँ (6 या अधिक)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "कक्षा का समूह बनाएँ और छात्रों को आमंत्रण भेजें। फिर भेजी गई चीज़ें सीधे उन तक पहुँचेंगी।",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "नीचे दिए + बटन से अपना पहला लक्ष्य, उद्देश्य या सपना बनाएँ।",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "एक प्रोजेक्ट बनाएँ, शामिल लोगों को आमंत्रित करें और चरण बाँटें। हर व्यक्ति अपना किया हुआ मार्क करता है।",
 "Crie uma senha nova para começar.": "शुरू करने के लिए नया पासवर्ड बनाएँ।",
 "Cuidados arquivados": "संग्रहीत देखभाल",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "आज की व्यक्तिगत देखभाल पूरी (सेहत)",
 "Curto prazo": "अल्पकालिक",
 "Custos": "लागत",
 "Céu estrelado": "तारों भरा आसमान",
 "Círculo": "वृत्त",
 "Cômodos arquivados": "संग्रहीत कमरे",
 "DIAS CUMPRIDOS": "पूरे किए गए दिन",
 "Data (opcional)": "तारीख (वैकल्पिक)",
 "De {d}": "{d} से",
 "Desafixar do topo": "ऊपर से अनपिन करें",
 "Desenho mais fraco ou mais forte": "ड्रॉइंग हल्की या गहरी",
 "Desfazer \"Concluído\" ({d})": "\"पूरा हुआ\" वापस लें ({d})",
 "Desligado": "बंद",
 "Desmarcar": "अनमार्क करें",
 "Desmarcar como paga?": "भुगतान हुआ का निशान हटाएँ?",
 "Desmarcar como recebida?": "प्राप्त हुआ का निशान हटाएँ?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "जो आप इस्तेमाल नहीं करते उसे अनमार्क करें: वह स्क्रीन से हट जाता है और टैब सरल हो जाता है। बाद में सेटिंग्स › टैब › {aba} › इस टैब के हिस्से में बदल सकते हैं।",
 "Dias da semana": "सप्ताह के दिन",
 "Dias de aula": "कक्षा के दिन",
 "Dias de aula: {d}": "कक्षा के दिन: {d}",
 "Dias escritos": "लिखे गए दिन",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "सुझाव: आकृति हाथ से बनाएँ और लाइन के अंत में उंगली दबाए रखें, ताकि वह एकदम सही बन जाए।",
 "Ditado": "डिक्टेशन",
 "Ditar (falar para escrever)": "बोलकर लिखें",
 "Diário apagado": "डायरी मिटा दी गई",
 "Diário protegido": "सुरक्षित डायरी",
 "Dom": "रवि",
 "Dê um nome a ele na pasta Hábitos.": "आदतें फ़ोल्डर में इसे एक नाम दें।",
 "EVOLUÇÃO": "प्रगति",
 "Editada em {d}": "{d} को संपादित",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "यह {d} को ({n} दिन में) खुलेगा। तब तक इसे दोबारा पढ़ा या संपादित नहीं किया जा सकता।",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "यह {d} को खुलेगा। उस दिन आपको एक सूचना मिलेगी।",
 "Ela fica guardada com a data de hoje para comparar depois.": "यह आज की तारीख के साथ सेव रहेगा ताकि बाद में तुलना कर सकें।",
 "Enorme": "बहुत बड़ा",
 "Enviado ao paciente": "मरीज़ को भेजा गया",
 "Enviado em": "भेजा गया",
 "Enviar \"{t}\" para todos do grupo {g}?": "\"{t}\" समूह {g} के सभी लोगों को भेजें?",
 "Enviar a nota para cada aluno": "हर छात्र को अंक भेजें",
 "Enviar as notas": "अंक भेजें",
 "Enviar o arquivo: {nome}": "फ़ाइल भेजें: {nome}",
 "Enviar o recado para a turma": "कक्षा को सूचना भेजें",
 "Enviar o título para outra aba": "शीर्षक दूसरे टैब में भेजें",
 "Enviar para a turma": "कक्षा को भेजें",
 "Enviar para outra aba": "दूसरे टैब में भेजें",
 "Escolha a cor desta bolinha": "इस बिंदु का रंग चुनें",
 "Escolha uma data no futuro": "भविष्य की कोई तारीख चुनें",
 "Escolher qualquer cor": "कोई भी रंग चुनें",
 "Esconder a barra": "बार छिपाएँ",
 "Escreva a frase": "वाक्य लिखें",
 "Escreva a que se refere a cobrança.": "लिखें कि शुल्क किस बारे में है।",
 "Escreva alguma coisa antes de guardar.": "सुरक्षित रखने से पहले कुछ लिखें।",
 "Escreva alguma coisa antes de salvar.": "सेव करने से पहले कुछ लिखें।",
 "Escreva hoje, abra no futuro": "आज लिखें, भविष्य में खोलें",
 "Escreva o que você quer mudar a partir de hoje": "लिखें कि आज से आप क्या बदलना चाहते हैं",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "भविष्य के अपने लिए लिखें। पत्र खुलने के दिन तक लॉक रहता है।",
 "Escrever uma carta": "एक पत्र लिखें",
 "Escrita em {e} · abre em {a}": "{e} को लिखा गया · {a} को खुलेगा",
 "Escuras (boas para folha clara)": "गहरे (हल्की शीट के लिए अच्छे)",
 "Esperado": "अपेक्षित",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "अपेक्षित: {e} · किया: {f} · बाकी: {fa}",
 "Esqueceu a senha do diário?": "डायरी का पासवर्ड भूल गए?",
 "Esqueci a senha do diário": "मैं डायरी का पासवर्ड भूल गया/गई",
 "Esta semana": "इस सप्ताह",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "यह प्रविष्टि ऐप के किसी दूसरे हिस्से से आती है और यहाँ से नहीं मिटती।",
 "Estudo: {h}": "पढ़ाई: {h}",
 "Esvaziar": "खाली करें",
 "Esvaziar a lixeira": "ट्रैश खाली करें",
 "Esvaziar a lixeira?": "ट्रैश खाली करें?",
 "Ex.: Comer uma fruta por dia": "जैसे: रोज़ एक फल खाना",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "जैसे: होमवर्क, 2 दिन का मेडिकल प्रमाणपत्र",
 "Ex.: Reservar a pousada": "जैसे: गेस्टहाउस बुक करना",
 "Ex.: Viagem em família, juntar para a festa": "जैसे: परिवार के साथ यात्रा, पार्टी के लिए बचत",
 "Excluir de vez?": "हमेशा के लिए हटाएँ?",
 "Excluir esta avaliação?": "यह मूल्यांकन हटाएँ?",
 "Excluir este bloco?": "यह ब्लॉक हटाएँ?",
 "Excluir este desenho?": "यह ड्रॉइंग हटाएँ?",
 "Excluir este item?": "यह आइटम हटाएँ?",
 "Excluir {n} item(ns)?": "{n} आइटम हटाएँ?",
 "Exportar como imagem": "इमेज के रूप में एक्सपोर्ट करें",
 "Exportar em PDF": "PDF में एक्सपोर्ट करें",
 "FOTOS": "फ़ोटो",
 "FRASE DO DIA": "आज का विचार",
 "FREQUÊNCIA": "आवृत्ति",
 "Falta o valor": "राशि नहीं है",
 "Feriado": "छुट्टी",
 "Feriado: {f}": "छुट्टी: {f}",
 "Fica 30 dias na lixeira.": "30 दिन ट्रैश में रहता है।",
 "Ficam 30 dias na lixeira.": "30 दिन ट्रैश में रहते हैं।",
 "Fichários arquivados": "संग्रहीत फ़ाइलें",
 "Fixar no topo": "ऊपर पिन करें",
 "Floral": "फूलदार",
 "Folha": "शीट",
 "Folha, tema e cores das páginas com escrita": "लिखने वाले पेजों की शीट, थीम और रंग",
 "Folhas e plantas": "पत्ते और पौधे",
 "Foto adicionada": "फ़ोटो जोड़ी गई",
 "Foto do sonho": "सपने की फ़ोटो",
 "Fotos do dia": "आज की फ़ोटो",
 "Frase": "विचार",
 "Frase do dia (aparece no topo do Meu Dia)": "आज का विचार (मेरा दिन में ऊपर दिखता है)",
 "Frases, textos, vídeos e fotos que motivam": "प्रेरित करने वाले विचार, लेख, वीडियो और फ़ोटो",
 "Geométrico": "ज्यामितीय",
 "Gerar": "बनाएँ",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "आपके कहने पर आवाज़ से रिमाइंडर और नोट्स रिकॉर्ड करना और टेक्स्ट बोलकर लिखना (🎤)। माइक्रोफ़ोन सिर्फ़ आपके टैप करने पर चालू होता है, और डिक्टेशन का ऑडियो सेव नहीं होता।",
 "Guardar e trancar": "सुरक्षित रखें और लॉक करें",
 "Guardar e trancar?": "सुरक्षित रखें और लॉक करें?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "जो आपको प्रेरित करता है उसे यहाँ रखें: विचार, आपके लेख, वीडियो और फ़ोटो।",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "यह पासवर्ड अच्छी तरह संभालकर रखें: इसके बिना डायरी वापस नहीं पाई जा सकती।",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "आज छुट्टी है: {f}। फिर भी दर्ज करें?",
 "Humor do mês": "महीने का मूड",
 "Humor do período": "अवधि का मूड",
 "HÁBITOS LIGADOS": "जुड़ी आदतें",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "चयन में बड़े आइटम हैं। उन्हें पुष्टि और पासवर्ड के साथ एक-एक करके ही हटाया जा सकता है।",
 "Há um ano": "एक साल पहले",
 "Há um mês": "एक महीने पहले",
 "Hábito": "आदत",
 "Hábito criado": "आदत बनाई गई",
 "Hábitos": "आदतें",
 "Hábitos cumpridos": "पूरी की गई आदतें",
 "Hábitos cumpridos: {f} de {n}": "पूरी की गई आदतें: {n} में से {f}",
 "Hábitos formados": "बनी हुई आदतें",
 "INSPIRAÇÃO": "प्रेरणा",
 "Imagem adicionada": "इमेज जोड़ी गई",
 "Imagem não encontrada": "इमेज नहीं मिली",
 "Incrível": "शानदार",
 "Informação nutricional": "पोषण संबंधी जानकारी",
 "Inserir": "डालें",
 "Inspiração": "प्रेरणा",
 "Item para o paciente": "मरीज़ के लिए आइटम",
 "Itens grandes só se excluem um por um.": "बड़े आइटम एक-एक करके ही हटते हैं।",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "जो आप जीना चाहते हैं उसकी फ़ोटो इकट्ठा करें। व्यवस्थित करने के लिए दबाकर खींचें।",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "जीवन प्रोजेक्ट के किसी सपने से जोड़ें (वैकल्पिक)",
 "LIGAR A UMA META (OPCIONAL)": "किसी लक्ष्य से जोड़ें (वैकल्पिक)",
 "LINKS DE VÍDEO": "वीडियो लिंक",
 "Lance as notas antes de enviar.": "भेजने से पहले अंक दर्ज करें।",
 "Lançamentos arquivados": "संग्रहीत प्रविष्टियाँ",
 "Legenda (opcional)": "कैप्शन (वैकल्पिक)",
 "Lembrete diário": "रोज़ का रिमाइंडर",
 "Lendo o comprovante...": "रसीद पढ़ी जा रही है...",
 "Ler o comprovante com a minha IA": "मेरे AI से रसीद पढ़ें",
 "Ligado": "चालू",
 "Ligar um texto de motivação (Inspiração)": "एक प्रेरक लेख जोड़ें (प्रेरणा)",
 "Lilás": "बैंगनी",
 "Limpar a folha inteira?": "पूरी शीट साफ़ करें?",
 "Linha reta": "सीधी रेखा",
 "Linhas": "लाइनें",
 "Link do vídeo (YouTube, Instagram...)": "वीडियो का लिंक (YouTube, Instagram...)",
 "Lisa": "सादी",
 "Liste os passos do projeto e diga quem faz cada um.": "प्रोजेक्ट के चरण लिखें और बताएँ कि हर एक कौन करेगा।",
 "Lixeira": "ट्रैश",
 "Longo prazo": "दीर्घकालिक",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "सेहत से अपने-आप मार्क करें (वैकल्पिक)",
 "META OU SONHO LIGADO (OPCIONAL)": "जुड़ा लक्ष्य या सपना (वैकल्पिक)",
 "Mais opções": "और विकल्प",
 "Mal": "बुरा",
 "Mandar ao paciente pelo WhatsApp": "मरीज़ को WhatsApp पर भेजें",
 "Marque o que fez em cada dia": "हर दिन जो किया उसे मार्क करें",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "कक्षा (संपादित करें) में कक्षा के दिन मार्क करें ताकि हाज़िरी में सिर्फ़ वही दिन दिखें।",
 "Matérias arquivadas": "संग्रहीत विषय",
 "Mensalidade": "मासिक फ़ीस",
 "Meta de água do Bem-Estar": "सेहत का पानी लक्ष्य",
 "Metas arquivadas": "संग्रहीत लक्ष्य",
 "Metas e sonhos concluídos": "पूरे हुए लक्ष्य और सपने",
 "Metas em andamento": "जारी लक्ष्य",
 "Metas que avançaram": "आगे बढ़े लक्ष्य",
 "Metas, objetivos e sonhos, com passos e prazos": "लक्ष्य, उद्देश्य और सपने, चरणों और समय-सीमाओं के साथ",
 "Meu Dia": "मेरा दिन",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "खाली पेज के साथ मेरा दिन, जीवन प्रोजेक्ट, आदतें, सपनों का बोर्ड, जीवन चक्र, भविष्य के लिए पत्र और उपलब्धियाँ। पासवर्ड से सुरक्षित।",
 "Minimalista": "मिनिमलिस्ट",
 "Mostrar as contas antes do vencimento": "बिल को देय तारीख से पहले दिखाएँ",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "आप जहाँ हैं उसके अनुसार सही तारीख, समय, मुद्रा और छुट्टियाँ दिखाना। फ़ोन की अनुमानित लोकेशन सिर्फ़ तब इस्तेमाल होती है जब आप डायरी में आज का मौसम माँगते हैं, और यह सेव नहीं होती।",
 "Muito bem": "बहुत अच्छा",
 "Muito mal": "बहुत बुरा",
 "Mural de fotos dos seus sonhos": "आपके सपनों की फ़ोटो का मूरल",
 "Mural, relatório e revisão do mês": "मूरल, रिपोर्ट और महीने की समीक्षा",
 "Médio prazo": "मध्यमकालिक",
 "N dias cumpridos no mês": "महीने में N दिन पूरे",
 "N dias seguidos": "लगातार N दिन",
 "NESTE DIA": "इस दिन",
 "Nada a enviar": "भेजने के लिए कुछ नहीं",
 "Nenhum estudo registrado nesta semana.": "इस सप्ताह कोई पढ़ाई दर्ज नहीं हुई।",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "अभी कोई आदत नहीं। जैसे: \"रोज़ एक फल खाना\", \"2 L पानी पीना\", \"नाश्ता न छोड़ना\"।",
 "Nenhum no período.": "इस अवधि में कोई नहीं।",
 "Nenhuma": "कोई नहीं",
 "Nenhuma carta ainda.": "अभी कोई पत्र नहीं।",
 "Nenhuma foto ainda.": "अभी कोई फ़ोटो नहीं।",
 "Neutras e opacas": "न्यूट्रल और मैट",
 "Ninguém encontrado no grupo": "समूह में कोई नहीं मिला",
 "No computador: {link}": "कंप्यूटर पर: {link}",
 "No navegador, a senha do diário é pedida sempre.": "ब्राउज़र में डायरी का पासवर्ड हमेशा पूछा जाता है।",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "महीने के आखिरी दिन: \"क्यों न अपने महीने की समीक्षा करें? ✨\"",
 "Nome da página (opcional)": "पेज का नाम (वैकल्पिक)",
 "Nome de quem faz este passo": "यह चरण करने वाले का नाम",
 "Nome do vídeo (opcional)": "वीडियो का नाम (वैकल्पिक)",
 "Normal": "सामान्य",
 "Nota de 0 a 10 para cada área da vida": "जीवन के हर क्षेत्र के लिए 0 से 10 तक अंक",
 "Nota: {a}": "अंक: {a}",
 "Nova caixa": "नया बॉक्स",
 "Nova carta": "नया पत्र",
 "Nova meta, objetivo ou sonho": "नया लक्ष्य, उद्देश्य या सपना",
 "Nova senha (6 caracteres ou mais)": "नया पासवर्ड (6 या अधिक अक्षर)",
 "Nova área (ex.: Espiritualidade)": "नया क्षेत्र (जैसे: आध्यात्मिकता)",
 "Novo cômodo": "नया कमरा",
 "Novo hábito": "नई आदत",
 "Não dá para excluir em grupo": "समूह में हटाया नहीं जा सकता",
 "Não enviados": "नहीं भेजे गए",
 "Não estão no grupo (ou com outro nome): {l}": "समूह में नहीं हैं (या दूसरे नाम से हैं): {l}",
 "Não foi possível exportar": "एक्सपोर्ट नहीं हो सका",
 "Não foi possível ouvir agora ({erro}).": "अभी सुना नहीं जा सका ({erro})।",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "डायरी का पासवर्ड नहीं माँगता। यही एकमात्र हिस्सा है जिसे साझा किया जा सकता है।",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "आज इस कक्षा का दिन नहीं है। हाज़िरी भरपाई या अतिरिक्त कक्षा के रूप में दर्ज होगी।",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "ऐप देय तारीख से {n} दिन पहले और उसी दिन सुबह 9 बजे सूचना देता है। इसे सेटिंग्स › टैब › वित्त में बदल सकते हैं।",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "स्वचालित मौसम फ़ोन की लोकेशन का इस्तेमाल करता है। अनुमति के बिना इसे यहाँ भरना होगा।",
 "O conteúdo desta carta não foi encontrado.": "इस पत्र की सामग्री नहीं मिली।",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "डिक्टेशन ऐप के नए वर्ज़न के साथ आता है। माइक्रोफ़ोन इस्तेमाल करने के लिए स्टोर से My Planner अपडेट करें (या नया APK इंस्टॉल करें)।",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "ऐप अनलॉक होने पर भी, डायरी में जाते समय हर बार पासवर्ड पूछा जाता है।",
 "O diário só abre com essa senha, sempre.": "डायरी हमेशा सिर्फ़ इसी पासवर्ड से खुलती है।",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "डायरी एन्क्रिप्टेड है: पासवर्ड के बिना कोई इसे नहीं खोल सकता, सहायता टीम भी नहीं। चाहें तो डायरी मिटाकर नई शुरू कर सकते हैं (समूह प्रोजेक्ट बने रहेंगे)।",
 "O que aprendi hoje?": "आज मैंने क्या सीखा?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "इस महीने ने आपको क्या सिखाया? अगले महीने में क्या साथ ले जाना चाहते हैं?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "जो अनमार्क है वह स्क्रीन से हट जाता है। डेटा सुरक्षित रहता है।",
 "O que foi bom hoje?": "आज क्या अच्छा रहा?",
 "O que foi excluído nos últimos 30 dias": "पिछले 30 दिनों में जो हटाया गया",
 "O que quero melhorar amanhã?": "कल मैं क्या बेहतर करना चाहता/चाहती हूँ?",
 "O que quero mudar agora": "मैं अभी क्या बदलना चाहता/चाहती हूँ",
 "O que você escreveu nesta carta vai se perder.": "आपने इस पत्र में जो लिखा है वह खो जाएगा।",
 "O que você quer fazer com o arquivo?": "आप फ़ाइल के साथ क्या करना चाहते हैं?",
 "Objetivo": "उद्देश्य",
 "Oculta": "छिपा हुआ",
 "Orientação": "निर्देश",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "मरीज़ को देने के लिए निर्देश, पर्चे, मेडिकल प्रमाणपत्र और सामग्री, फ़ाइलों के साथ। सिर्फ़ यहाँ मौजूद चीज़ें भेजी जाती हैं: मेडिकल रिकॉर्ड इस फ़ोल्डर से कभी बाहर नहीं जाता।",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "जिन दिनों पेज लिखा गया है वे मार्क रहते हैं। खोलने के लिए किसी दिन पर टैप करें।",
 "Os itens saem de vez e não podem mais ser restaurados.": "आइटम हमेशा के लिए हट जाते हैं और फिर रीस्टोर नहीं किए जा सकते।",
 "Outra data": "दूसरी तारीख",
 "Outras moedas": "अन्य मुद्राएँ",
 "Ouvindo…": "सुन रहा है…",
 "PASSOS": "चरण",
 "PDF com seus dados e assinatura": "आपके डेटा और हस्ताक्षर के साथ PDF",
 "POR DIA": "प्रति दिन",
 "POR MATÉRIA": "प्रति विषय",
 "PROGRESSO": "प्रगति",
 "Paciente: {nome}": "मरीज़: {nome}",
 "Para o paciente": "मरीज़ के लिए",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "खुलने का तरीका बदलने के लिए, डायरी में उसके पासवर्ड से जाएँ और यहाँ वापस आएँ।",
 "Para {nome} de {tempo} depois": "{tempo} बाद की {nome} के लिए",
 "Parar o ditado": "डिक्टेशन रोकें",
 "Parcelado": "किस्तों में",
 "Partes desta aba": "इस टैब के हिस्से",
 "Passo": "चरण",
 "Pastas arquivadas": "संग्रहीत फ़ोल्डर",
 "Pastas arquivadas ({n})": "संग्रहीत फ़ोल्डर ({n})",
 "Pautada": "लाइनदार",
 "Pautada com margem": "मार्जिन के साथ लाइनदार",
 "Pedido de exame": "जाँच का अनुरोध",
 "Pelo que sou grata hoje?": "आज मैं किस बात के लिए आभारी हूँ?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "फ़ोन की सेटिंग्स में My Planner के लिए माइक्रोफ़ोन और स्पीच रिकग्निशन की अनुमति दें।",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "कस्टमाइज़ करें: शीट का प्रकार, रंग और थीम और बिंदुओं के रंग, सिर्फ़ इस टैब के लिए",
 "Pontilhada": "बिंदीदार",
 "Posto": "पेट्रोल पंप",
 "Preenche o clima do Meu Dia pela localização do celular.": "फ़ोन की लोकेशन से मेरा दिन का मौसम भरता है।",
 "Preencher pela foto do comprovante": "रसीद की फ़ोटो से भरें",
 "Primeira vez neste aparelho: digite a senha do diário.": "इस डिवाइस पर पहली बार: डायरी का पासवर्ड डालें।",
 "Projeto": "प्रोजेक्ट",
 "Projeto de Vida": "जीवन प्रोजेक्ट",
 "Projetos com amigos e família (compartilhados)": "दोस्तों और परिवार के साथ प्रोजेक्ट (साझा)",
 "Projetos em Grupo": "समूह प्रोजेक्ट",
 "Proprietário / Locador": "मालिक / किराए पर देने वाला",
 "Páginas arquivadas": "संग्रहीत पेज",
 "Páginas desta aba": "इस टैब के पेज",
 "QUANDO ELA ABRE": "यह कब खुलेगा",
 "Qua": "बुध",
 "Quadriculada": "ग्रिड वाली",
 "Quadro dos Sonhos": "सपनों का बोर्ड",
 "Quais partes você vai usar?": "आप कौन-से हिस्से इस्तेमाल करेंगे?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "जब आप कोई लक्ष्य पूरा करेंगे या कोई आदत बनाएँगे, तो जश्न मनाने के लिए वह यहाँ दिखेगा। 🎉",
 "Quanto você pagou?": "आपने कितना भुगतान किया?",
 "Quanto você recebeu?": "आपको कितना मिला?",
 "Que tal revisar o seu mês? ✨": "क्यों न अपने महीने की समीक्षा करें? ✨",
 "Quem faz": "कौन करेगा",
 "Quem fez o meu dia melhor?": "आज मेरा दिन किसने बेहतर बनाया?",
 "Quer guardar o comprovante agora?": "क्या अभी रसीद सुरक्षित रखना चाहते हैं?",
 "Qui": "गुरु",
 "REFLEXÃO DO MÊS": "महीने पर विचार",
 "Recebeu {v} a mais": "{v} ज़्यादा मिला",
 "Recebeu {v} a menos": "{v} कम मिला",
 "Receita médica": "डॉक्टर का पर्चा",
 "Receitas médicas": "डॉक्टर के पर्चे",
 "Recolher": "समेटें",
 "Refeições arquivadas": "संग्रहीत भोजन",
 "Refeições do cronograma feitas (Bem-Estar)": "योजना के भोजन पूरे (सेहत)",
 "Referente a (ex.: material, passeio, inscrição)": "किस बारे में (जैसे: सामग्री, सैर, पंजीकरण)",
 "Registrar": "दर्ज करें",
 "Relacionamentos": "रिश्ते",
 "Relatório de estudos": "पढ़ाई की रिपोर्ट",
 "Relatório de realizações": "उपलब्धियों की रिपोर्ट",
 "Relatório em PDF": "PDF रिपोर्ट",
 "Renomear, adicionar ou tirar áreas": "क्षेत्रों का नाम बदलें, जोड़ें या हटाएँ",
 "Reposição": "भरपाई कक्षा",
 "Restaurado": "रीस्टोर हुआ",
 "Resumida": "संक्षिप्त",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "संक्षिप्त: कुल के साथ सिर्फ़ एक लाइन। पूरा: दिन के आइटम दिखाता है। छिपा हुआ: नहीं दिखता। इस टैब की कोई चीज़ अपने-आप कार्य नहीं बनती।",
 "Resumo de {nome}": "{nome} का सारांश",
 "Resumo do dia": "दिन का सारांश",
 "Retângulo": "आयत",
 "Revisar antes": "पहले समीक्षा करें",
 "Revisão do mês": "महीने की समीक्षा",
 "Roda da Vida": "जीवन चक्र",
 "Rosa": "गुलाबी",
 "Sair sem guardar?": "सेव किए बिना बाहर जाएँ?",
 "Salvar avaliação de hoje": "आज का मूल्यांकन सेव करें",
 "Salvar ou enviar": "सेव करें या भेजें",
 "Seg": "सोम",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "क्रम बदलने के लिए फ़ोल्डरों को दबाकर खींचें। संग्रहीत करने के लिए बाईं ओर खींचें।",
 "Sem chamada neste dia: cobra todos os alunos.": "इस दिन कोई हाज़िरी नहीं: सभी छात्रों से शुल्क लिया जाएगा।",
 "Sem ideia do que escrever? Toque numa pergunta:": "समझ नहीं आ रहा क्या लिखें? किसी सवाल पर टैप करें:",
 "Sem registros de humor.": "मूड का कोई रिकॉर्ड नहीं।",
 "Sem tema": "बिना थीम",
 "Semana de {d}": "{d} का सप्ताह",
 "Senha atual do diário": "डायरी का मौजूदा पासवर्ड",
 "Senha do diário": "डायरी का पासवर्ड",
 "Senha do diário incorreta.": "डायरी का पासवर्ड गलत है।",
 "Senha do diário trocada": "डायरी का पासवर्ड बदल दिया गया",
 "Senha própria só do diário": "सिर्फ़ डायरी का अपना पासवर्ड",
 "Sequência dos hábitos": "आदतों का सिलसिला",
 "Seta": "तीर",
 "Seu diário, só seu": "आपकी डायरी, सिर्फ़ आपकी",
 "Seu texto de motivação": "आपका प्रेरक लेख",
 "Sex": "शुक्र",
 "Sonho": "सपना",
 "Suplementos arquivados": "संग्रहीत सप्लीमेंट",
 "Sáb": "शनि",
 "Só abre com a senha do diário.": "सिर्फ़ डायरी के पासवर्ड से खुलता है।",
 "TEMA DECORATIVO": "सजावटी थीम",
 "TIPO DE FOLHA": "शीट का प्रकार",
 "Tarefas arquivadas": "संग्रहीत कार्य",
 "Ter": "मंगल",
 "Texto para o paciente": "मरीज़ के लिए टेक्स्ट",
 "Tipo, cor e tema da folha": "शीट का प्रकार, रंग और थीम",
 "Tirar a área \"{a}\"?": "क्षेत्र \"{a}\" हटाएँ?",
 "Tirar da frase do dia": "आज के विचार से हटाएँ",
 "Tirar do arquivo": "संग्रह से निकालें",
 "Tirar esta foto do quadro?": "यह फ़ोटो बोर्ड से हटाएँ?",
 "Tirar esta pergunta?": "यह सवाल हटाएँ?",
 "Tirar este vídeo?": "यह वीडियो हटाएँ?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "हर दिन {h} बजे: \"आपका दिन कैसा रहा? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "सभी छात्रों पर इस संदर्भ का शुल्क पहले से है।",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "\"अन्य\" (छूट, मेडिकल प्रमाणपत्र...) के लिए फिर से टैप करें: इसे न अनुपस्थिति माना जाता है, न कक्षा।",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "आज जो किया उसे मार्क करने के लिए वृत्त पर टैप करें। आदतें अपने-आप My Planner में नहीं जातीं: ⋮ मेनू में भेजें इस्तेमाल करें।",
 "Toque num dia para marcar ou desmarcar.": "मार्क करने या निशान हटाने के लिए किसी दिन पर टैप करें।",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "रंग बदलने के लिए किसी बिंदु पर टैप करें। पेज पर बिंदु को दबाए रखने से भी यही होता है।",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "खोलने के लिए टैप करें। संग्रहीत या डुप्लिकेट करने के लिए बाईं ओर, हटाने के लिए दाईं ओर खींचें।",
 "Treino do dia feito (Bem-Estar)": "आज का वर्कआउट पूरा (सेहत)",
 "Treinos arquivados": "संग्रहीत वर्कआउट",
 "Trocar a senha do diário": "डायरी का पासवर्ड बदलें",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "डायरी में आप जो भी लिखते हैं वह आपके खाते में जाने से पहले इसी डिवाइस पर एन्क्रिप्ट हो जाता है। कोई और इसे नहीं पढ़ सकता, सहायता टीम भी नहीं।",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "आप जो भी हटाते हैं वह 30 दिन यहाँ रहता है। उसके बाद हमेशा के लिए हट जाता है।",
 "Título (ex.: Ter uma boa alimentação)": "शीर्षक (जैसे: अच्छा खान-पान रखना)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "{n} छात्रों में से हर एक के लिए एक एकल शुल्क। सिर्फ़ एक छात्र से शुल्क लेने के लिए + पर टैप करें।",
 "Uma senha própria, só do diário": "एक अपना पासवर्ड, सिर्फ़ डायरी का",
 "Usar a senha do diário": "डायरी का पासवर्ड इस्तेमाल करें",
 "Usar como frase do dia": "आज के विचार के रूप में इस्तेमाल करें",
 "Usar este valor": "यह राशि इस्तेमाल करें",
 "Usar o padrão do app": "ऐप का डिफ़ॉल्ट इस्तेमाल करें",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "सभी टैब की राशियों पर लागू होता है (वित्त, किराया, मासिक फ़ीस...)।",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "लिखने वाले सभी पेजों पर लागू होता है (पढ़ाई, नोट्स, डायरी, दस्तावेज़...)। हर टैब का अपना डिफ़ॉल्ट सेटिंग्स › टैब में हो सकता है, और हर पेज ⋮ › शीट में अपनी शीट बदल सकता है।",
 "Valor da aula extra (por aluno)": "अतिरिक्त कक्षा की राशि (प्रति छात्र)",
 "Valor por aluno": "प्रति छात्र राशि",
 "Valor previsto: {v}": "अनुमानित राशि: {v}",
 "Vencimento: {d}": "देय तारीख: {d}",
 "Ver o comprovante": "रसीद देखें",
 "Verde": "हरा",
 "Visualizar": "पूर्वावलोकन",
 "Você está como convidado": "आप अतिथि के रूप में हैं",
 "Voltar a acompanhar este hábito": "इस आदत को फिर से ट्रैक करें",
 "Voltar ao início da folha": "शीट की शुरुआत पर वापस जाएँ",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "शुरुआती डिफ़ॉल्ट पर लौटें (लाइनदार शीट; काला, नीला, लाल और हरा)",
 "Voltar para a nova avaliação": "नए मूल्यांकन पर वापस जाएँ",
 "Vídeos": "वीडियो",
 "X vezes por semana": "सप्ताह में X बार",
 "abre em {n} dias": "{n} दिन में खुलेगा",
 "agradável": "सुहावना",
 "arquivo": "फ़ाइल",
 "aula extra": "अतिरिक्त कक्षा",
 "calor": "गर्मी",
 "chuva": "बारिश",
 "concluído": "पूरा हुआ",
 "céu limpo": "साफ़ आसमान",
 "de {n} planejados": "{n} नियोजित में से",
 "dentro de {p}": "{p} के भीतर",
 "enviado em {d}": "{d} को भेजा गया",
 "estudados na semana": "सप्ताह में पढ़े गए",
 "excluído em {d}": "{d} को हटाया गया",
 "falta 1 dia": "1 दिन बाकी",
 "faltam {n} dias": "{n} दिन बाकी",
 "feito {dur} na semana": "सप्ताह में {dur} किया",
 "fresco": "ठंडक",
 "frio": "ठंड",
 "garoa": "बूंदाबांदी",
 "hoje não está planejado": "आज की योजना में नहीं है",
 "hábito formado ✨": "आदत बन गई ✨",
 "incorreta": "गलत",
 "neblina": "कोहरा",
 "neve": "बर्फ़",
 "nublado": "बादल",
 "não enviado": "नहीं भेजा गया",
 "parcela {k}/{n}": "किस्त {k}/{n}",
 "passou há {n} dias": "{n} दिन पहले बीत गया",
 "pelo Bem-Estar": "सेहत से",
 "poucas nuvens": "हल्के बादल",
 "reposição": "भरपाई कक्षा",
 "sai de vez em {n} dia(s)": "{n} दिन में हमेशा के लिए हट जाएगा",
 "sem registros": "कोई रिकॉर्ड नहीं",
 "tempestade": "तूफ़ान",
 "tracejado: {d}": "डैश वाली: {d}",
 "ver mais": "और देखें",
 "ver menos": "कम देखें",
 "{aluno}: {n} de {max}": "{aluno}: {max} में से {n}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} को छुट्टी है: {f}। फिर भी दर्ज करें?",
 "{f} de {n} passos feitos": "{n} में से {f} चरण पूरे",
 "{f}/{n} passos": "{f}/{n} चरण",
 "{nome} daqui a 1 ano": "1 साल बाद की {nome}",
 "{nome} daqui a 10 anos": "10 साल बाद की {nome}",
 "{nome} daqui a 6 meses": "6 महीने बाद की {nome}",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} छात्रों को \"{a}\" में सिर्फ़ अपने अंक मिलेंगे।",
 "{n} aluno(s) receberam a nota.": "{n} छात्रों को अंक मिल गए।",
 "{n} aluno(s) · {v} cada": "{n} छात्र · {v} प्रत्येक",
 "{n} anos": "{n} साल",
 "{n} dia(s) antes": "{n} दिन पहले",
 "{n} dia(s) cumprido(s) no mês": "महीने में {n} दिन पूरे",
 "{n} dia(s) registrado(s) · média {e}": "{n} दिन दर्ज · औसत {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} दिन दर्ज, औसत 6 में से {m}",
 "{n} dia(s) seguido(s)": "लगातार {n} दिन",
 "{n} dispensada(s) hoje": "आज {n} छूट दी गई",
 "{n} meses": "{n} महीने",
 "{n} outro(s)": "{n} अन्य",
 "{n} selecionado(s)": "{n} चुने गए",
 "{n} tarefa(s) concluída(s) no My Planner": "My Planner में {n} कार्य पूरे हुए",
 "{n} vez(es) por semana": "सप्ताह में {n} बार",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "पानी: {m} ml में से {a}",
 "ÚLTIMAS 8 SEMANAS": "पिछले 8 सप्ताह",
 "Última parcela em {d}": "आखिरी किस्त {d} को",
 "é hoje!": "आज है!",
 "A mesma do app": "ऐप वाला ही",
 "Abrir com o código": "कोड से खोलें",
 "Ainda não criado": "अभी बनाया नहीं गया",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "बनाते समय ऐप आपको सँभालकर रखने के लिए एक रिकवरी कोड दिखाएगा।",
 "Apagar o diário e começar de novo": "डायरी मिटाकर फिर से शुरू करें",
 "Biometria ou código do dispositivo": "बायोमेट्रिक या डिवाइस कोड",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "बायोमेट्रिक, डिवाइस PIN या ऐप पासवर्ड। अलग पासवर्ड बनाने की ज़रूरत नहीं।",
 "Bloquear o app": "ऐप लॉक करें",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "उपयोग करने के लिए डिवाइस में फ़िंगरप्रिंट, चेहरा या लॉक कोड सेट करें।",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "बायोमेट्रिक चालू होने पर यह पहले दिखता है। विफल होने पर उसी विंडो में डिवाइस का कोड/PIN/पैटर्न मिलता है; ऐप पासवर्ड भी काम करता रहता है।",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "पासवर्ड भूलने या डिवाइस बदलने पर इससे आप डायरी वापस पा सकते हैं।",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "पासवर्ड भूलने या डिवाइस बदलने पर इस कोड से आप डायरी वापस पा सकते हैं। इसे सुरक्षित जगह रखें और किसी को न दिखाएँ।",
 "Como funciona a Roda da Vida": "जीवन चक्र कैसे काम करता है",
 "Como o diário abre": "डायरी कैसे खुलती है",
 "Crie a senha que vai abrir o diário.": "डायरी खोलने के लिए पासवर्ड बनाएँ।",
 "Crie o PIN do diário (4 a 6 números)": "डायरी का PIN बनाएँ (4 से 6 अंक)",
 "Crie o diário de novo para começar.": "शुरू करने के लिए डायरी फिर से बनाएँ।",
 "Código aceito. Crie uma senha nova para o diário.": "कोड स्वीकार हुआ। डायरी के लिए नया पासवर्ड बनाएँ।",
 "Código de recuperação": "रिकवरी कोड",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "रिकवरी कोड (उदा.: ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "रिकवरी कोड गलत है।",
 "Cômodos": "कमरे",
 "Depois de 1 minuto": "1 मिनट बाद",
 "Depois de {n} minutos": "{n} मिनट बाद",
 "Desenhe o padrão do diário": "डायरी का पैटर्न बनाएँ",
 "Dias no mês": "महीने में दिन",
 "Dias seguidos": "लगातार दिन",
 "Digite o seu PIN": "अपना PIN डालें",
 "Diário ainda não criado": "डायरी अभी बनाई नहीं गई",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "आज जीवन के हर क्षेत्र में आप कैसा महसूस करते हैं, उसे 0 से 10 तक अंक दें। चित्र दिखाता है कि आपका जीवन कहाँ संतुलित है और कहाँ ध्यान चाहिए। मूल्यांकन सहेजें और समय-समय पर (जैसे हर महीने) दोहराएँ ताकि तुलना करके अपनी प्रगति देख सकें। आप क्षेत्रों का नाम बदल सकते हैं, नए जोड़ सकते हैं या हटा सकते हैं।",
 "Entre na aba Diário para criar o seu diário.": "अपनी डायरी बनाने के लिए डायरी टैब में जाएँ।",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "डायरी में जाएँ (उसके पासवर्ड या ऐप अनलॉक से) और यहाँ वापस आएँ।",
 "Esconder a senha": "पासवर्ड छिपाएँ",
 "Gerar novo código": "नया कोड बनाएँ",
 "Gerar um código de recuperação novo?": "नया रिकवरी कोड बनाएँ?",
 "Guarde este código": "यह कोड सँभालकर रखें",
 "Já guardei": "रख लिया",
 "Ligar um hábito que já existe": "किसी मौजूदा आदत से जोड़ें",
 "Mostrar a senha": "पासवर्ड दिखाएँ",
 "Mudar como o diário abre": "डायरी खुलने का तरीका बदलें",
 "My Planner · Código de recuperação do Diário": "My Planner · डायरी का रिकवरी कोड",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "इस डिवाइस की कुंजी से नहीं खुल सका। डायरी का पासवर्ड या रिकवरी कोड इस्तेमाल करें।",
 "O Caps Lock parece estar ligado.": "लगता है Caps Lock चालू है।",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "PIN केवल इसी डिवाइस पर सुरक्षित रूप से रखा जाता है। PIN भूल जाने पर पासवर्ड काम करता रहेगा।",
 "O PIN precisa ter de 4 a 6 números.": "PIN में 4 से 6 अंक होने चाहिए।",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "पिछला कोड अमान्य हो जाएगा। सुरक्षा के लिए कोड ऐप में सहेजा नहीं जाता: इसे केवल बनाते समय ही देखा जा सकता है।",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "कोड ऐसी किसी जगह सहेजा नहीं जाता जिसे सपोर्ट टीम देख सके। पासवर्ड और कोड के बिना डायरी वापस नहीं पाई जा सकती।",
 "O diário agora abre só com a senha dele.": "अब डायरी केवल अपने पासवर्ड से खुलती है।",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "इस डिवाइस की फ़ेस पहचान ऐप्स इस्तेमाल नहीं कर सकते। फ़िंगरप्रिंट या डिवाइस का कोड/PIN इस्तेमाल करें।",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "समय उस पल से गिना जाता है जब ऐप स्क्रीन से हटता है (दूसरा ऐप, होम स्क्रीन या स्क्रीन बंद)। नोटिफ़िकेशन नीचे खींचना, बायोमेट्रिक विंडो, अनुमति का अनुरोध या फ़ोटो या फ़ाइल चुनना नहीं गिना जाता।",
 "Os PINs não conferem.": "PIN मेल नहीं खाते।",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (4 से 6 अंक)",
 "PIN (só números, 4 a 6)": "PIN (केवल अंक, 4 से 6)",
 "PIN do diário": "डायरी PIN",
 "PIN incorreto": "गलत PIN",
 "PIN salvo.": "PIN सहेजा गया।",
 "Padrão do app": "ऐप डिफ़ॉल्ट",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "मिटाने के लिए ऐप पासवर्ड, बायोमेट्रिक या डिवाइस PIN से पुष्टि करें। इससे डायरी का मेरा दिन, लक्ष्य, आदतें, पत्र और फ़ोटो मिट जाएँगे। समूह प्रोजेक्ट बने रहेंगे।",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "जारी रखने के लिए ऐप पासवर्ड डालें या डिवाइस का बायोमेट्रिक/कोड इस्तेमाल करें।",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "पासवर्ड भूलने या डिवाइस बदलने पर डायरी वापस पाने के लिए।",
 "Pastas": "फ़ोल्डर",
 "Pedir a senha de novo": "फिर से पासवर्ड माँगें",
 "Personalizada": "कस्टम",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "इस डिवाइस पर पहली बार: डायरी का पासवर्ड डालें या रिकवरी कोड इस्तेमाल करें।",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "इस डिवाइस पर पहली बार: डायरी का रिकवरी कोड डालें।",
 "Reconhecimento de rosto": "फ़ेस पहचान",
 "Repita o PIN": "PIN दोबारा डालें",
 "Salvar a senha nova": "नया पासवर्ड सहेजें",
 "Salvar em arquivo / no Drive": "फ़ाइल में / Drive में सहेजें",
 "Salvar o código de recuperação": "रिकवरी कोड सहेजें",
 "Senha (letras e números)": "पासवर्ड (अक्षर और अंक)",
 "Senha do app": "ऐप पासवर्ड",
 "Senha nova do diário": "डायरी का नया पासवर्ड",
 "Senha própria": "अलग पासवर्ड",
 "Senha própria do diário": "डायरी का अलग पासवर्ड",
 "Tarefas": "कार्य",
 "Trocar o PIN": "PIN बदलें",
 "Usar a senha": "पासवर्ड इस्तेमाल करें",
 "Usar o PIN": "PIN इस्तेमाल करें",
 "Usar o código de recuperação": "रिकवरी कोड इस्तेमाल करें",
 "Usar o desbloqueio do app": "ऐप अनलॉक इस्तेमाल करें",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "बायोमेट्रिक या डिवाइस का कोड/PIN/पैटर्न इस्तेमाल करें।",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "डायरी बनाते समय दिखा रिकवरी कोड इस्तेमाल करें। पासवर्ड और कोड के बिना कोई भी डायरी नहीं खोल सकता, सपोर्ट टीम भी नहीं।",
 "Voltar a usar só a senha?": "फिर से केवल पासवर्ड इस्तेमाल करें?",
 "incorreto": "गलत",
 "1 h": "1 घं",
 "12 horas (2:30 PM)": "12 घंटे (2:30 PM)",
 "15 min": "15 मिनट",
 "24 horas (14:30)": "24 घंटे (14:30)",
 "30 min": "30 मिनट",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "ट्रैश में बड़े आइटम हैं। ऐप पासवर्ड, बायोमेट्रिक या डिवाइस कोड से पुष्टि करें।",
 "A semana começa na": "सप्ताह शुरू होता है",
 "Abra o Diário primeiro": "पहले डायरी खोलें",
 "Abrir configurações do celular": "फ़ोन की सेटिंग्स खोलें",
 "Agenda e mapas": "कैलेंडर और मैप",
 "Agora: {m}": "अभी: {m}",
 "Ajuda e sobre": "सहायता और जानकारी",
 "Alarme (som)": "अलार्म (ध्वनि)",
 "Alarme ou vibração das pausas": "ब्रेक का अलार्म या वाइब्रेशन",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "खाता और क्लाउड व इस डिवाइस का सारा डेटा हमेशा के लिए मिटा देता है। पहले आपका पासवर्ड माँगता है।",
 "Apagar todas ({n})": "सभी मिटाएँ ({n})",
 "Apagar {n} selecionada(s)": "{n} चयनित मिटाएँ",
 "Aparência": "दिखावट",
 "App das rotas": "रास्तों के लिए ऐप",
 "Ardósia": "स्लेट",
 "Arrastar para a direita": "दाईं ओर खींचें",
 "Arrastar para a esquerda": "बाईं ओर खींचें",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "वित्त के बिल My Planner में इतने दिन पहले दिखते हैं।",
 "Atualizações e sobre": "अपडेट और जानकारी",
 "Avisar antes do vencimento": "देय तिथि से पहले सूचित करें",
 "Aviso marcado": "रिमाइंडर सेट हुआ",
 "Aviso no começo e no fim de cada pausa": "हर ब्रेक की शुरुआत और अंत में सूचना",
 "Avisos desta aba": "इस टैब की सूचनाएँ",
 "Avisos e alarmes": "सूचनाएँ और अलार्म",
 "Avisos silenciosos": "साइलेंट सूचनाएँ",
 "Avisos: som e vibração": "सूचनाएँ: ध्वनि और वाइब्रेशन",
 "Avisos: só som": "सूचनाएँ: केवल ध्वनि",
 "Avisos: só vibração": "सूचनाएँ: केवल वाइब्रेशन",
 "Azul elétrico": "इलेक्ट्रिक ब्लू",
 "Azul-aço": "स्टील ब्लू",
 "Azul-bebê": "बेबी ब्लू",
 "Azul-marinho": "नेवी ब्लू",
 "Baixar meus dados": "मेरा डेटा डाउनलोड करें",
 "Baixar todos os meus dados": "मेरा सारा डेटा डाउनलोड करें",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "मेरा सारा डेटा डाउनलोड करें और खाता हटाएँ (LGPD)",
 "Biometria": "बायोमेट्रिक",
 "Bissexual": "बाइसेक्शुअल",
 "Brilhante": "चमकीला",
 "Buscar abas": "टैब खोजें",
 "Buscar nos ajustes": "सेटिंग्स में खोजें",
 "Cancelar aviso": "रिमाइंडर रद्द करें",
 "Cinza-chumbo": "चारकोल ग्रे",
 "Cofre": "तिजोरी",
 "Coloque pelo menos uma matéria.": "कम से कम एक विषय जोड़ें।",
 "Como usar": "उपयोग कैसे करें",
 "Conexões": "कनेक्शन",
 "Cor da aba": "टैब का रंग",
 "Cor de destaque": "हाइलाइट रंग",
 "Crie uma matéria primeiro": "पहले एक विषय बनाएँ",
 "Cítrico": "सिट्रस",
 "Cópia de segurança em arquivo": "फ़ाइल में बैकअप",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "मरीज़ और मेडिकल रिकॉर्ड का डेटा। ऐप पासवर्ड, बायोमेट्रिक या डिवाइस कोड से पुष्टि करें।",
 "Desligadas": "बंद",
 "Digite a senha da sua conta para confirmar.": "पुष्टि के लिए अपने खाते का पासवर्ड डालें।",
 "Duração padrão de uma tarefa nova": "नए कार्य की डिफ़ॉल्ट अवधि",
 "Editar sessão": "सत्र संपादित करें",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "यह बिना अंतिम तिथि के दोहराया जाता है: {data} तक की बारियाँ दिख रही हैं। सभी चुनने पर पूरा कार्य हट जाएगा।",
 "Em atividade": "सक्रिय",
 "Em pausa": "ब्रेक पर",
 "Emoji da pausa": "ब्रेक का इमोजी",
 "Encerrar": "समाप्त करें",
 "Encerrar a sessão?": "सत्र समाप्त करें?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "चयन मोड में जाता है, ताकि एक साथ कई आइटम चुने जा सकें।",
 "Escolha um horário no futuro.": "भविष्य का कोई समय चुनें।",
 "Escolher a matéria": "विषय चुनें",
 "Esconde os valores em dinheiro (R$ •••)": "पैसों की राशि छिपाता है (R$ •••)",
 "Esconder o CPF": "CPF छिपाएँ",
 "Esconder os valores": "राशि छिपाएँ",
 "Esta e as próximas": "यह और आगे वाले",
 "Esta tarefa se repete. Onde aplicar a mudança?": "यह कार्य दोहराया जाता है। बदलाव कहाँ लागू करें?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "इस आइटम में बहुत कुछ है। ऐप पासवर्ड, बायोमेट्रिक या डिवाइस कोड से पुष्टि करें।",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "आइटम हटाता है (पुष्टि माँगता है)। बाद में पूर्ववत कर सकते हैं या ट्रैश से वापस ला सकते हैं।",
 "Excluir minha conta": "मेरा खाता हटाएँ",
 "Ficha protegida": "सुरक्षित रिकॉर्ड",
 "Formato da hora": "समय का फ़ॉर्मेट",
 "Foto do Quadro dos Sonhos": "सपनों के बोर्ड की फ़ोटो",
 "Geral": "सामान्य",
 "Gestos": "जेस्चर",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive और बैकअप फ़ाइल",
 "Grafite": "ग्रेफ़ाइट",
 "Guardar em": "यहाँ सहेजें",
 "Hábito do Diário": "डायरी की आदत",
 "Idioma e moeda": "भाषा और मुद्रा",
 "Inspiração do Diário": "डायरी की प्रेरणा",
 "Intenso": "गहरा",
 "Item arquivado": "आइटम संग्रहीत किया गया",
 "Item excluído": "आइटम हटाया गया",
 "Lavanda": "लैवेंडर",
 "Ligadas": "चालू",
 "Limite de energia": "ऊर्जा सीमा",
 "Lésbica": "लेस्बियन",
 "Marque as vezes que vão ser apagadas.": "वे बारियाँ चुनें जिन्हें मिटाना है।",
 "Matéria": "विषय",
 "Me avise em…": "मुझे याद दिलाएँ…",
 "Menta": "मिंट",
 "Menu ⋮": "मेनू ⋮",
 "Meta do Diário": "डायरी का लक्ष्य",
 "Modo discreto": "गोपनीय मोड",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "सत्र एक बार तैयार करें (विषय, हर एक का समय और ब्रेक) और बाकी दिनों में शुरू करें दबाकर दोहराएँ। पढ़ाई का समय अपने-आप लक्ष्य में जुड़ जाता है।",
 "Mostra Arquivar e Duplicar.": "संग्रहीत करें और डुप्लिकेट करें दिखाता है।",
 "Mostrar feriados no topo": "ऊपर अवकाश दिखाएँ",
 "Mostrar os valores": "राशि दिखाएँ",
 "Muda a ordem dos itens.": "आइटमों का क्रम बदलता है।",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "केवल My Planner का रंग बदलता है। ऐप का हाइलाइट रंग सेटिंग्स > दिखावट में है। हर कार्य का अपना रंग उसके रिकॉर्ड में हो सकता है।",
 "Nada encontrado nos ajustes.": "सेटिंग्स में कुछ नहीं मिला।",
 "Nenhuma sessão salva ainda.": "अभी तक कोई सत्र सहेजा नहीं गया।",
 "Neon": "नियॉन",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "इस समय ऐप न बजेगा न वाइब्रेट करेगा। सूचनाएँ चुपचाप आती रहेंगी।",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "किसी भी आइटम के मेनू ⋮ में: फ़ोन चुने गए समय पर सूचित करता है, My Planner में कार्य बनाए बिना।",
 "Nome (ex.: Sessão do mestrado)": "नाम (जैसे: मास्टर्स सत्र)",
 "Nova sessão": "नया सत्र",
 "Nuvem e cópias de segurança": "क्लाउड और बैकअप",
 "Não perturbe": "परेशान न करें",
 "Não perturbe {de}–{ate}": "परेशान न करें {de}–{ate}",
 "Não-binário": "नॉन-बाइनरी",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "My Planner के ऊपर 🎉 अवकाश बटन। देश और अवकाश सूची सेटिंग्स > अवकाश में हैं।",
 "O celular avisa às {h}.": "फ़ोन {h} बजे सूचित करेगा।",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "डायरी से हटाई गई चीज़ें ट्रैश में एन्क्रिप्टेड रहती हैं। वापस लाने के लिए पहले डायरी खोलें, फिर यहाँ लौटें।",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "जो हटेगा वह 30 दिन तक ट्रैश में रहेगा। पुष्टि के लिए अपने खाते का पासवर्ड डालें।",
 "O que saiu fica na Lixeira por 30 dias.": "जो हटाया गया वह 30 दिन तक ट्रैश में रहेगा।",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "थीम लाइट और डार्क मोड में टैब के रंग, हाइलाइट रंग और बैकग्राउंड में हल्का स्पर्श बदलती है। केवल एक टैब का रंग बदलने के लिए सेटिंग्स > टैब में जाएँ।",
 "O tempo estudado até agora entra na meta.": "अब तक पढ़ाई का समय लक्ष्य में जुड़ जाएगा।",
 "Oliva": "ऑलिव",
 "Orgulho": "प्राइड",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "सूचनाएँ इंस्टॉल किए गए ऐप में, नोटिफ़िकेशन चालू होने पर काम करती हैं।",
 "Os gestos do app": "ऐप के जेस्चर",
 "Outro (escolher a hora)": "अन्य (समय चुनें)",
 "Pansexual": "पैनसेक्शुअल",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "चालू करने के लिए फ़ोन पर ऐप इस्तेमाल करें (सेटिंग्स › कैलेंडर और मैप › Google कैलेंडर)। फिर सब कुछ यहाँ भी दिखेगा।",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "दोबारा न पूछने के लिए सेटिंग्स › कैलेंडर और मैप में ऐप चुनें।",
 "Pausa": "ब्रेक",
 "Petróleo": "पेट्रोल ब्लू",
 "Pink elétrico": "इलेक्ट्रिक पिंक",
 "Preto total": "पूरा काला",
 "Progresso": "प्रगति",
 "Pêssego": "पीच",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "बिल कितने दिन पहले दिखें, यह सेटिंग्स > सूचनाएँ और अलार्म में है।",
 "Rosa-chá": "डस्टी रोज़",
 "Roxo-profundo": "गहरा बैंगनी",
 "Segurança e dados": "सुरक्षा और डेटा",
 "Segurar e arrastar": "दबाकर खींचें",
 "Segurar e soltar": "दबाकर छोड़ें",
 "Selecionar todas": "सभी चुनें",
 "Semana começa na {dia}": "सप्ताह {dia} से शुरू होता है",
 "Sessão de estudo": "पढ़ाई सत्र",
 "Sessão encerrada": "सत्र समाप्त",
 "Sessão pausada": "सत्र रोका गया",
 "Som e vibração": "ध्वनि और वाइब्रेशन",
 "Suave": "सौम्य",
 "Só esta semana": "केवल इस सप्ताह",
 "Só hoje": "केवल आज",
 "Só neste dia ({data})": "केवल इस दिन ({data})",
 "Tamanho das caixas": "बॉक्स का आकार",
 "Tamanho do texto": "टेक्स्ट का आकार",
 "Tarefa nova": "नया कार्य",
 "Tela inicial": "होम स्क्रीन",
 "Tema e cor de destaque": "थीम और हाइलाइट रंग",
 "Testar alerta": "अलर्ट टेस्ट करें",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "अलर्ट टेस्ट, \"परेशान न करें\" और फ़ोन की सेटिंग्स सेटिंग्स > सूचनाएँ और अलार्म में हैं।",
 "Testar e conferir": "टेस्ट और जाँच",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "आइटम के सभी विकल्प: संपादित करें, ले जाएँ, शेयर करें, संग्रहीत करें, हटाएँ...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "बटनों, + बटन और चयनित आइटम के लिए {tema} थीम का कोई रंग टैप करें।",
 "Total: {dur}": "कुल: {dur}",
 "Tropical": "ट्रॉपिकल",
 "Turquesa": "फ़िरोज़ी",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "My Planner के आपके सारे डेटा वाली एक फ़ाइल, सहेजने या कहीं और ले जाने के लिए (पोर्टेबिलिटी, LGPD)।",
 "Usar no computador, pelo navegador": "कंप्यूटर पर ब्राउज़र से इस्तेमाल करें",
 "Usar o padrão": "डिफ़ॉल्ट इस्तेमाल करें",
 "Usar o padrão ({emoji})": "डिफ़ॉल्ट इस्तेमाल करें ({emoji})",
 "Use o app no celular para baixar o arquivo.": "फ़ाइल डाउनलोड करने के लिए फ़ोन पर ऐप इस्तेमाल करें।",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "सभी टैब पर लागू होता है। हर टैब का अपना सेटिंग्स > टैब में हो सकता है।",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "ब्रेक वाले कार्यों पर लागू होते हैं। हर कार्य अपने रिकॉर्ड में अलार्म और इमोजी बदल सकता है।",
 "Ver lista": "सूची देखें",
 "Ver o CPF inteiro": "पूरा CPF देखें",
 "Verde-floresta": "फ़ॉरेस्ट ग्रीन",
 "Verde-água": "एक्वा ग्रीन",
 "Vibração": "वाइब्रेशन",
 "Vinho": "वाइन",
 "Você pediu para ser avisado agora.": "आपने अभी सूचित किए जाने को कहा था।",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "आप कर सकते हैं: पुष्टि करें कि हम आपका डेटा प्रोसेस करते हैं या नहीं, उसे देखें, सुधारें, पोर्टेबिलिटी माँगें (सेटिंग्स > मेरी जानकारी में अपना डेटा डाउनलोड करें), हटाने का अनुरोध करें, जानें कि हम किसके साथ साझा करते हैं, सहमति वापस लें और ANPD में शिकायत करें।",
 "Voltar ao filtro": "फ़िल्टर पर वापस जाएँ",
 "Voltar à lista": "सूची पर वापस जाएँ",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "सेटिंग्स › My Planner Web में जाएँ और \"ब्राउज़र कनेक्ट करें\" पर टैप करें।",
 "atividade {n} de {total}": "गतिविधि {n} / {total}",
 "matéria {n} de {t}": "विषय {n} / {t}",
 "padrão": "डिफ़ॉल्ट",
 "pausa em {n} min": "{n} मिनट में ब्रेक",
 "pausa {n} de {total}": "ब्रेक {n} / {total}",
 "termina em {n} min": "{n} मिनट में समाप्त",
 "todas as vezes": "सभी बारियाँ",
 "troca em {n} min": "{n} मिनट में बदलाव",
 "volta em {n} min": "{n} मिनट में वापसी",
 "{nome} · {n} dia(s)": "{nome} · {n} दिन",
 "{n} de {total} vezes": "{total} में से {n} बार",
 "{n} itens arquivados": "{n} आइटम संग्रहीत किए गए",
 "{n} itens excluídos": "{n} आइटम हटाए गए",
 "{n} marcada(s)": "{n} चयनित",
 "{n} vezes": "{n} बार",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} मिनट / {total}",
 "📔 Diário": "📔 डायरी",
 "Agendados": "निर्धारित",
 "Atrasado": "बकाया",
 "Atrasado: {v}": "बकाया: {v}",
 "Atualizar o a receber": "प्राप्य अपडेट करें",
 "Até (fim do contrato, se houver)": "तक (अनुबंध की समाप्ति, यदि हो)",
 "Clínica": "क्लिनिक",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "हर वह दिन गिना जाता है जिसमें हाज़िरी ली गई हो या पाठ योजना \"कक्षा हो गई\" के रूप में चिह्नित हो।",
 "Data do recebimento": "प्राप्ति की तारीख",
 "Data prevista do pagamento": "भुगतान की अनुमानित तारीख",
 "Desmarcar como recebido": "प्राप्त का निशान हटाएँ",
 "Dia do pagamento": "भुगतान का दिन",
 "Diferença: {v} (juros/multa)": "अंतर: {v} (ब्याज/जुर्माना)",
 "Diferença: {v} (taxas/descontos)": "अंतर: {v} (शुल्क/छूट)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "स्कूल, विश्वविद्यालय और कोचिंग संस्थान जो आपको भुगतान करते हैं। निश्चित वेतन पर ऐप हर महीने प्राप्य बनाता है; प्रति घंटा-कक्षा पर, संस्थान से जुड़ी कक्षाओं में दी गई कक्षाएँ जोड़ता है।",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "भुगतान का प्रकार चुनें (संपादित करें) ताकि ऐप आपकी प्राप्य राशि की गणना कर सके।",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "यह राशि {aba} टैब के \"मैं कहाँ काम करता/करती हूँ\" भाग से आती है। यहाँ प्राप्त के रूप में चिह्नित करें या संस्थान देखने के लिए टैब खोलें।",
 "Ex.: Colégio Estadual, Universidade Federal": "उदा.: राजकीय विद्यालय, केंद्रीय विश्वविद्यालय",
 "Ex.: Hospital Santa Casa, Clínica Vida": "उदा.: सांता कासा अस्पताल, वीडा क्लिनिक",
 "Ex.: Salário de outubro, 13º, férias": "उदा.: अक्टूबर का वेतन, 13वाँ वेतन, छुट्टियाँ",
 "Feitos": "किए गए",
 "Horas-aula de cada aula": "हर कक्षा के घंटे-कक्षा",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "अस्पताल और क्लिनिक जो आपको भुगतान करते हैं। निश्चित वेतन पर ऐप हर महीने प्राप्य बनाता है; प्रति शिफ्ट या परामर्श पर, किए गए चिह्नित करें और ऐप गणना करेगा।",
 "Hospital": "अस्पताल",
 "Instituição": "संस्थान",
 "Instituição (Onde trabalho)": "संस्थान (मैं कहाँ काम करता/करती हूँ)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "कक्षाओं को इस संस्थान से जोड़ें (कक्षा में, संपादित करें › संस्थान) ताकि ऐप दी गई कक्षाएँ जोड़ सके।",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "हर शिफ्ट या परामर्श को किया गया चिह्नित करें: ऐप जोड़कर महीने की राशि की गणना करता है।",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "इस संस्थान में की गई हर शिफ्ट या परामर्श को चिह्नित करें। ऐप जोड़कर महीने की प्राप्य राशि की गणना करता है।",
 "Nome da instituição": "संस्थान का नाम",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "संस्थान को आपको हर महीने क्या देना है। पैसा आने पर प्राप्त के रूप में चिह्नित करें: यह वित्त टैब में भी जाएगा।",
 "Onde trabalho": "मैं कहाँ काम करता/करती हूँ",
 "Plantão": "शिफ्ट",
 "Plantão ou atendimento": "शिफ्ट या परामर्श",
 "Plantões e atendimentos": "शिफ्ट और परामर्श",
 "Por atendimento ou procedimento": "प्रति परामर्श या प्रक्रिया",
 "Por hora-aula": "प्रति घंटा-कक्षा",
 "Por plantão": "प्रति शिफ्ट",
 "Previsto: {v}": "अनुमानित: {v}",
 "Previsão do mês: {v}": "महीने का अनुमान: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "मात्रा (कक्षाएँ, शिफ्ट या परामर्श)",
 "Recebe no mês seguinte ao trabalhado": "काम किए गए महीने के अगले महीने में प्राप्त",
 "Receber: {t}": "प्राप्य: {t}",
 "Recebimentos": "प्राप्तियाँ",
 "Salário": "वेतन",
 "Salário (valor do mês)": "वेतन (महीने की राशि)",
 "Salário fixo": "निश्चित वेतन",
 "Telefone (RH ou financeiro)": "फ़ोन (HR या वित्त)",
 "Tipo de pagamento": "भुगतान का प्रकार",
 "Universidade": "विश्वविद्यालय",
 "Valor da hora-aula": "घंटा-कक्षा की दर",
 "Valor de cada um (se for diferente)": "हर एक की राशि (यदि अलग हो)",
 "Valor do plantão": "शिफ्ट की राशि",
 "Valor por atendimento ou procedimento": "प्रति परामर्श या प्रक्रिया राशि",
 "Valor previsto": "अनुमानित राशि",
 "feito": "किया गया",
 "recebido em {d}": "{d} को प्राप्त",
 "{n} aula(s) dada(s)": "{n} कक्षा(एँ) दी गईं",
 "{n} hora(s)-aula": "{n} घंटा-कक्षा",
 "{n} plantão(ões)": "{n} शिफ्ट",
 "Abas do My Planner Anne": "My Planner Anne के टैब",
 "Acesso ao Não perturbe": "परेशान न करें की एक्सेस",
 "Alarme dos remédios (mesmo no silencioso)": "दवा का अलार्म (साइलेंट में भी)",
 "Algodão-doce": "कॉटन कैंडी",
 "Aplicar tema": "थीम लागू करें",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "हर थीम के अपने रंग: गुलाबी फूल, हरी पत्तियाँ, नीला आसमान...",
 "Assim ficam as letras no app.": "ऐप में अक्षर ऐसे दिखेंगे।",
 "Automática": "स्वचालित",
 "Baht tailandês": "थाई बाट",
 "Boliviano": "बोलिवियाई बोलिवियानो",
 "Bolívar venezuelano": "वेनेज़ुएलाई बोलिवर",
 "Botão": "बटन",
 "Buscar moeda": "मुद्रा खोजें",
 "Cor do desenho": "ड्रॉइंग का रंग",
 "Coroa dinamarquesa": "डेनिश क्रोन",
 "Coroa norueguesa": "नॉर्वेजियन क्रोन",
 "Coroa sueca": "स्वीडिश क्रोना",
 "Coroa tcheca": "चेक कोरुना",
 "Crepúsculo": "गोधूलि",
 "Crescente": "बढ़ती हुई",
 "Curta": "छोटी",
 "Despesas em outra moeda (fora do lucro): {v}": "दूसरी मुद्रा में खर्च (लाभ से बाहर): {v}",
 "Dirham dos Emirados Árabes Unidos": "संयुक्त अरब अमीरात दिरहम",
 "Dirham marroquino": "मोरक्कन दिरहम",
 "Do seu país": "आपके देश की",
 "Dong vietnamita": "वियतनामी डोंग",
 "Dupla": "दोहरी",
 "Dólar americano": "अमेरिकी डॉलर",
 "Dólar australiano": "ऑस्ट्रेलियाई डॉलर",
 "Dólar canadense": "कनाडाई डॉलर",
 "Dólar de Hong Kong": "हांगकांग डॉलर",
 "Dólar de Singapura": "सिंगापुर डॉलर",
 "Dólar neozelandês": "न्यूज़ीलैंड डॉलर",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "इस सूची के सभी आइटम भेजता है, बाद में बनाए जाने वाले नए आइटम भी।",
 "Enviar todos para a equipe": "सभी टीम को भेजें",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "चुनें कि इस दवा का अलार्म फ़ोन साइलेंट होने पर भी बजे या नहीं।",
 "Euro": "यूरो",
 "Exemplo": "उदाहरण",
 "Falta uma resposta": "एक उत्तर बाकी है",
 "Folha, tema e cores da caneta e das letras": "पेज, थीम और पेन व अक्षरों के रंग",
 "Franco suíço": "स्विस फ़्रैंक",
 "Guarani paraguaio": "पैराग्वेयन गुआरानी",
 "Hryvnia ucraniana": "यूक्रेनी रिव्निया",
 "Iene japonês": "जापानी येन",
 "Kwanza angolano": "अंगोलन क्वांज़ा",
 "Libra egípcia": "मिस्री पाउंड",
 "Libra esterlina": "ब्रिटिश पाउंड स्टर्लिंग",
 "Lira turca": "तुर्की लीरा",
 "Longa": "लंबी",
 "Mais usadas": "सबसे ज़्यादा इस्तेमाल",
 "Metical moçambicano": "मोज़ाम्बिकन मेटिकल",
 "Na página, segurar a bolinha faz o mesmo.": "पेज पर बिंदु को दबाकर रखने से भी यही होता है।",
 "Naira nigeriana": "नाइजीरियाई नाइरा",
 "Nenhuma moeda encontrada": "कोई मुद्रा नहीं मिली",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Android पर, \"परेशान न करें\" चालू होने पर दवा का अलार्म बजने के लिए फ़ोन को My Planner को \"परेशान न करें\" की एक्सेस देनी होगी। \"सेटिंग्स खोलें\" पर टैप करें, सूची में My Planner ढूँढें और अनुमति चालू करें।",
 "No My Planner": "My Planner में",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "iPhone पर, फ़ोन का साइलेंट मोड अलार्म को रोक सकता है। फ़ोन को सामान्य मोड में रखें।",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "iPhone पर, ▶ हर प्रकार का एक अंदाज़ा दिखाता है। असली सूचनाएँ iPhone के मानक वाइब्रेशन का उपयोग करती हैं।",
 "Novo dólar taiwanês": "नया ताइवान डॉलर",
 "Novo shekel israelense": "नया इज़राइली शेकेल",
 "Ouvir/Sentir": "सुनें/महसूस करें",
 "Peso argentino": "अर्जेंटीनी पेसो",
 "Peso chileno": "चिली पेसो",
 "Peso colombiano": "कोलंबियाई पेसो",
 "Peso filipino": "फ़िलिपीनी पेसो",
 "Peso mexicano": "मैक्सिकन पेसो",
 "Peso uruguaio": "उरुग्वे पेसो",
 "Política de privacidade": "गोपनीयता नीति",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "हो गया। स्क्रीन लॉक करें और 1 मिनट प्रतीक्षा करें: सूचना बिना आवाज़ के दिखनी चाहिए।",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "हो गया। स्क्रीन लॉक करें और 1 मिनट प्रतीक्षा करें: सूचना बिना आवाज़ के, वाइब्रेट करते हुए दिखनी चाहिए।",
 "Páginas e canetas": "पेज और पेन",
 "Pôr do sol": "सूर्यास्त",
 "Rand sul-africano": "दक्षिण अफ़्रीकी रैंड",
 "Real brasileiro": "ब्राज़ीलियाई रियाल",
 "Ringgit malaio": "मलेशियाई रिंगित",
 "Riyal saudita": "सऊदी रियाल",
 "Rublo russo": "रूसी रूबल",
 "Rupia indiana": "भारतीय रुपया",
 "Rupia indonésia": "इंडोनेशियाई रुपिया",
 "Rupia paquistanesa": "पाकिस्तानी रुपया",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "अगर सूची में My Planner नहीं दिखता, तो यह अनुमति ऐप के अगले संस्करण में आएगी (स्टोर से अपडेट करें)।",
 "Sentir": "महसूस करें",
 "Sol peruano": "पेरूवियन सोल",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "ये पेजों पर पेन और अक्षरों के त्वरित रंग हैं। पहला रंग पेज खोलने पर डिफ़ॉल्ट रंग होता है। किसी बिंदु का रंग बदलने के लिए उस पर टैप करें।",
 "Taka bengali": "बांग्लादेशी टका",
 "Teste grátis por {n} dias": "{n} दिन का मुफ़्त ट्रायल",
 "Tipo de vibração": "वाइब्रेशन का प्रकार",
 "Tirar do My Planner": "My Planner से हटाएँ",
 "Tocar mesmo no silencioso e no Não perturbe": "साइलेंट और परेशान न करें में भी बजाएँ",
 "Tocar só se o celular estiver no normal": "केवल तब बजाएँ जब फ़ोन सामान्य मोड में हो",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "इस सूची के सभी आइटम My Planner में दिखते हैं, नए आइटम भी।",
 "Vaga-lume": "जुगनू",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "वाइब्रेट होने वाली सभी सूचनाओं पर लागू (वाइब्रेशन और आवाज़ व वाइब्रेशन)।",
 "Won sul-coreano": "दक्षिण कोरियाई वॉन",
 "Xelim queniano": "केन्याई शिलिंग",
 "Yuan chinês": "चीनी युआन",
 "Zloty polonês": "पोलिश ज़्लॉटी",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 क्या इस दवा का अलार्म फ़ोन साइलेंट होने पर भी बजना चाहिए?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "फ़ोटो गैलरी ऐप के अगले संस्करण में आएगी। फ़िलहाल, फ़ाइलें या फ़ोटो लें का उपयोग करें।",
 "Abrir o fichário do grupo": "समूह का बाइंडर खोलें",
 "Arrastar a barra": "बार खींचें",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "बाइंडर साझा होते ही यहाँ दिखाई देगा।",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "नाम से आइकन खोजें (जैसे: किताब, घर, कॉफ़ी)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "पढ़ाई टैब में आप अपने बाइंडर बना सकते हैं, टाइमर चला सकते हैं, अपनी रिपोर्ट देख सकते हैं और भी बहुत कुछ। ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "{aba} टैब में आप अपनी चीज़ें बनाते हैं और सभी सुविधाओं का उपयोग करते हैं। ✨",
 "Conhecer a aba": "टैब देखें",
 "Crie um fichário em Estudos e volte aqui.": "पढ़ाई में एक बाइंडर बनाएँ और फिर यहाँ लौटें।",
 "Em sessão": "सत्र में",
 "Encerrar e salvar o cronômetro e começar a sessão?": "टाइमर समाप्त करके सहेजें और सत्र शुरू करें?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "टाइमर समाप्त करके सहेजें और सत्र जारी रखें?",
 "Enquadre e toque no botão": "फ़्रेम में लाएँ और बटन पर टैप करें",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "वह बाइंडर चुनें जिसे साथी स्क्रीन पर देखेंगे (केवल पढ़ने के लिए)।",
 "Esconder": "छिपाएँ",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "यह फ़ाइल केवल साझा करने वाले के डिवाइस या Drive में सहेजी गई है, इसलिए यहाँ नहीं दिखती।",
 "Fichário do grupo": "समूह का बाइंडर",
 "Guia passo a passo do app e de cada aba": "ऐप और हर टैब की चरण-दर-चरण गाइड",
 "Há um cronômetro em andamento.": "एक टाइमर चल रहा है।",
 "Há uma sessão em andamento.": "एक सत्र चल रहा है।",
 "Inserir imagem": "चित्र डालें",
 "Mais ícones": "और आइकन",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "इस नाम का कोई आइकन नहीं मिला। कोई दूसरा शब्द आज़माएँ या किसी श्रेणी से चुनें।",
 "Nenhuma matéria neste fichário ainda.": "इस बाइंडर में अभी कोई विषय नहीं है।",
 "Nenhuma página nesta matéria ainda.": "इस विषय में अभी कोई पेज नहीं है।",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "अध्ययन समूह में, चित्र और PDF यहीं स्क्रीन पर खुलते हैं। इस प्रकार की फ़ाइल का ऐप के अंदर पूर्वावलोकन नहीं होता।",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "अभी दिखाया नहीं जा सका। अपना इंटरनेट जाँचें और फिर से कोशिश करें।",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "बाइंडर साझा करने की सुविधा अभी तैयार की जा रही है। थोड़ी देर बाद फिर आएँ।",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "इस समूह का बाइंडर आपके दूसरे डिवाइस पर है। वह वहीं से साझा होता रहेगा।",
 "OK = Conhecer a aba · Cancelar = Agora não": "ठीक है = टैब देखें · रद्द करें = अभी नहीं",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "साथी अब बाइंडर नहीं देख पाएँगे। सब कुछ आपके पास बना रहेगा।",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "साथी इस बाइंडर को स्क्रीन पर केवल पढ़ने के लिए देखते हैं: वे संपादित, डाउनलोड, प्रिंट या साझा नहीं कर सकते। आपके लक्ष्य, टाइमर और दोहराए गए पेज केवल आपके ही रहते हैं।",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "यहाँ स्क्रीन पर PDF देखने के लिए, स्टोर से ऐप का नवीनतम संस्करण इंस्टॉल करें।",
 "Parar de compartilhar": "साझा करना बंद करें",
 "Pausar a sessão": "सत्र रोकें",
 "Pausar a sessão e estudar só esta?": "सत्र रोककर केवल यही पढ़ें?",
 "Página em branco.": "खाली पेज।",
 "Quer estudar com tudo isso?": "क्या आप इन सबके साथ पढ़ाई करना चाहते हैं?",
 "Quer usar tudo isso?": "क्या आप इन सबका उपयोग करना चाहते हैं?",
 "Selecionar todos": "सभी चुनें",
 "Trocar fichário": "बाइंडर बदलें",
 "Você está participando do grupo de {nome}": "आप {nome} के समूह में भाग ले रहे हैं",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "इस समूह में जो साझा किया गया है उसे आप स्क्रीन पर पढ़ने और देखने के लिए देख सकते हैं।",
 "abacate, fruta": "एवोकाडो, फल",
 "academia, musculação, treino, peso": "जिम, बॉडीबिल्डिंग, कसरत, वज़न",
 "acampamento, camping": "कैंपिंग, शिविर",
 "alfinete, fixar, importante": "पिन, लगाना, महत्वपूर्ण",
 "almoço, arroz, prato": "दोपहर का खाना, चावल, थाली",
 "alvo, meta, objetivo, foco": "निशाना, लक्ष्य, उद्देश्य, फ़ोकस",
 "aniversário, bolo": "जन्मदिन, केक",
 "anotação, nota, lista, escrever": "नोट, टिप्पणी, सूची, लिखना",
 "arco-íris": "इंद्रधनुष",
 "avião, viagem, voo": "हवाई जहाज़, यात्रा, उड़ान",
 "balança, direito, justiça, lei, processo": "तराज़ू, क़ानून, न्याय, विधि, मुक़दमा",
 "balde, limpeza": "बाल्टी, सफ़ाई",
 "banana, fruta": "केला, फल",
 "banheira, banho, banheiro": "बाथटब, नहाना, बाथरूम",
 "barbear, barba, lâmina": "शेव, दाढ़ी, ब्लेड",
 "bicicleta, pedalar, bike": "साइकिल, साइकिल चलाना, बाइक",
 "bolo, doce, sobremesa": "केक, मिठाई, डेज़र्ट",
 "brilho, mágica": "चमक, जादू",
 "cabelo, cabeleireiro, corte": "बाल, नाई, कटिंग",
 "cachorro, cão, pet": "कुत्ता, श्वान, पालतू",
 "caderno": "नोटबुक",
 "caderno, fichário, amarelo": "नोटबुक, बाइंडर, पीला",
 "café, xícara, pausa": "कॉफ़ी, कप, ब्रेक",
 "caixa, pacote, mudança, entrega": "डिब्बा, पैकेट, शिफ़्टिंग, डिलीवरी",
 "calendário, agenda, data": "कैलेंडर, अजेंडा, तारीख़",
 "cama, quarto": "बिस्तर, कमरा",
 "caminhada, caminhar, andar": "सैर, टहलना, चलना",
 "camisa, gravata, roupa, trabalho": "शर्ट, टाई, कपड़े, काम",
 "carne, churrasco": "मांस, बारबेक्यू",
 "carrinho, mercado, compras, supermercado": "ट्रॉली, बाज़ार, ख़रीदारी, सुपरमार्केट",
 "carro, dirigir, veículo": "कार, गाड़ी चलाना, वाहन",
 "certo, feito, visto": "सही, हो गया, टिक",
 "cesto, roupa, lavanderia, lavar roupa": "टोकरी, कपड़े, लॉन्ड्री, कपड़े धोना",
 "chave de fenda, ferramenta, conserto": "पेचकस, औज़ार, मरम्मत",
 "chave, senha": "चाबी, पासवर्ड",
 "chocolate, doce": "चॉकलेट, मिठाई",
 "chuveiro, banho": "शावर, नहाना",
 "chá, xícara": "चाय, कप",
 "compras, sacolas, shopping": "ख़रीदारी, थैले, शॉपिंग",
 "computador, monitor, tela": "कंप्यूटर, मॉनिटर, स्क्रीन",
 "computador, notebook, informática": "कंप्यूटर, लैपटॉप, आईटी",
 "coração amarelo": "पीला दिल",
 "coração azul": "नीला दिल",
 "coração branco": "सफ़ेद दिल",
 "coração laranja": "नारंगी दिल",
 "coração roxo": "बैंगनी दिल",
 "coração verde": "हरा दिल",
 "coração, amor, saúde, vermelho": "दिल, प्यार, स्वास्थ्य, लाल",
 "corrida, correr": "दौड़, दौड़ना",
 "creme, hidratante, pele, skincare": "क्रीम, मॉइस्चराइज़र, त्वचा, स्किनकेयर",
 "croissant, pão, café da manhã": "क्रोसां, ब्रेड, नाश्ता",
 "câmera, foto, fotografia": "कैमरा, फ़ोटो, फ़ोटोग्राफ़ी",
 "cérebro, mente, memória, pensar": "दिमाग़, मन, याददाश्त, सोचना",
 "dado, jogo de tabuleiro": "पासा, बोर्ड गेम",
 "dente, dentista": "दाँत, दंत चिकित्सक",
 "despertador, relógio, alarme, acordar": "अलार्म घड़ी, घड़ी, अलार्म, जागना",
 "diamante, joia": "हीरा, गहना",
 "dinheiro, pagar, conta, pagamento": "पैसा, भुगतान करना, बिल, भुगतान",
 "dormir, sono, descanso": "सोना, नींद, आराम",
 "e-mail, mensagem, carta": "ईमेल, संदेश, पत्र",
 "escada": "सीढ़ी",
 "escova de dentes, dentes": "टूथब्रश, दाँत",
 "escrever, redação, caneta": "लिखना, निबंध, पेन",
 "esponja, lavar louça": "स्पंज, बर्तन धोना",
 "esquadro, régua, geometria, desenho técnico": "सेट स्क्वेयर, रूलर, ज्यामिति, तकनीकी ड्रॉइंग",
 "estrela brilhante, destaque": "चमकता तारा, ख़ास",
 "estrela, favorito": "तारा, पसंदीदा",
 "etiqueta, marcador": "टैग, मार्कर",
 "extintor, segurança, incêndio": "अग्निशामक, सुरक्षा, आग",
 "falar, idioma, inglês, conversa": "बोलना, भाषा, अंग्रेज़ी, बातचीत",
 "feito, concluído, certo": "हो गया, पूरा, सही",
 "ferramenta, conserto, manutenção": "औज़ार, मरम्मत, रखरखाव",
 "festa, comemoração": "पार्टी, जश्न",
 "filme, cinema, série": "फ़िल्म, सिनेमा, सीरीज़",
 "fogo, urgente, sequência": "आग, ज़रूरी, स्ट्रीक",
 "folha, natureza, erva, chá": "पत्ता, प्रकृति, जड़ी-बूटी, चाय",
 "fone de ouvido, áudio, música, podcast": "हेडफ़ोन, ऑडियो, संगीत, पॉडकास्ट",
 "formatura, capelo, faculdade, diploma, universidade": "दीक्षांत, ग्रेजुएशन टोपी, कॉलेज, डिग्री, विश्वविद्यालय",
 "força, braço, músculo": "ताक़त, बाँह, मांसपेशी",
 "frango, coxa": "चिकन, लेग पीस",
 "frigideira, cozinhar, ovo, cozinha": "फ्राइंग पैन, खाना बनाना, अंडा, रसोई",
 "futebol, bola, esporte": "फ़ुटबॉल, गेंद, खेल",
 "gato, pet": "बिल्ली, पालतू",
 "gelo, geladeira, congelador": "बर्फ़, फ़्रिज, फ़्रीज़र",
 "gráfico, planilha, finanças, relatório": "चार्ट, स्प्रेडशीट, वित्त, रिपोर्ट",
 "ingresso, show, evento": "टिकट, शो, कार्यक्रम",
 "jogo, videogame, game": "गेम, वीडियो गेम, खेल",
 "lancha, barco": "मोटरबोट, नाव",
 "leite, copo": "दूध, गिलास",
 "letras, alfabeto, português": "अक्षर, वर्णमाला, भाषा",
 "link, corrente": "लिंक, चेन",
 "livro aberto, leitura, ler": "खुली किताब, पठन, पढ़ना",
 "livro azul, caderno": "नीली किताब, नोटबुक",
 "livro laranja, caderno": "नारंगी किताब, नोटबुक",
 "livro verde, caderno": "हरी किताब, नोटबुक",
 "livro vermelho, caderno": "लाल किताब, नोटबुक",
 "livros, estudo, estudar, biblioteca": "किताबें, अध्ययन, पढ़ाई, पुस्तकालय",
 "lixo, lixeira": "कचरा, कूड़ेदान",
 "lua, noite": "चाँद, रात",
 "lâmpada, ideia, luz": "बल्ब, विचार, रोशनी",
 "macarrão, massa": "पास्ता, नूडल्स",
 "maleta, trabalho, escritório, negócios": "ब्रीफ़केस, काम, ऑफ़िस, व्यवसाय",
 "massagem, relaxar": "मालिश, आराम",
 "maçã, fruta": "सेब, फल",
 "microfone, cantar, karaokê, palestra": "माइक्रोफ़ोन, गाना, कराओके, व्याख्यान",
 "microscópio, ciência, biologia": "माइक्रोस्कोप, विज्ञान, जीवविज्ञान",
 "mochila, escola, filhos": "बस्ता, स्कूल, बच्चे",
 "montanha, trilha": "पहाड़, ट्रेकिंग",
 "mundo, planeta, geografia": "दुनिया, ग्रह, भूगोल",
 "médico, consulta, exame, saúde": "डॉक्टर, परामर्श, जाँच, स्वास्थ्य",
 "música, nota musical": "संगीत, सुर",
 "natação, nadar, piscina": "तैराकी, तैरना, स्विमिंग पूल",
 "olho, visão, oftalmologista": "आँख, दृष्टि, नेत्र रोग विशेषज्ञ",
 "oração, orar, gratidão, igreja": "प्रार्थना, प्रार्थना करना, आभार, चर्च",
 "ovo": "अंडा",
 "pastas, arquivo, fichário, divisórias": "फ़ोल्डर, फ़ाइल, बाइंडर, विभाजक",
 "peixe": "मछली",
 "pescaria, pescar": "मछली पकड़ना, मछलीबाज़ी",
 "pessoas, reunião, equipe, grupo": "लोग, बैठक, टीम, समूह",
 "piano, teclado musical": "पियानो, कीबोर्ड",
 "pintura, arte, desenho": "पेंटिंग, कला, चित्रकारी",
 "pipa": "पतंग",
 "pipoca, cinema": "पॉपकॉर्न, सिनेमा",
 "pizza": "पिज़्ज़ा",
 "planta, vaso, regar": "पौधा, गमला, पानी देना",
 "porta, entrada": "दरवाज़ा, प्रवेश",
 "praia, férias": "समुद्र तट, छुट्टियाँ",
 "prato, refeição, louça, jantar": "थाली, भोजन, बर्तन, रात का खाना",
 "prédio, história, governo, tribunal": "इमारत, इतिहास, सरकार, अदालत",
 "pão, padaria": "ब्रेड, बेकरी",
 "pé, podólogo": "पैर, पोडियाट्रिस्ट",
 "pôr do sol, amanhecer": "सूर्यास्त, सूर्योदय",
 "quebra-cabeça, peça": "पहेली, टुकड़ा",
 "queijo": "चीज़, पनीर",
 "raio, energia, rápido": "बिजली, ऊर्जा, तेज़",
 "refrigerante, suco, bebida": "सॉफ़्ट ड्रिंक, जूस, पेय",
 "remédio, medicamento, vitamina, farmácia": "दवा, औषधि, विटामिन, फ़ार्मेसी",
 "sabão, sabonete, lavar": "साबुन, साबुन की टिकिया, धोना",
 "salada, dieta, verdura": "सलाद, डाइट, सब्ज़ी",
 "sanduíche, lanche": "सैंडविच, नाश्ता",
 "sino, aviso, lembrete": "घंटी, सूचना, रिमाइंडर",
 "skate": "स्केटबोर्ड",
 "sofá, sala": "सोफ़ा, बैठक",
 "sol, manhã, dia": "सूरज, सुबह, दिन",
 "spa, sauna, autocuidado": "स्पा, सौना, सेल्फ़-केयर",
 "teatro, máscaras": "रंगमंच, मुखौटे",
 "telefone, ligação, ligar": "फ़ोन, कॉल, कॉल करना",
 "tigela, cereal, sopa, mingau": "कटोरा, सीरियल, सूप, दलिया",
 "trevo, sorte": "तिपतिया, भाग्य",
 "troféu, conquista, prêmio": "ट्रॉफ़ी, उपलब्धि, पुरस्कार",
 "tubo de ensaio, química, laboratório": "टेस्ट ट्यूब, रसायन, प्रयोगशाला",
 "tênis, esporte": "टेनिस, खेल",
 "unha, manicure": "नाख़ून, मैनीक्योर",
 "vassoura, limpeza, faxina, varrer": "झाड़ू, सफ़ाई, साफ़-सफ़ाई, झाड़ू लगाना",
 "violão, guitarra": "गिटार, इलेक्ट्रिक गिटार",
 "yoga, meditação, alongamento": "योग, ध्यान, स्ट्रेचिंग",
 "{n} selecionada": "{n} चयनित",
 "{n} selecionadas": "{n} चयनित",
 "{n} selecionado": "{n} चयनित",
 "{n} selecionados": "{n} चयनित",
 "ábaco, matemática, contas, cálculo, contabilidade": "अबेकस, गणित, हिसाब, गणना, लेखांकन",
 "água, gota, hidratar": "पानी, बूँद, हाइड्रेट",
 "árvore, jardim, quintal": "पेड़, बगीचा, आँगन",
 "ônibus, transporte": "बस, परिवहन",
 "1 dia antes": "1 दिन पहले",
 "1 dia depois": "1 दिन बाद",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "सब्सक्रिप्शन फ़ोन के ऐप में ऐप स्टोर से लिया जाता है, और यहाँ साइट पर भी मान्य होता है।",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "की अधूरी है (बहुत छोटी)। की वाले पेज के कॉपी बटन से फिर से कॉपी करें।",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "की में ऐसे अक्षर हैं जो की का हिस्सा नहीं हैं। फिर से कॉपी करें, सिर्फ़ की, आसपास के टेक्स्ट के बिना।",
 "A galeria chega na próxima atualização do app.": "गैलरी ऐप के अगले अपडेट में आएगी।",
 "ALERTAS": "अलर्ट",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "कोई पेड टैब खोलें और मुफ़्त ट्रायल शुरू करें। फिर यहाँ वापस आएँ।",
 "Abrir a barra do editor": "एडिटर बार खोलें",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "अभी ऐप के परेशान न करें का समय है: सूचना 5 सेकंड में आएगी, बिना ध्वनि और बिना वाइब्रेशन के।",
 "Aguardando confirmação": "पुष्टि का इंतज़ार",
 "Aguardando envio ao My Planner": "My Planner पर भेजे जाने का इंतज़ार",
 "Alertas de cada fatura": "हर बिल के अलर्ट",
 "Alertas do fim da garantia": "वारंटी खत्म होने के अलर्ट",
 "Alertas do vencimento": "देय तारीख के अलर्ट",
 "Alertas: {campo}": "अलर्ट: {campo}",
 "Alvorada": "भोर",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "यह टैब खोलने पर ऐप वही अनलॉक माँगता है जो ऐप का है (पासवर्ड, बायोमेट्रिक या PIN)। इसे सेटिंग्स > टैब में बदल सकते हैं।",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "अटैच की गई फ़ाइल पर टैप करने पर वह आपके चुने हुए फ़ोन ऐप में खुलती है (अगर फ़ोन पूछे, तो \"सिर्फ़ एक बार\" या \"हमेशा\")। वहाँ किए गए बदलाव उसी फ़ाइल में सेव रहते हैं।",
 "App instalado": "इंस्टॉल किया गया ऐप",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: यह पहले से ही सब कुछ फ़ोन के Health ऐप में रिकॉर्ड करती है। कुछ करने की ज़रूरत नहीं।",
 "Arquivados e fixados": "संग्रहीत और पिन किए गए",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "पढ़ने और रखने के लिए फ़ाइल, टैब के अनुसार व्यवस्थित। {data} को बनाई गई।",
 "As notificações do My Planner estão desligadas no celular.": "फ़ोन पर My Planner की सूचनाएँ बंद हैं।",
 "Atualização automática disponível no app instalado.": "इंस्टॉल किए गए ऐप में अपने-आप अपडेट उपलब्ध है।",
 "Aurora": "ऑरोरा",
 "Avisos: alarme (som)": "सूचनाएँ: अलार्म (ध्वनि)",
 "Baixar o app": "ऐप डाउनलोड करें",
 "Baixar o arquivo técnico": "तकनीकी फ़ाइल डाउनलोड करें",
 "Baixar para ler (PDF)": "पढ़ने के लिए डाउनलोड करें (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "एडिटर बार (पेन, हाइलाइटर, टेक्स्ट)",
 "Brisa": "हवा का झोंका",
 "Campainha": "घंटी की आवाज़",
 "Canal": "चैनल",
 "Cole a chave antes de testar.": "टेस्ट करने से पहले की पेस्ट करें।",
 "Começa em": "शुरू होता है",
 "Como avisar": "कैसे सूचित करें",
 "Confira a chave": "की जाँचें",
 "Conta de teste de compras": "खरीदारी टेस्ट खाता",
 "Conta vencida": "बिल की तारीख निकल गई",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "की तुरंत कॉपी करें (यह सिर्फ़ एक बार दिखती है)। यह \"sk-\" से शुरू होती है।",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "की तुरंत कॉपी करें (यह सिर्फ़ एक बार दिखती है)। यह \"sk-ant-\" से शुरू होती है।",
 "Cristal": "क्रिस्टल",
 "Daqui a 1 hora": "1 घंटे बाद",
 "Daqui a 1 semana": "1 हफ़्ते बाद",
 "Daqui a 3 dias": "3 दिन बाद",
 "Depois de 5 min fora": "5 मिनट बाहर रहने के बाद",
 "Depois de 5 minutos fora": "5 मिनट बाहर रहने के बाद",
 "Desligar a senha desta aba": "इस टैब का पासवर्ड बंद करें",
 "Detalhes técnicos": "तकनीकी विवरण",
 "Dia {n} de {t}": "दिन {n} / {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "सुझाव: की पासवर्ड जैसी होती है। इसे मैसेज में न भेजें और न ही सार्वजनिक करें। अगर लीक हो जाए, तो साइट पर इसे मिटाएँ और नई बनाएँ।",
 "Documento vencido": "दस्तावेज़ की समय-सीमा खत्म",
 "Ela abre em {d}.": "यह {d} को खुलेगा।",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "यह {d} को खुलेगा। आपको सूचनाएँ मिलेंगी: {quando}।",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "यह {d} को खुलेगा। आपको एक सूचना मिलेगी: {quando}।",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "\"API keys\" में \"Create key\" (की बनाएँ) पर टैप करें और कोई नाम दें, जैसे \"My Planner\"।",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "\"Billing\" (बिलिंग) में एक कार्ड जोड़ें और कुछ डॉलर का क्रेडिट डालें। ChatGPT Plus सब्सक्रिप्शन यहाँ मान्य नहीं है।",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "\"Billing\" (बिलिंग) में क्रेडिट खरीदें। Claude Pro सब्सक्रिप्शन यहाँ मान्य नहीं है।",
 "Em breve": "जल्द आ रहा है",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "ChatGPT वाले ही खाते से लॉग इन करें या नया बनाएँ।",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "अपने Google खाते से लॉग इन करें (Gmail वाला भी चलेगा)।",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "लॉग इन करें या खाता बनाएँ (Claude वाला ही ईमेल हो सकता है)।",
 "Enviados para o My Planner": "My Planner पर भेजे गए",
 "Enviar agora": "अभी भेजें",
 "Escolha hoje ou uma data futura.": "आज या आगे की कोई तारीख चुनें।",
 "Escolhas lembradas": "याद रखे गए विकल्प",
 "Escolher a data": "तारीख चुनें",
 "Escolher células": "सेल चुनें",
 "Escolher quando": "कब, चुनें",
 "Espessura": "मोटाई",
 "Esquecer": "भूल जाएँ",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "यह की किसी दूसरी सेवा ({servico}) की है। यहाँ सिर्फ़ Claude, ChatGPT या Gemini की की चलती है।",
 "Esta chave é do {ia}, não do {escolhida}.": "यह की {ia} की है, {escolhida} की नहीं।",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "यह खाता ऐप को नए खाते की तरह देखता है, बिना किसी खुले टैब के, ताकि ताले, मुफ़्त ट्रायल और खरीदारी जाँची जा सके। बाकी खाते नहीं बदलते।",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "इस टूल को PDF के पेज देखने होते हैं, जो ऐप के नए वर्ज़न (0.50) के साथ आता है। ब्राउज़र इस्तेमाल करें या स्टोर से My Planner अपडेट करें।",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "यह {ia} की की नहीं लगती। {ia} की की {ini} से शुरू होती है।",
 "Este aviso está em \"Desligado\": nada vai tocar.": "यह सूचना \"बंद\" पर है: कुछ नहीं बजेगा।",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "यह फ़ोन अभी ऐप बंद होने पर सूचनाएँ नहीं पाता। स्टोर से My Planner अपडेट करें (वर्ज़न {v} या नया)। ऐप खुला होने पर सूचनाएँ पहले से काम करती हैं।",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "इस तरह की सूचना फ़ोन की सूचना सेटिंग्स में बंद है।",
 "Estudado": "पढ़ाई हुई",
 "Estudado: {dur}": "पढ़ाई हुई: {dur}",
 "Faltou: {dur}": "बाकी रहा: {dur}",
 "Fazer os testes terminarem agora": "ट्रायल अभी खत्म करें",
 "Fechar a barra do editor": "एडिटर बार बंद करें",
 "Fichário": "बाइंडर",
 "Figurinhas e emojis": "स्टिकर और इमोजी",
 "Garantia terminou": "वारंटी खत्म हो गई",
 "Gerando…": "बनाया जा रहा है…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "दस्तावेज़, जाँच रिपोर्ट और सेहत का इतिहास इसके अपने पासवर्ड से सुरक्षित रखता है। सपोर्ट भी इसे नहीं पढ़ सकता। अगर आप पासवर्ड भूल गए, तो इसे वापस पाने का कोई तरीका नहीं है।",
 "Harpa": "हार्प",
 "Horas por dia": "रोज़ के घंटे",
 "Identificação": "पहचान",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "यह की नहीं, बल्कि कोई लिंक या ईमेल लगता है। API की वाले पेज से पूरी की कॉपी करें।",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "यह My Planner में सिर्फ़ तभी दिखेगा जब आप भेजेंगे। अभी भेजना है?",
 "Já dá para confirmar {titulo}?": "क्या अब {titulo} की पुष्टि कर सकते हैं?",
 "Lembrar minha escolha nesta aba": "इस टैब में मेरा विकल्प याद रखें",
 "Lembrete para confirmar: {data}": "पुष्टि का रिमाइंडर: {data}",
 "Marimba": "मरिम्बा",
 "Marque pelo menos um dia da semana no plano.": "प्लान में हफ़्ते का कम से कम एक दिन चुनें।",
 "Me lembre de confirmar": "मुझे पुष्टि करने की याद दिलाएँ",
 "Me lembre depois": "मुझे बाद में याद दिलाएँ",
 "Menos": "कम",
 "Meta somada": "कुल लक्ष्य",
 "Meta somada: {dur}": "कुल लक्ष्य: {dur}",
 "Meus dados - My Planner {data}": "मेरा डेटा - My Planner {data}",
 "Meus dados do My Planner": "My Planner का मेरा डेटा",
 "Mostrar a barra": "बार दिखाएँ",
 "Mudar senha do diário": "डायरी का पासवर्ड बदलें",
 "Na primeira vez, aceite os termos de uso.": "पहली बार में उपयोग की शर्तें स्वीकार करें।",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "स्टोर वाले वर्ज़न में खरीदारी फ़ोन के ऐप स्टोर से होगी। फ़िलहाल यह की टेस्ट के लिए सब्सक्रिप्शन की नकल करती है।",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "दूसरे टैब से कुछ भी अपने-आप My Planner में नहीं जाता। इन आइटम की तारीख है और ये अभी भेजे नहीं गए हैं।",
 "Nenhum estudo registrado neste mês.": "इस महीने कोई पढ़ाई दर्ज नहीं है।",
 "Nenhum item aguardando envio.": "भेजे जाने के इंतज़ार में कोई आइटम नहीं।",
 "Nenhum teste começado": "कोई ट्रायल शुरू नहीं हुआ",
 "Nesta tela não há nada para adicionar.": "इस स्क्रीन पर जोड़ने के लिए कुछ नहीं है।",
 "No dia": "उसी दिन",
 "Nova nota rápida": "नया क्विक नोट",
 "Nova página do dia": "दिन का नया पेज",
 "Não deu certo": "नहीं हो सका",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "शामिल नहीं हैं: डायरी की सामग्री और तिजोरी के फ़ील्ड (पासवर्ड से सुरक्षित रहते हैं), फ़ोटो और अटैच की गई फ़ाइलें। ऐप में डेटा वापस लाने के लिए तकनीकी फ़ाइल इस्तेमाल करें।",
 "Não foi possível gerar o PDF.": "PDF नहीं बनाई जा सकी।",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "अभी टेस्ट नहीं हो सका। कुछ सेकंड बाद फिर से कोशिश करें।",
 "Não lembrar": "याद न रखें",
 "Não, obrigada": "नहीं, धन्यवाद",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "डायरी अपने पासवर्ड से सुरक्षित है और इस फ़ाइल में शामिल नहीं होती।",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "ऐप \"Files में सेव करें\" खोलता है ताकि आप फ़ोल्डर चुन सकें (iCloud Drive भी हो सकता है)।",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "ऐप सिर्फ़ चुनी गई फ़ाइल का शॉर्टकट रखता है: फ़ाइल जहाँ है वहीं रहती है (Drive, OneDrive, Downloads) और फ़ोन ऐप में खुलती है। कुछ भी कॉपी नहीं होता। यह विकल्प कैमरे से ली गई फ़ोटो पर लागू होता है।",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "इस डिवाइस पर इंस्टॉल ऐप का वर्ज़न {v} है। ऑडियो और वीडियो कॉल के लिए स्टोर से My Planner अपडेट करें (वर्ज़न 0.35 या नया)। मैसेज पहले से काम करते हैं।",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "सूचना चुपचाप, सीधे सूचना सूची में आएगी: फ़ोन की सेटिंग्स में My Planner के अलर्ट चालू करें।",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "सूचना बिना ध्वनि के आएगी: इस तरह की सूचना की ध्वनि फ़ोन की सेटिंग्स में बंद है।",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "सूचना आएगी, लेकिन फ़ोन पर My Planner की सूचनाओं की ध्वनि बंद है।",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "निमंत्रण में ऐप डाउनलोड करने का लिंक होता है। लिंक से आने वाला सीधे ऑफ़िस में पहुँचता है।",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "डिक्टेशन ऐप के नए वर्ज़न के साथ आता है। माइक्रोफ़ोन इस्तेमाल करने के लिए स्टोर से My Planner अपडेट करें।",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "ऐप वाला ही अनलॉक: पासवर्ड, बायोमेट्रिक या PIN। अंदर जाते समय एक बार माँगता है; टैब के अंदर दोबारा नहीं माँगता। गैलरी, कैमरा या फ़ाइलें खोलना बाहर जाना नहीं माना जाता। बड़े आइटम मिटाने के लिए पासवर्ड अब भी माँगा जाता है।",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "फ़ोन का साइलेंट मोड अलार्म को रोक सकता है। फ़ोन को सामान्य मोड में रखें।",
 "O plano fica só em Estudos (não vai para o My Planner).": "प्लान सिर्फ़ पढ़ाई में रहता है (My Planner में नहीं जाता)।",
 "Opcional: prazo, horas por dia e dias da semana.": "वैकल्पिक: समय-सीमा, रोज़ के घंटे और हफ़्ते के दिन।",
 "Os avisos do celular funcionam no app instalado.": "फ़ोन की सूचनाएँ इंस्टॉल किए गए ऐप में काम करती हैं।",
 "Os avisos no celular funcionam no app instalado.": "फ़ोन पर सूचनाएँ इंस्टॉल किए गए ऐप में काम करती हैं।",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "शुरू किए गए ट्रायल खत्म हो गए। \"मुफ़्त ट्रायल खत्म हो गया\" देखने के लिए टैब खोलें।",
 "Outros dados": "अन्य डेटा",
 "Ouvir": "सुनें",
 "Pacote em uso": "इस्तेमाल में पैक",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "सब्सक्राइब करने के लिए फ़ोन के ऐप स्टोर से My Planner अपडेट करें।",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "पढ़ने के लिए (PDF): टैब के अनुसार व्यवस्थित, शीर्षक और तारीखों के साथ। किसी भी डिवाइस या कंप्यूटर पर खुलती है।",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "\"परेशान न करें\" चालू होने पर दवा का अलार्म बजे, इसके लिए फ़ोन को My Planner को \"परेशान न करें\" की एक्सेस देनी होगी। \"सेटिंग्स खोलें\" पर टैप करें, सूची में My Planner ढूँढें और अनुमति चालू करें।",
 "Passo a passo para criar a chave": "की बनाने के चरण",
 "Pedir de novo": "फिर से माँगें",
 "Pedir senha ao abrir esta aba": "यह टैब खोलने पर पासवर्ड माँगें",
 "Plano com período": "अवधि वाला प्लान",
 "Plano começa em {d}": "प्लान {d} को शुरू होता है",
 "Por matéria": "विषय के अनुसार",
 "Prolongar": "आगे बढ़ाएँ",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "हो गया: सूचना 5 सेकंड में ध्वनि के साथ आएगी। अगर न बजे, तो देखें कि फ़ोन साइलेंट पर तो नहीं है।",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "हो गया: सूचना 5 सेकंड में सिर्फ़ वाइब्रेशन के साथ आएगी।",
 "Publicado em": "प्रकाशित",
 "Pulso": "पल्स",
 "Quando o app bloquear": "जब ऐप लॉक हो",
 "Quer proteger esta aba com senha?": "क्या इस टैब को पासवर्ड से सुरक्षित करना है?",
 "Recolher ou arrastar a barra": "बार को समेटें या खींचें",
 "Recomeçar os testes grátis": "मुफ़्त ट्रायल फिर से शुरू करें",
 "Recomeçar os testes grátis?": "मुफ़्त ट्रायल फिर से शुरू करें?",
 "Rolar a folha para os lados": "शीट को दाएँ-बाएँ स्क्रॉल करें",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "अगर आप घड़ी जोड़ते हैं: हर दिन के कदम, दूरी, कैलोरी, व्यायाम, धड़कन और नींद के कुल आँकड़े, Health Connect या फ़ोन के Health ऐप से पढ़े जाते हैं। ऐप सिर्फ़ पढ़ता है और इन आँकड़ों को कभी नहीं बदलता।",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "इंटरनेट नहीं है या कनेक्शन टूट गया। Wi-Fi या मोबाइल डेटा जाँचें और फिर से कोशिश करें।",
 "Senha desta aba": "इस टैब का पासवर्ड",
 "Seu plano terminou": "आपका प्लान खत्म हो गया",
 "Sino": "घंटी",
 "Som do alarme": "अलार्म की ध्वनि",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "कानूनी वारंटी और निर्माता की वारंटी जोड़ता है। वारंटी कार्ड में जाँचें।",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "ये आपके My Planner डेटा वाली दो फ़ाइलें हैं (डेटा पोर्टेबिलिटी, LGPD):",
 "Só quando o app bloquear": "सिर्फ़ जब ऐप लॉक हो",
 "Tamanho da borracha": "इरेज़र का आकार",
 "Tamanho da letra": "अक्षरों का आकार",
 "Tempo": "समय",
 "Termina em": "खत्म होता है",
 "Testar": "टेस्ट करें",
 "Texto de exemplo": "नमूना टेक्स्ट",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "\"अलार्म (ध्वनि)\" वाली सूचनाओं में बजती है। \"ध्वनि और वाइब्रेशन\" फ़ोन की सूचना ध्वनि इस्तेमाल करता है।",
 "Toda vez que sair": "हर बार बाहर जाने पर",
 "Toda vez que sair da aba": "हर बार टैब से बाहर जाने पर",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "सभी टैब नए खाते की तरह \"{n} दिन का मुफ़्त ट्रायल\" पर लौट आते हैं। नकली सब्सक्रिप्शन बंद कर दिए जाते हैं।",
 "Todos os fichários": "सभी बाइंडर",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "\"Create API key\" (API की बनाएँ) पर टैप करें। अगर प्रोजेक्ट माँगे, तो दिखने वाला चुनें या नया बनाएँ।",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "ऊपर \"मेरी API की बनाएँ\" पर टैप करें। OpenAI प्लेटफ़ॉर्म खुलेगा (यह ChatGPT की साइट नहीं है)।",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "ऊपर \"मेरी API की बनाएँ\" पर टैप करें। Anthropic Console खुलेगा (यह Claude की साइट नहीं है)।",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "ऊपर \"मेरी API की बनाएँ\" पर टैप करें। Google AI Studio खुलेगा।",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "कनेक्ट करें पर टैप करें और Health ऐप की स्क्रीन पर वे आइटम चालू करें जिन्हें My Planner पढ़ सकता है।",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "की के पास वाले कॉपी आइकन पर टैप करें। यह \"AIza\" या \"AQ.\" से शुरू होती है।",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "टेबल के किसी सेल पर (या \"सेल चुनें\" पर) टैप करें ताकि उसके अक्षरों का आकार बदल सकें।",
 "Transparência": "पारदर्शिता",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "तकनीकी (वापस लाने के लिए): पूरी कॉपी जिसे सिर्फ़ My Planner पढ़ता है। इस्तेमाल के लिए सेटिंग्स › क्लाउड और बैकअप › फ़ाइल इंपोर्ट करें पर जाएँ।",
 "Uma carta da {nome} abre em {n} dias 💌": "{nome} का एक पत्र {n} दिन में खुलेगा 💌",
 "Usa a senha do app": "ऐप का पासवर्ड इस्तेमाल करता है",
 "Usar no {ia}": "{ia} में इस्तेमाल करें",
 "Use o app no celular para baixar o arquivo técnico.": "तकनीकी फ़ाइल डाउनलोड करने के लिए फ़ोन पर ऐप इस्तेमाल करें।",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "अंतिम कीमत ऐप स्टोर तय करता है, आपके देश की मुद्रा में।",
 "Você ainda não enviou {titulo} para o My Planner.": "आपने अभी तक {titulo} को My Planner पर नहीं भेजा है।",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "यहाँ वापस आएँ, नीचे वाले फ़ील्ड में पेस्ट करें और \"सेव करें और टेस्ट करें\" पर टैप करें।",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "\"API keys\" पर वापस जाएँ और \"Create new secret key\" (की बनाएँ) पर टैप करें।",
 "atualização automática": "अपने-आप अपडेट",
 "erro desconhecido": "अज्ञात त्रुटि",
 "estudados no mês": "महीने में पढ़ाई",
 "faltou {dur}": "{dur} बाकी रहा",
 "hoje {feito} de {meta}": "आज {feito} / {meta}",
 "hoje é folga": "आज छुट्टी है",
 "login do Google (não é chave de API)": "Google लॉगिन (API की नहीं)",
 "meta cumprida": "लक्ष्य पूरा",
 "o que veio com a instalação": "इंस्टॉलेशन के साथ आया",
 "outro": "अन्य",
 "provisório": "अस्थायी",
 "superou {dur}": "{dur} ज़्यादा",
 "token de login (não é chave de API)": "लॉगिन टोकन (API की नहीं)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} ने जवाब देने में बहुत देर लगाई। थोड़ी देर में फिर से कोशिश करें।",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} अभी बंद है या बहुत व्यस्त है। यह आपकी की की समस्या नहीं है: बाद में फिर से कोशिश करें।",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} ने मॉडल {modelo} से टेस्ट का जवाब दिया। अब आप इसे टैब में इस्तेमाल कर सकते हैं।",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} ने यह सामग्री पढ़ने से मना कर दिया (कंपनी का सुरक्षा फ़िल्टर)।",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: की मौजूद है, लेकिन इसे AI इस्तेमाल करने की अनुमति नहीं है। चरणों में बताए गए पेज पर नई की बनाएँ।",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: अमान्य की। जाँचें कि आपने पूरी की कॉपी की है या नई बनाएँ।",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: यह की कंपनी ने ब्लॉक कर दी क्योंकि यह इंटरनेट पर सार्वजनिक हो गई थी। इसे मिटाएँ और नई बनाएँ।",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: उपयोग की सीमा पूरी हो गई। कुछ मिनट (या मुफ़्त प्लान में कल तक) रुकें और फिर से कोशिश करें।",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: चुना गया मॉडल आपके खाते के लिए उपलब्ध नहीं है। \"मॉडल\" में कोई दूसरा चुनें।",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: यह सेवा आपके क्षेत्र में या इस तरह के खाते के लिए उपलब्ध नहीं है।",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: आपके API खाते में बैलेंस या भुगतान का तरीका नहीं है। कंपनी की साइट पर क्रेडिट जोड़ें।",
 "{item}: a garantia termina hoje ({data}).": "{item}: वारंटी आज ({data}) खत्म हो रही है।",
 "{item}: a garantia terminou em {data}.": "{item}: वारंटी {data} को खत्म हो गई।",
 "{item}: venceu em {data}.": "{item}: {data} को समय-सीमा खत्म हुई।",
 "{mes} de {ano}": "{mes} {ano}",
 "{nome} protegida com senha": "{nome} पासवर्ड से सुरक्षित",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: प्लान खत्म करें या नई अंतिम तारीख के साथ आगे बढ़ाएँ? कुछ भी मिटाया नहीं जाता।",
 "{n} dias antes": "{n} दिन पहले",
 "{n} dias de estudo no plano · {dur} por dia": "प्लान में पढ़ाई के {n} दिन · रोज़ {dur}",
 "{n} dias de plano": "{n} दिन का प्लान",
 "{n} dias depois": "{n} दिन बाद",
 "{n} item(ns) aguardando envio ao My Planner": "{n} आइटम My Planner पर भेजे जाने के इंतज़ार में",
 "{n} itens aguardando envio": "{n} आइटम भेजे जाने के इंतज़ार में",
 "{quando} às {hora}": "{quando} को {hora} बजे",
 "ÚLTIMOS 6 MESES": "पिछले 6 महीने",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "My Planner Anne खोलें और अपने CPF या ईमेल और पासवर्ड से साइन इन करें।",
 "Anexo": "अटैचमेंट",
 "Assédio ou ameaça": "उत्पीड़न या धमकी",
 "Bloquear {nome}": "{nome} को ब्लॉक करें",
 "Conte mais (opcional)": "और बताएँ (वैकल्पिक)",
 "Conteúdo impróprio": "अनुचित सामग्री",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "आपत्तिजनक सामग्री और दुर्व्यवहार करने वाले उपयोगकर्ता बर्दाश्त नहीं किए जाते। हमारी टीम 24 घंटे के भीतर रिपोर्ट की समीक्षा करती है।",
 "Denunciar": "रिपोर्ट करें",
 "Denunciar contato": "संपर्क की रिपोर्ट करें",
 "Denunciar grupo": "समूह की रिपोर्ट करें",
 "Denunciar mensagem": "संदेश की रिपोर्ट करें",
 "Denúncia enviada": "रिपोर्ट भेज दी गई",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "संदेशों में आपके द्वारा की गई रिपोर्ट: कारण, किसकी रिपोर्ट की गई और रिपोर्ट किए गए संदेश का अंश। मामले की समीक्षा के लिए इन्हें सिर्फ़ My Planner की टीम पढ़ती है।",
 "Enviar denúncia": "रिपोर्ट भेजें",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "खाते के CPF या ईमेल के साथ हटाने का अनुरोध करते हुए ईमेल भेजें। हम 15 दिनों के भीतर जवाब देते हैं।",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "हम संदेशों और समूहों में आपत्तिजनक, अवैध या अनुचित सामग्री और दुर्व्यवहार करने वाले उपयोगकर्ताओं को बर्दाश्त नहीं करते। कोई भी किसी संदेश, संपर्क या समूह की रिपोर्ट कर सकता है (संदेश को दबाकर रखें या ⋮ > रिपोर्ट करें पर टैप करें) और जिसे चाहे ब्लॉक कर सकता है। हमारी टीम 24 घंटे के भीतर रिपोर्ट की समीक्षा करती है: सामग्री हटाई जा सकती है और भेजने वाले का खाता निलंबित या बंद किया जा सकता है।",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "धन्यवाद। हमारी टीम 24 घंटे के भीतर समीक्षा करेगी।",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "जो खाते CPF से साइन इन करते हैं, उनके लिए नया पासवर्ड हमारी सहायता टीम यह पुष्टि करने के बाद बनाती है कि खाता आपका है। अपना CPF या पंजीकृत ईमेल बताते हुए {email} पर लिखें।",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "आप रिपोर्ट क्यों कर रहे हैं? जिसकी रिपोर्ट की गई है उसे पता नहीं चलेगा कि किसने रिपोर्ट की।",
 "Spam": "स्पैम",
 "{nome} não pode mais conversar com você.": "{nome} अब आपसे बात नहीं कर सकता।",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\n{d} तक मान्य। यह आपके वॉल्ट में एन्क्रिप्ट होकर रहता है, सिर्फ़ इस डिवाइस पर और आपकी क्लाउड कॉपी में।",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. कंप्यूटर पर {url} खोलें और QR कोड से प्रवेश चुनें।",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. यहाँ ब्राउज़र जोड़ें पर टैप करें और कैमरा कंप्यूटर के QR कोड की ओर करें।",
 "Abandonados": "छोड़ी गई",
 "Bloquear o computador": "कंप्यूटर लॉक करें",
 "Cheguei na página...": "मैं इस पेज पर पहुँचा...",
 "Computador conectado": "जुड़ा हुआ कंप्यूटर",
 "Computador desconectado": "कंप्यूटर डिस्कनेक्ट हुआ",
 "Conectado em {d}": "{d} को जुड़ा",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "समूह बनाएँ और लिंक भेजें: जो जुड़ेगा वह किताब की सामग्री देखेगा और पढ़ाई पर नज़र रखेगा। व्यवस्थापक जोड़ते, संपादित करते और फ़ोटो डालते हैं, और यह उन्हें भी दे सकते हैं जो यह टैब इस्तेमाल करते हैं। केवल व्यवस्थापक लोगों को जोड़ या हटा सकते हैं।",
 "Depois de {n} minutos parado": "{n} मिनट निष्क्रिय रहने पर",
 "Desconectar o computador?": "कंप्यूटर डिस्कनेक्ट करें?",
 "Difícil demais": "बहुत कठिन",
 "Editar livro": "किताब संपादित करें",
 "Entrar com o QR Code": "QR कोड से प्रवेश करें",
 "Escreva (ex.: filosofia)": "लिखें (जैसे: दर्शन)",
 "Este computador": "यह कंप्यूटर",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "यह कंप्यूटर डिस्कनेक्ट कर दिया गया (फ़ोन से या किसी दूसरे कंप्यूटर के जुड़ने से)। फिर से इस्तेमाल करने के लिए QR कोड से प्रवेश करें।",
 "Já existe um computador conectado": "पहले से एक कंप्यूटर जुड़ा है",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "पहले से एक कंप्यूटर जुड़ा है। इस पर बदलें? दूसरा डिस्कनेक्ट हो जाएगा।",
 "Navegador": "ब्राउज़र",
 "Nenhum computador conectado": "कोई कंप्यूटर नहीं जुड़ा",
 "Novo livro": "नई किताब",
 "Não gostei": "पसंद नहीं आई",
 "Não, abandonei": "नहीं, छोड़ दी",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "कंप्यूटर पर My Planner बंद हो जाएगा। फिर से इस्तेमाल के लिए बस QR कोड से जोड़ें।",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "QR कोड हर 3 मिनट में बदलता है और केवल एक बार चलता है। साझा कंप्यूटर पर, काम खत्म होने पर सेटिंग्स › इस कंप्यूटर से बाहर निकलें इस्तेमाल करें।",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "आपका डेटा क्लाउड और फ़ोन में सुरक्षित रहता है। फिर से प्रवेश के लिए QR कोड इस्तेमाल करें।",
 "Parei em": "रोका",
 "Perdi o interesse": "रुचि खत्म हो गई",
 "Por que parei": "मैंने क्यों रोका",
 "Páginas e meta": "पेज और लक्ष्य",
 "Quero voltar a ler?": "फिर से पढ़ना चाहता/चाहती हूँ?",
 "Sair deste computador": "इस कंप्यूटर से बाहर निकलें",
 "Sair deste computador?": "इस कंप्यूटर से बाहर निकलें?",
 "Se quiser, escreva com as suas palavras": "चाहें तो अपने शब्दों में लिखें",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "इतनी देर माउस या कीबोर्ड न चलाने पर My Planner लॉक हो जाता है। वापस आने के लिए खाते का पासवर्ड लिखें (या फिर से QR कोड से प्रवेश करें)।",
 "Sem tempo": "समय नहीं",
 "Sim, depois": "हाँ, बाद में",
 "Só um computador pode ficar conectado por vez.": "एक समय में केवल एक कंप्यूटर जुड़ सकता है।",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "प्रमाणपत्र की फ़ोटो या PDF \"फ़ोटो, फ़ाइलें और लिंक\" में डालें और उसे प्रमाणपत्र चिह्नित करें।",
 "ABNT copiada": "ABNT कॉपी हुआ",
 "APA copiada": "APA कॉपी हुआ",
 "Ano inválido": "अमान्य वर्ष",
 "Ano ou data de publicação": "प्रकाशन वर्ष या तारीख",
 "Assisti em": "देखा",
 "Buscando os dados...": "डेटा खोजा जा रहा है...",
 "Calculado pelos módulos": "मॉड्यूल से गणना",
 "Carga horária (horas)": "कुल घंटे",
 "Certificado": "प्रमाणपत्र",
 "Certificado emitido em": "प्रमाणपत्र जारी होने की तारीख",
 "Cheguei na aula": "मैं इस पाठ पर हूँ",
 "Cheguei na aula...": "मैं इस पाठ पर हूँ...",
 "Cheguei na temporada": "मैं इस सीज़न पर हूँ",
 "Cheguei no episódio": "मैं इस एपिसोड पर हूँ",
 "Citação copiada": "उद्धरण कॉपी हुआ",
 "Colocar em pasta": "फ़ोल्डर में रखें",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "सूची बनाने के लिए इस फ़ोल्डर में किताबें, फ़िल्में या कोर्स रखें।",
 "Comentário": "टिप्पणी",
 "Copiar ABNT": "ABNT कॉपी करें",
 "Copiar APA": "APA कॉपी करें",
 "Copiar citação (ABNT)": "उद्धरण कॉपी करें (ABNT)",
 "Copiar citação (APA)": "उद्धरण कॉपी करें (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "इस विषय के लिए चेकलिस्ट, सूची, मुक्त पाठ या ड्रॉइंग वाले कार्ड बनाएँ। हटाने के लिए दाईं ओर, संग्रहित या डुप्लिकेट करने के लिए बाईं ओर खींचें।",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "समूह बनाएँ और लिंक भेजें: जो जुड़ेगा वह सूची देखेगा और साथ चलेगा। व्यवस्थापक जोड़ते, संपादित करते और फ़ोटो डालते हैं, और यह टैब इस्तेमाल करने वालों को भी दे सकते हैं। केवल व्यवस्थापक लोगों को जोड़ या हटा सकते हैं।",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "समूह बनाएँ और लिंक भेजें: जो जुड़ेगा वह कोर्स की सामग्री देखेगा और साथ चलेगा। व्यवस्थापक जोड़ते, संपादित करते और फ़ोटो डालते हैं, और यह टैब इस्तेमाल करने वालों को भी दे सकते हैं। केवल व्यवस्थापक लोगों को जोड़ या हटा सकते हैं।",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "पहले इस टैब के 📁 फ़ोल्डर हिस्से में फ़ोल्डर बनाएँ।",
 "DOI (artigos)": "DOI (लेख)",
 "Data de acesso": "पहुँच की तारीख",
 "Deixar avulsas": "अलग छोड़ दें",
 "Descrição (objetivo)": "विवरण (उद्देश्य)",
 "Digite o ano com 4 números (ex.: {a}).": "वर्ष 4 अंकों में लिखें (जैसे: {a})।",
 "Direção": "निर्देशन",
 "Editar pasta": "फ़ोल्डर संपादित करें",
 "Editora": "प्रकाशक",
 "Edição": "संस्करण",
 "Em 1 mês": "1 महीने में",
 "Em {n} meses": "{n} महीने में",
 "Episódios por temporada (opcional)": "प्रति सीज़न एपिसोड (वैकल्पिक)",
 "Escreva o trecho na anotação para copiar a citação.": "उद्धरण कॉपी करने के लिए नोट में अंश लिखें।",
 "Este item já está em todas as pastas.": "यह आइटम पहले से सभी फ़ोल्डरों में है।",
 "Ex.: 10.1590/...": "जैसे: 10.1590/...",
 "Ex.: TCC — Ética e Direito": "जैसे: शोध — नैतिकता और कानून",
 "Ex.: {a}": "जैसे: {a}",
 "Fazendo": "चल रहा",
 "Grupo de filmes e séries": "फ़िल्म और सीरीज़ समूह",
 "Grupo de leitura": "पढ़ने का समूह",
 "Grupo do curso": "कोर्स समूह",
 "ISBN": "ISBN",
 "Ideia minha": "मेरा विचार",
 "Instrutor": "प्रशिक्षक",
 "Itens da pasta": "फ़ोल्डर के आइटम",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "किताबें, फ़िल्में और कोर्स एक फ़ोल्डर में रखें (जैसे: \"शोध\", \"सिर्फ़ उपन्यास\")। एक ही आइटम कई फ़ोल्डरों में हो सकता है।",
 "Link (material online)": "लिंक (ऑनलाइन सामग्री)",
 "Lista copiada": "सूची कॉपी हुई",
 "Lista de referências": "संदर्भ सूची",
 "Mais de um autor: separe com ponto e vírgula (;).": "एक से अधिक लेखक: अर्धविराम (;) से अलग करें।",
 "Módulo": "मॉड्यूल",
 "Nada novo": "कुछ नया नहीं",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "किसी किताब, फ़िल्म या कोर्स के ⋮ में \"फ़ोल्डर में रखें\" पर टैप करें।",
 "Nome da pasta": "फ़ोल्डर का नाम",
 "Não achei dados novos para completar a ficha.": "रिकॉर्ड पूरा करने के लिए नया डेटा नहीं मिला।",
 "Não foi possível preencher": "भरा नहीं जा सका",
 "O módulo não tem cards de anotações.": "इस मॉड्यूल में नोट कार्ड नहीं हैं।",
 "Organizador": "संपादक",
 "Os dados vêm da ficha do livro (Editar › Referência).": "डेटा किताब के रिकॉर्ड से आता है (संपादित करें › संदर्भ)।",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "फ़ोल्डर की किताबें, फ़िल्में और कोर्स नहीं हटेंगे: वे टैब में रहेंगे।",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "इस मॉड्यूल के {n} नोट कार्ड भी रद्दी में जाएँगे।",
 "Pasta vazia": "खाली फ़ोल्डर",
 "Preencha o título (e o que mais tiver) na ficha.": "रिकॉर्ड में शीर्षक (और जो भी हो) भरें।",
 "Preencher pelo DOI": "DOI से भरें",
 "Preencher pelo link": "लिंक से भरें",
 "Produtora ou país": "निर्माता या देश",
 "Quero fazer": "करना चाहता/चाहती हूँ",
 "Quero voltar?": "फिर से शुरू करना चाहते हैं?",
 "Referência vazia": "संदर्भ खाली है",
 "Referências": "संदर्भ",
 "Se deixar avulsas, elas continuam somando no total do curso.": "अलग छोड़ने पर भी वे कोर्स के कुल में गिने जाएँगे।",
 "Subtítulo": "उपशीर्षक",
 "Tirar da pasta": "फ़ोल्डर से हटाएँ",
 "Total de episódios (opcional)": "कुल एपिसोड (वैकल्पिक)",
 "Total de temporadas (opcional)": "कुल सीज़न (वैकल्पिक)",
 "Tradutor": "अनुवादक",
 "Trecho (citação)": "अंश (उद्धरण)",
 "Trecho vazio": "अंश खाली है",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "आप {n} पाठ देख चुके हैं। किस मॉड्यूल में रखें?",
 "Volume": "खंड",
 "{n} item(ns)": "{n} आइटम",
 "{n} referência(s) em ordem alfabética.": "वर्णानुक्रम में {n} संदर्भ।",
 "Ícone": "आइकन",
 "ASSISTIDOS POR DIA": "प्रति दिन देखे",
 "ASSISTIDOS POR MÊS": "प्रति माह देखे",
 "AULAS POR DIA": "प्रति दिन पाठ",
 "AULAS POR MÊS": "प्रति माह पाठ",
 "Apagar a meta": "लक्ष्य हटाएँ",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "देखे {a} · देख रहे {b} · रोके {c} · देखना है {d}",
 "Aulas": "पाठ",
 "CURSOS": "कोर्स",
 "Concluí {a} · Fazendo {b} · Parei {c}": "पूरे {a} · चल रहे {b} · रोके {c}",
 "Datas": "तारीखें",
 "Datas escolhidas": "चुनी गई तारीखें",
 "Datas à escolha": "अपनी तारीखें",
 "Definir meta de {ano}": "{ano} का लक्ष्य तय करें",
 "Definir meta do ano": "साल का लक्ष्य तय करें",
 "FILMES E SÉRIES": "फ़िल्में और सीरीज़",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "{f} कोर्स बाकी: लगभग {m} हर महीने",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "{f} किताबें बाकी: लगभग {m} हर महीने",
 "Faltam {f} título(s): dá cerca de {m} por mês": "{f} शीर्षक बाकी: लगभग {m} हर महीने",
 "Gênero": "शैली",
 "Incluir lista de referências no PDF": "PDF में संदर्भ सूची शामिल करें",
 "LIVROS": "किताबें",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "पढ़ीं {a} · रोकीं {b} · पढ़ रहे {c}",
 "Meta de {ano}": "{ano} का लक्ष्य",
 "Meta de {ano}: usar a de {antes} ({n})?": "{ano} का लक्ष्य: {antes} वाला ({n}) रखें?",
 "Meta do ano cumprida": "साल का लक्ष्य पूरा",
 "Mudar": "बदलें",
 "Nada neste período.": "इस अवधि में कुछ नहीं।",
 "Nota": "रेटिंग",
 "O PDF não leva as suas anotações, resumos e comentários.": "PDF में आपके नोट, सारांश और टिप्पणियाँ नहीं होतीं।",
 "POR ITEM": "हर आइटम",
 "Plataforma": "प्लेटफ़ॉर्म",
 "PÁGINAS POR DIA": "प्रति दिन पेज",
 "PÁGINAS POR MÊS": "प्रति माह पेज",
 "Quantos no ano?": "साल में कितने?",
 "Quero ler {a} · Abandonei {b}": "पढ़ना है {a} · छोड़ीं {b}",
 "Relatório de leitura e mídia": "पढ़ाई और मीडिया रिपोर्ट",
 "concluídos no período": "अवधि में पूरे",
 "cursos concluídos no período": "अवधि में पूरे कोर्स",
 "livros lidos no período": "अवधि में पढ़ी किताबें",
 "pág. {a} de {n}": "पेज {a}/{n}",
 "títulos assistidos no período": "अवधि में देखे शीर्षक",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "अवधि में {a} पाठ · पूरे कोर्स के {h} घंटे",
 "{a} de {n} aulas ({p}%)": "{a}/{n} पाठ ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{ano} में {a}/{n} कोर्स पूरे",
 "{a} de {n} livro(s) em {ano}": "{ano} में {a}/{n} किताबें",
 "{a} de {n} título(s) assistido(s) em {ano}": "{ano} में {a}/{n} शीर्षक देखे",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} आइटम में स्थिति बदलने की तारीख नहीं: बनने की तारीख ली।",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{d} दिनों में {p} पेज · सबसे लंबा क्रम: {s} दिन",
 "{p}% lido · falta {f}%": "{p}% पढ़ा · {f}% बाकी",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "यह टैब पासवर्ड माँगता है। पहले इसे खोलें, गाइड यहीं से आगे चलेगी।",
 "Abrir esta aba": "यह टैब खोलें",
 "Mostrar na tela": "स्क्रीन पर दिखाएँ",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "अभी स्क्रीन पर यह जगह नहीं मिली। सही स्क्रीन खुली है, देखकर फिर कोशिश करें।",
 "Primeiros passos": "पहले कदम",
 "Buscar no guia": "गाइड में खोजें",
 "Entendi": "समझ गया",
 "{n} de {total} passos feitos": "{total} में से {n} कदम पूरे",
 "Já fiz": "कर लिया",
 "Guia em construção": "गाइड बन रही है",
 "Limpar marcações": "निशान हटाएँ",
 "Este ponto ainda não está marcado no app.": "यह जगह अभी ऐप में चिह्नित नहीं है।",
 "Dicas e atalhos": "सुझाव और शॉर्टकट",
 "Gestos do app": "ऐप के इशारे",
 "Procurando na tela…": "स्क्रीन पर खोज रहे हैं…",
 "Guia das abas": "टैब गाइड",
 "Voltar ao guia": "गाइड पर लौटें",
 "Para que serve": "यह किसलिए है",
 "Disponível no app do celular.": "फ़ोन ऐप में उपलब्ध।",
 "Nada encontrado no guia.": "गाइड में कुछ नहीं मिला।",
 "Recursos que valem para todas as abas": "सभी टैब के लिए सुविधाएँ",
 "Perguntas comuns": "सामान्य प्रश्न",
 "Ligar e desligar partes": "हिस्से चालू-बंद करें",
 "Entrada cancelada. Este computador não foi conectado.": "साइन-इन रद्द किया गया। यह कंप्यूटर कनेक्ट नहीं हुआ।",
 "Alterações ainda não enviadas": "बदलाव अभी भेजे नहीं गए",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "कुछ बदलाव अभी सर्वर पर नहीं भेजे गए (इंटरनेट नहीं?)। अभी बाहर निकलने पर वे खो जाएँगे। फिर भी बाहर निकलें?",
 "Sair mesmo assim": "फिर भी बाहर निकलें",
 "O seu papel no grupo não permite mudar aqui.": "समूह में आपकी भूमिका यहाँ बदलाव की अनुमति नहीं देती।",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "अभी DOI नहीं देखा जा सका (इंटरनेट नहीं?)। फिर से कोशिश करें।",
 "DOI inválido.": "अमान्य DOI।",
 "DOI não encontrado.": "DOI नहीं मिला।",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "साइट ने यहाँ से डेटा पढ़ने नहीं दिया (कंप्यूटर ब्राउज़र में यह आम है)। फ़ोन पर ऐप से कोशिश करें, DOI इस्तेमाल करें, या फ़ील्ड भरें।",
 "Atualizando...": "अपडेट हो रहा है...",
 "Banco de dados (Supabase, plano grátis)": "डेटाबेस (Supabase, मुफ़्त प्लान)",
 "Cadeado (HTTPS) até": "HTTPS ताला इस तारीख तक",
 "Dados das abas: {d}": "टैब का डेटा: {d}",
 "Disco": "डिस्क",
 "Esta conta não tem acesso a estas informações.": "इस खाते को यह जानकारी देखने की अनुमति नहीं है।",
 "Ligado há": "चालू है",
 "Livre: {l} · site: {s}": "खाली: {l} · साइट: {s}",
 "Maiores tabelas": "सबसे बड़ी तालिकाएँ",
 "Memória em uso": "उपयोग में मेमोरी",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "सर्वर ने अभी रिपोर्ट नहीं भेजी। 53-SERVIDOR-0.78.bat के बाद यह हर 10 मिनट में भेजता है।",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "सर्वर में अभी यह सुविधा नहीं है। कंप्यूटर पर 53-SERVIDOR-0.78.bat चलाएँ।",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "सर्वर सिस्टम रीस्टार्ट माँग रहा है (सुरक्षा अपडेट इंस्टॉल हुआ)।",
 "Processador": "प्रोसेसर",
 "Relatório do servidor: {q}": "सर्वर रिपोर्ट: {q}",
 "Servidor": "सर्वर",
 "Servidor do site (Locaweb)": "साइट का सर्वर (Locaweb)",
 "Sistema": "सिस्टम",
 "Só você vê este quadro.": "यह हिस्सा सिर्फ़ आपको दिखता है।",
 "Versão do site no ar": "लाइव साइट का संस्करण",
 "atrasado: confira se o servidor está ligado": "देर हो गई: जाँचें कि सर्वर चालू है",
 "sem cadeado": "कोई ताला नहीं",
 "{a} ({n} guardadas)": "{a} ({n} रखी गईं)",
 "{d} dia(s) e {h} h": "{d} दिन और {h} घंटे",
 "{n} núcleo(s) · carga {c}": "{n} कोर · लोड {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · 7 दिनों में {novas} नए और {ativas} सक्रिय",
 "{u} de {t} ({p}%)": "{t} में से {u} ({p}%)",
 "Fechar teclado": "कीबोर्ड बंद करें",
 "Mostrar as ferramentas": "टूल दिखाएँ",
 "Últimas cores usadas": "हाल में इस्तेमाल रंग",
 "Voltar ao topo": "ऊपर जाएँ",
 "Topo": "ऊपर",
 "1 atividade do roteiro por fazer": "यात्रा कार्यक्रम की 1 गतिविधि बाकी",
 "1 dia": "1 दिन",
 "1 item por pôr na mala": "1 चीज़ अभी पैक करनी है",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "यात्रा की 1 सूची पूरी की पूरी My Planner में जाती थी और वहाँ से हटा दी गई है। अब हर आइटम के ⋮ से एक-एक करके भेजें।",
 "1 lugar não visitado": "1 जगह नहीं देखी",
 "1 reserva por confirmar": "1 बुकिंग की पुष्टि बाकी",
 "Abrir o bloco": "सेक्शन खोलें",
 "Adicionar pessoa": "व्यक्ति जोड़ें",
 "Ainda pode gastar {v}": "अभी {v} और खर्च कर सकते हैं",
 "Ao ligar, o valor entra em Gastos como pago.": "चालू करने पर राशि खर्च में भुगतान के रूप में जुड़ जाती है।",
 "Até (dd/mm/aaaa)": "तक (दिन/माह/वर्ष)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "\"कौन जा रहा है\" में लोगों को जोड़ें (यात्रा संपादित करें)।",
 "Como foi?": "कैसा रहा?",
 "Concluído em {d}": "{d} को पूरा हुआ",
 "Confirmada em {d}": "{d} को पुष्टि हुई",
 "Confirmadas": "पुष्टि हुई",
 "Dia anterior": "पिछला दिन",
 "Dias": "दिन",
 "Dias × valor por dia": "दिन × प्रति दिन राशि",
 "Documentos (só o tipo e a validade)": "दस्तावेज़ (सिर्फ़ प्रकार और वैधता)",
 "EXIGÊNCIAS DO DESTINO": "गंतव्य की शर्तें",
 "Em mãos": "हाथ में",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "लिखें कि गंतव्य क्या माँगता है (जैसे: पासपोर्ट में 2 खाली पन्ने, टीकाकरण प्रमाणपत्र)। देश की आधिकारिक वेबसाइट पर जाँच लें।",
 "Ex.: Lisboa (LIS)": "जैसे: लिस्बन (LIS)",
 "Ex.: São Paulo (GRU)": "जैसे: साओ पाउलो (GRU)",
 "Falta confirmar": "पुष्टि बाकी",
 "Falta pôr": "पैक करना बाकी",
 "Faltou ({n}): {l}": "छूट गया ({n}): {l}",
 "Foi ({n}): {l}": "साथ गया ({n}): {l}",
 "Fotos (lista das legendas)": "फ़ोटो (कैप्शन की सूची)",
 "Gasto de {nome} em {d}": "{d} को {nome} का खर्च",
 "Gastos do dia": "दिन का खर्च",
 "Gastos em outras moedas (não convertidos): {v}": "अन्य मुद्राओं में खर्च (बदला नहीं गया): {v}",
 "Gastos por dia": "प्रति दिन खर्च",
 "Horário de chegada": "पहुँचने का समय",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "जगहें (देखी गईं, बाकी, ज़रूर देखें और रेटिंग)",
 "Mala (o que foi e o que faltou)": "सामान (क्या साथ गया और क्या छूट गया)",
 "Marcar como acertado": "चुकता के रूप में चिह्नित करें",
 "Marcar como acertado?": "चुकता के रूप में चिह्नित करें?",
 "Na mala": "पैक हो गया",
 "Nenhuma parada ainda": "अभी कोई पड़ाव नहीं",
 "Nova exigência": "नई शर्त",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "दस्तावेज़ों के नंबर और तिजोरी की चीज़ें रिपोर्ट में कभी नहीं जातीं। अलग-अलग मुद्राओं की राशियाँ अलग दिखती हैं।",
 "O QUE AINDA FALTA": "अभी क्या बाकी है",
 "O QUE INCLUIR": "क्या शामिल करें",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "वैकल्पिक। अगर वापसी से गिनकर पासपोर्ट इससे पहले खत्म हो रहा हो, तो ऐप सूचित करेगा। देश की शर्त जाँच लें।",
 "Orçamento previsto × gasto por categoria": "अनुमानित बजट × श्रेणी के अनुसार खर्च",
 "Passou do previsto em {v}": "बजट से {v} ज़्यादा",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "हर दस्तावेज़ की वैधता डालें: खत्म होने से पहले ऐप सूचित करेगा। दस्तावेज़ों की फ़ोटो तिजोरी में सुरक्षित रहती हैं।",
 "Próximo dia": "अगला दिन",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "यात्रा ग्रुप के लोग अपने-आप जुड़ जाते हैं। जिनके पास ऐप नहीं है, उनके लिए \"+ व्यक्ति जोड़ें\" इस्तेमाल करें।",
 "Recolher o bloco": "सेक्शन बंद करें",
 "Relatório da viagem": "यात्रा रिपोर्ट",
 "Reserva confirmada": "बुकिंग की पुष्टि हुई",
 "Resumo da viagem": "यात्रा सारांश",
 "Resumo da viagem (datas, destino, pessoas)": "यात्रा सारांश (तारीखें, गंतव्य, लोग)",
 "Roteiro por dia (feito e falta)": "दिन के अनुसार कार्यक्रम (हुआ और बाकी)",
 "Sem data": "कोई तारीख नहीं",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "आपका पासपोर्ट शायद स्वीकार न हो। देश की शर्त जाँच लें",
 "Subir": "ऊपर ले जाएँ",
 "Total do dia: {v}": "दिन का कुल: {v}",
 "Uma frase (opcional)": "एक वाक्य (वैकल्पिक)",
 "Validade mínima exigida (meses)": "पासपोर्ट की न्यूनतम आवश्यक वैधता (महीने)",
 "Validade: {d}": "वैधता: {d}",
 "Valor por dia": "प्रति दिन राशि",
 "Viagens no My Planner": "My Planner में यात्राएँ",
 "Visitado": "देखा गया",
 "Visitado em {d}": "{d} को देखा",
 "Voltaria: {r}": "फिर जाएँगे: {r}",
 "Voltaria?": "फिर जाएँगे?",
 "confirmada": "पुष्टि हुई",
 "em mãos": "हाथ में",
 "gasto na viagem {d}": "यात्रा का खर्च {d}",
 "meses": "महीने",
 "outro gasto": "अन्य खर्च",
 "vence em {d}": "{d} को खत्म",
 "{a} de {b} confirmadas": "{b} में से {a} की पुष्टि",
 "{a} de {b} em mãos": "{b} में से {a} हाथ में",
 "{a} de {b} feitos": "{b} में से {a} पूरे",
 "{a} de {b} na mala": "{b} में से {a} पैक",
 "{a} de {b} pagos": "{b} में से {a} का भुगतान",
 "{a} de {b} visitados": "{b} में से {a} देखी गईं",
 "{de} deve {v} a {para}": "{de} को {para} को {v} देने हैं",
 "{g} de {p}": "{p} में से {g}",
 "{n} atividades do roteiro por fazer": "यात्रा कार्यक्रम की {n} गतिविधियाँ बाकी",
 "{n} item(ns) enviado(s).": "{n} आइटम भेजे गए।",
 "{n} itens por pôr na mala": "{n} चीज़ें अभी पैक करनी हैं",
 "{n} já estava(m) no My Planner.": "{n} पहले से My Planner में था/थे।",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "यात्रा की {n} सूचियाँ पूरी की पूरी My Planner में जाती थीं और वहाँ से हटा दी गई हैं। अब हर आइटम के ⋮ से एक-एक करके भेजें।",
 "{n} lugares não visitados": "{n} जगहें नहीं देखीं",
 "{n} reservas por confirmar": "{n} बुकिंग की पुष्टि बाकी",
 "{n} sem data (não foi).": "{n} बिना तारीख (नहीं भेजा गया)।",
 "ARTIGOS E SITES": "लेख और वेबसाइटें",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "अब भेजना एक-एक आइटम करके होता है (आइटम के ⋮ से या कई चुनकर)। ये सूचियाँ पूरी भेजी जाती थीं और My Planner से हटा दी गईं ({n} आइटम, कुछ भी मिटाया नहीं गया):",
 "Artigo científico": "वैज्ञानिक लेख",
 "Artigo de site ou blog": "वेबसाइट या ब्लॉग लेख",
 "Artigo ou site": "लेख या वेबसाइट",
 "Artigos e sites": "लेख और वेबसाइटें",
 "Autor(es)": "लेखक",
 "Cadastrar pela foto ou PDF": "फोटो या PDF से जोड़ें",
 "Capítulo de livro": "पुस्तक का अध्याय",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "समूह बनाएँ और लिंक भेजें: जो जुड़ेगा वह लेख देखेगा और पढ़ाई पर नज़र रखेगा। व्यवस्थापक जोड़ते, संपादित करते और फ़ोटो लगाते हैं, और यह अनुमति उन्हें दे सकते हैं जो यह टैब भी इस्तेमाल करते हैं। केवल व्यवस्थापक लोगों को जोड़ या हटा सकते हैं।",
 "DOI": "DOI",
 "Data ou ano de publicação": "प्रकाशन तिथि या वर्ष",
 "Editar artigo ou site": "लेख या वेबसाइट संपादित करें",
 "Enviar para o My Planner (lembrete de renovação)": "My Planner में भेजें (नवीनीकरण रिमाइंडर)",
 "Envio para o My Planner": "My Planner में भेजना",
 "Ex.: 2024 ou 12/03/2024": "उदा.: 2024 या 12/03/2024",
 "Ex.: 45-60": "उदा.: 45-60",
 "Grupo de artigos": "लेख समूह",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "लेख, समाचार और वेब पेज तैयार संदर्भ (ABNT और APA) के साथ सहेजें। DOI या लिंक से भरें।",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "पढ़े {a} · पढ़ रहे {b} · रोके {c} · पढ़ना है {d}",
 "Minhas anotações do artigo": "लेख पर मेरे नोट्स",
 "Notícia": "समाचार",
 "Novo artigo ou site": "नया लेख या वेबसाइट",
 "Os dados vêm da ficha do artigo (Editar).": "डेटा लेख के कार्ड से आता है (संपादित करें)।",
 "Páginas (opcional)": "पृष्ठ (वैकल्पिक)",
 "Revista, site ou veículo": "पत्रिका, वेबसाइट या माध्यम",
 "artigos e sites lidos no período": "अवधि में पढ़े लेख और वेबसाइटें",
 "1 confirmado": "1 पुष्ट",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "\"लंबित\" में रहा 1 मेहमान \"आमंत्रित करना है\" में चला गया। ऐप से निमंत्रण भेजने पर वह अपने आप \"आमंत्रित, कोई जवाब नहीं\" में चला जाएगा।",
 "1 extra": "1 अतिरिक्त",
 "1 talvez": "1 शायद",
 "A convidar": "आमंत्रित करना है",
 "Agendar na igreja": "चर्च में समय तय करें",
 "Agora": "अभी",
 "Agradeci": "धन्यवाद दिया",
 "Agradeci em {d}": "{d} को धन्यवाद दिया",
 "Agradecidos": "धन्यवाद दिए गए",
 "Alianças": "अंगूठियाँ",
 "Aluguéis (mesas, cadeiras, louças)": "किराया (मेज़, कुर्सियाँ, बर्तन)",
 "Avisar a data (save the date)": "तारीख की सूचना दें (save the date)",
 "Bebidas": "पेय",
 "Beca e cerimônia": "गाउन और समारोह",
 "Bolo": "केक",
 "Brincadeiras": "खेल",
 "Brincadeiras e amigo secreto": "खेल और सीक्रेट सांता",
 "Brindes": "उपहार",
 "Buffet": "कैटरिंग",
 "Calculado sozinho: valor menos o sinal.": "अपने आप गणना: राशि में से अग्रिम घटाकर।",
 "Calcular quantidades": "मात्रा की गणना करें",
 "Categoria do orçamento": "बजट श्रेणी",
 "Celebrante": "अनुष्ठानकर्ता",
 "Cerimônia": "समारोह",
 "Cerveja (adultos)": "बीयर (वयस्क)",
 "Checklist de preparação": "तैयारी चेकलिस्ट",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "हर आइटम की अंतिम तिथि देखने के लिए कार्यक्रम की तारीख डालें (कार्यक्रम संपादित करें)।",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "\"कार्यक्रम के लोग\" में लोगों को जोड़ें (कार्यक्रम संपादित करें)।",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "हर श्रेणी में कितना खर्च करना है, डालें। प्रति मेहमान गणना के लिए ⊕ का उपयोग करें। अनुबंधित आपूर्तिकर्ता चुनी गई श्रेणी में अपने आप जुड़ जाते हैं।",
 "Combinado: {v}": "तय: {v}",
 "Comprado": "खरीदा",
 "Comprados": "खरीदे गए",
 "Comprar a decoração e as lembrancinhas": "सजावट और रिटर्न गिफ्ट खरीदें",
 "Comprar as alianças": "अंगूठियाँ खरीदें",
 "Comprar as lembrancinhas": "रिटर्न गिफ्ट खरीदें",
 "Comprar bebidas e gelo": "पेय और बर्फ खरीदें",
 "Comprar comida e bebidas": "खाना और पेय खरीदें",
 "Comprar o que falta": "जो बाकी है वह खरीदें",
 "Comprar ou alugar a roupa": "कपड़े खरीदें या किराये पर लें",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "साथियों सहित पुष्ट। किसी के पुष्टि करने या रद्द करने पर अपने आप बदलता है।",
 "Confirmar a presença dos convidados": "मेहमानों की उपस्थिति पक्की करें",
 "Confirmar os fornecedores": "आपूर्तिकर्ताओं की पुष्टि करें",
 "Confirmar os fornecedores e os convidados": "आपूर्तिकर्ताओं और मेहमानों की पुष्टि करें",
 "Contratar a comida": "खाने की व्यवस्था बुक करें",
 "Contratar a comida e o bolo": "खाना और केक बुक करें",
 "Contratar a decoração": "सजावट बुक करें",
 "Contratar comida e bebidas": "खाना और पेय बुक करें",
 "Contratar foto e vídeo": "फोटो और वीडियो बुक करें",
 "Contratar o buffet": "कैटरिंग बुक करें",
 "Convidado, sem resposta": "आमंत्रित, कोई जवाब नहीं",
 "Convidados (por situação, com acompanhantes)": "मेहमान (स्थिति के अनुसार, साथियों सहित)",
 "Convidados que contam no ⊕": "⊕ में गिने जाने वाले मेहमान",
 "Convites": "निमंत्रण",
 "Cronograma do dia (com responsáveis e situação)": "दिन का कार्यक्रम (ज़िम्मेदार और स्थिति सहित)",
 "Data do restante": "शेष राशि की तारीख",
 "Data do sinal": "अग्रिम की तारीख",
 "Decoração": "सजावट",
 "Definir a data e o orçamento": "तारीख और बजट तय करें",
 "Definir a lista de convidados": "मेहमानों की सूची तय करें",
 "Doces": "मिठाइयाँ",
 "Dá para mudar, tirar e incluir itens depois.": "आइटम बाद में बदले, हटाए और जोड़े जा सकते हैं।",
 "Enviar os convites": "निमंत्रण भेजें",
 "Equipamentos (projetor, som)": "उपकरण (प्रोजेक्टर, साउंड)",
 "Equipe (garçons, limpeza)": "स्टाफ़ (वेटर, सफ़ाई)",
 "Escolha \"Outro\" para escrever o nome.": "नाम लिखने के लिए \"अन्य\" चुनें।",
 "Escolher a roupa": "कपड़े चुनें",
 "Escolher a roupa dos noivos": "दूल्हा-दुल्हन के कपड़े चुनें",
 "Escolher os padrinhos": "गवाह/गॉडपेरेंट्स चुनें",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "{n} मेहमानों के लिए अनुमान। जोड़ने से पहले जो चाहें बदलें।",
 "Eu faço": "मैं करूँगा",
 "Ex.: 200 un.": "उदा.: 200 नग",
 "Ex.: Copos descartáveis": "उदा.: डिस्पोज़ेबल गिलास",
 "Ex.: Jogo de panelas": "उदा.: बर्तनों का सेट",
 "Ex.: Reservar o local": "उदा.: स्थान बुक करें",
 "Ex.: em negociação": "उदा.: बातचीत जारी",
 "Extras de margem (quem aparece sem avisar)": "अतिरिक्त गुंजाइश (बिना बताए आने वाले)",
 "Falta 1 dia": "1 दिन बाकी",
 "Falta agradecer": "धन्यवाद देना बाकी",
 "Falta comprar": "खरीदना बाकी",
 "Falta pagar": "भुगतान बाकी",
 "Fazer a lista de presentes": "उपहारों की सूची बनाएँ",
 "Fazer o curso de batismo": "बपतिस्मा का कोर्स करें",
 "Fornecedores (contratado, pago, falta)": "आपूर्तिकर्ता (तय, भुगतान, बाकी)",
 "Foto e vídeo": "फोटो और वीडियो",
 "Fraldas": "डायपर",
 "Frase curta (opcional)": "छोटा वाक्य (वैकल्पिक)",
 "Hoje é o dia do evento!": "आज कार्यक्रम का दिन है!",
 "Igreja e celebrante": "चर्च और अनुष्ठानकर्ता",
 "Incluir os Talvez": "\"शायद\" शामिल करें",
 "Incluir telefones": "फ़ोन नंबर शामिल करें",
 "Item da lista de compras": "खरीदारी सूची का आइटम",
 "Item da preparação": "तैयारी का आइटम",
 "Já deram: {d} · Falta: {f}": "दिया जा चुका: {d} · बाकी: {f}",
 "Já deu": "दे चुका",
 "L": "ली.",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "जो खर्च हुआ उसे यहाँ दर्ज करें। आपूर्तिकर्ताओं को भुगतान और चिह्नित खरीदारी अपने आप जुड़ जाती हैं।",
 "Lançar o gasto": "खर्च दर्ज करें",
 "Lembrancinhas": "रिटर्न गिफ्ट",
 "Levar para os itens": "आइटम में जोड़ें",
 "Local / espaço": "स्थान / जगह",
 "Mais um extra": "एक और अतिरिक्त",
 "Menos um extra": "एक अतिरिक्त कम",
 "Música / som / DJ": "संगीत / साउंड / DJ",
 "No dia do evento": "कार्यक्रम के दिन",
 "O que comprar": "क्या खरीदना है",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "किसी के पुष्टि करने या रद्द करने पर कुल अपने आप बदलता है।",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "अनुबंध की राशि इस श्रेणी में अनुमानित के रूप में अपने आप जुड़ती है, और जो भुगतान होगा वह खर्च में जाएगा।",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "राशि कार्यक्रम के खर्च में, आइटम की श्रेणी में जाएगी। चाहें तो छोड़ दें।",
 "Onde comprar": "कहाँ से खरीदें",
 "Orçamento do evento": "कार्यक्रम का बजट",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "चिह्नित आइटम प्रति मेहमान ⊕ के साथ श्रेणी में जाते हैं। फिर बस ⊕ पर टैप करें और इकाई मूल्य डालें।",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "मेहमानों के फ़ोन नंबर PDF में तभी आते हैं जब आप \"फ़ोन नंबर शामिल करें\" चुनें। अलग-अलग मुद्राओं की राशियाँ अलग दिखती हैं।",
 "Pago em {d}": "{d} को भुगतान",
 "Parte da vaquinha": "सामूहिक चंदे का हिस्सा",
 "Pessoas do evento": "कार्यक्रम के लोग",
 "Pessoas do evento: {p}": "कार्यक्रम के लोग: {p}",
 "Preparar as brincadeiras": "खेल तैयार करें",
 "Preparação": "तैयारी",
 "Presente recebido": "उपहार मिला",
 "Presentes": "उपहार",
 "Prova final da roupa": "कपड़ों का अंतिम ट्रायल",
 "Pular": "छोड़ें",
 "Quantidade por convidado": "प्रति मेहमान मात्रा",
 "Quantidade por convidado × valor unitário": "प्रति मेहमान मात्रा × इकाई मूल्य",
 "Quanto custou?": "कितने का पड़ा?",
 "Quanto já deu": "कितना दे चुका",
 "Quanto vai contribuir": "कितना योगदान देंगे",
 "Quantos dias antes do evento": "कार्यक्रम से कितने दिन पहले",
 "Quem deu": "किसने दिया",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "कार्यक्रम के समूह में शामिल लोग अपने आप जुड़ जाते हैं। जिनके पास ऐप नहीं है उनके लिए \"+ व्यक्ति जोड़ें\" का उपयोग करें। यह सूची कार्यक्रम-सूची, खर्च और सामूहिक चंदे में उपयोग होती है।",
 "Recreação e brinquedos": "मनोरंजन और खिलौने",
 "Refrigerante": "सॉफ्ट ड्रिंक",
 "Relatório do evento": "कार्यक्रम रिपोर्ट",
 "Relatório do evento (PDF)": "कार्यक्रम रिपोर्ट (PDF)",
 "Reservar o local": "स्थान बुक करें",
 "Reservar o local da cerimônia e da festa": "समारोह और पार्टी का स्थान बुक करें",
 "Reservar o local ou a mesa da festa": "पार्टी का स्थान या टेबल बुक करें",
 "Restante": "शेष राशि",
 "Restante pago": "शेष राशि का भुगतान हुआ",
 "Resumo do evento": "कार्यक्रम का सारांश",
 "Roupa e beleza": "कपड़े और सौंदर्य",
 "Salgados": "नमकीन",
 "Separar a roupa e o que levar": "कपड़े और साथ ले जाने का सामान अलग रखें",
 "Separar os documentos e as alianças": "दस्तावेज़ और अंगूठियाँ अलग रखें",
 "Separar os documentos e os ingressos": "दस्तावेज़ और टिकट अलग रखें",
 "Sinal": "अग्रिम",
 "Sinal pago": "अग्रिम का भुगतान हुआ",
 "Sinal {v} pago": "अग्रिम {v} का भुगतान हुआ",
 "Usar a lista pronta para {tipo}": "{tipo} के लिए तैयार सूची का उपयोग करें",
 "Vai contribuir": "योगदान देंगे",
 "Valor unitário": "इकाई मूल्य",
 "Vaquinha": "सामूहिक चंदा",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "आप साझा की गई हर चीज़ हमेशा अपडेट रूप में देख सकते हैं। जोड़ने, संपादित करने और कार्य लेने के लिए यह टैब सब्सक्राइब करें।",
 "agradeci": "धन्यवाद दिया",
 "atrasado": "देर से",
 "completo": "पूरा",
 "deu {d} de {v}": "{v} में से {d} दिए",
 "em {l}": "{l} में",
 "falta o valor": "राशि नहीं डाली",
 "falta {v} até {d}": "{d} तक {v} बाकी",
 "gasto em {e}": "{e} पर खर्च",
 "kg": "kg",
 "o evento": "कार्यक्रम",
 "restante": "शेष राशि",
 "sinal": "अग्रिम",
 "total": "कुल",
 "un.": "नग",
 "{n} confirmados": "{n} पुष्ट",
 "{n} convidados contam no ⊕ por convidado.": "{n} मेहमान प्रति मेहमान ⊕ में गिने जाते हैं।",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "\"लंबित\" में रहे {n} मेहमान \"आमंत्रित करना है\" में चले गए। ऐप से निमंत्रण भेजने पर वे अपने आप \"आमंत्रित, कोई जवाब नहीं\" में चले जाएँगे।",
 "{n} extras": "{n} अतिरिक्त",
 "{n} talvez": "{n} शायद",
 "{q} por convidado": "प्रति मेहमान {q}",
 "{v} por convidado": "प्रति मेहमान {v}",
 "Item completo": "पूरा आइटम",
 "Nota rápida": "त्वरित नोट",
 "📝 Nota rápida": "📝 त्वरित नोट",
 "Conteúdo da nota": "नोट की सामग्री",
 "{c} confirmado(s) de {n} convidado(s)": "{n} मेहमानों में से {c} ने पुष्टि की",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "सभी के लिए हटाए जाएंगे: ऑफिस \"{nome}\" के दस्तावेज़, तय मीटिंग और रिकॉर्डिंग। बातचीत संदेशों में रहेगी।",
 "Confirme para apagar o escritório": "ऑफिस हटाने के लिए पुष्टि करें",
 "Escreva o assunto da reunião para poder marcar.": "मीटिंग तय करने के लिए विषय लिखें।",
 "{n} min (marcada para {m} min)": "{n} मिनट ({m} मिनट के लिए तय)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "अभी फ़ाइल डाउनलोड नहीं हो सकी। इंटरनेट जाँचें और फिर कोशिश करें।",
 "Meus clientes": "मेरे ग्राहक",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "ग्राहकों की एक ही सूची, जो सभी काम के टैब में इस्तेमाल होती है: संपर्क, पता, टैग, नोट्स और फ़ाइलें।",
 "Copiar para Meus clientes": "मेरे ग्राहक में कॉपी करें",
 "Ver ou mudar": "देखें या बदलें",
 "Ver o documento completo": "पूरा दस्तावेज़ देखें",
 "CEP incompleto": "CEP अधूरा है",
 "O CEP tem 8 números.": "CEP में 8 अंक होते हैं।",
 "CEP não encontrado": "CEP नहीं मिला",
 "Confira os números ou preencha o endereço à mão.": "अंक जाँचें या पता खुद भरें।",
 "Não foi possível buscar o CEP": "CEP नहीं खोजा जा सका",
 "Confira a internet ou preencha o endereço à mão.": "इंटरनेट जाँचें या पता खुद भरें।",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "इस ईमेल में कुछ कमी लग रही है (जैसे: name@site.com)।",
 "opcional": "वैकल्पिक",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "अब आपके ग्राहक एक ही सूची में हैं, जो सभी काम के टैब में इस्तेमाल होती है।",
 "Portal do Cliente: {n} cliente(s).": "ग्राहक पोर्टल: {n} ग्राहक।",
 "Freelancer & Projetos: {n} cliente(s).": "फ्रीलांसर और प्रोजेक्ट: {n} ग्राहक।",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} एक से ज़्यादा टैब में एक ही ग्राहक थे और अब एक ही रिकॉर्ड बन गए।",
 "Nenhum cliente repetido.": "कोई दोहराया ग्राहक नहीं।",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "कुछ भी हटाया नहीं गया: दस्तावेज़, ऑर्डर, कार्ड और घंटे जहाँ थे वहीं हैं।",
 "Já está em Meus clientes": "पहले से मेरे ग्राहक में है",
 "{nome} já está na lista.": "{nome} पहले से सूची में है।",
 "Copiado para Meus clientes": "मेरे ग्राहक में कॉपी किया गया",
 "Só o nome e o contato foram copiados.": "केवल नाम और संपर्क कॉपी किए गए।",
 "Aniversário hoje!": "आज जन्मदिन है!",
 "Fechar tudo": "सब बंद करें",
 "Abrir tudo": "सब खोलें",
 "Quem é": "कौन हैं",
 "Razão social": "कंपनी का कानूनी नाम",
 "Nome fantasia": "व्यापारिक नाम",
 "Data de abertura": "स्थापना तिथि",
 "Inscrição estadual / municipal": "राज्य / नगरपालिका पंजीकरण",
 "Outras pessoas de contato": "अन्य संपर्क व्यक्ति",
 "Como chamar": "किस नाम से बुलाएँ",
 "Cliente desde": "ग्राहक कब से",
 "Outro telefone": "दूसरा फ़ोन",
 "Site": "वेबसाइट",
 "Melhor jeito de falar": "बात करने का सबसे अच्छा तरीका",
 "Autorizou receber mensagens": "संदेश पाने की अनुमति दी",
 "Outros endereços": "अन्य पते",
 "Relacionamento": "संबंध",
 "Como me conheceu": "मुझे कैसे जाना",
 "Etiquetas": "टैग",
 "Nada anotado ainda.": "अभी कोई नोट नहीं।",
 "Bloco da aba {aba}": "{aba} टैब का भाग",
 "Abrir na aba {aba}": "{aba} टैब में खोलें",
 "Uma lista só, usada por todas as abas de trabalho.": "एक ही सूची, जो सभी काम के टैब में इस्तेमाल होती है।",
 "Escreva o nome do cliente.": "ग्राहक का नाम लिखें।",
 "Telefone / WhatsApp": "फ़ोन / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "केवल नाम ज़रूरी है। जो भाग भरना चाहें उन्हें खोलें।",
 "Como chamar (apelido)": "किस नाम से बुलाएँ (उपनाम)",
 "Inscrição estadual / municipal (opcional)": "राज्य / नगरपालिका पंजीकरण (वैकल्पिक)",
 "Cargo": "पद",
 "Telefone da pessoa de contato": "संपर्क व्यक्ति का फ़ोन",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "अन्य संपर्क व्यक्ति (हर पंक्ति में एक: नाम, पद, फ़ोन)",
 "O telefone principal é WhatsApp": "मुख्य फ़ोन WhatsApp है",
 "O outro telefone é WhatsApp": "दूसरा फ़ोन WhatsApp है",
 "Instagram": "Instagram",
 "Ex.: @nome": "जैसे: @name",
 "Ex.: WhatsApp, à tarde": "जैसे: WhatsApp, दोपहर में",
 "Estado (UF)": "राज्य (UF)",
 "Endereço (como estava escrito)": "पता (जैसा लिखा था)",
 "Outros endereços (trabalho, entrega...)": "अन्य पते (काम, डिलीवरी...)",
 "Google": "Google",
 "Passou na frente": "दुकान के सामने से गुज़रे",
 "Indicado por": "किसने सुझाया",
 "Criar etiqueta": "टैग बनाएँ",
 "Ex.: VIP, Mensal, Atacado": "जैसे: VIP, मासिक, थोक",
 "Ativo": "सक्रिय",
 "Inativo": "निष्क्रिय",
 "Em negociação": "बातचीत जारी",
 "O cliente autorizou receber mensagens?": "क्या ग्राहक ने संदेश पाने की अनुमति दी है?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "अनुमति के बिना इस ग्राहक को जन्मदिन संदेश, स्वचालित भुगतान अनुस्मारक या प्रमोशन नहीं भेजे जाएँगे।",
 "aniversário hoje": "आज जन्मदिन",
 "contato: {n}": "संपर्क: {n}",
 "com esse telefone": "इस फ़ोन के साथ",
 "com esse e-mail": "इस ईमेल के साथ",
 "com esse documento": "इस दस्तावेज़ के साथ",
 "com esse nome": "इस नाम के साथ",
 "Cliente parecido": "मिलता-जुलता ग्राहक",
 "Já existe {nome} {por}. Abrir?": "{nome} पहले से है ({por})। खोलें?",
 "Cadastrar mesmo assim": "फिर भी जोड़ें",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "इस ग्राहक का रिकॉर्ड, नोट्स और फ़ाइलें हटा दी जाएँगी।",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "इन टैब में भी: {abas} (वहाँ के दस्तावेज़, ऑर्डर, कार्ड और घंटों सहित)।",
 "Juntar com outra ficha": "दूसरे रिकॉर्ड से मिलाएँ",
 "Juntar fichas": "रिकॉर्ड मिलाएँ",
 "Não há outra ficha para juntar.": "मिलाने के लिए कोई दूसरा रिकॉर्ड नहीं है।",
 "Juntar \"{nome}\" com:": "\"{nome}\" को इसके साथ मिलाएँ:",
 "Juntar as duas fichas?": "दोनों रिकॉर्ड मिलाएँ?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "\"{a}\" को \"{b}\" का सब कुछ मिलेगा (जानकारी, नोट्स, फ़ाइलें और टैब से जुड़ाव)। \"{b}\" रिकॉर्ड हट जाएगा।",
 "Juntar": "मिलाएँ",
 "Confirme para juntar as fichas": "रिकॉर्ड मिलाने के लिए पुष्टि करें",
 "Aniversariantes do mês": "इस महीने के जन्मदिन",
 "Ativos": "सक्रिय",
 "Inativos": "निष्क्रिय",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "हर ग्राहक को एक बार जोड़ें: वह आपके सभी काम के टैब में दिखेगा।",
 "Novo cliente": "नया ग्राहक",
 "Editar cliente": "ग्राहक संपादित करें",
 "Linha do tempo": "टाइमलाइन",
 "{n} registro(s)": "{n} रिकॉर्ड",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "अभी कुछ नहीं। बिक्री, भुगतान, दस्तावेज़ और घंटे यहाँ दिखेंगे।",
 "Me deve": "मेरा बकाया",
 "Total pago": "कुल भुगतान",
 "Última compra ou atendimento": "पिछली खरीद या सेवा",
 "Próximo compromisso": "अगली मुलाकात",
 "na entrega": "डिलीवरी पर",
 "Passou do limite de fiado ({v}).": "उधार की सीमा ({v}) पार हो गई।",
 "Recebeu {v} ({p})": "{v} मिले ({p})",
 "Hoje é aniversário de {n}.": "आज {n} का जन्मदिन है।",
 "Mandar parabéns": "बधाई भेजें",
 "{n}: parcela de {v} atrasada.": "{n}: {v} की किस्त बकाया है।",
 "Cobrar": "भुगतान माँगें",
 "{n} não compra há {d} dias.": "{n} ने {d} दिनों से कुछ नहीं खरीदा।",
 "Chamar de volta": "फिर से संपर्क करें",
 "🟢 em dia · 🟡 sumido": "🟢 समय पर · 🟡 लंबे समय से नहीं आए",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 समय पर · 🟡 कुछ देय होने वाला या ग्राहक गायब · 🔴 बकाया",
 "Limite de fiado (opcional)": "उधार सीमा (वैकल्पिक)",
 "Avisa quando o que ele deve passar deste valor.": "जब बकाया इस राशि से ज़्यादा हो जाए तो सूचना देता है।",
 "A prazo": "किस्तों में",
 "parcela atrasada": "बकाया किस्त",
 "falta na entrega": "डिलीवरी पर बाकी",
 "Sumidos": "लंबे समय से गायब",
 "Sinal pago, falta o resto": "अग्रिम दिया, बाकी शेष",
 "Pagou {a} de {b}": "{b} में से {a} चुकाए",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "यह किस्त मेरे ग्राहक से आई है। इसे यहाँ प्राप्त के रूप में चिह्नित करें या भुगतान माँगने और रसीद बनाने के लिए ग्राहक खोलें।",
 "Sinal + restante": "अग्रिम + शेष",
 "Pix": "Pix",
 "Cartão de crédito à vista": "क्रेडिट कार्ड, एकमुश्त",
 "Cartão de crédito parcelado": "क्रेडिट कार्ड, किस्तों में",
 "Fiado / a prazo": "उधार / किस्तों में",
 "Parcela única": "एकमुश्त भुगतान",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "नमस्ते {nome}! जन्मदिन की बहुत-बहुत शुभकामनाएँ! 🎉 आपका दिन शानदार हो।",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "नमस्ते {nome}! काफ़ी समय से बात नहीं हुई। क्या मैं किसी चीज़ में मदद कर सकती हूँ? आपकी फिर से सेवा करके खुशी होगी!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "नमस्ते {nome}! बस याद दिला रही हूँ: {v} की किस्त {d} को देय थी। कोई बात हो तो मुझे बताइए। धन्यवाद!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "नमस्ते {nome}! बस याद दिला रही हूँ: {v} की किस्त{d}। कोई बात हो तो मुझे बताइए। धन्यवाद!",
 "que vence dia {d}": "जो {d} को देय है",
 "Quanto recebeu?": "कितना मिला?",
 "Falta {v}. Pode ser só uma parte.": "{v} बाकी है। केवल कुछ हिस्सा भी हो सकता है।",
 "(seu nome ou sua marca, em Como você recebe?)": "(आपका नाम या ब्रांड, \"आपको भुगतान कैसे मिलता है?\" में)",
 "Recibo {c}": "रसीद {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "मैंने {c} से {o} के लिए {v} की राशि प्राप्त की।",
 "{v} no {f} → recebe {l}": "{f} से {v} → आपको मिलेंगे {l}",
 "Pagou {a} de {b}, faltam {c}": "{b} में से {a} चुकाए, {c} बाकी",
 "Recebido em {d}": "{d} को प्राप्त",
 "Cobrar pelo WhatsApp": "WhatsApp पर भुगतान माँगें",
 "Sem autorização": "अनुमति नहीं",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "इस ग्राहक ने संदेश पाने की अनुमति नहीं दी है (ग्राहक प्रोफ़ाइल › संबंध)।",
 "Sem telefone": "फ़ोन नंबर नहीं",
 "Coloque o telefone na ficha do cliente.": "ग्राहक प्रोफ़ाइल में फ़ोन नंबर जोड़ें।",
 "Gerar recibo": "रसीद बनाएँ",
 "Como você recebe?": "आपको भुगतान कैसे मिलता है?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "केवल \"एकमुश्त\": साफ़ स्क्रीन, बिना किस्तों या लाल रंग के।",
 "Taxa da maquininha (%)": "कार्ड मशीन शुल्क (%)",
 "Taxa {k}": "{k} शुल्क",
 "Cliente sumido depois de (dias sem comprar)": "ग्राहक को गायब मानें (बिना खरीद के दिन)",
 "Dias para considerar sumido": "गायब मानने के दिन",
 "Lembretes de cobrança por parcela atrasada": "बकाया किस्तों के लिए भुगतान रिमाइंडर",
 "Nome ou marca no recibo": "रसीद पर नाम या ब्रांड",
 "Ex.: Ana Beatriz Doces": "उदा.: Ana Beatriz मिठाइयाँ",
 "Venda ou serviço": "बिक्री या सेवा",
 "O que foi vendido ou feito": "क्या बेचा या किया गया",
 "Ex.: Bolo de aniversário": "उदा.: जन्मदिन का केक",
 "Como paga": "भुगतान का तरीका",
 "Sinal (%)": "अग्रिम (%)",
 "Ou escreva o valor do sinal logo abaixo.": "या ठीक नीचे अग्रिम राशि लिखें।",
 "Sinal (valor)": "अग्रिम (राशि)",
 "Restante na entrega": "शेष डिलीवरी पर",
 "Próximo vencimento": "अगली देय तिथि",
 "Sinal a receber": "प्राप्त होने वाला अग्रिम",
 "falta {v}{q}": "{v} बाकी{q}",
 "quitado": "चुकता",
 "Parcelas mantidas": "किस्तें बरकरार",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "भुगतान पहले से दर्ज है: किस्तें दोबारा नहीं बनाई गईं। बदलने के लिए पहले भुगतान पूर्ववत करें।",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "दर्ज करें कि ग्राहक ने क्या खरीदा या आपने कौन सी सेवा दी, और वह कैसे भुगतान करता है।",
 "Débito": "डेबिट",
 "Crédito à vista": "क्रेडिट, एकमुश्त",
 "Crédito 2x": "क्रेडिट, 2 किस्तें",
 "Crédito 3x": "क्रेडिट, 3 किस्तें",
 "Crédito 4x": "क्रेडिट, 4 किस्तें",
 "Crédito 5x": "क्रेडिट, 5 किस्तें",
 "Crédito 6x": "क्रेडिट, 6 किस्तें",
 "Crédito 7x": "क्रेडिट, 7 किस्तें",
 "Crédito 8x": "क्रेडिट, 8 किस्तें",
 "Crédito 9x": "क्रेडिट, 9 किस्तें",
 "Crédito 10x": "क्रेडिट, 10 किस्तें",
 "Crédito 11x": "क्रेडिट, 11 किस्तें",
 "Crédito 12x": "क्रेडिट, 12 किस्तें",
 "ATRASADOS": "बकाया",
 "Atrasado (hoje): {v}": "बकाया (आज तक): {v}",
 "Buscar um cliente": "ग्राहक खोजें",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "पूरा CPF/CNPJ, पूरा पता और जन्मतिथि। ऐप का पासवर्ड माँगा जाएगा।",
 "Cliente cadastrado": "ग्राहक जोड़ा गया",
 "Com documentos: guarde o arquivo em lugar seguro.": "दस्तावेज़ों के साथ: फ़ाइल को सुरक्षित जगह रखें।",
 "Como pagou": "भुगतान का तरीका",
 "Esse contato não tem nome.": "इस संपर्क का कोई नाम नहीं है।",
 "Exportar planilha": "स्प्रेडशीट एक्सपोर्ट करें",
 "Falta receber": "अभी मिलना बाकी",
 "Falta receber (hoje): {v}": "अभी मिलना बाकी (आज तक): {v}",
 "Importar dos contatos": "संपर्कों से इम्पोर्ट करें",
 "Importar dos contatos do celular": "फ़ोन के संपर्कों से इम्पोर्ट करें",
 "Incluir documentos": "दस्तावेज़ शामिल करें",
 "Incluir documentos no relatório": "रिपोर्ट में दस्तावेज़ शामिल करें",
 "MELHORES CLIENTES": "शीर्ष ग्राहक",
 "Melhores clientes": "शीर्ष ग्राहक",
 "Não foi possível gerar a planilha.": "स्प्रेडशीट नहीं बन सकी।",
 "O que foi": "क्या था",
 "Pago em": "भुगतान की तारीख",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "फ़ोन के संपर्कों से ग्राहक लाने के लिए, ऐप स्टोर से My Planner अपडेट करें।",
 "RECEBIDO POR DIA": "प्रतिदिन प्राप्त",
 "RECEBIDO POR MÊS": "प्रति माह प्राप्त",
 "Recebeu": "प्राप्त",
 "Recebeu no período": "अवधि में प्राप्त",
 "Recebeu no período: {v}": "अवधि में प्राप्त: {v}",
 "Recebido no período": "अवधि में प्राप्त",
 "Relatório de clientes": "ग्राहक रिपोर्ट",
 "Relatório deste cliente": "इस ग्राहक की रिपोर्ट",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "संपर्कों की अनुमति के बिना संपर्क नहीं चुना जा सकता। आप फ़ोन की सेटिंग में इसे चालू कर सकते हैं।",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "दस्तावेज़ों के बिना: CPF/CNPJ के सिर्फ़ आख़िरी 2 अंक दिखेंगे। नोट्स कभी शामिल नहीं होते।",
 "Todos os clientes": "सभी ग्राहक",
 "Trabalha em: {e}": "काम करते हैं: {e}",
 "Trazer outro": "एक और लाएँ",
 "VENDAS E ATENDIMENTOS": "बिक्री और सेवाएँ",
 "Vence": "देय तिथि",
 "Venceu": "देय तिथि बीत गई",
 "Vendas e atendimentos": "बिक्री और सेवाएँ",
 "Vendeu": "बिक्री",
 "Vendeu no período": "अवधि में बिक्री",
 "Vendeu no período: {v}": "अवधि में बिक्री: {v}",
 "venceu {d}": "{d} को देय था",
 "vendido no período": "अवधि में बिक्री",
 "{nome} comprou no período": "{nome} ने अवधि में खरीदा",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} मेरे ग्राहक में जुड़ गए। विवरण जाँचें और चिह्नित करें कि उन्होंने संदेश पाने की अनुमति दी है या नहीं।",
 "{n} compra(s)": "{n} खरीद",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "संग्रहित करने के लिए बॉक्स को बाएँ और हटाने के लिए दाएँ स्वाइप करें। क्रम बदलने के लिए बॉक्स के खाली हिस्से को दबाकर खींचें।",
 "Bloco": "ब्लॉक",
 "Confirme para apagar o grupo": "समूह हटाने के लिए पुष्टि करें",
 "Descer": "नीचे करें",
 "Opções do bloco": "ब्लॉक के विकल्प",
 "Exigências do destino": "गंतव्य की आवश्यकताएँ",
 "{n} para acertar": "{n} निपटाने बाकी",
 "{n} parada(s)": "{n} पड़ाव",
 "Cor do item selecionado": "चुने गए आइटम का रंग",
 "Abrir o grupo": "समूह खोलें",
 "Recolher o grupo": "समूह समेटें",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "हटाने के लिए बॉक्स को दाएँ और संग्रहित करने के लिए बाएँ स्वाइप करें। क्रम बदलने के लिए दबाकर खींचें।",
 "Editar subtítulo": "उपशीर्षक संपादित करें",
 "Início da caixa": "बॉक्स की शुरुआत",
 "Mover para…": "यहाँ ले जाएँ…",
 "Mover {n} item(ns) para": "{n} आइटम यहाँ ले जाएँ",
 "Opções do item": "आइटम के विकल्प",
 "Transformar em subtítulo": "उपशीर्षक में बदलें",
 "Transformar em texto": "टेक्स्ट में बदलें",
 "esta caixa": "यह बॉक्स",
 "{a} de {n} feitos": "{n} में से {a} पूरे",
 "1 documento pedido atrasado": "1 मांगा गया दस्तावेज़ देर से",
 "1 pedido vence logo": "1 अनुरोध जल्द देय",
 "A lista vem de \"Meus clientes\".": "सूची \"मेरे क्लाइंट\" से आती है।",
 "Abrir Meus clientes": "मेरे क्लाइंट खोलें",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "ऑफ़िस और क्लाइंट पोर्टल टैब अब एक ही टैब हैं।",
 "Clientes com pendência": "लंबित काम वाले क्लाइंट",
 "Com pendência ({n})": "लंबित ({n})",
 "Conversa da equipe": "टीम चैट",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "ऑफ़िस बनाएँ और टीम को बुलाएँ (ऐप के दोस्त या लिंक से आमंत्रण): चैट, वीडियो मीटिंग और आंतरिक दस्तावेज़। अकेले काम करते हैं? सिर्फ़ क्लाइंट इस्तेमाल करें।",
 "Documentos internos": "आंतरिक दस्तावेज़",
 "Entrar com um código de convite": "आमंत्रण कोड से जुड़ें",
 "Escritório & Clientes": "ऑफ़िस और क्लाइंट",
 "Escritórios: {n}": "ऑफ़िस: {n}",
 "Esta parte é para quem trabalha com equipe": "यह हिस्सा टीम के साथ काम करने वालों के लिए है",
 "Guias vencendo": "देय टैक्स पर्चियाँ",
 "Minhas tarefas": "मेरे काम",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "कुछ भी नहीं मिटाया गया: टीम, चैट, मीटिंग, दस्तावेज़ और आमंत्रित क्लाइंट पहले जैसे ही हैं।",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "अभी कोई क्लाइंट नहीं। \"मेरे क्लाइंट\" में जोड़ें: वह तुरंत यहाँ दिखेगा।",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "क्लाइंट के साथ काम करने वालों के लिए, अकेले या टीम के साथ: हर क्लाइंट का फ़ोल्डर (दस्तावेज़, अनुरोध, टैक्स पर्चियाँ), टीम, चैट, मीटिंग और आंतरिक दस्तावेज़।",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "पोर्टल के क्लाइंट फ़ोल्डर: {c} ({d} दस्तावेज़ और {p} अनुरोध)",
 "Pessoa física": "व्यक्ति",
 "Procurar por nome, CNPJ ou CPF": "नाम, CNPJ या CPF से खोजें",
 "Reuniões hoje": "आज की मीटिंग",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "कोई ऑफ़िस (टीम) नहीं। बनाने या कोड से जुड़ने के लिए टैप करें।",
 "Só a equipe vê. Clientes nunca veem esta parte.": "सिर्फ़ टीम देखती है। क्लाइंट यह हिस्सा कभी नहीं देखते।",
 "Tudo em dia": "सब कुछ अप टू डेट",
 "Vencendo ({n})": "जल्द देय ({n})",
 "chega na próxima versão": "अगले संस्करण में आएगा",
 "nos próximos 7 dias": "अगले 7 दिनों में",
 "vence amanhã": "कल देय",
 "vence hoje": "आज देय",
 "{doc} venceu em {d}": "{doc} की तारीख {d} को निकल गई",
 "{n} documentos pedidos atrasados": "{n} मांगे गए दस्तावेज़ देर से",
 "{n} pedidos vencem logo": "{n} अनुरोध जल्द देय",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 अप टू डेट · 🟡 कुछ जल्द देय · 🔴 अनुरोध देर से या टैक्स पर्ची की तारीख निकली",
 "Acesso ao gov.br": "gov.br एक्सेस",
 "Alvará": "व्यापार लाइसेंस",
 "Até o dia (do mês)": "तारीख तक (महीने की)",
 "CCMEI (certificado do MEI)": "CCMEI (MEI प्रमाणपत्र)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "WhatsApp पर याद दिलाने के लिए क्लाइंट का फ़ोन नंबर जोड़ें।",
 "Cartão CNPJ": "CNPJ कार्ड",
 "Checklist criado": "चेकलिस्ट बनाई गई",
 "Checklist de cliente novo": "नए क्लाइंट की चेकलिस्ट",
 "Cliente viu {doc}": "क्लाइंट ने {doc} देखा",
 "Cole no app do banco, em Pix copia e cola.": "बैंक ऐप में Pix कॉपी-पेस्ट में चिपकाएँ।",
 "Cole no app do banco.": "बैंक ऐप में चिपकाएँ।",
 "Comprovante de endereço": "पते का प्रमाण",
 "Contrato social e alterações": "साझेदारी/कंपनी अनुबंध और संशोधन",
 "Copiado": "कॉपी हो गया",
 "Copiar Pix": "Pix कॉपी करें",
 "Copiar código de barras": "बारकोड कॉपी करें",
 "Código de barras (linha digitável)": "बारकोड (अंकों वाली लाइन)",
 "Dados bancários": "बैंक विवरण",
 "Escreva o recado.": "संदेश लिखें।",
 "Escritório enviou {doc}": "ऑफ़िस ने {doc} भेजा",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "इस क्लाइंट ने संदेश पाने की अनुमति नहीं दी है (मेरे क्लाइंट में प्रोफ़ाइल देखें)।",
 "Extratos bancários": "बैंक स्टेटमेंट",
 "Ficha completa": "पूरी प्रोफ़ाइल",
 "Guia": "कर भुगतान पर्ची",
 "Guias a pagar": "भुगतान बाकी कर पर्चियाँ",
 "Honorário": "शुल्क",
 "Honorário por": "शुल्क प्रति",
 "Informes de rendimentos": "आय विवरण",
 "Lembrar pelo WhatsApp": "WhatsApp पर याद दिलाएँ",
 "Ler a guia ou o boleto com a minha IA": "कर पर्ची या बोलेतो मेरी AI से पढ़ें",
 "Lucro presumido": "अनुमानित लाभ",
 "Lucro real": "वास्तविक लाभ",
 "Nada ainda.": "अभी कुछ नहीं।",
 "Nenhum pedido em aberto.": "कोई खुला अनुरोध नहीं।",
 "Notas fiscais emitidas": "जारी किए गए इनवॉइस",
 "O cliente": "क्लाइंट",
 "O pedido entrou em Pedidos de documentos.": "अनुरोध दस्तावेज़ अनुरोधों में जोड़ दिया गया।",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "नमस्ते {nome}! यह बाकी है: {itens}। क्या यहीं भेज सकते हैं?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "नमस्ते {nome}! ये बाकी हैं: {itens}। क्या यहीं भेज सकते हैं?",
 "Oi, {nome}! Tudo certo por aí?": "नमस्ते {nome}! वहाँ सब ठीक है?",
 "Pedido criado": "अनुरोध बनाया गया",
 "Pedido feito: {o}": "अनुरोध भेजा: {o}",
 "Pedido recebido: {o}": "अनुरोध मिला: {o}",
 "Pedidos pendentes": "लंबित अनुरोध",
 "Pedir de novo todo mês": "हर महीने फिर से माँगें",
 "Pedir nova ({c})": "नया माँगें ({c})",
 "Pendentes": "लंबित",
 "Que tipo de cliente?": "किस प्रकार का क्लाइंट?",
 "RG e CPF": "RG और CPF",
 "RG e CPF do titular": "मालिक का RG और CPF",
 "RG e CPF dos sócios": "साझेदारों का RG और CPF",
 "Recados": "संदेश",
 "Recados entre você e o cliente, presos à pasta dele.": "आपके और क्लाइंट के बीच के संदेश, उनके फ़ोल्डर में रखे जाते हैं।",
 "Responde ao pedido": "अनुरोध का जवाब",
 "Tipo / regime": "प्रकार / कर व्यवस्था",
 "Visto pelo cliente em {d}": "क्लाइंट ने {d} को देखा",
 "Válido até": "तक मान्य",
 "ano": "वर्ष",
 "código Pix copia e cola, se houver": "Pix कॉपी-पेस्ट कोड, यदि हो",
 "data de vencimento": "देय तिथि",
 "documento": "दस्तावेज़",
 "linha digitável do boleto ou da guia, só números": "बोलेतो या कर पर्ची की अंकों वाली लाइन, केवल अंक",
 "mês": "महीना",
 "novo": "नया",
 "todo mês, até o dia {n}": "हर महीने, {n} तारीख तक",
 "valor a pagar": "देय राशि",
 "válido até {d}": "{d} तक मान्य",
 "{c} nova": "नया {c}",
 "{doc} pago": "{doc} का भुगतान हो गया",
 "{n} a pagar": "{n} भुगतान बाकी",
 "{n} enviou {doc}": "{n} ने {doc} भेजा",
 "{n} novo(s)": "{n} नए",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "{n} दस्तावेज़ अनुरोध बनाए गए, 7 दिन की समय-सीमा के साथ।",
 "{n} vencida(s)": "{n} समय-सीमा पार",
 "Última declaração do Imposto de Renda": "पिछला आयकर रिटर्न",
 "Últimas guias pagas": "हाल में भरी गई कर पर्चियाँ",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "ऑफ़िस का यह हिस्सा अभी सर्वर से नहीं जुड़ा है। कंप्यूटर पर 56-SERVIDOR-0.96.bat चलाएँ (सिर्फ़ एक बार)।",
 "Só vê": "सिर्फ़ देखे",
 "Nova versão": "नया संस्करण",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "इस नाम की फ़ाइल पहले से थी: पिछली फ़ाइल संस्करण {n} के रूप में सहेजी गई है।",
 "Visto por e comentários": "देखने वाले और टिप्पणियाँ",
 "Arquivar (só neste aparelho)": "संग्रहित करें (सिर्फ़ इस डिवाइस पर)",
 "Tirar do topo": "शीर्ष से हटाएँ",
 "Fixar no topo (para todos)": "शीर्ष पर पिन करें (सभी के लिए)",
 "Mover para a pasta…": "फ़ोल्डर में ले जाएँ…",
 "versão {n}": "संस्करण {n}",
 "visto por {n}": "{n} ने देखा",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "प्रति फ़ाइल 50 MB तक। उसी नाम की फ़ाइल भेजने पर पिछली फ़ाइल एक संस्करण के रूप में सहेजी जाती है।",
 "Procurar documento ou pasta": "दस्तावेज़ या फ़ोल्डर खोजें",
 "Fixados": "पिन किए गए",
 "Abrir o documento": "दस्तावेज़ खोलें",
 "enviado por {nome}": "{nome} द्वारा भेजा गया",
 "Versões ({n})": "संस्करण ({n})",
 "Versão {n} (atual)": "संस्करण {n} (वर्तमान)",
 "Versão {n}": "संस्करण {n}",
 "Visto por ({n})": "देखने वाले ({n})",
 "Ninguém da equipe abriu ainda.": "टीम में अभी तक किसी ने नहीं खोला।",
 "{nome} em {d}": "{nome}, {d} को",
 "Comentários ({n})": "टिप्पणियाँ ({n})",
 "Escreva um comentário": "टिप्पणी लिखें",
 "Contratos": "अनुबंध",
 "Financeiro do escritório": "ऑफ़िस वित्त",
 "RH": "एचआर",
 "Mover para a pasta": "फ़ोल्डर में ले जाएँ",
 "Ou escreva o nome de uma pasta nova": "या नए फ़ोल्डर का नाम लिखें",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "यह हर सप्ताह दोहराई जाती है: रद्द करने पर यह सभी सप्ताहों, सूची और टीम के प्राप्त में से हट जाएगी।",
 "a equipe toda": "पूरी टीम",
 "Com {quem}": "{quem} के साथ",
 "toda semana": "हर सप्ताह",
 "Vão: {n}": "जाएँगे: {n}",
 "Não vão: {n}": "नहीं जाएँगे: {n}",
 "Vou": "मैं जाऊँगा",
 "Não vou": "मैं नहीं जाऊँगा",
 "Pauta": "एजेंडा",
 "Ata": "कार्यवृत्त",
 "Escrever a ata": "कार्यवृत्त लिखें",
 "Abrir o link": "लिंक खोलें",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "आमंत्रित हर व्यक्ति को मीटिंग प्राप्त में मिलती है और वह एक टैप से अलर्ट के साथ उसे Planner में जोड़ सकता है।",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "पहले मीटिंग के नोट्स लिखें (क्या कहा गया और क्या तय हुआ); AI उन्हें कार्यवृत्त में व्यवस्थित करता है।",
 "Ata: {nome}": "कार्यवृत्त: {nome}",
 "Gerando...": "बन रहा है...",
 "Gerar ata com a minha IA": "मेरे AI से कार्यवृत्त बनाएँ",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "AI एजेंडा और आपके नोट्स को कार्यवृत्त में व्यवस्थित करता है। सहेजने से पहले जाँच लें।",
 "Ainda sem ata.": "अभी कोई कार्यवृत्त नहीं।",
 "Tarefas da reunião ({n})": "मीटिंग के कार्य ({n})",
 "Tarefa da reunião": "मीटिंग का कार्य",
 "Salvar a ata": "कार्यवृत्त सहेजें",
 "Repetir toda semana ({dia})": "हर सप्ताह दोहराएँ ({dia})",
 "Quem participa": "कौन भाग ले रहा है",
 "A equipe toda": "पूरी टीम",
 "Link externo (opcional: Meet, Zoom, Teams)": "बाहरी लिंक (वैकल्पिक: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "लिंक https:// से शुरू होना चाहिए",
 "Marcar e avisar quem participa": "तय करें और प्रतिभागियों को सूचित करें",
 "Cargo e papel": "पद और भूमिका",
 "Passar o Admin": "एडमिन सौंपें",
 "Passar o Admin para {nome}?": "एडमिन {nome} को सौंपें?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} अब ऑफ़िस की देखरेख करेगा/करेगी (उसे हटा भी सकता/सकती है)। आप प्रशासक के रूप में टीम में बने रहेंगे (जिसे मिला है वह इसे बाद में बदल सकता है)।",
 "Passar": "सौंपें",
 "{nome} agora cuida do escritório.": "{nome} अब ऑफ़िस की देखरेख करता/करती है।",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "यहाँ आपकी भूमिका \"सिर्फ़ देखे\" है: आप सूचनाएँ, कार्य, मीटिंग और दस्तावेज़ देख सकते हैं।",
 "Edita": "संपादित करे",
 "Incluir": "जोड़ें",
 "Novo aviso no mural": "नोटिस बोर्ड पर नई सूचना",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "आप इस ऑफ़िस को सिर्फ़ देख सकते हैं: एडमिन ने आपके लिए \"सिर्फ़ देखे\" भूमिका चुनी है। ज़रूरत हो तो एडमिन से बदलने को कहें।",
 "Quem viu": "किसने देखा",
 "Apagar aviso": "सूचना हटाएँ",
 "Mural de avisos": "नोटिस बोर्ड",
 "Novo aviso": "नई सूचना",
 "Ex.: Feriado na sexta: escritório fechado": "उदा.: शुक्रवार को छुट्टी: ऑफ़िस बंद",
 "Fixar no mural": "बोर्ड पर पिन करें",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "कोई सूचना नहीं। सूचनाएँ यहाँ पूरी टीम के लिए पिन रहती हैं।",
 "visto por {n} de {m}": "{m} में से {n} ने देखा",
 "sem responsável": "कोई ज़िम्मेदार नहीं",
 "atrasada desde {d}": "{d} से विलंबित",
 "prazo {d}": "समय-सीमा {d}",
 "Comecei": "शुरू किया",
 "Terminei": "पूरा किया",
 "Reabrir": "फिर से खोलें",
 "Tarefas da equipe": "टीम के कार्य",
 "1 aberta": "1 खुला",
 "{n} abertas": "{n} खुले",
 "Minhas tarefas ({n})": "मेरे कार्य ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "आपका कोई कार्य खुला नहीं है। टीम के किसी कार्य पर \"मैं करूँगा\" पर टैप करें।",
 "Nenhuma tarefa aberta.": "कोई कार्य खुला नहीं है।",
 "Feitas ({n})": "पूरे हुए ({n})",
 "Apagar a tarefa?": "कार्य हटाएँ?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "क्या करना है? (उदा.: मार्च का DAS निकालना)",
 "Cliente (opcional)": "ग्राहक (वैकल्पिक)",
 "Prazo (opcional)": "समय-सीमा (वैकल्पिक)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "ज़िम्मेदार (वैकल्पिक; नहीं तो कोई \"मैं करूँगा\" पर टैप करेगा)",
 "Escreva a tarefa para poder salvar.": "सहेजने के लिए कार्य लिखें।",
 "Membro": "सदस्य",
 "Cargo (livre)": "पद (मनचाहा)",
 "Ex.: Advogada, Assistente, Estagiário": "उदा.: वकील, सहायक, इंटर्न",
 "Papel": "भूमिका",
 "Admin: pode tudo no escritório.": "एडमिन: ऑफ़िस में सब कुछ कर सकता है।",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "संपादित करे: कार्य, सूचनाएँ, दस्तावेज़ और मीटिंग जोड़ सकता है",
 "Só vê: acompanha tudo, sem incluir nem mudar": "सिर्फ़ देखे: सब कुछ देखता है, जोड़ या बदल नहीं सकता",
 "Proposta": "प्रस्ताव",
 "Documento sensível (pede a senha do app para abrir)": "संवेदनशील दस्तावेज़ (खोलने के लिए ऐप पासवर्ड चाहिए)",
 "Li e concordo: {d}": "पढ़ा और सहमत: {d}",
 "Li e concordo": "मैंने पढ़ा और सहमत हूँ",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "\"सहमत\" पर टैप करने पर ऐप वह तारीख और समय सहेजता है जब आपने \"{doc}\" पढ़ा और सहमति दी। यह एक साधारण स्वीकृति है: यह आधिकारिक डिजिटल हस्ताक्षर की जगह नहीं लेती।",
 "Concordo": "सहमत",
 "Fotos (escolha quais entram)": "फ़ोटो (चुनें कौन-सी जाएँ)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 फ़ोटो इस डिवाइस पर नहीं पढ़ी जा सकी और छोड़ दी गई।",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} फ़ोटो इस डिवाइस पर नहीं पढ़ी जा सकीं और छोड़ दी गईं।",
 "Nenhuma foto no álbum desta viagem.": "इस यात्रा के एल्बम में कोई फ़ोटो नहीं।",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "चुनने या हटाने के लिए फ़ोटो पर टैप करें। PDF हल्की रहे, इसलिए फ़ोटो छोटी करके जाती हैं।",
 "Sugerir até 12": "12 तक सुझाएँ",
 "1 foto marcada": "1 फ़ोटो चुनी गई",
 "{n} fotos marcadas": "{n} फ़ोटो चुनी गईं",
 "Com mais de 12 fotos o PDF fica mais pesado.": "12 से ज़्यादा फ़ोटो पर PDF भारी हो जाती है।",
 "Confirme para abrir este documento": "यह दस्तावेज़ खोलने के लिए पुष्टि करें",
 "Como usar esta aba": "इस टैब का उपयोग कैसे करें",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 ग्राहक एक से ज़्यादा टैब में था और अब एक ही रिकॉर्ड बन गया।",
 "Juntar {n} fotos num PDF?": "{n} फ़ोटो को एक PDF में जोड़ें?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "फ़ोटो सूची के क्रम में एक ही PDF के पन्ने बन जाएँगी। अलग-अलग फ़ोटो इस फ़ाइल से हट जाएँगी।",
 "Não foi possível ler as fotos neste dispositivo.": "इस डिवाइस पर फ़ोटो नहीं पढ़ी जा सकीं।",
 "PDF criado": "PDF बन गया",
 "Montando o PDF...": "PDF बनाया जा रहा है...",
 "Juntar as {n} fotos num PDF": "{n} फ़ोटो को एक PDF में जोड़ें",
 "Baixar o mês": "महीना डाउनलोड करें",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "इस महीने की फ़ाइलें किसी दूसरे डिवाइस पर हैं और यहाँ पढ़ी नहीं जा सकीं।",
 "Os documentos deste mês não têm arquivos.": "इस महीने के दस्तावेज़ों में कोई फ़ाइल नहीं है।",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1 फ़ाइल किसी दूसरे डिवाइस पर है और शामिल नहीं हो सकी।",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} फ़ाइलें किसी दूसरे डिवाइस पर हैं और शामिल नहीं हो सकीं।",
 "Conversa sobre este documento": "इस दस्तावेज़ पर बातचीत",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "इस दस्तावेज़ के बारे में पूछें या जवाब दें। ऑफ़िस और क्लाइंट दोनों इसे देखते हैं।",
 "Escreva a mensagem": "संदेश लिखें",
 "Usar um modelo de pedido ({n})": "अनुरोध टेम्पलेट इस्तेमाल करें ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "WhatsApp पर {nome} को याद दिलाएँ: {o}",
 "Sem honorário": "कोई शुल्क नहीं",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "\"मेरे क्लाइंट\" में क्लाइंट की फ़ाइल के \"ऑफ़िस\" ब्लॉक में शुल्क की राशि दर्ज करें।",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "{c} से {v} की राशि प्राप्त हुई, जो अवधि {m} के शुल्क के लिए है।",
 "Recibo honorário {m} {c}": "शुल्क रसीद {m} {c}",
 "Recibo do honorário {m}": "शुल्क रसीद {m}",
 "Recibo criado": "रसीद बन गई",
 "O recibo entrou em Documentos, na competência {m}.": "रसीद दस्तावेज़ में अवधि {m} के तहत जुड़ गई है।",
 "Vendo como o cliente": "क्लाइंट के रूप में देख रहे हैं",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "क्लाइंट को उसका फ़ोल्डर ऐसा दिखता है: आंतरिक टिप्पणियों और केवल टीम के लिए की सामग्री के बिना। इस मोड में कुछ भी बदला नहीं जा सकता।",
 "Voltar a ver como escritório": "ऑफ़िस के रूप में देखना फिर शुरू करें",
 "Ver como o cliente": "क्लाइंट के रूप में देखें",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 आंतरिक टिप्पणियाँ (क्लाइंट कभी नहीं देखता)",
 "Recibo do honorário…": "शुल्क रसीद…",
 "Competência do recibo": "रसीद की अवधि",
 "⬇️ Baixar o mês": "⬇️ महीना डाउनलोड करें",
 "Me avisar para lembrar o cliente": "क्लाइंट को याद दिलाने के लिए मुझे सूचित करें",
 "Guardar como modelo": "टेम्पलेट के रूप में सहेजें",
 "Modelo guardado": "टेम्पलेट सहेज लिया गया",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "किसी भी क्लाइंट के लिए अनुरोध बनाते समय \"अनुरोध टेम्पलेट इस्तेमाल करें\" पर टैप करें।",
 "Relatório do mês": "मासिक रिपोर्ट",
 "Notas rápidas": "त्वरित नोट्स",
 "Item completo: {o}": "पूरा आइटम: {o}",
 "Reuniões do mês": "इस महीने की बैठकें",
 "Tarefas feitas e pendentes": "पूरे और लंबित कार्य",
 "Documentos internos enviados": "भेजे गए आंतरिक दस्तावेज़",
 "Documentos enviados e recebidos dos clientes": "क्लाइंट को भेजे और उनसे प्राप्त दस्तावेज़",
 "Documentos da competência": "अवधि के दस्तावेज़",
 "Guias pagas e vencidas": "भुगतान हो चुके और अतिदेय कर चालान",
 "Honorários": "शुल्क",
 "Relatório do mês · {m}": "मासिक रिपोर्ट · {m}",
 "Reuniões ({n})": "बैठकें ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "कार्य: महीने में {f} पूरे · {p} लंबित",
 "Quem fez": "किसने किया",
 "Feita em": "पूरी हुई",
 "Documentos internos enviados ({n})": "भेजे गए आंतरिक दस्तावेज़ ({n})",
 "Documentos trocados com os clientes": "क्लाइंट के साथ आदान-प्रदान किए गए दस्तावेज़",
 "Enviados pelo escritório": "ऑफ़िस द्वारा भेजे गए",
 "Recebidos do cliente": "क्लाइंट से प्राप्त",
 "Nenhum documento trocado neste mês.": "इस महीने कोई दस्तावेज़ आदान-प्रदान नहीं हुआ।",
 "Clientes com pendência ({n})": "लंबित मामलों वाले क्लाइंट ({n})",
 "Pendência": "लंबित मामला",
 "Nenhum cliente com pendência.": "किसी क्लाइंट का कोई मामला लंबित नहीं है।",
 "Documentos da competência {m} ({n})": "अवधि {m} के दस्तावेज़ ({n})",
 "Pedidos de documentos ({n})": "दस्तावेज़ अनुरोध ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "महीने के चालान: {p} भुगतान हुए · {v} अतिदेय",
 "Vencida": "अतिदेय",
 "Recebido no mês": "महीने में प्राप्त",
 "Relatório {m} {q}": "रिपोर्ट {m} {q}",
 "MÊS": "महीना",
 "DE QUEM": "किसका",
 "O escritório": "ऑफ़िस",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "ऑफ़िस (टीम) होने पर बैठकें, कार्य और आंतरिक दस्तावेज़ शामिल होते हैं।",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF, CNPJ, आंतरिक टिप्पणियाँ और बातचीत कभी रिपोर्ट में नहीं जाती।",
 "Anotações recebidas": "प्राप्त नोट्स",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "इस सूची की बकाया राशियाँ My Planner में दिखती हैं, नई भी।",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "इस सूची की केवल बकाया राशियाँ भेजता है (अपॉइंटमेंट अपने-आप जाते हैं), नई भी।",
 "Acrescentar": "जोड़ें",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "{n} बॉक्स {aba} में \"मिले हुए नोट्स\" में हैं।",
 "Enviadas": "भेजे गए",
 "Enviar para": "इसमें भेजें",
 "Excluir 1 item?": "1 आइटम हटाएं?",
 "Excluir {n} itens?": "{n} आइटम हटाएं?",
 "Inserir abaixo": "नीचे जोड़ें",
 "Mover para": "यहाँ ले जाएँ",
 "Mover {n} selecionados para": "{n} चुने हुए यहाँ ले जाएँ",
 "adicionar aqui": "यहाँ जोड़ें",
 "continue segurando para selecionar": "चुनने के लिए दबाए रखें"
}
